/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.net = (function() {

    /**
     * Namespace net.
     * @exports net
     * @namespace
     */
    var net = {};

    net.base_info = (function() {

        /**
         * Properties of a base_info.
         * @memberof net
         * @interface Ibase_info
         * @property {number|null} [uid] base_info uid
         * @property {Uint8Array|null} [nickname] base_info nickname
         * @property {Uint8Array|null} [phonenum] base_info phonenum
         * @property {Uint8Array|null} [headurl] base_info headurl
         * @property {number|null} [coin] base_info coin
         * @property {number|null} [lastlogouttime] base_info lastlogouttime
         * @property {Uint8Array|null} [sign] base_info sign
         * @property {Uint8Array|null} [region] base_info region
         * @property {Uint8Array|null} [qrcode] base_info qrcode
         * @property {number|null} [freezecoin] base_info freezecoin
         * @property {Uint8Array|null} [fname] base_info fname
         * @property {number|null} [usertype] base_info usertype
         * @property {Uint8Array|null} [zone] base_info zone
         * @property {number|null} [shopcoin] base_info shopcoin
         * @property {number|null} [fid] base_info fid
         * @property {Array.<net.Icoin_info>|null} [coin_list] base_info coin_list
         * @property {number|null} [channel] base_info channel
         * @property {number|null} [thirduid] base_info thirduid
         * @property {number|null} [viplevel] base_info viplevel
         * @property {number|null} [isadmin] base_info isadmin
         * @property {Uint8Array|null} [firstname] base_info firstname
         * @property {Uint8Array|null} [lastname] base_info lastname
         * @property {number|Long|null} [privacy] base_info privacy
         */

        /**
         * Constructs a new base_info.
         * @memberof net
         * @classdesc Represents a base_info.
         * @implements Ibase_info
         * @constructor
         * @param {net.Ibase_info=} [properties] Properties to set
         */
        function base_info(properties) {
            this.coin_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * base_info uid.
         * @member {number} uid
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.uid = 0;

        /**
         * base_info nickname.
         * @member {Uint8Array} nickname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.nickname = $util.newBuffer([]);

        /**
         * base_info phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.phonenum = $util.newBuffer([]);

        /**
         * base_info headurl.
         * @member {Uint8Array} headurl
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.headurl = $util.newBuffer([]);

        /**
         * base_info coin.
         * @member {number} coin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.coin = 0;

        /**
         * base_info lastlogouttime.
         * @member {number} lastlogouttime
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.lastlogouttime = 0;

        /**
         * base_info sign.
         * @member {Uint8Array} sign
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.sign = $util.newBuffer([]);

        /**
         * base_info region.
         * @member {Uint8Array} region
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.region = $util.newBuffer([]);

        /**
         * base_info qrcode.
         * @member {Uint8Array} qrcode
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.qrcode = $util.newBuffer([]);

        /**
         * base_info freezecoin.
         * @member {number} freezecoin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.freezecoin = 0;

        /**
         * base_info fname.
         * @member {Uint8Array} fname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.fname = $util.newBuffer([]);

        /**
         * base_info usertype.
         * @member {number} usertype
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.usertype = 0;

        /**
         * base_info zone.
         * @member {Uint8Array} zone
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.zone = $util.newBuffer([]);

        /**
         * base_info shopcoin.
         * @member {number} shopcoin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.shopcoin = 0;

        /**
         * base_info fid.
         * @member {number} fid
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.fid = 0;

        /**
         * base_info coin_list.
         * @member {Array.<net.Icoin_info>} coin_list
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.coin_list = $util.emptyArray;

        /**
         * base_info channel.
         * @member {number} channel
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.channel = 0;

        /**
         * base_info thirduid.
         * @member {number} thirduid
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.thirduid = 0;

        /**
         * base_info viplevel.
         * @member {number} viplevel
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.viplevel = 0;

        /**
         * base_info isadmin.
         * @member {number} isadmin
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.isadmin = 0;

        /**
         * base_info firstname.
         * @member {Uint8Array} firstname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.firstname = $util.newBuffer([]);

        /**
         * base_info lastname.
         * @member {Uint8Array} lastname
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.lastname = $util.newBuffer([]);

        /**
         * base_info privacy.
         * @member {number|Long} privacy
         * @memberof net.base_info
         * @instance
         */
        base_info.prototype.privacy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified base_info message. Does not implicitly {@link net.base_info.verify|verify} messages.
         * @function encode
         * @memberof net.base_info
         * @static
         * @param {net.Ibase_info} message base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        base_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.phonenum);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.headurl);
            if (message.coin != null && Object.hasOwnProperty.call(message, "coin"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.coin);
            if (message.lastlogouttime != null && Object.hasOwnProperty.call(message, "lastlogouttime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.lastlogouttime);
            if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.sign);
            if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.region);
            if (message.qrcode != null && Object.hasOwnProperty.call(message, "qrcode"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.qrcode);
            if (message.freezecoin != null && Object.hasOwnProperty.call(message, "freezecoin"))
                writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.freezecoin);
            if (message.fname != null && Object.hasOwnProperty.call(message, "fname"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.fname);
            if (message.usertype != null && Object.hasOwnProperty.call(message, "usertype"))
                writer.uint32(/* id 12, wireType 0 =*/96).uint32(message.usertype);
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 13, wireType 2 =*/106).bytes(message.zone);
            if (message.shopcoin != null && Object.hasOwnProperty.call(message, "shopcoin"))
                writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.shopcoin);
            if (message.fid != null && Object.hasOwnProperty.call(message, "fid"))
                writer.uint32(/* id 15, wireType 0 =*/120).uint32(message.fid);
            if (message.coin_list != null && message.coin_list.length)
                for (var i = 0; i < message.coin_list.length; ++i)
                    $root.net.coin_info.encode(message.coin_list[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 17, wireType 0 =*/136).uint32(message.channel);
            if (message.thirduid != null && Object.hasOwnProperty.call(message, "thirduid"))
                writer.uint32(/* id 18, wireType 0 =*/144).uint32(message.thirduid);
            if (message.viplevel != null && Object.hasOwnProperty.call(message, "viplevel"))
                writer.uint32(/* id 19, wireType 0 =*/152).uint32(message.viplevel);
            if (message.isadmin != null && Object.hasOwnProperty.call(message, "isadmin"))
                writer.uint32(/* id 20, wireType 0 =*/160).uint32(message.isadmin);
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 21, wireType 2 =*/170).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 22, wireType 2 =*/178).bytes(message.lastname);
            if (message.privacy != null && Object.hasOwnProperty.call(message, "privacy"))
                writer.uint32(/* id 23, wireType 0 =*/184).int64(message.privacy);
            return writer;
        };

        /**
         * Decodes a base_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.base_info} base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        base_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.base_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.uint32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                case 3:
                    message.phonenum = reader.bytes();
                    break;
                case 4:
                    message.headurl = reader.bytes();
                    break;
                case 5:
                    message.coin = reader.uint32();
                    break;
                case 6:
                    message.lastlogouttime = reader.int32();
                    break;
                case 7:
                    message.sign = reader.bytes();
                    break;
                case 8:
                    message.region = reader.bytes();
                    break;
                case 9:
                    message.qrcode = reader.bytes();
                    break;
                case 10:
                    message.freezecoin = reader.uint32();
                    break;
                case 11:
                    message.fname = reader.bytes();
                    break;
                case 12:
                    message.usertype = reader.uint32();
                    break;
                case 13:
                    message.zone = reader.bytes();
                    break;
                case 14:
                    message.shopcoin = reader.uint32();
                    break;
                case 15:
                    message.fid = reader.uint32();
                    break;
                case 16:
                    if (!(message.coin_list && message.coin_list.length))
                        message.coin_list = [];
                    message.coin_list.push($root.net.coin_info.decode(reader, reader.uint32()));
                    break;
                case 17:
                    message.channel = reader.uint32();
                    break;
                case 18:
                    message.thirduid = reader.uint32();
                    break;
                case 19:
                    message.viplevel = reader.uint32();
                    break;
                case 20:
                    message.isadmin = reader.uint32();
                    break;
                case 21:
                    message.firstname = reader.bytes();
                    break;
                case 22:
                    message.lastname = reader.bytes();
                    break;
                case 23:
                    message.privacy = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return base_info;
    })();

    net.friend_apply = (function() {

        /**
         * Properties of a friend_apply.
         * @memberof net
         * @interface Ifriend_apply
         * @property {net.Ibase_info|null} [info] friend_apply info
         * @property {number|null} [applytime] friend_apply applytime
         * @property {number|null} [applyState] friend_apply applyState
         * @property {Uint8Array|null} [hellomsg] friend_apply hellomsg
         */

        /**
         * Constructs a new friend_apply.
         * @memberof net
         * @classdesc Represents a friend_apply.
         * @implements Ifriend_apply
         * @constructor
         * @param {net.Ifriend_apply=} [properties] Properties to set
         */
        function friend_apply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * friend_apply info.
         * @member {net.Ibase_info|null|undefined} info
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.info = null;

        /**
         * friend_apply applytime.
         * @member {number} applytime
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.applytime = 0;

        /**
         * friend_apply applyState.
         * @member {number} applyState
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.applyState = 0;

        /**
         * friend_apply hellomsg.
         * @member {Uint8Array} hellomsg
         * @memberof net.friend_apply
         * @instance
         */
        friend_apply.prototype.hellomsg = $util.newBuffer([]);

        /**
         * Encodes the specified friend_apply message. Does not implicitly {@link net.friend_apply.verify|verify} messages.
         * @function encode
         * @memberof net.friend_apply
         * @static
         * @param {net.Ifriend_apply} message friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        friend_apply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                $root.net.base_info.encode(message.info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.applytime != null && Object.hasOwnProperty.call(message, "applytime"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.applytime);
            if (message.applyState != null && Object.hasOwnProperty.call(message, "applyState"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.applyState);
            if (message.hellomsg != null && Object.hasOwnProperty.call(message, "hellomsg"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.hellomsg);
            return writer;
        };

        /**
         * Decodes a friend_apply message from the specified reader or buffer.
         * @function decode
         * @memberof net.friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.friend_apply} friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        friend_apply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.friend_apply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.applytime = reader.uint32();
                    break;
                case 3:
                    message.applyState = reader.uint32();
                    break;
                case 4:
                    message.hellomsg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return friend_apply;
    })();

    net.chat_msg = (function() {

        /**
         * Properties of a chat_msg.
         * @memberof net
         * @interface Ichat_msg
         * @property {number|Long|null} [chatkey] chat_msg chatkey
         * @property {number|null} [chatmsgno] chat_msg chatmsgno
         * @property {number|null} [uid] chat_msg uid
         * @property {number|null} [msgtype] chat_msg msgtype
         * @property {number|null} [msgtime] chat_msg msgtime
         * @property {Uint8Array|null} [content] chat_msg content
         * @property {Uint8Array|null} [nickname] chat_msg nickname
         * @property {Uint8Array|null} [headurl] chat_msg headurl
         * @property {Uint8Array|null} [clientkey] chat_msg clientkey
         * @property {number|null} [snaptime] chat_msg snaptime
         * @property {number|null} [viplevel] chat_msg viplevel
         * @property {number|null} [isadmin] chat_msg isadmin
         * @property {Uint8Array|null} [firstname] chat_msg firstname
         * @property {Uint8Array|null} [lastname] chat_msg lastname
         */

        /**
         * Constructs a new chat_msg.
         * @memberof net
         * @classdesc Represents a chat_msg.
         * @implements Ichat_msg
         * @constructor
         * @param {net.Ichat_msg=} [properties] Properties to set
         */
        function chat_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * chat_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * chat_msg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.chatmsgno = 0;

        /**
         * chat_msg uid.
         * @member {number} uid
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.uid = 0;

        /**
         * chat_msg msgtype.
         * @member {number} msgtype
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.msgtype = 0;

        /**
         * chat_msg msgtime.
         * @member {number} msgtime
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.msgtime = 0;

        /**
         * chat_msg content.
         * @member {Uint8Array} content
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.content = $util.newBuffer([]);

        /**
         * chat_msg nickname.
         * @member {Uint8Array} nickname
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.nickname = $util.newBuffer([]);

        /**
         * chat_msg headurl.
         * @member {Uint8Array} headurl
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.headurl = $util.newBuffer([]);

        /**
         * chat_msg clientkey.
         * @member {Uint8Array} clientkey
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.clientkey = $util.newBuffer([]);

        /**
         * chat_msg snaptime.
         * @member {number} snaptime
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.snaptime = 0;

        /**
         * chat_msg viplevel.
         * @member {number} viplevel
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.viplevel = 0;

        /**
         * chat_msg isadmin.
         * @member {number} isadmin
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.isadmin = 0;

        /**
         * chat_msg firstname.
         * @member {Uint8Array} firstname
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.firstname = $util.newBuffer([]);

        /**
         * chat_msg lastname.
         * @member {Uint8Array} lastname
         * @memberof net.chat_msg
         * @instance
         */
        chat_msg.prototype.lastname = $util.newBuffer([]);

        /**
         * Encodes the specified chat_msg message. Does not implicitly {@link net.chat_msg.verify|verify} messages.
         * @function encode
         * @memberof net.chat_msg
         * @static
         * @param {net.Ichat_msg} message chat_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        chat_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            if (message.msgtype != null && Object.hasOwnProperty.call(message, "msgtype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.msgtype);
            if (message.msgtime != null && Object.hasOwnProperty.call(message, "msgtime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.msgtime);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.content);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.nickname);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.headurl);
            if (message.clientkey != null && Object.hasOwnProperty.call(message, "clientkey"))
                writer.uint32(/* id 9, wireType 2 =*/74).bytes(message.clientkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.snaptime);
            if (message.viplevel != null && Object.hasOwnProperty.call(message, "viplevel"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.viplevel);
            if (message.isadmin != null && Object.hasOwnProperty.call(message, "isadmin"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.isadmin);
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 13, wireType 2 =*/106).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 14, wireType 2 =*/114).bytes(message.lastname);
            return writer;
        };

        /**
         * Decodes a chat_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.chat_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.chat_msg} chat_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        chat_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.chat_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                case 4:
                    message.msgtype = reader.int32();
                    break;
                case 5:
                    message.msgtime = reader.int32();
                    break;
                case 6:
                    message.content = reader.bytes();
                    break;
                case 7:
                    message.nickname = reader.bytes();
                    break;
                case 8:
                    message.headurl = reader.bytes();
                    break;
                case 9:
                    message.clientkey = reader.bytes();
                    break;
                case 10:
                    message.snaptime = reader.int32();
                    break;
                case 11:
                    message.viplevel = reader.int32();
                    break;
                case 12:
                    message.isadmin = reader.int32();
                    break;
                case 13:
                    message.firstname = reader.bytes();
                    break;
                case 14:
                    message.lastname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return chat_msg;
    })();

    net.red_info = (function() {

        /**
         * Properties of a red_info.
         * @memberof net
         * @interface Ired_info
         * @property {number|null} [redtype] red_info redtype
         * @property {number|Long|null} [chatkey] red_info chatkey
         * @property {number|null} [uid] red_info uid
         * @property {Uint8Array|null} [content] red_info content
         * @property {number|null} [unread_apply_num] red_info unread_apply_num
         */

        /**
         * Constructs a new red_info.
         * @memberof net
         * @classdesc Represents a red_info.
         * @implements Ired_info
         * @constructor
         * @param {net.Ired_info=} [properties] Properties to set
         */
        function red_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * red_info redtype.
         * @member {number} redtype
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.redtype = 0;

        /**
         * red_info chatkey.
         * @member {number|Long} chatkey
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * red_info uid.
         * @member {number} uid
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.uid = 0;

        /**
         * red_info content.
         * @member {Uint8Array} content
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.content = $util.newBuffer([]);

        /**
         * red_info unread_apply_num.
         * @member {number} unread_apply_num
         * @memberof net.red_info
         * @instance
         */
        red_info.prototype.unread_apply_num = 0;

        /**
         * Encodes the specified red_info message. Does not implicitly {@link net.red_info.verify|verify} messages.
         * @function encode
         * @memberof net.red_info
         * @static
         * @param {net.Ired_info} message red_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        red_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redtype != null && Object.hasOwnProperty.call(message, "redtype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redtype);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.content);
            if (message.unread_apply_num != null && Object.hasOwnProperty.call(message, "unread_apply_num"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.unread_apply_num);
            return writer;
        };

        /**
         * Decodes a red_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.red_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.red_info} red_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        red_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.red_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redtype = reader.int32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                case 4:
                    message.content = reader.bytes();
                    break;
                case 5:
                    message.unread_apply_num = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return red_info;
    })();

    net.group_base_info = (function() {

        /**
         * Properties of a group_base_info.
         * @memberof net
         * @interface Igroup_base_info
         * @property {number|null} [groupkey] group_base_info groupkey
         * @property {number|null} [chatmsgno] group_base_info chatmsgno
         * @property {number|null} [attrversion] group_base_info attrversion
         * @property {number|null} [grouphost] group_base_info grouphost
         * @property {Uint8Array|null} [groupname] group_base_info groupname
         * @property {Uint8Array|null} [groupnotify] group_base_info groupnotify
         * @property {Array.<number>|null} [groupadmins] group_base_info groupadmins
         * @property {number|null} [info_limits] group_base_info info_limits
         * @property {number|null} [add_limits] group_base_info add_limits
         * @property {number|null} [look_limits] group_base_info look_limits
         * @property {number|null} [member_cnt] group_base_info member_cnt
         * @property {number|null} [send_msg_limits] group_base_info send_msg_limits
         * @property {number|null} [notifyversion] group_base_info notifyversion
         * @property {number|null} [forbidbegintm] group_base_info forbidbegintm
         * @property {number|null} [forbidendtm] group_base_info forbidendtm
         * @property {number|null} [isforbid] group_base_info isforbid
         * @property {Uint8Array|null} [groupheadurl] group_base_info groupheadurl
         * @property {number|null} [online_cnt] group_base_info online_cnt
         */

        /**
         * Constructs a new group_base_info.
         * @memberof net
         * @classdesc Represents a group_base_info.
         * @implements Igroup_base_info
         * @constructor
         * @param {net.Igroup_base_info=} [properties] Properties to set
         */
        function group_base_info(properties) {
            this.groupadmins = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * group_base_info groupkey.
         * @member {number} groupkey
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupkey = 0;

        /**
         * group_base_info chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.chatmsgno = 0;

        /**
         * group_base_info attrversion.
         * @member {number} attrversion
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.attrversion = 0;

        /**
         * group_base_info grouphost.
         * @member {number} grouphost
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.grouphost = 0;

        /**
         * group_base_info groupname.
         * @member {Uint8Array} groupname
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupname = $util.newBuffer([]);

        /**
         * group_base_info groupnotify.
         * @member {Uint8Array} groupnotify
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupnotify = $util.newBuffer([]);

        /**
         * group_base_info groupadmins.
         * @member {Array.<number>} groupadmins
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupadmins = $util.emptyArray;

        /**
         * group_base_info info_limits.
         * @member {number} info_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.info_limits = 0;

        /**
         * group_base_info add_limits.
         * @member {number} add_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.add_limits = 0;

        /**
         * group_base_info look_limits.
         * @member {number} look_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.look_limits = 0;

        /**
         * group_base_info member_cnt.
         * @member {number} member_cnt
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.member_cnt = 0;

        /**
         * group_base_info send_msg_limits.
         * @member {number} send_msg_limits
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.send_msg_limits = 0;

        /**
         * group_base_info notifyversion.
         * @member {number} notifyversion
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.notifyversion = 0;

        /**
         * group_base_info forbidbegintm.
         * @member {number} forbidbegintm
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.forbidbegintm = 0;

        /**
         * group_base_info forbidendtm.
         * @member {number} forbidendtm
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.forbidendtm = 0;

        /**
         * group_base_info isforbid.
         * @member {number} isforbid
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.isforbid = 0;

        /**
         * group_base_info groupheadurl.
         * @member {Uint8Array} groupheadurl
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.groupheadurl = $util.newBuffer([]);

        /**
         * group_base_info online_cnt.
         * @member {number} online_cnt
         * @memberof net.group_base_info
         * @instance
         */
        group_base_info.prototype.online_cnt = 0;

        /**
         * Encodes the specified group_base_info message. Does not implicitly {@link net.group_base_info.verify|verify} messages.
         * @function encode
         * @memberof net.group_base_info
         * @static
         * @param {net.Igroup_base_info} message group_base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_base_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            if (message.attrversion != null && Object.hasOwnProperty.call(message, "attrversion"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.attrversion);
            if (message.grouphost != null && Object.hasOwnProperty.call(message, "grouphost"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.grouphost);
            if (message.groupname != null && Object.hasOwnProperty.call(message, "groupname"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.groupname);
            if (message.groupnotify != null && Object.hasOwnProperty.call(message, "groupnotify"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.groupnotify);
            if (message.groupadmins != null && message.groupadmins.length)
                for (var i = 0; i < message.groupadmins.length; ++i)
                    writer.uint32(/* id 7, wireType 0 =*/56).int32(message.groupadmins[i]);
            if (message.info_limits != null && Object.hasOwnProperty.call(message, "info_limits"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.info_limits);
            if (message.add_limits != null && Object.hasOwnProperty.call(message, "add_limits"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.add_limits);
            if (message.look_limits != null && Object.hasOwnProperty.call(message, "look_limits"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.look_limits);
            if (message.member_cnt != null && Object.hasOwnProperty.call(message, "member_cnt"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.member_cnt);
            if (message.send_msg_limits != null && Object.hasOwnProperty.call(message, "send_msg_limits"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.send_msg_limits);
            if (message.notifyversion != null && Object.hasOwnProperty.call(message, "notifyversion"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.notifyversion);
            if (message.forbidbegintm != null && Object.hasOwnProperty.call(message, "forbidbegintm"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.forbidbegintm);
            if (message.forbidendtm != null && Object.hasOwnProperty.call(message, "forbidendtm"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.forbidendtm);
            if (message.isforbid != null && Object.hasOwnProperty.call(message, "isforbid"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.isforbid);
            if (message.groupheadurl != null && Object.hasOwnProperty.call(message, "groupheadurl"))
                writer.uint32(/* id 17, wireType 2 =*/138).bytes(message.groupheadurl);
            if (message.online_cnt != null && Object.hasOwnProperty.call(message, "online_cnt"))
                writer.uint32(/* id 18, wireType 0 =*/144).int32(message.online_cnt);
            return writer;
        };

        /**
         * Decodes a group_base_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.group_base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.group_base_info} group_base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_base_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.group_base_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                case 3:
                    message.attrversion = reader.int32();
                    break;
                case 4:
                    message.grouphost = reader.int32();
                    break;
                case 5:
                    message.groupname = reader.bytes();
                    break;
                case 6:
                    message.groupnotify = reader.bytes();
                    break;
                case 7:
                    if (!(message.groupadmins && message.groupadmins.length))
                        message.groupadmins = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.groupadmins.push(reader.int32());
                    } else
                        message.groupadmins.push(reader.int32());
                    break;
                case 8:
                    message.info_limits = reader.int32();
                    break;
                case 9:
                    message.add_limits = reader.int32();
                    break;
                case 10:
                    message.look_limits = reader.int32();
                    break;
                case 11:
                    message.member_cnt = reader.int32();
                    break;
                case 12:
                    message.send_msg_limits = reader.int32();
                    break;
                case 13:
                    message.notifyversion = reader.int32();
                    break;
                case 14:
                    message.forbidbegintm = reader.int32();
                    break;
                case 15:
                    message.forbidendtm = reader.int32();
                    break;
                case 16:
                    message.isforbid = reader.int32();
                    break;
                case 17:
                    message.groupheadurl = reader.bytes();
                    break;
                case 18:
                    message.online_cnt = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return group_base_info;
    })();

    net.redbag_get_record = (function() {

        /**
         * Properties of a redbag_get_record.
         * @memberof net
         * @interface Iredbag_get_record
         * @property {number|null} [uid] redbag_get_record uid
         * @property {Uint8Array|null} [nickname] redbag_get_record nickname
         * @property {number|null} [getvalue] redbag_get_record getvalue
         * @property {number|null} [gettime] redbag_get_record gettime
         * @property {Uint8Array|null} [headurl] redbag_get_record headurl
         */

        /**
         * Constructs a new redbag_get_record.
         * @memberof net
         * @classdesc Represents a redbag_get_record.
         * @implements Iredbag_get_record
         * @constructor
         * @param {net.Iredbag_get_record=} [properties] Properties to set
         */
        function redbag_get_record(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * redbag_get_record uid.
         * @member {number} uid
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.uid = 0;

        /**
         * redbag_get_record nickname.
         * @member {Uint8Array} nickname
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.nickname = $util.newBuffer([]);

        /**
         * redbag_get_record getvalue.
         * @member {number} getvalue
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.getvalue = 0;

        /**
         * redbag_get_record gettime.
         * @member {number} gettime
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.gettime = 0;

        /**
         * redbag_get_record headurl.
         * @member {Uint8Array} headurl
         * @memberof net.redbag_get_record
         * @instance
         */
        redbag_get_record.prototype.headurl = $util.newBuffer([]);

        /**
         * Encodes the specified redbag_get_record message. Does not implicitly {@link net.redbag_get_record.verify|verify} messages.
         * @function encode
         * @memberof net.redbag_get_record
         * @static
         * @param {net.Iredbag_get_record} message redbag_get_record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        redbag_get_record.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            if (message.getvalue != null && Object.hasOwnProperty.call(message, "getvalue"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.getvalue);
            if (message.gettime != null && Object.hasOwnProperty.call(message, "gettime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.gettime);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.headurl);
            return writer;
        };

        /**
         * Decodes a redbag_get_record message from the specified reader or buffer.
         * @function decode
         * @memberof net.redbag_get_record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.redbag_get_record} redbag_get_record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        redbag_get_record.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.redbag_get_record();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                case 3:
                    message.getvalue = reader.int32();
                    break;
                case 4:
                    message.gettime = reader.int32();
                    break;
                case 5:
                    message.headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return redbag_get_record;
    })();

    net.oper_chatkey_info = (function() {

        /**
         * Properties of an oper_chatkey_info.
         * @memberof net
         * @interface Ioper_chatkey_info
         * @property {number|Long|null} [chatkey] oper_chatkey_info chatkey
         * @property {number|null} [opertime] oper_chatkey_info opertime
         */

        /**
         * Constructs a new oper_chatkey_info.
         * @memberof net
         * @classdesc Represents an oper_chatkey_info.
         * @implements Ioper_chatkey_info
         * @constructor
         * @param {net.Ioper_chatkey_info=} [properties] Properties to set
         */
        function oper_chatkey_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * oper_chatkey_info chatkey.
         * @member {number|Long} chatkey
         * @memberof net.oper_chatkey_info
         * @instance
         */
        oper_chatkey_info.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * oper_chatkey_info opertime.
         * @member {number} opertime
         * @memberof net.oper_chatkey_info
         * @instance
         */
        oper_chatkey_info.prototype.opertime = 0;

        /**
         * Encodes the specified oper_chatkey_info message. Does not implicitly {@link net.oper_chatkey_info.verify|verify} messages.
         * @function encode
         * @memberof net.oper_chatkey_info
         * @static
         * @param {net.Ioper_chatkey_info} message oper_chatkey_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        oper_chatkey_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertime != null && Object.hasOwnProperty.call(message, "opertime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertime);
            return writer;
        };

        /**
         * Decodes an oper_chatkey_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.oper_chatkey_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.oper_chatkey_info} oper_chatkey_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        oper_chatkey_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.oper_chatkey_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return oper_chatkey_info;
    })();

    net.snap_chatkey_info = (function() {

        /**
         * Properties of a snap_chatkey_info.
         * @memberof net
         * @interface Isnap_chatkey_info
         * @property {number|Long|null} [chatkey] snap_chatkey_info chatkey
         * @property {number|null} [snaptime] snap_chatkey_info snaptime
         */

        /**
         * Constructs a new snap_chatkey_info.
         * @memberof net
         * @classdesc Represents a snap_chatkey_info.
         * @implements Isnap_chatkey_info
         * @constructor
         * @param {net.Isnap_chatkey_info=} [properties] Properties to set
         */
        function snap_chatkey_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * snap_chatkey_info chatkey.
         * @member {number|Long} chatkey
         * @memberof net.snap_chatkey_info
         * @instance
         */
        snap_chatkey_info.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * snap_chatkey_info snaptime.
         * @member {number} snaptime
         * @memberof net.snap_chatkey_info
         * @instance
         */
        snap_chatkey_info.prototype.snaptime = 0;

        /**
         * Encodes the specified snap_chatkey_info message. Does not implicitly {@link net.snap_chatkey_info.verify|verify} messages.
         * @function encode
         * @memberof net.snap_chatkey_info
         * @static
         * @param {net.Isnap_chatkey_info} message snap_chatkey_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        snap_chatkey_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.snaptime);
            return writer;
        };

        /**
         * Decodes a snap_chatkey_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.snap_chatkey_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.snap_chatkey_info} snap_chatkey_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        snap_chatkey_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.snap_chatkey_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.snaptime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return snap_chatkey_info;
    })();

    net.alias_info = (function() {

        /**
         * Properties of an alias_info.
         * @memberof net
         * @interface Ialias_info
         * @property {number|null} [fuid] alias_info fuid
         * @property {Uint8Array|null} [aliasname] alias_info aliasname
         */

        /**
         * Constructs a new alias_info.
         * @memberof net
         * @classdesc Represents an alias_info.
         * @implements Ialias_info
         * @constructor
         * @param {net.Ialias_info=} [properties] Properties to set
         */
        function alias_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * alias_info fuid.
         * @member {number} fuid
         * @memberof net.alias_info
         * @instance
         */
        alias_info.prototype.fuid = 0;

        /**
         * alias_info aliasname.
         * @member {Uint8Array} aliasname
         * @memberof net.alias_info
         * @instance
         */
        alias_info.prototype.aliasname = $util.newBuffer([]);

        /**
         * Encodes the specified alias_info message. Does not implicitly {@link net.alias_info.verify|verify} messages.
         * @function encode
         * @memberof net.alias_info
         * @static
         * @param {net.Ialias_info} message alias_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        alias_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fuid);
            if (message.aliasname != null && Object.hasOwnProperty.call(message, "aliasname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.aliasname);
            return writer;
        };

        /**
         * Decodes an alias_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.alias_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.alias_info} alias_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        alias_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.alias_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuid = reader.int32();
                    break;
                case 2:
                    message.aliasname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return alias_info;
    })();

    net.redbag_base_info = (function() {

        /**
         * Properties of a redbag_base_info.
         * @memberof net
         * @interface Iredbag_base_info
         * @property {number|null} [redbag_id] redbag_base_info redbag_id
         * @property {number|null} [redbagtype] redbag_base_info redbagtype
         * @property {number|null} [redbagvalue] redbag_base_info redbagvalue
         * @property {number|null} [tm] redbag_base_info tm
         * @property {number|null} [uid] redbag_base_info uid
         * @property {Uint8Array|null} [nickname] redbag_base_info nickname
         * @property {number|null} [cointype] redbag_base_info cointype
         */

        /**
         * Constructs a new redbag_base_info.
         * @memberof net
         * @classdesc Represents a redbag_base_info.
         * @implements Iredbag_base_info
         * @constructor
         * @param {net.Iredbag_base_info=} [properties] Properties to set
         */
        function redbag_base_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * redbag_base_info redbag_id.
         * @member {number} redbag_id
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.redbag_id = 0;

        /**
         * redbag_base_info redbagtype.
         * @member {number} redbagtype
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.redbagtype = 0;

        /**
         * redbag_base_info redbagvalue.
         * @member {number} redbagvalue
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.redbagvalue = 0;

        /**
         * redbag_base_info tm.
         * @member {number} tm
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.tm = 0;

        /**
         * redbag_base_info uid.
         * @member {number} uid
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.uid = 0;

        /**
         * redbag_base_info nickname.
         * @member {Uint8Array} nickname
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.nickname = $util.newBuffer([]);

        /**
         * redbag_base_info cointype.
         * @member {number} cointype
         * @memberof net.redbag_base_info
         * @instance
         */
        redbag_base_info.prototype.cointype = 0;

        /**
         * Encodes the specified redbag_base_info message. Does not implicitly {@link net.redbag_base_info.verify|verify} messages.
         * @function encode
         * @memberof net.redbag_base_info
         * @static
         * @param {net.Iredbag_base_info} message redbag_base_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        redbag_base_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            if (message.redbagtype != null && Object.hasOwnProperty.call(message, "redbagtype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.redbagtype);
            if (message.redbagvalue != null && Object.hasOwnProperty.call(message, "redbagvalue"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.redbagvalue);
            if (message.tm != null && Object.hasOwnProperty.call(message, "tm"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tm);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.nickname);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.cointype);
            return writer;
        };

        /**
         * Decodes a redbag_base_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.redbag_base_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.redbag_base_info} redbag_base_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        redbag_base_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.redbag_base_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                case 2:
                    message.redbagtype = reader.int32();
                    break;
                case 3:
                    message.redbagvalue = reader.int32();
                    break;
                case 4:
                    message.tm = reader.int32();
                    break;
                case 5:
                    message.uid = reader.int32();
                    break;
                case 6:
                    message.nickname = reader.bytes();
                    break;
                case 7:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return redbag_base_info;
    })();

    net.money_change_info = (function() {

        /**
         * Properties of a money_change_info.
         * @memberof net
         * @interface Imoney_change_info
         * @property {number|null} [uid] money_change_info uid
         * @property {number|null} [otheruid] money_change_info otheruid
         * @property {Uint8Array|null} [othername] money_change_info othername
         * @property {number|null} [moneytype] money_change_info moneytype
         * @property {number|null} [amount] money_change_info amount
         * @property {Uint8Array|null} [remarks] money_change_info remarks
         * @property {number|null} [ptime] money_change_info ptime
         * @property {number|Long|null} [orderid] money_change_info orderid
         * @property {number|null} [cointype] money_change_info cointype
         * @property {number|null} [outcointype] money_change_info outcointype
         */

        /**
         * Constructs a new money_change_info.
         * @memberof net
         * @classdesc Represents a money_change_info.
         * @implements Imoney_change_info
         * @constructor
         * @param {net.Imoney_change_info=} [properties] Properties to set
         */
        function money_change_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * money_change_info uid.
         * @member {number} uid
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.uid = 0;

        /**
         * money_change_info otheruid.
         * @member {number} otheruid
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.otheruid = 0;

        /**
         * money_change_info othername.
         * @member {Uint8Array} othername
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.othername = $util.newBuffer([]);

        /**
         * money_change_info moneytype.
         * @member {number} moneytype
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.moneytype = 0;

        /**
         * money_change_info amount.
         * @member {number} amount
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.amount = 0;

        /**
         * money_change_info remarks.
         * @member {Uint8Array} remarks
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.remarks = $util.newBuffer([]);

        /**
         * money_change_info ptime.
         * @member {number} ptime
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.ptime = 0;

        /**
         * money_change_info orderid.
         * @member {number|Long} orderid
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * money_change_info cointype.
         * @member {number} cointype
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.cointype = 0;

        /**
         * money_change_info outcointype.
         * @member {number} outcointype
         * @memberof net.money_change_info
         * @instance
         */
        money_change_info.prototype.outcointype = 0;

        /**
         * Encodes the specified money_change_info message. Does not implicitly {@link net.money_change_info.verify|verify} messages.
         * @function encode
         * @memberof net.money_change_info
         * @static
         * @param {net.Imoney_change_info} message money_change_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        money_change_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.othername != null && Object.hasOwnProperty.call(message, "othername"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.othername);
            if (message.moneytype != null && Object.hasOwnProperty.call(message, "moneytype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.moneytype);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.amount);
            if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.remarks);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ptime);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.orderid);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.outcointype);
            return writer;
        };

        /**
         * Decodes a money_change_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.money_change_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.money_change_info} money_change_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        money_change_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.money_change_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.othername = reader.bytes();
                    break;
                case 4:
                    message.moneytype = reader.int32();
                    break;
                case 5:
                    message.amount = reader.int32();
                    break;
                case 6:
                    message.remarks = reader.bytes();
                    break;
                case 7:
                    message.ptime = reader.int32();
                    break;
                case 8:
                    message.orderid = reader.int64();
                    break;
                case 9:
                    message.cointype = reader.int32();
                    break;
                case 10:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return money_change_info;
    })();

    net.mobile_pay_info = (function() {

        /**
         * Properties of a mobile_pay_info.
         * @memberof net
         * @interface Imobile_pay_info
         * @property {number|null} [id] mobile_pay_info id
         * @property {number|null} [uid] mobile_pay_info uid
         * @property {number|null} [paytype] mobile_pay_info paytype
         * @property {Uint8Array|null} [accountname] mobile_pay_info accountname
         * @property {Uint8Array|null} [phoneno] mobile_pay_info phoneno
         * @property {number|null} [addfriendtype] mobile_pay_info addfriendtype
         * @property {Uint8Array|null} [name] mobile_pay_info name
         * @property {Uint8Array|null} [bankcode] mobile_pay_info bankcode
         */

        /**
         * Constructs a new mobile_pay_info.
         * @memberof net
         * @classdesc Represents a mobile_pay_info.
         * @implements Imobile_pay_info
         * @constructor
         * @param {net.Imobile_pay_info=} [properties] Properties to set
         */
        function mobile_pay_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * mobile_pay_info id.
         * @member {number} id
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.id = 0;

        /**
         * mobile_pay_info uid.
         * @member {number} uid
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.uid = 0;

        /**
         * mobile_pay_info paytype.
         * @member {number} paytype
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.paytype = 0;

        /**
         * mobile_pay_info accountname.
         * @member {Uint8Array} accountname
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.accountname = $util.newBuffer([]);

        /**
         * mobile_pay_info phoneno.
         * @member {Uint8Array} phoneno
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.phoneno = $util.newBuffer([]);

        /**
         * mobile_pay_info addfriendtype.
         * @member {number} addfriendtype
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.addfriendtype = 0;

        /**
         * mobile_pay_info name.
         * @member {Uint8Array} name
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.name = $util.newBuffer([]);

        /**
         * mobile_pay_info bankcode.
         * @member {Uint8Array} bankcode
         * @memberof net.mobile_pay_info
         * @instance
         */
        mobile_pay_info.prototype.bankcode = $util.newBuffer([]);

        /**
         * Encodes the specified mobile_pay_info message. Does not implicitly {@link net.mobile_pay_info.verify|verify} messages.
         * @function encode
         * @memberof net.mobile_pay_info
         * @static
         * @param {net.Imobile_pay_info} message mobile_pay_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        mobile_pay_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.paytype);
            if (message.accountname != null && Object.hasOwnProperty.call(message, "accountname"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.accountname);
            if (message.phoneno != null && Object.hasOwnProperty.call(message, "phoneno"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.phoneno);
            if (message.addfriendtype != null && Object.hasOwnProperty.call(message, "addfriendtype"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.addfriendtype);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.name);
            if (message.bankcode != null && Object.hasOwnProperty.call(message, "bankcode"))
                writer.uint32(/* id 8, wireType 2 =*/66).bytes(message.bankcode);
            return writer;
        };

        /**
         * Decodes a mobile_pay_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.mobile_pay_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.mobile_pay_info} mobile_pay_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        mobile_pay_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.mobile_pay_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.paytype = reader.int32();
                    break;
                case 4:
                    message.accountname = reader.bytes();
                    break;
                case 5:
                    message.phoneno = reader.bytes();
                    break;
                case 6:
                    message.addfriendtype = reader.int32();
                    break;
                case 7:
                    message.name = reader.bytes();
                    break;
                case 8:
                    message.bankcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return mobile_pay_info;
    })();

    net.goods_info = (function() {

        /**
         * Properties of a goods_info.
         * @memberof net
         * @interface Igoods_info
         * @property {number|Long|null} [goodsid] goods_info goodsid
         * @property {number|null} [goodsvalue] goods_info goodsvalue
         * @property {number|null} [uid] goods_info uid
         * @property {number|null} [minlimit] goods_info minlimit
         * @property {number|null} [maxlimit] goods_info maxlimit
         * @property {number|null} [cointype] goods_info cointype
         * @property {number|null} [rate] goods_info rate
         * @property {number|null} [status] goods_info status
         * @property {number|null} [ptime] goods_info ptime
         * @property {Uint8Array|null} [username] goods_info username
         * @property {Array.<number>|null} [paylist] goods_info paylist
         * @property {Uint8Array|null} [headurl] goods_info headurl
         * @property {number|null} [dealnum] goods_info dealnum
         * @property {number|null} [goodstype] goods_info goodstype
         * @property {number|null} [outcointype] goods_info outcointype
         * @property {Array.<net.Imobile_pay_info>|null} [payinfolist] goods_info payinfolist
         */

        /**
         * Constructs a new goods_info.
         * @memberof net
         * @classdesc Represents a goods_info.
         * @implements Igoods_info
         * @constructor
         * @param {net.Igoods_info=} [properties] Properties to set
         */
        function goods_info(properties) {
            this.paylist = [];
            this.payinfolist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * goods_info goodsid.
         * @member {number|Long} goodsid
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * goods_info goodsvalue.
         * @member {number} goodsvalue
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.goodsvalue = 0;

        /**
         * goods_info uid.
         * @member {number} uid
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.uid = 0;

        /**
         * goods_info minlimit.
         * @member {number} minlimit
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.minlimit = 0;

        /**
         * goods_info maxlimit.
         * @member {number} maxlimit
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.maxlimit = 0;

        /**
         * goods_info cointype.
         * @member {number} cointype
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.cointype = 0;

        /**
         * goods_info rate.
         * @member {number} rate
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.rate = 0;

        /**
         * goods_info status.
         * @member {number} status
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.status = 0;

        /**
         * goods_info ptime.
         * @member {number} ptime
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.ptime = 0;

        /**
         * goods_info username.
         * @member {Uint8Array} username
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.username = $util.newBuffer([]);

        /**
         * goods_info paylist.
         * @member {Array.<number>} paylist
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.paylist = $util.emptyArray;

        /**
         * goods_info headurl.
         * @member {Uint8Array} headurl
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.headurl = $util.newBuffer([]);

        /**
         * goods_info dealnum.
         * @member {number} dealnum
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.dealnum = 0;

        /**
         * goods_info goodstype.
         * @member {number} goodstype
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.goodstype = 0;

        /**
         * goods_info outcointype.
         * @member {number} outcointype
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.outcointype = 0;

        /**
         * goods_info payinfolist.
         * @member {Array.<net.Imobile_pay_info>} payinfolist
         * @memberof net.goods_info
         * @instance
         */
        goods_info.prototype.payinfolist = $util.emptyArray;

        /**
         * Encodes the specified goods_info message. Does not implicitly {@link net.goods_info.verify|verify} messages.
         * @function encode
         * @memberof net.goods_info
         * @static
         * @param {net.Igoods_info} message goods_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        goods_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.goodsid);
            if (message.goodsvalue != null && Object.hasOwnProperty.call(message, "goodsvalue"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.goodsvalue);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            if (message.minlimit != null && Object.hasOwnProperty.call(message, "minlimit"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minlimit);
            if (message.maxlimit != null && Object.hasOwnProperty.call(message, "maxlimit"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxlimit);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.cointype);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.rate);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.ptime);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 10, wireType 2 =*/82).bytes(message.username);
            if (message.paylist != null && message.paylist.length)
                for (var i = 0; i < message.paylist.length; ++i)
                    writer.uint32(/* id 11, wireType 0 =*/88).int32(message.paylist[i]);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.headurl);
            if (message.dealnum != null && Object.hasOwnProperty.call(message, "dealnum"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.dealnum);
            if (message.goodstype != null && Object.hasOwnProperty.call(message, "goodstype"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.goodstype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.outcointype);
            if (message.payinfolist != null && message.payinfolist.length)
                for (var i = 0; i < message.payinfolist.length; ++i)
                    $root.net.mobile_pay_info.encode(message.payinfolist[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a goods_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.goods_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.goods_info} goods_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        goods_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.goods_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.goodsid = reader.int64();
                    break;
                case 2:
                    message.goodsvalue = reader.int32();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                case 4:
                    message.minlimit = reader.int32();
                    break;
                case 5:
                    message.maxlimit = reader.int32();
                    break;
                case 6:
                    message.cointype = reader.int32();
                    break;
                case 7:
                    message.rate = reader.int32();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.ptime = reader.int32();
                    break;
                case 10:
                    message.username = reader.bytes();
                    break;
                case 11:
                    if (!(message.paylist && message.paylist.length))
                        message.paylist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.paylist.push(reader.int32());
                    } else
                        message.paylist.push(reader.int32());
                    break;
                case 12:
                    message.headurl = reader.bytes();
                    break;
                case 13:
                    message.dealnum = reader.int32();
                    break;
                case 14:
                    message.goodstype = reader.int32();
                    break;
                case 15:
                    message.outcointype = reader.int32();
                    break;
                case 16:
                    if (!(message.payinfolist && message.payinfolist.length))
                        message.payinfolist = [];
                    message.payinfolist.push($root.net.mobile_pay_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return goods_info;
    })();

    net.order_info = (function() {

        /**
         * Properties of an order_info.
         * @memberof net
         * @interface Iorder_info
         * @property {number|Long|null} [orderid] order_info orderid
         * @property {number|Long|null} [goodsid] order_info goodsid
         * @property {number|null} [ordertype] order_info ordertype
         * @property {number|null} [buyer] order_info buyer
         * @property {number|null} [seller] order_info seller
         * @property {number|null} [status] order_info status
         * @property {number|null} [ordervalue] order_info ordervalue
         * @property {number|null} [expiretm] order_info expiretm
         * @property {number|null} [paytype] order_info paytype
         * @property {number|null} [rate] order_info rate
         * @property {number|null} [createtm] order_info createtm
         * @property {number|null} [cancelflag] order_info cancelflag
         * @property {number|null} [cointype] order_info cointype
         * @property {number|null} [outcointype] order_info outcointype
         */

        /**
         * Constructs a new order_info.
         * @memberof net
         * @classdesc Represents an order_info.
         * @implements Iorder_info
         * @constructor
         * @param {net.Iorder_info=} [properties] Properties to set
         */
        function order_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * order_info orderid.
         * @member {number|Long} orderid
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * order_info goodsid.
         * @member {number|Long} goodsid
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * order_info ordertype.
         * @member {number} ordertype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.ordertype = 0;

        /**
         * order_info buyer.
         * @member {number} buyer
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.buyer = 0;

        /**
         * order_info seller.
         * @member {number} seller
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.seller = 0;

        /**
         * order_info status.
         * @member {number} status
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.status = 0;

        /**
         * order_info ordervalue.
         * @member {number} ordervalue
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.ordervalue = 0;

        /**
         * order_info expiretm.
         * @member {number} expiretm
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.expiretm = 0;

        /**
         * order_info paytype.
         * @member {number} paytype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.paytype = 0;

        /**
         * order_info rate.
         * @member {number} rate
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.rate = 0;

        /**
         * order_info createtm.
         * @member {number} createtm
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.createtm = 0;

        /**
         * order_info cancelflag.
         * @member {number} cancelflag
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.cancelflag = 0;

        /**
         * order_info cointype.
         * @member {number} cointype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.cointype = 0;

        /**
         * order_info outcointype.
         * @member {number} outcointype
         * @memberof net.order_info
         * @instance
         */
        order_info.prototype.outcointype = 0;

        /**
         * Encodes the specified order_info message. Does not implicitly {@link net.order_info.verify|verify} messages.
         * @function encode
         * @memberof net.order_info
         * @static
         * @param {net.Iorder_info} message order_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        order_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.goodsid);
            if (message.ordertype != null && Object.hasOwnProperty.call(message, "ordertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ordertype);
            if (message.buyer != null && Object.hasOwnProperty.call(message, "buyer"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.buyer);
            if (message.seller != null && Object.hasOwnProperty.call(message, "seller"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.seller);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
            if (message.ordervalue != null && Object.hasOwnProperty.call(message, "ordervalue"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ordervalue);
            if (message.expiretm != null && Object.hasOwnProperty.call(message, "expiretm"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.expiretm);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.paytype);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.rate);
            if (message.createtm != null && Object.hasOwnProperty.call(message, "createtm"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.createtm);
            if (message.cancelflag != null && Object.hasOwnProperty.call(message, "cancelflag"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.cancelflag);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.outcointype);
            return writer;
        };

        /**
         * Decodes an order_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.order_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.order_info} order_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        order_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.order_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                case 2:
                    message.goodsid = reader.int64();
                    break;
                case 3:
                    message.ordertype = reader.int32();
                    break;
                case 4:
                    message.buyer = reader.int32();
                    break;
                case 5:
                    message.seller = reader.int32();
                    break;
                case 6:
                    message.status = reader.int32();
                    break;
                case 7:
                    message.ordervalue = reader.int32();
                    break;
                case 8:
                    message.expiretm = reader.int32();
                    break;
                case 9:
                    message.paytype = reader.int32();
                    break;
                case 10:
                    message.rate = reader.int32();
                    break;
                case 11:
                    message.createtm = reader.int32();
                    break;
                case 12:
                    message.cancelflag = reader.int32();
                    break;
                case 13:
                    message.cointype = reader.int32();
                    break;
                case 14:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return order_info;
    })();

    net.group_nickname_info = (function() {

        /**
         * Properties of a group_nickname_info.
         * @memberof net
         * @interface Igroup_nickname_info
         * @property {number|null} [uid] group_nickname_info uid
         * @property {Uint8Array|null} [nickname] group_nickname_info nickname
         */

        /**
         * Constructs a new group_nickname_info.
         * @memberof net
         * @classdesc Represents a group_nickname_info.
         * @implements Igroup_nickname_info
         * @constructor
         * @param {net.Igroup_nickname_info=} [properties] Properties to set
         */
        function group_nickname_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * group_nickname_info uid.
         * @member {number} uid
         * @memberof net.group_nickname_info
         * @instance
         */
        group_nickname_info.prototype.uid = 0;

        /**
         * group_nickname_info nickname.
         * @member {Uint8Array} nickname
         * @memberof net.group_nickname_info
         * @instance
         */
        group_nickname_info.prototype.nickname = $util.newBuffer([]);

        /**
         * Encodes the specified group_nickname_info message. Does not implicitly {@link net.group_nickname_info.verify|verify} messages.
         * @function encode
         * @memberof net.group_nickname_info
         * @static
         * @param {net.Igroup_nickname_info} message group_nickname_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        group_nickname_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            return writer;
        };

        /**
         * Decodes a group_nickname_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.group_nickname_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.group_nickname_info} group_nickname_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        group_nickname_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.group_nickname_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return group_nickname_info;
    })();

    net.customer_info = (function() {

        /**
         * Properties of a customer_info.
         * @memberof net
         * @interface Icustomer_info
         * @property {number|null} [customer_type] customer_info customer_type
         * @property {number|null} [uid] customer_info uid
         */

        /**
         * Constructs a new customer_info.
         * @memberof net
         * @classdesc Represents a customer_info.
         * @implements Icustomer_info
         * @constructor
         * @param {net.Icustomer_info=} [properties] Properties to set
         */
        function customer_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * customer_info customer_type.
         * @member {number} customer_type
         * @memberof net.customer_info
         * @instance
         */
        customer_info.prototype.customer_type = 0;

        /**
         * customer_info uid.
         * @member {number} uid
         * @memberof net.customer_info
         * @instance
         */
        customer_info.prototype.uid = 0;

        /**
         * Encodes the specified customer_info message. Does not implicitly {@link net.customer_info.verify|verify} messages.
         * @function encode
         * @memberof net.customer_info
         * @static
         * @param {net.Icustomer_info} message customer_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        customer_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customer_type != null && Object.hasOwnProperty.call(message, "customer_type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.customer_type);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a customer_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.customer_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.customer_info} customer_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        customer_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.customer_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.customer_type = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return customer_info;
    })();

    net.coin_info = (function() {

        /**
         * Properties of a coin_info.
         * @memberof net
         * @interface Icoin_info
         * @property {number|null} [cointype] coin_info cointype
         * @property {number|null} [coin] coin_info coin
         * @property {number|null} [freezecoin] coin_info freezecoin
         * @property {number|null} [shopcoin] coin_info shopcoin
         * @property {number|null} [shopfreezecoin] coin_info shopfreezecoin
         */

        /**
         * Constructs a new coin_info.
         * @memberof net
         * @classdesc Represents a coin_info.
         * @implements Icoin_info
         * @constructor
         * @param {net.Icoin_info=} [properties] Properties to set
         */
        function coin_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * coin_info cointype.
         * @member {number} cointype
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.cointype = 0;

        /**
         * coin_info coin.
         * @member {number} coin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.coin = 0;

        /**
         * coin_info freezecoin.
         * @member {number} freezecoin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.freezecoin = 0;

        /**
         * coin_info shopcoin.
         * @member {number} shopcoin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.shopcoin = 0;

        /**
         * coin_info shopfreezecoin.
         * @member {number} shopfreezecoin
         * @memberof net.coin_info
         * @instance
         */
        coin_info.prototype.shopfreezecoin = 0;

        /**
         * Encodes the specified coin_info message. Does not implicitly {@link net.coin_info.verify|verify} messages.
         * @function encode
         * @memberof net.coin_info
         * @static
         * @param {net.Icoin_info} message coin_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        coin_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cointype);
            if (message.coin != null && Object.hasOwnProperty.call(message, "coin"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.coin);
            if (message.freezecoin != null && Object.hasOwnProperty.call(message, "freezecoin"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.freezecoin);
            if (message.shopcoin != null && Object.hasOwnProperty.call(message, "shopcoin"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.shopcoin);
            if (message.shopfreezecoin != null && Object.hasOwnProperty.call(message, "shopfreezecoin"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.shopfreezecoin);
            return writer;
        };

        /**
         * Decodes a coin_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.coin_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.coin_info} coin_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        coin_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.coin_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cointype = reader.int32();
                    break;
                case 2:
                    message.coin = reader.int32();
                    break;
                case 3:
                    message.freezecoin = reader.int32();
                    break;
                case 4:
                    message.shopcoin = reader.int32();
                    break;
                case 5:
                    message.shopfreezecoin = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return coin_info;
    })();

    net.rate_info = (function() {

        /**
         * Properties of a rate_info.
         * @memberof net
         * @interface Irate_info
         * @property {number|null} [cointype] rate_info cointype
         * @property {number|null} [outcointype] rate_info outcointype
         * @property {number|null} [crate] rate_info crate
         * @property {number|null} [trate] rate_info trate
         * @property {number|null} [drate] rate_info drate
         * @property {number|null} [crate1] rate_info crate1
         * @property {number|null} [trate1] rate_info trate1
         * @property {number|null} [drate1] rate_info drate1
         */

        /**
         * Constructs a new rate_info.
         * @memberof net
         * @classdesc Represents a rate_info.
         * @implements Irate_info
         * @constructor
         * @param {net.Irate_info=} [properties] Properties to set
         */
        function rate_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * rate_info cointype.
         * @member {number} cointype
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.cointype = 0;

        /**
         * rate_info outcointype.
         * @member {number} outcointype
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.outcointype = 0;

        /**
         * rate_info crate.
         * @member {number} crate
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.crate = 0;

        /**
         * rate_info trate.
         * @member {number} trate
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.trate = 0;

        /**
         * rate_info drate.
         * @member {number} drate
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.drate = 0;

        /**
         * rate_info crate1.
         * @member {number} crate1
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.crate1 = 0;

        /**
         * rate_info trate1.
         * @member {number} trate1
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.trate1 = 0;

        /**
         * rate_info drate1.
         * @member {number} drate1
         * @memberof net.rate_info
         * @instance
         */
        rate_info.prototype.drate1 = 0;

        /**
         * Encodes the specified rate_info message. Does not implicitly {@link net.rate_info.verify|verify} messages.
         * @function encode
         * @memberof net.rate_info
         * @static
         * @param {net.Irate_info} message rate_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        rate_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.outcointype);
            if (message.crate != null && Object.hasOwnProperty.call(message, "crate"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.crate);
            if (message.trate != null && Object.hasOwnProperty.call(message, "trate"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.trate);
            if (message.drate != null && Object.hasOwnProperty.call(message, "drate"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.drate);
            if (message.crate1 != null && Object.hasOwnProperty.call(message, "crate1"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.crate1);
            if (message.trate1 != null && Object.hasOwnProperty.call(message, "trate1"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.trate1);
            if (message.drate1 != null && Object.hasOwnProperty.call(message, "drate1"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.drate1);
            return writer;
        };

        /**
         * Decodes a rate_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.rate_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.rate_info} rate_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        rate_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.rate_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cointype = reader.int32();
                    break;
                case 2:
                    message.outcointype = reader.int32();
                    break;
                case 3:
                    message.crate = reader.int32();
                    break;
                case 4:
                    message.trate = reader.int32();
                    break;
                case 5:
                    message.drate = reader.int32();
                    break;
                case 6:
                    message.crate1 = reader.int32();
                    break;
                case 7:
                    message.trate1 = reader.int32();
                    break;
                case 8:
                    message.drate1 = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return rate_info;
    })();

    net.goods_deal_data = (function() {

        /**
         * Properties of a goods_deal_data.
         * @memberof net
         * @interface Igoods_deal_data
         * @property {number|null} [cnum] goods_deal_data cnum
         * @property {number|null} [cval] goods_deal_data cval
         * @property {number|null} [tnum] goods_deal_data tnum
         * @property {number|null} [tval] goods_deal_data tval
         * @property {number|null} [innum] goods_deal_data innum
         * @property {number|null} [inval] goods_deal_data inval
         * @property {number|null} [outnum] goods_deal_data outnum
         * @property {number|null} [outval] goods_deal_data outval
         * @property {number|null} [cointype] goods_deal_data cointype
         */

        /**
         * Constructs a new goods_deal_data.
         * @memberof net
         * @classdesc Represents a goods_deal_data.
         * @implements Igoods_deal_data
         * @constructor
         * @param {net.Igoods_deal_data=} [properties] Properties to set
         */
        function goods_deal_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * goods_deal_data cnum.
         * @member {number} cnum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.cnum = 0;

        /**
         * goods_deal_data cval.
         * @member {number} cval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.cval = 0;

        /**
         * goods_deal_data tnum.
         * @member {number} tnum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.tnum = 0;

        /**
         * goods_deal_data tval.
         * @member {number} tval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.tval = 0;

        /**
         * goods_deal_data innum.
         * @member {number} innum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.innum = 0;

        /**
         * goods_deal_data inval.
         * @member {number} inval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.inval = 0;

        /**
         * goods_deal_data outnum.
         * @member {number} outnum
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.outnum = 0;

        /**
         * goods_deal_data outval.
         * @member {number} outval
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.outval = 0;

        /**
         * goods_deal_data cointype.
         * @member {number} cointype
         * @memberof net.goods_deal_data
         * @instance
         */
        goods_deal_data.prototype.cointype = 0;

        /**
         * Encodes the specified goods_deal_data message. Does not implicitly {@link net.goods_deal_data.verify|verify} messages.
         * @function encode
         * @memberof net.goods_deal_data
         * @static
         * @param {net.Igoods_deal_data} message goods_deal_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        goods_deal_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cnum != null && Object.hasOwnProperty.call(message, "cnum"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.cnum);
            if (message.cval != null && Object.hasOwnProperty.call(message, "cval"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cval);
            if (message.tnum != null && Object.hasOwnProperty.call(message, "tnum"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.tnum);
            if (message.tval != null && Object.hasOwnProperty.call(message, "tval"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.tval);
            if (message.innum != null && Object.hasOwnProperty.call(message, "innum"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.innum);
            if (message.inval != null && Object.hasOwnProperty.call(message, "inval"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.inval);
            if (message.outnum != null && Object.hasOwnProperty.call(message, "outnum"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.outnum);
            if (message.outval != null && Object.hasOwnProperty.call(message, "outval"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.outval);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.cointype);
            return writer;
        };

        /**
         * Decodes a goods_deal_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.goods_deal_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.goods_deal_data} goods_deal_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        goods_deal_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.goods_deal_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cnum = reader.int32();
                    break;
                case 2:
                    message.cval = reader.int32();
                    break;
                case 3:
                    message.tnum = reader.int32();
                    break;
                case 4:
                    message.tval = reader.int32();
                    break;
                case 5:
                    message.innum = reader.int32();
                    break;
                case 6:
                    message.inval = reader.int32();
                    break;
                case 7:
                    message.outnum = reader.int32();
                    break;
                case 8:
                    message.outval = reader.int32();
                    break;
                case 9:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return goods_deal_data;
    })();

    net.friend_state_info = (function() {

        /**
         * Properties of a friend_state_info.
         * @memberof net
         * @interface Ifriend_state_info
         * @property {number|null} [fuid] friend_state_info fuid
         * @property {number|null} [lastlogouttime] friend_state_info lastlogouttime
         */

        /**
         * Constructs a new friend_state_info.
         * @memberof net
         * @classdesc Represents a friend_state_info.
         * @implements Ifriend_state_info
         * @constructor
         * @param {net.Ifriend_state_info=} [properties] Properties to set
         */
        function friend_state_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * friend_state_info fuid.
         * @member {number} fuid
         * @memberof net.friend_state_info
         * @instance
         */
        friend_state_info.prototype.fuid = 0;

        /**
         * friend_state_info lastlogouttime.
         * @member {number} lastlogouttime
         * @memberof net.friend_state_info
         * @instance
         */
        friend_state_info.prototype.lastlogouttime = 0;

        /**
         * Encodes the specified friend_state_info message. Does not implicitly {@link net.friend_state_info.verify|verify} messages.
         * @function encode
         * @memberof net.friend_state_info
         * @static
         * @param {net.Ifriend_state_info} message friend_state_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        friend_state_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fuid);
            if (message.lastlogouttime != null && Object.hasOwnProperty.call(message, "lastlogouttime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.lastlogouttime);
            return writer;
        };

        /**
         * Decodes a friend_state_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.friend_state_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.friend_state_info} friend_state_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        friend_state_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.friend_state_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuid = reader.int32();
                    break;
                case 2:
                    message.lastlogouttime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return friend_state_info;
    })();

    net.chat_room_info = (function() {

        /**
         * Properties of a chat_room_info.
         * @memberof net
         * @interface Ichat_room_info
         * @property {number|null} [roomkey] chat_room_info roomkey
         * @property {number|null} [roomhost] chat_room_info roomhost
         * @property {number|null} [createtm] chat_room_info createtm
         * @property {Uint8Array|null} [roomname] chat_room_info roomname
         * @property {Uint8Array|null} [pic] chat_room_info pic
         * @property {number|null} [usercnt] chat_room_info usercnt
         */

        /**
         * Constructs a new chat_room_info.
         * @memberof net
         * @classdesc Represents a chat_room_info.
         * @implements Ichat_room_info
         * @constructor
         * @param {net.Ichat_room_info=} [properties] Properties to set
         */
        function chat_room_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * chat_room_info roomkey.
         * @member {number} roomkey
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.roomkey = 0;

        /**
         * chat_room_info roomhost.
         * @member {number} roomhost
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.roomhost = 0;

        /**
         * chat_room_info createtm.
         * @member {number} createtm
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.createtm = 0;

        /**
         * chat_room_info roomname.
         * @member {Uint8Array} roomname
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.roomname = $util.newBuffer([]);

        /**
         * chat_room_info pic.
         * @member {Uint8Array} pic
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.pic = $util.newBuffer([]);

        /**
         * chat_room_info usercnt.
         * @member {number} usercnt
         * @memberof net.chat_room_info
         * @instance
         */
        chat_room_info.prototype.usercnt = 0;

        /**
         * Encodes the specified chat_room_info message. Does not implicitly {@link net.chat_room_info.verify|verify} messages.
         * @function encode
         * @memberof net.chat_room_info
         * @static
         * @param {net.Ichat_room_info} message chat_room_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        chat_room_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.roomhost != null && Object.hasOwnProperty.call(message, "roomhost"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.roomhost);
            if (message.createtm != null && Object.hasOwnProperty.call(message, "createtm"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.createtm);
            if (message.roomname != null && Object.hasOwnProperty.call(message, "roomname"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.roomname);
            if (message.pic != null && Object.hasOwnProperty.call(message, "pic"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.pic);
            if (message.usercnt != null && Object.hasOwnProperty.call(message, "usercnt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.usercnt);
            return writer;
        };

        /**
         * Decodes a chat_room_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.chat_room_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.chat_room_info} chat_room_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        chat_room_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.chat_room_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.roomhost = reader.int32();
                    break;
                case 3:
                    message.createtm = reader.int32();
                    break;
                case 4:
                    message.roomname = reader.bytes();
                    break;
                case 5:
                    message.pic = reader.bytes();
                    break;
                case 6:
                    message.usercnt = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return chat_room_info;
    })();

    net.msg_heart_test = (function() {

        /**
         * Properties of a msg_heart_test.
         * @memberof net
         * @interface Imsg_heart_test
         * @property {number|null} [svr_time] msg_heart_test svr_time
         * @property {number|Long|null} [ms_time] msg_heart_test ms_time
         */

        /**
         * Constructs a new msg_heart_test.
         * @memberof net
         * @classdesc Represents a msg_heart_test.
         * @implements Imsg_heart_test
         * @constructor
         * @param {net.Imsg_heart_test=} [properties] Properties to set
         */
        function msg_heart_test(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_heart_test svr_time.
         * @member {number} svr_time
         * @memberof net.msg_heart_test
         * @instance
         */
        msg_heart_test.prototype.svr_time = 0;

        /**
         * msg_heart_test ms_time.
         * @member {number|Long} ms_time
         * @memberof net.msg_heart_test
         * @instance
         */
        msg_heart_test.prototype.ms_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_heart_test message. Does not implicitly {@link net.msg_heart_test.verify|verify} messages.
         * @function encode
         * @memberof net.msg_heart_test
         * @static
         * @param {net.Imsg_heart_test} message msg_heart_test message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_heart_test.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.svr_time != null && Object.hasOwnProperty.call(message, "svr_time"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.svr_time);
            if (message.ms_time != null && Object.hasOwnProperty.call(message, "ms_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ms_time);
            return writer;
        };

        /**
         * Decodes a msg_heart_test message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_heart_test
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_heart_test} msg_heart_test
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_heart_test.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_heart_test();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.svr_time = reader.uint32();
                    break;
                case 2:
                    message.ms_time = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_heart_test;
    })();

    net.msg_login_req = (function() {

        /**
         * Properties of a msg_login_req.
         * @memberof net
         * @interface Imsg_login_req
         * @property {number|null} [uid] msg_login_req uid
         * @property {Uint8Array|null} [fastkey] msg_login_req fastkey
         * @property {Uint8Array|null} [phonenum] msg_login_req phonenum
         * @property {Uint8Array|null} [deviceid] msg_login_req deviceid
         * @property {Uint8Array|null} [version] msg_login_req version
         */

        /**
         * Constructs a new msg_login_req.
         * @memberof net
         * @classdesc Represents a msg_login_req.
         * @implements Imsg_login_req
         * @constructor
         * @param {net.Imsg_login_req=} [properties] Properties to set
         */
        function msg_login_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_login_req uid.
         * @member {number} uid
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.uid = 0;

        /**
         * msg_login_req fastkey.
         * @member {Uint8Array} fastkey
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.fastkey = $util.newBuffer([]);

        /**
         * msg_login_req phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_login_req deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.deviceid = $util.newBuffer([]);

        /**
         * msg_login_req version.
         * @member {Uint8Array} version
         * @memberof net.msg_login_req
         * @instance
         */
        msg_login_req.prototype.version = $util.newBuffer([]);

        /**
         * Encodes the specified msg_login_req message. Does not implicitly {@link net.msg_login_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_login_req
         * @static
         * @param {net.Imsg_login_req} message msg_login_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.fastkey != null && Object.hasOwnProperty.call(message, "fastkey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.fastkey);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.phonenum);
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.deviceid);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.version);
            return writer;
        };

        /**
         * Decodes a msg_login_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_login_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_login_req} msg_login_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_login_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.fastkey = reader.bytes();
                    break;
                case 3:
                    message.phonenum = reader.bytes();
                    break;
                case 4:
                    message.deviceid = reader.bytes();
                    break;
                case 5:
                    message.version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_login_req;
    })();

    net.msg_login_rep = (function() {

        /**
         * Properties of a msg_login_rep.
         * @memberof net
         * @interface Imsg_login_rep
         * @property {number|null} [result] msg_login_rep result
         * @property {number|null} [server_time] msg_login_rep server_time
         * @property {Array.<net.Icustomer_info>|null} [customer_list] msg_login_rep customer_list
         * @property {number|Long|null} [ms_time] msg_login_rep ms_time
         */

        /**
         * Constructs a new msg_login_rep.
         * @memberof net
         * @classdesc Represents a msg_login_rep.
         * @implements Imsg_login_rep
         * @constructor
         * @param {net.Imsg_login_rep=} [properties] Properties to set
         */
        function msg_login_rep(properties) {
            this.customer_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_login_rep result.
         * @member {number} result
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.result = 0;

        /**
         * msg_login_rep server_time.
         * @member {number} server_time
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.server_time = 0;

        /**
         * msg_login_rep customer_list.
         * @member {Array.<net.Icustomer_info>} customer_list
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.customer_list = $util.emptyArray;

        /**
         * msg_login_rep ms_time.
         * @member {number|Long} ms_time
         * @memberof net.msg_login_rep
         * @instance
         */
        msg_login_rep.prototype.ms_time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_login_rep message. Does not implicitly {@link net.msg_login_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_login_rep
         * @static
         * @param {net.Imsg_login_rep} message msg_login_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.server_time != null && Object.hasOwnProperty.call(message, "server_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.server_time);
            if (message.customer_list != null && message.customer_list.length)
                for (var i = 0; i < message.customer_list.length; ++i)
                    $root.net.customer_info.encode(message.customer_list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.ms_time != null && Object.hasOwnProperty.call(message, "ms_time"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ms_time);
            return writer;
        };

        /**
         * Decodes a msg_login_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_login_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_login_rep} msg_login_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_login_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.server_time = reader.uint32();
                    break;
                case 3:
                    if (!(message.customer_list && message.customer_list.length))
                        message.customer_list = [];
                    message.customer_list.push($root.net.customer_info.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.ms_time = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_login_rep;
    })();

    net.msg_user_data_rep = (function() {

        /**
         * Properties of a msg_user_data_rep.
         * @memberof net
         * @interface Imsg_user_data_rep
         * @property {net.Ibase_info|null} [base_data] msg_user_data_rep base_data
         */

        /**
         * Constructs a new msg_user_data_rep.
         * @memberof net
         * @classdesc Represents a msg_user_data_rep.
         * @implements Imsg_user_data_rep
         * @constructor
         * @param {net.Imsg_user_data_rep=} [properties] Properties to set
         */
        function msg_user_data_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_user_data_rep base_data.
         * @member {net.Ibase_info|null|undefined} base_data
         * @memberof net.msg_user_data_rep
         * @instance
         */
        msg_user_data_rep.prototype.base_data = null;

        /**
         * Encodes the specified msg_user_data_rep message. Does not implicitly {@link net.msg_user_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_user_data_rep
         * @static
         * @param {net.Imsg_user_data_rep} message msg_user_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_user_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.base_data != null && Object.hasOwnProperty.call(message, "base_data"))
                $root.net.base_info.encode(message.base_data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_user_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_user_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_user_data_rep} msg_user_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_user_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_user_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.base_data = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_user_data_rep;
    })();

    net.msg_add_friend_nty = (function() {

        /**
         * Properties of a msg_add_friend_nty.
         * @memberof net
         * @interface Imsg_add_friend_nty
         * @property {number|null} [uid] msg_add_friend_nty uid
         */

        /**
         * Constructs a new msg_add_friend_nty.
         * @memberof net
         * @classdesc Represents a msg_add_friend_nty.
         * @implements Imsg_add_friend_nty
         * @constructor
         * @param {net.Imsg_add_friend_nty=} [properties] Properties to set
         */
        function msg_add_friend_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_nty uid.
         * @member {number} uid
         * @memberof net.msg_add_friend_nty
         * @instance
         */
        msg_add_friend_nty.prototype.uid = 0;

        /**
         * Encodes the specified msg_add_friend_nty message. Does not implicitly {@link net.msg_add_friend_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {net.Imsg_add_friend_nty} message msg_add_friend_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_add_friend_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_nty} msg_add_friend_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_add_friend_nty;
    })();

    net.msg_add_friend = (function() {

        /**
         * Properties of a msg_add_friend.
         * @memberof net
         * @interface Imsg_add_friend
         * @property {Uint8Array|null} [phonenum] msg_add_friend phonenum
         * @property {Uint8Array|null} [hellomsg] msg_add_friend hellomsg
         */

        /**
         * Constructs a new msg_add_friend.
         * @memberof net
         * @classdesc Represents a msg_add_friend.
         * @implements Imsg_add_friend
         * @constructor
         * @param {net.Imsg_add_friend=} [properties] Properties to set
         */
        function msg_add_friend(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_add_friend
         * @instance
         */
        msg_add_friend.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_add_friend hellomsg.
         * @member {Uint8Array} hellomsg
         * @memberof net.msg_add_friend
         * @instance
         */
        msg_add_friend.prototype.hellomsg = $util.newBuffer([]);

        /**
         * Encodes the specified msg_add_friend message. Does not implicitly {@link net.msg_add_friend.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend
         * @static
         * @param {net.Imsg_add_friend} message msg_add_friend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.phonenum);
            if (message.hellomsg != null && Object.hasOwnProperty.call(message, "hellomsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.hellomsg);
            return writer;
        };

        /**
         * Decodes a msg_add_friend message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend} msg_add_friend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.phonenum = reader.bytes();
                    break;
                case 2:
                    message.hellomsg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_add_friend;
    })();

    net.msg_add_friend_rep = (function() {

        /**
         * Properties of a msg_add_friend_rep.
         * @memberof net
         * @interface Imsg_add_friend_rep
         * @property {number|null} [result] msg_add_friend_rep result
         */

        /**
         * Constructs a new msg_add_friend_rep.
         * @memberof net
         * @classdesc Represents a msg_add_friend_rep.
         * @implements Imsg_add_friend_rep
         * @constructor
         * @param {net.Imsg_add_friend_rep=} [properties] Properties to set
         */
        function msg_add_friend_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_rep result.
         * @member {number} result
         * @memberof net.msg_add_friend_rep
         * @instance
         */
        msg_add_friend_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_add_friend_rep message. Does not implicitly {@link net.msg_add_friend_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {net.Imsg_add_friend_rep} message msg_add_friend_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_add_friend_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_rep} msg_add_friend_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_add_friend_rep;
    })();

    net.msg_handle_friend_apply = (function() {

        /**
         * Properties of a msg_handle_friend_apply.
         * @memberof net
         * @interface Imsg_handle_friend_apply
         * @property {number|null} [otheruid] msg_handle_friend_apply otheruid
         * @property {number|null} [handletype] msg_handle_friend_apply handletype
         */

        /**
         * Constructs a new msg_handle_friend_apply.
         * @memberof net
         * @classdesc Represents a msg_handle_friend_apply.
         * @implements Imsg_handle_friend_apply
         * @constructor
         * @param {net.Imsg_handle_friend_apply=} [properties] Properties to set
         */
        function msg_handle_friend_apply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_handle_friend_apply otheruid.
         * @member {number} otheruid
         * @memberof net.msg_handle_friend_apply
         * @instance
         */
        msg_handle_friend_apply.prototype.otheruid = 0;

        /**
         * msg_handle_friend_apply handletype.
         * @member {number} handletype
         * @memberof net.msg_handle_friend_apply
         * @instance
         */
        msg_handle_friend_apply.prototype.handletype = 0;

        /**
         * Encodes the specified msg_handle_friend_apply message. Does not implicitly {@link net.msg_handle_friend_apply.verify|verify} messages.
         * @function encode
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {net.Imsg_handle_friend_apply} message msg_handle_friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_apply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.otheruid);
            if (message.handletype != null && Object.hasOwnProperty.call(message, "handletype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.handletype);
            return writer;
        };

        /**
         * Decodes a msg_handle_friend_apply message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_handle_friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_handle_friend_apply} msg_handle_friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_apply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_handle_friend_apply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.otheruid = reader.int32();
                    break;
                case 2:
                    message.handletype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_handle_friend_apply;
    })();

    net.msg_handle_friend_apply_rep = (function() {

        /**
         * Properties of a msg_handle_friend_apply_rep.
         * @memberof net
         * @interface Imsg_handle_friend_apply_rep
         * @property {number|null} [result] msg_handle_friend_apply_rep result
         * @property {number|null} [otheruid] msg_handle_friend_apply_rep otheruid
         * @property {number|null} [handletype] msg_handle_friend_apply_rep handletype
         */

        /**
         * Constructs a new msg_handle_friend_apply_rep.
         * @memberof net
         * @classdesc Represents a msg_handle_friend_apply_rep.
         * @implements Imsg_handle_friend_apply_rep
         * @constructor
         * @param {net.Imsg_handle_friend_apply_rep=} [properties] Properties to set
         */
        function msg_handle_friend_apply_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_handle_friend_apply_rep result.
         * @member {number} result
         * @memberof net.msg_handle_friend_apply_rep
         * @instance
         */
        msg_handle_friend_apply_rep.prototype.result = 0;

        /**
         * msg_handle_friend_apply_rep otheruid.
         * @member {number} otheruid
         * @memberof net.msg_handle_friend_apply_rep
         * @instance
         */
        msg_handle_friend_apply_rep.prototype.otheruid = 0;

        /**
         * msg_handle_friend_apply_rep handletype.
         * @member {number} handletype
         * @memberof net.msg_handle_friend_apply_rep
         * @instance
         */
        msg_handle_friend_apply_rep.prototype.handletype = 0;

        /**
         * Encodes the specified msg_handle_friend_apply_rep message. Does not implicitly {@link net.msg_handle_friend_apply_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {net.Imsg_handle_friend_apply_rep} message msg_handle_friend_apply_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_apply_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.handletype != null && Object.hasOwnProperty.call(message, "handletype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.handletype);
            return writer;
        };

        /**
         * Decodes a msg_handle_friend_apply_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_handle_friend_apply_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_handle_friend_apply_rep} msg_handle_friend_apply_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_apply_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_handle_friend_apply_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.handletype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_handle_friend_apply_rep;
    })();

    net.msg_friend_apply_list = (function() {

        /**
         * Properties of a msg_friend_apply_list.
         * @memberof net
         * @interface Imsg_friend_apply_list
         */

        /**
         * Constructs a new msg_friend_apply_list.
         * @memberof net
         * @classdesc Represents a msg_friend_apply_list.
         * @implements Imsg_friend_apply_list
         * @constructor
         * @param {net.Imsg_friend_apply_list=} [properties] Properties to set
         */
        function msg_friend_apply_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_friend_apply_list message. Does not implicitly {@link net.msg_friend_apply_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {net.Imsg_friend_apply_list} message msg_friend_apply_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_apply_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_friend_apply_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_apply_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_apply_list} msg_friend_apply_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_apply_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_apply_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_friend_apply_list;
    })();

    net.msg_friend_apply_list_rep = (function() {

        /**
         * Properties of a msg_friend_apply_list_rep.
         * @memberof net
         * @interface Imsg_friend_apply_list_rep
         * @property {Array.<net.Ifriend_apply>|null} [apply_list] msg_friend_apply_list_rep apply_list
         */

        /**
         * Constructs a new msg_friend_apply_list_rep.
         * @memberof net
         * @classdesc Represents a msg_friend_apply_list_rep.
         * @implements Imsg_friend_apply_list_rep
         * @constructor
         * @param {net.Imsg_friend_apply_list_rep=} [properties] Properties to set
         */
        function msg_friend_apply_list_rep(properties) {
            this.apply_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_friend_apply_list_rep apply_list.
         * @member {Array.<net.Ifriend_apply>} apply_list
         * @memberof net.msg_friend_apply_list_rep
         * @instance
         */
        msg_friend_apply_list_rep.prototype.apply_list = $util.emptyArray;

        /**
         * Encodes the specified msg_friend_apply_list_rep message. Does not implicitly {@link net.msg_friend_apply_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {net.Imsg_friend_apply_list_rep} message msg_friend_apply_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_apply_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.apply_list != null && message.apply_list.length)
                for (var i = 0; i < message.apply_list.length; ++i)
                    $root.net.friend_apply.encode(message.apply_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_friend_apply_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_apply_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_apply_list_rep} msg_friend_apply_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_apply_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_apply_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.apply_list && message.apply_list.length))
                        message.apply_list = [];
                    message.apply_list.push($root.net.friend_apply.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_friend_apply_list_rep;
    })();

    net.msg_friend_list = (function() {

        /**
         * Properties of a msg_friend_list.
         * @memberof net
         * @interface Imsg_friend_list
         */

        /**
         * Constructs a new msg_friend_list.
         * @memberof net
         * @classdesc Represents a msg_friend_list.
         * @implements Imsg_friend_list
         * @constructor
         * @param {net.Imsg_friend_list=} [properties] Properties to set
         */
        function msg_friend_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_friend_list message. Does not implicitly {@link net.msg_friend_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_list
         * @static
         * @param {net.Imsg_friend_list} message msg_friend_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_friend_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_list} msg_friend_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_friend_list;
    })();

    net.msg_friend_list_rep = (function() {

        /**
         * Properties of a msg_friend_list_rep.
         * @memberof net
         * @interface Imsg_friend_list_rep
         * @property {Array.<net.Ibase_info>|null} [flist] msg_friend_list_rep flist
         * @property {number|null} [isfirst] msg_friend_list_rep isfirst
         * @property {number|null} [isend] msg_friend_list_rep isend
         * @property {number|null} [version] msg_friend_list_rep version
         */

        /**
         * Constructs a new msg_friend_list_rep.
         * @memberof net
         * @classdesc Represents a msg_friend_list_rep.
         * @implements Imsg_friend_list_rep
         * @constructor
         * @param {net.Imsg_friend_list_rep=} [properties] Properties to set
         */
        function msg_friend_list_rep(properties) {
            this.flist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_friend_list_rep flist.
         * @member {Array.<net.Ibase_info>} flist
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.flist = $util.emptyArray;

        /**
         * msg_friend_list_rep isfirst.
         * @member {number} isfirst
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.isfirst = 0;

        /**
         * msg_friend_list_rep isend.
         * @member {number} isend
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.isend = 0;

        /**
         * msg_friend_list_rep version.
         * @member {number} version
         * @memberof net.msg_friend_list_rep
         * @instance
         */
        msg_friend_list_rep.prototype.version = 0;

        /**
         * Encodes the specified msg_friend_list_rep message. Does not implicitly {@link net.msg_friend_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {net.Imsg_friend_list_rep} message msg_friend_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.flist != null && message.flist.length)
                for (var i = 0; i < message.flist.length; ++i)
                    $root.net.base_info.encode(message.flist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.isend);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.version);
            return writer;
        };

        /**
         * Decodes a msg_friend_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_list_rep} msg_friend_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.flist && message.flist.length))
                        message.flist = [];
                    message.flist.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    message.isend = reader.int32();
                    break;
                case 4:
                    message.version = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_friend_list_rep;
    })();

    net.msg_get_user_info = (function() {

        /**
         * Properties of a msg_get_user_info.
         * @memberof net
         * @interface Imsg_get_user_info
         * @property {Uint8Array|null} [phonenum] msg_get_user_info phonenum
         * @property {number|null} [uid] msg_get_user_info uid
         * @property {number|null} [fid] msg_get_user_info fid
         * @property {number|null} [channel] msg_get_user_info channel
         * @property {number|null} [thirduid] msg_get_user_info thirduid
         * @property {Uint8Array|null} [zone] msg_get_user_info zone
         */

        /**
         * Constructs a new msg_get_user_info.
         * @memberof net
         * @classdesc Represents a msg_get_user_info.
         * @implements Imsg_get_user_info
         * @constructor
         * @param {net.Imsg_get_user_info=} [properties] Properties to set
         */
        function msg_get_user_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_user_info phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_get_user_info uid.
         * @member {number} uid
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.uid = 0;

        /**
         * msg_get_user_info fid.
         * @member {number} fid
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.fid = 0;

        /**
         * msg_get_user_info channel.
         * @member {number} channel
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.channel = 0;

        /**
         * msg_get_user_info thirduid.
         * @member {number} thirduid
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.thirduid = 0;

        /**
         * msg_get_user_info zone.
         * @member {Uint8Array} zone
         * @memberof net.msg_get_user_info
         * @instance
         */
        msg_get_user_info.prototype.zone = $util.newBuffer([]);

        /**
         * Encodes the specified msg_get_user_info message. Does not implicitly {@link net.msg_get_user_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_user_info
         * @static
         * @param {net.Imsg_get_user_info} message msg_get_user_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_user_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.phonenum);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.fid != null && Object.hasOwnProperty.call(message, "fid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.fid);
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.channel);
            if (message.thirduid != null && Object.hasOwnProperty.call(message, "thirduid"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.thirduid);
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.zone);
            return writer;
        };

        /**
         * Decodes a msg_get_user_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_user_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_user_info} msg_get_user_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_user_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_user_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.phonenum = reader.bytes();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.fid = reader.int32();
                    break;
                case 4:
                    message.channel = reader.uint32();
                    break;
                case 5:
                    message.thirduid = reader.uint32();
                    break;
                case 6:
                    message.zone = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_user_info;
    })();

    net.msg_get_user_info_rep = (function() {

        /**
         * Properties of a msg_get_user_info_rep.
         * @memberof net
         * @interface Imsg_get_user_info_rep
         * @property {net.Ibase_info|null} [user_info] msg_get_user_info_rep user_info
         */

        /**
         * Constructs a new msg_get_user_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_user_info_rep.
         * @implements Imsg_get_user_info_rep
         * @constructor
         * @param {net.Imsg_get_user_info_rep=} [properties] Properties to set
         */
        function msg_get_user_info_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_user_info_rep user_info.
         * @member {net.Ibase_info|null|undefined} user_info
         * @memberof net.msg_get_user_info_rep
         * @instance
         */
        msg_get_user_info_rep.prototype.user_info = null;

        /**
         * Encodes the specified msg_get_user_info_rep message. Does not implicitly {@link net.msg_get_user_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {net.Imsg_get_user_info_rep} message msg_get_user_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_user_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.user_info != null && Object.hasOwnProperty.call(message, "user_info"))
                $root.net.base_info.encode(message.user_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_user_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_user_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_user_info_rep} msg_get_user_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_user_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_user_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.user_info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_user_info_rep;
    })();

    net.msg_send_private_msg = (function() {

        /**
         * Properties of a msg_send_private_msg.
         * @memberof net
         * @interface Imsg_send_private_msg
         * @property {number|null} [recvuid] msg_send_private_msg recvuid
         * @property {number|null} [msg_type] msg_send_private_msg msg_type
         * @property {Uint8Array|null} [content] msg_send_private_msg content
         * @property {Uint8Array|null} [clientkey] msg_send_private_msg clientkey
         * @property {number|null} [nopush] msg_send_private_msg nopush
         * @property {Uint8Array|null} [authcode] msg_send_private_msg authcode
         */

        /**
         * Constructs a new msg_send_private_msg.
         * @memberof net
         * @classdesc Represents a msg_send_private_msg.
         * @implements Imsg_send_private_msg
         * @constructor
         * @param {net.Imsg_send_private_msg=} [properties] Properties to set
         */
        function msg_send_private_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_private_msg recvuid.
         * @member {number} recvuid
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.recvuid = 0;

        /**
         * msg_send_private_msg msg_type.
         * @member {number} msg_type
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.msg_type = 0;

        /**
         * msg_send_private_msg content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.content = $util.newBuffer([]);

        /**
         * msg_send_private_msg clientkey.
         * @member {Uint8Array} clientkey
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.clientkey = $util.newBuffer([]);

        /**
         * msg_send_private_msg nopush.
         * @member {number} nopush
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.nopush = 0;

        /**
         * msg_send_private_msg authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_send_private_msg
         * @instance
         */
        msg_send_private_msg.prototype.authcode = $util.newBuffer([]);

        /**
         * Encodes the specified msg_send_private_msg message. Does not implicitly {@link net.msg_send_private_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_private_msg
         * @static
         * @param {net.Imsg_send_private_msg} message msg_send_private_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_private_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recvuid != null && Object.hasOwnProperty.call(message, "recvuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.recvuid);
            if (message.msg_type != null && Object.hasOwnProperty.call(message, "msg_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msg_type);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
            if (message.clientkey != null && Object.hasOwnProperty.call(message, "clientkey"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.clientkey);
            if (message.nopush != null && Object.hasOwnProperty.call(message, "nopush"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.nopush);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.authcode);
            return writer;
        };

        /**
         * Decodes a msg_send_private_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_private_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_private_msg} msg_send_private_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_private_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_private_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.recvuid = reader.int32();
                    break;
                case 2:
                    message.msg_type = reader.int32();
                    break;
                case 3:
                    message.content = reader.bytes();
                    break;
                case 4:
                    message.clientkey = reader.bytes();
                    break;
                case 5:
                    message.nopush = reader.int32();
                    break;
                case 6:
                    message.authcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_private_msg;
    })();

    net.msg_send_private_msg_rep = (function() {

        /**
         * Properties of a msg_send_private_msg_rep.
         * @memberof net
         * @interface Imsg_send_private_msg_rep
         * @property {number|null} [result] msg_send_private_msg_rep result
         * @property {net.Ichat_msg|null} [msg_info] msg_send_private_msg_rep msg_info
         */

        /**
         * Constructs a new msg_send_private_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_send_private_msg_rep.
         * @implements Imsg_send_private_msg_rep
         * @constructor
         * @param {net.Imsg_send_private_msg_rep=} [properties] Properties to set
         */
        function msg_send_private_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_private_msg_rep result.
         * @member {number} result
         * @memberof net.msg_send_private_msg_rep
         * @instance
         */
        msg_send_private_msg_rep.prototype.result = 0;

        /**
         * msg_send_private_msg_rep msg_info.
         * @member {net.Ichat_msg|null|undefined} msg_info
         * @memberof net.msg_send_private_msg_rep
         * @instance
         */
        msg_send_private_msg_rep.prototype.msg_info = null;

        /**
         * Encodes the specified msg_send_private_msg_rep message. Does not implicitly {@link net.msg_send_private_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {net.Imsg_send_private_msg_rep} message msg_send_private_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_private_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.msg_info != null && Object.hasOwnProperty.call(message, "msg_info"))
                $root.net.chat_msg.encode(message.msg_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_send_private_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_private_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_private_msg_rep} msg_send_private_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_private_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_private_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.msg_info = $root.net.chat_msg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_private_msg_rep;
    })();

    net.msg_get_msg_list = (function() {

        /**
         * Properties of a msg_get_msg_list.
         * @memberof net
         * @interface Imsg_get_msg_list
         * @property {number|Long|null} [chatkey] msg_get_msg_list chatkey
         * @property {number|null} [chatmsgno] msg_get_msg_list chatmsgno
         */

        /**
         * Constructs a new msg_get_msg_list.
         * @memberof net
         * @classdesc Represents a msg_get_msg_list.
         * @implements Imsg_get_msg_list
         * @constructor
         * @param {net.Imsg_get_msg_list=} [properties] Properties to set
         */
        function msg_get_msg_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_msg_list chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_msg_list
         * @instance
         */
        msg_get_msg_list.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_msg_list chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_get_msg_list
         * @instance
         */
        msg_get_msg_list.prototype.chatmsgno = 0;

        /**
         * Encodes the specified msg_get_msg_list message. Does not implicitly {@link net.msg_get_msg_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_msg_list
         * @static
         * @param {net.Imsg_get_msg_list} message msg_get_msg_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_msg_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Decodes a msg_get_msg_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_msg_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_msg_list} msg_get_msg_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_msg_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_msg_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_msg_list;
    })();

    net.msg_get_msg_list_rep = (function() {

        /**
         * Properties of a msg_get_msg_list_rep.
         * @memberof net
         * @interface Imsg_get_msg_list_rep
         * @property {Array.<net.Ichat_msg>|null} [msg_list] msg_get_msg_list_rep msg_list
         * @property {number|null} [hasred] msg_get_msg_list_rep hasred
         * @property {number|null} [readversion] msg_get_msg_list_rep readversion
         */

        /**
         * Constructs a new msg_get_msg_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_msg_list_rep.
         * @implements Imsg_get_msg_list_rep
         * @constructor
         * @param {net.Imsg_get_msg_list_rep=} [properties] Properties to set
         */
        function msg_get_msg_list_rep(properties) {
            this.msg_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_msg_list_rep msg_list.
         * @member {Array.<net.Ichat_msg>} msg_list
         * @memberof net.msg_get_msg_list_rep
         * @instance
         */
        msg_get_msg_list_rep.prototype.msg_list = $util.emptyArray;

        /**
         * msg_get_msg_list_rep hasred.
         * @member {number} hasred
         * @memberof net.msg_get_msg_list_rep
         * @instance
         */
        msg_get_msg_list_rep.prototype.hasred = 0;

        /**
         * msg_get_msg_list_rep readversion.
         * @member {number} readversion
         * @memberof net.msg_get_msg_list_rep
         * @instance
         */
        msg_get_msg_list_rep.prototype.readversion = 0;

        /**
         * Encodes the specified msg_get_msg_list_rep message. Does not implicitly {@link net.msg_get_msg_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {net.Imsg_get_msg_list_rep} message msg_get_msg_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_msg_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.msg_list != null && message.msg_list.length)
                for (var i = 0; i < message.msg_list.length; ++i)
                    $root.net.chat_msg.encode(message.msg_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.hasred != null && Object.hasOwnProperty.call(message, "hasred"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.hasred);
            if (message.readversion != null && Object.hasOwnProperty.call(message, "readversion"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.readversion);
            return writer;
        };

        /**
         * Decodes a msg_get_msg_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_msg_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_msg_list_rep} msg_get_msg_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_msg_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_msg_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.msg_list && message.msg_list.length))
                        message.msg_list = [];
                    message.msg_list.push($root.net.chat_msg.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.hasred = reader.int32();
                    break;
                case 3:
                    message.readversion = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_msg_list_rep;
    })();

    net.msg_confirm_read_msg = (function() {

        /**
         * Properties of a msg_confirm_read_msg.
         * @memberof net
         * @interface Imsg_confirm_read_msg
         * @property {number|Long|null} [chatkey] msg_confirm_read_msg chatkey
         * @property {number|null} [chatmsgno] msg_confirm_read_msg chatmsgno
         */

        /**
         * Constructs a new msg_confirm_read_msg.
         * @memberof net
         * @classdesc Represents a msg_confirm_read_msg.
         * @implements Imsg_confirm_read_msg
         * @constructor
         * @param {net.Imsg_confirm_read_msg=} [properties] Properties to set
         */
        function msg_confirm_read_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_read_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_read_msg
         * @instance
         */
        msg_confirm_read_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_read_msg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_confirm_read_msg
         * @instance
         */
        msg_confirm_read_msg.prototype.chatmsgno = 0;

        /**
         * Encodes the specified msg_confirm_read_msg message. Does not implicitly {@link net.msg_confirm_read_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {net.Imsg_confirm_read_msg} message msg_confirm_read_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_read_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Decodes a msg_confirm_read_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_read_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_read_msg} msg_confirm_read_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_read_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_read_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_read_msg;
    })();

    net.msg_confirm_read_msg_rep = (function() {

        /**
         * Properties of a msg_confirm_read_msg_rep.
         * @memberof net
         * @interface Imsg_confirm_read_msg_rep
         * @property {number|null} [result] msg_confirm_read_msg_rep result
         */

        /**
         * Constructs a new msg_confirm_read_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_read_msg_rep.
         * @implements Imsg_confirm_read_msg_rep
         * @constructor
         * @param {net.Imsg_confirm_read_msg_rep=} [properties] Properties to set
         */
        function msg_confirm_read_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_read_msg_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_read_msg_rep
         * @instance
         */
        msg_confirm_read_msg_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_confirm_read_msg_rep message. Does not implicitly {@link net.msg_confirm_read_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {net.Imsg_confirm_read_msg_rep} message msg_confirm_read_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_read_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_confirm_read_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_read_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_read_msg_rep} msg_confirm_read_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_read_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_read_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_read_msg_rep;
    })();

    net.msg_create_group_chat = (function() {

        /**
         * Properties of a msg_create_group_chat.
         * @memberof net
         * @interface Imsg_create_group_chat
         * @property {Array.<number>|null} [uids] msg_create_group_chat uids
         * @property {number|null} [opertm] msg_create_group_chat opertm
         */

        /**
         * Constructs a new msg_create_group_chat.
         * @memberof net
         * @classdesc Represents a msg_create_group_chat.
         * @implements Imsg_create_group_chat
         * @constructor
         * @param {net.Imsg_create_group_chat=} [properties] Properties to set
         */
        function msg_create_group_chat(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_group_chat uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_create_group_chat
         * @instance
         */
        msg_create_group_chat.prototype.uids = $util.emptyArray;

        /**
         * msg_create_group_chat opertm.
         * @member {number} opertm
         * @memberof net.msg_create_group_chat
         * @instance
         */
        msg_create_group_chat.prototype.opertm = 0;

        /**
         * Encodes the specified msg_create_group_chat message. Does not implicitly {@link net.msg_create_group_chat.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_group_chat
         * @static
         * @param {net.Imsg_create_group_chat} message msg_create_group_chat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_group_chat.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uids[i]);
            if (message.opertm != null && Object.hasOwnProperty.call(message, "opertm"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.opertm);
            return writer;
        };

        /**
         * Decodes a msg_create_group_chat message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_group_chat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_group_chat} msg_create_group_chat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_group_chat.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_group_chat();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                case 2:
                    message.opertm = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_create_group_chat;
    })();

    net.msg_create_group_chat_rep = (function() {

        /**
         * Properties of a msg_create_group_chat_rep.
         * @memberof net
         * @interface Imsg_create_group_chat_rep
         * @property {number|null} [result] msg_create_group_chat_rep result
         * @property {net.Igroup_base_info|null} [group_info] msg_create_group_chat_rep group_info
         * @property {Array.<net.Ibase_info>|null} [users] msg_create_group_chat_rep users
         */

        /**
         * Constructs a new msg_create_group_chat_rep.
         * @memberof net
         * @classdesc Represents a msg_create_group_chat_rep.
         * @implements Imsg_create_group_chat_rep
         * @constructor
         * @param {net.Imsg_create_group_chat_rep=} [properties] Properties to set
         */
        function msg_create_group_chat_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_group_chat_rep result.
         * @member {number} result
         * @memberof net.msg_create_group_chat_rep
         * @instance
         */
        msg_create_group_chat_rep.prototype.result = 0;

        /**
         * msg_create_group_chat_rep group_info.
         * @member {net.Igroup_base_info|null|undefined} group_info
         * @memberof net.msg_create_group_chat_rep
         * @instance
         */
        msg_create_group_chat_rep.prototype.group_info = null;

        /**
         * msg_create_group_chat_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_create_group_chat_rep
         * @instance
         */
        msg_create_group_chat_rep.prototype.users = $util.emptyArray;

        /**
         * Encodes the specified msg_create_group_chat_rep message. Does not implicitly {@link net.msg_create_group_chat_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {net.Imsg_create_group_chat_rep} message msg_create_group_chat_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_group_chat_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.group_info != null && Object.hasOwnProperty.call(message, "group_info"))
                $root.net.group_base_info.encode(message.group_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_create_group_chat_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_group_chat_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_group_chat_rep} msg_create_group_chat_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_group_chat_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_group_chat_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.group_info = $root.net.group_base_info.decode(reader, reader.uint32());
                    break;
                case 3:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_create_group_chat_rep;
    })();

    net.msg_add_group_member = (function() {

        /**
         * Properties of a msg_add_group_member.
         * @memberof net
         * @interface Imsg_add_group_member
         * @property {number|null} [groupkey] msg_add_group_member groupkey
         * @property {Array.<number>|null} [uids] msg_add_group_member uids
         */

        /**
         * Constructs a new msg_add_group_member.
         * @memberof net
         * @classdesc Represents a msg_add_group_member.
         * @implements Imsg_add_group_member
         * @constructor
         * @param {net.Imsg_add_group_member=} [properties] Properties to set
         */
        function msg_add_group_member(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_group_member groupkey.
         * @member {number} groupkey
         * @memberof net.msg_add_group_member
         * @instance
         */
        msg_add_group_member.prototype.groupkey = 0;

        /**
         * msg_add_group_member uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_add_group_member
         * @instance
         */
        msg_add_group_member.prototype.uids = $util.emptyArray;

        /**
         * Encodes the specified msg_add_group_member message. Does not implicitly {@link net.msg_add_group_member.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_group_member
         * @static
         * @param {net.Imsg_add_group_member} message msg_add_group_member message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_group_member.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uids[i]);
            return writer;
        };

        /**
         * Decodes a msg_add_group_member message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_group_member
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_group_member} msg_add_group_member
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_group_member.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_group_member();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_add_group_member;
    })();

    net.msg_add_group_member_rep = (function() {

        /**
         * Properties of a msg_add_group_member_rep.
         * @memberof net
         * @interface Imsg_add_group_member_rep
         * @property {number|null} [result] msg_add_group_member_rep result
         */

        /**
         * Constructs a new msg_add_group_member_rep.
         * @memberof net
         * @classdesc Represents a msg_add_group_member_rep.
         * @implements Imsg_add_group_member_rep
         * @constructor
         * @param {net.Imsg_add_group_member_rep=} [properties] Properties to set
         */
        function msg_add_group_member_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_group_member_rep result.
         * @member {number} result
         * @memberof net.msg_add_group_member_rep
         * @instance
         */
        msg_add_group_member_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_add_group_member_rep message. Does not implicitly {@link net.msg_add_group_member_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {net.Imsg_add_group_member_rep} message msg_add_group_member_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_group_member_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_add_group_member_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_group_member_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_group_member_rep} msg_add_group_member_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_group_member_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_group_member_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_add_group_member_rep;
    })();

    net.msg_del_group_member = (function() {

        /**
         * Properties of a msg_del_group_member.
         * @memberof net
         * @interface Imsg_del_group_member
         * @property {number|null} [groupkey] msg_del_group_member groupkey
         * @property {Array.<number>|null} [uids] msg_del_group_member uids
         */

        /**
         * Constructs a new msg_del_group_member.
         * @memberof net
         * @classdesc Represents a msg_del_group_member.
         * @implements Imsg_del_group_member
         * @constructor
         * @param {net.Imsg_del_group_member=} [properties] Properties to set
         */
        function msg_del_group_member(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_group_member groupkey.
         * @member {number} groupkey
         * @memberof net.msg_del_group_member
         * @instance
         */
        msg_del_group_member.prototype.groupkey = 0;

        /**
         * msg_del_group_member uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_del_group_member
         * @instance
         */
        msg_del_group_member.prototype.uids = $util.emptyArray;

        /**
         * Encodes the specified msg_del_group_member message. Does not implicitly {@link net.msg_del_group_member.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_group_member
         * @static
         * @param {net.Imsg_del_group_member} message msg_del_group_member message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_group_member.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uids[i]);
            return writer;
        };

        /**
         * Decodes a msg_del_group_member message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_group_member
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_group_member} msg_del_group_member
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_group_member.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_group_member();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_group_member;
    })();

    net.msg_del_group_member_rep = (function() {

        /**
         * Properties of a msg_del_group_member_rep.
         * @memberof net
         * @interface Imsg_del_group_member_rep
         * @property {number|null} [result] msg_del_group_member_rep result
         * @property {number|null} [groupkey] msg_del_group_member_rep groupkey
         * @property {Array.<number>|null} [uids] msg_del_group_member_rep uids
         */

        /**
         * Constructs a new msg_del_group_member_rep.
         * @memberof net
         * @classdesc Represents a msg_del_group_member_rep.
         * @implements Imsg_del_group_member_rep
         * @constructor
         * @param {net.Imsg_del_group_member_rep=} [properties] Properties to set
         */
        function msg_del_group_member_rep(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_group_member_rep result.
         * @member {number} result
         * @memberof net.msg_del_group_member_rep
         * @instance
         */
        msg_del_group_member_rep.prototype.result = 0;

        /**
         * msg_del_group_member_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_del_group_member_rep
         * @instance
         */
        msg_del_group_member_rep.prototype.groupkey = 0;

        /**
         * msg_del_group_member_rep uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_del_group_member_rep
         * @instance
         */
        msg_del_group_member_rep.prototype.uids = $util.emptyArray;

        /**
         * Encodes the specified msg_del_group_member_rep message. Does not implicitly {@link net.msg_del_group_member_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {net.Imsg_del_group_member_rep} message msg_del_group_member_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_group_member_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uids[i]);
            return writer;
        };

        /**
         * Decodes a msg_del_group_member_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_group_member_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_group_member_rep} msg_del_group_member_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_group_member_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_group_member_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_group_member_rep;
    })();

    net.msg_dismiss_group = (function() {

        /**
         * Properties of a msg_dismiss_group.
         * @memberof net
         * @interface Imsg_dismiss_group
         * @property {number|null} [groupkey] msg_dismiss_group groupkey
         */

        /**
         * Constructs a new msg_dismiss_group.
         * @memberof net
         * @classdesc Represents a msg_dismiss_group.
         * @implements Imsg_dismiss_group
         * @constructor
         * @param {net.Imsg_dismiss_group=} [properties] Properties to set
         */
        function msg_dismiss_group(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_dismiss_group groupkey.
         * @member {number} groupkey
         * @memberof net.msg_dismiss_group
         * @instance
         */
        msg_dismiss_group.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_dismiss_group message. Does not implicitly {@link net.msg_dismiss_group.verify|verify} messages.
         * @function encode
         * @memberof net.msg_dismiss_group
         * @static
         * @param {net.Imsg_dismiss_group} message msg_dismiss_group message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_dismiss_group.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_dismiss_group message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_dismiss_group
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_dismiss_group} msg_dismiss_group
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_dismiss_group.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_dismiss_group();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_dismiss_group;
    })();

    net.msg_dismiss_group_rep = (function() {

        /**
         * Properties of a msg_dismiss_group_rep.
         * @memberof net
         * @interface Imsg_dismiss_group_rep
         * @property {number|null} [result] msg_dismiss_group_rep result
         * @property {number|null} [groupkey] msg_dismiss_group_rep groupkey
         */

        /**
         * Constructs a new msg_dismiss_group_rep.
         * @memberof net
         * @classdesc Represents a msg_dismiss_group_rep.
         * @implements Imsg_dismiss_group_rep
         * @constructor
         * @param {net.Imsg_dismiss_group_rep=} [properties] Properties to set
         */
        function msg_dismiss_group_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_dismiss_group_rep result.
         * @member {number} result
         * @memberof net.msg_dismiss_group_rep
         * @instance
         */
        msg_dismiss_group_rep.prototype.result = 0;

        /**
         * msg_dismiss_group_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_dismiss_group_rep
         * @instance
         */
        msg_dismiss_group_rep.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_dismiss_group_rep message. Does not implicitly {@link net.msg_dismiss_group_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {net.Imsg_dismiss_group_rep} message msg_dismiss_group_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_dismiss_group_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_dismiss_group_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_dismiss_group_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_dismiss_group_rep} msg_dismiss_group_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_dismiss_group_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_dismiss_group_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_dismiss_group_rep;
    })();

    net.msg_send_group_msg = (function() {

        /**
         * Properties of a msg_send_group_msg.
         * @memberof net
         * @interface Imsg_send_group_msg
         * @property {number|null} [groupkey] msg_send_group_msg groupkey
         * @property {number|null} [msg_type] msg_send_group_msg msg_type
         * @property {Uint8Array|null} [content] msg_send_group_msg content
         * @property {Uint8Array|null} [clientkey] msg_send_group_msg clientkey
         * @property {number|null} [nopush] msg_send_group_msg nopush
         * @property {Uint8Array|null} [authcode] msg_send_group_msg authcode
         */

        /**
         * Constructs a new msg_send_group_msg.
         * @memberof net
         * @classdesc Represents a msg_send_group_msg.
         * @implements Imsg_send_group_msg
         * @constructor
         * @param {net.Imsg_send_group_msg=} [properties] Properties to set
         */
        function msg_send_group_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_group_msg groupkey.
         * @member {number} groupkey
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.groupkey = 0;

        /**
         * msg_send_group_msg msg_type.
         * @member {number} msg_type
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.msg_type = 0;

        /**
         * msg_send_group_msg content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.content = $util.newBuffer([]);

        /**
         * msg_send_group_msg clientkey.
         * @member {Uint8Array} clientkey
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.clientkey = $util.newBuffer([]);

        /**
         * msg_send_group_msg nopush.
         * @member {number} nopush
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.nopush = 0;

        /**
         * msg_send_group_msg authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_send_group_msg
         * @instance
         */
        msg_send_group_msg.prototype.authcode = $util.newBuffer([]);

        /**
         * Encodes the specified msg_send_group_msg message. Does not implicitly {@link net.msg_send_group_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_group_msg
         * @static
         * @param {net.Imsg_send_group_msg} message msg_send_group_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_group_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.msg_type != null && Object.hasOwnProperty.call(message, "msg_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msg_type);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
            if (message.clientkey != null && Object.hasOwnProperty.call(message, "clientkey"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.clientkey);
            if (message.nopush != null && Object.hasOwnProperty.call(message, "nopush"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.nopush);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.authcode);
            return writer;
        };

        /**
         * Decodes a msg_send_group_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_group_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_group_msg} msg_send_group_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_group_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_group_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.msg_type = reader.int32();
                    break;
                case 3:
                    message.content = reader.bytes();
                    break;
                case 4:
                    message.clientkey = reader.bytes();
                    break;
                case 5:
                    message.nopush = reader.int32();
                    break;
                case 6:
                    message.authcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_group_msg;
    })();

    net.msg_send_group_msg_rep = (function() {

        /**
         * Properties of a msg_send_group_msg_rep.
         * @memberof net
         * @interface Imsg_send_group_msg_rep
         * @property {number|null} [result] msg_send_group_msg_rep result
         * @property {net.Ichat_msg|null} [msg_info] msg_send_group_msg_rep msg_info
         */

        /**
         * Constructs a new msg_send_group_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_send_group_msg_rep.
         * @implements Imsg_send_group_msg_rep
         * @constructor
         * @param {net.Imsg_send_group_msg_rep=} [properties] Properties to set
         */
        function msg_send_group_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_group_msg_rep result.
         * @member {number} result
         * @memberof net.msg_send_group_msg_rep
         * @instance
         */
        msg_send_group_msg_rep.prototype.result = 0;

        /**
         * msg_send_group_msg_rep msg_info.
         * @member {net.Ichat_msg|null|undefined} msg_info
         * @memberof net.msg_send_group_msg_rep
         * @instance
         */
        msg_send_group_msg_rep.prototype.msg_info = null;

        /**
         * Encodes the specified msg_send_group_msg_rep message. Does not implicitly {@link net.msg_send_group_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {net.Imsg_send_group_msg_rep} message msg_send_group_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_group_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.msg_info != null && Object.hasOwnProperty.call(message, "msg_info"))
                $root.net.chat_msg.encode(message.msg_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_send_group_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_group_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_group_msg_rep} msg_send_group_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_group_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_group_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.msg_info = $root.net.chat_msg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_group_msg_rep;
    })();

    net.msg_get_group_info = (function() {

        /**
         * Properties of a msg_get_group_info.
         * @memberof net
         * @interface Imsg_get_group_info
         * @property {number|null} [groupkey] msg_get_group_info groupkey
         * @property {number|null} [is_stranger] msg_get_group_info is_stranger
         * @property {number|null} [is_end] msg_get_group_info is_end
         */

        /**
         * Constructs a new msg_get_group_info.
         * @memberof net
         * @classdesc Represents a msg_get_group_info.
         * @implements Imsg_get_group_info
         * @constructor
         * @param {net.Imsg_get_group_info=} [properties] Properties to set
         */
        function msg_get_group_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_info groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_info
         * @instance
         */
        msg_get_group_info.prototype.groupkey = 0;

        /**
         * msg_get_group_info is_stranger.
         * @member {number} is_stranger
         * @memberof net.msg_get_group_info
         * @instance
         */
        msg_get_group_info.prototype.is_stranger = 0;

        /**
         * msg_get_group_info is_end.
         * @member {number} is_end
         * @memberof net.msg_get_group_info
         * @instance
         */
        msg_get_group_info.prototype.is_end = 0;

        /**
         * Encodes the specified msg_get_group_info message. Does not implicitly {@link net.msg_get_group_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_info
         * @static
         * @param {net.Imsg_get_group_info} message msg_get_group_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.is_stranger != null && Object.hasOwnProperty.call(message, "is_stranger"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_stranger);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_end);
            return writer;
        };

        /**
         * Decodes a msg_get_group_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_info} msg_get_group_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.is_stranger = reader.int32();
                    break;
                case 3:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_info;
    })();

    net.msg_get_group_info_rep = (function() {

        /**
         * Properties of a msg_get_group_info_rep.
         * @memberof net
         * @interface Imsg_get_group_info_rep
         * @property {net.Igroup_base_info|null} [group_info] msg_get_group_info_rep group_info
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_group_info_rep users
         * @property {number|null} [is_stranger] msg_get_group_info_rep is_stranger
         * @property {number|null} [is_end] msg_get_group_info_rep is_end
         */

        /**
         * Constructs a new msg_get_group_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_info_rep.
         * @implements Imsg_get_group_info_rep
         * @constructor
         * @param {net.Imsg_get_group_info_rep=} [properties] Properties to set
         */
        function msg_get_group_info_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_info_rep group_info.
         * @member {net.Igroup_base_info|null|undefined} group_info
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.group_info = null;

        /**
         * msg_get_group_info_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.users = $util.emptyArray;

        /**
         * msg_get_group_info_rep is_stranger.
         * @member {number} is_stranger
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.is_stranger = 0;

        /**
         * msg_get_group_info_rep is_end.
         * @member {number} is_end
         * @memberof net.msg_get_group_info_rep
         * @instance
         */
        msg_get_group_info_rep.prototype.is_end = 0;

        /**
         * Encodes the specified msg_get_group_info_rep message. Does not implicitly {@link net.msg_get_group_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {net.Imsg_get_group_info_rep} message msg_get_group_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.group_info != null && Object.hasOwnProperty.call(message, "group_info"))
                $root.net.group_base_info.encode(message.group_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.is_stranger != null && Object.hasOwnProperty.call(message, "is_stranger"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_stranger);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.is_end);
            return writer;
        };

        /**
         * Decodes a msg_get_group_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_info_rep} msg_get_group_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.group_info = $root.net.group_base_info.decode(reader, reader.uint32());
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.is_stranger = reader.int32();
                    break;
                case 4:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_info_rep;
    })();

    net.msg_confirm_group_info = (function() {

        /**
         * Properties of a msg_confirm_group_info.
         * @memberof net
         * @interface Imsg_confirm_group_info
         * @property {number|null} [groupkey] msg_confirm_group_info groupkey
         * @property {number|null} [attrversion] msg_confirm_group_info attrversion
         */

        /**
         * Constructs a new msg_confirm_group_info.
         * @memberof net
         * @classdesc Represents a msg_confirm_group_info.
         * @implements Imsg_confirm_group_info
         * @constructor
         * @param {net.Imsg_confirm_group_info=} [properties] Properties to set
         */
        function msg_confirm_group_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_group_info groupkey.
         * @member {number} groupkey
         * @memberof net.msg_confirm_group_info
         * @instance
         */
        msg_confirm_group_info.prototype.groupkey = 0;

        /**
         * msg_confirm_group_info attrversion.
         * @member {number} attrversion
         * @memberof net.msg_confirm_group_info
         * @instance
         */
        msg_confirm_group_info.prototype.attrversion = 0;

        /**
         * Encodes the specified msg_confirm_group_info message. Does not implicitly {@link net.msg_confirm_group_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {net.Imsg_confirm_group_info} message msg_confirm_group_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_group_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.attrversion != null && Object.hasOwnProperty.call(message, "attrversion"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.attrversion);
            return writer;
        };

        /**
         * Decodes a msg_confirm_group_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_group_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_group_info} msg_confirm_group_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_group_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_group_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.attrversion = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_group_info;
    })();

    net.msg_confirm_group_info_rep = (function() {

        /**
         * Properties of a msg_confirm_group_info_rep.
         * @memberof net
         * @interface Imsg_confirm_group_info_rep
         * @property {number|null} [result] msg_confirm_group_info_rep result
         */

        /**
         * Constructs a new msg_confirm_group_info_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_group_info_rep.
         * @implements Imsg_confirm_group_info_rep
         * @constructor
         * @param {net.Imsg_confirm_group_info_rep=} [properties] Properties to set
         */
        function msg_confirm_group_info_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_group_info_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_group_info_rep
         * @instance
         */
        msg_confirm_group_info_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_confirm_group_info_rep message. Does not implicitly {@link net.msg_confirm_group_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {net.Imsg_confirm_group_info_rep} message msg_confirm_group_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_group_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_confirm_group_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_group_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_group_info_rep} msg_confirm_group_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_group_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_group_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_group_info_rep;
    })();

    net.msg_modify_groupname = (function() {

        /**
         * Properties of a msg_modify_groupname.
         * @memberof net
         * @interface Imsg_modify_groupname
         * @property {Uint8Array|null} [new_name] msg_modify_groupname new_name
         * @property {number|null} [groupkey] msg_modify_groupname groupkey
         */

        /**
         * Constructs a new msg_modify_groupname.
         * @memberof net
         * @classdesc Represents a msg_modify_groupname.
         * @implements Imsg_modify_groupname
         * @constructor
         * @param {net.Imsg_modify_groupname=} [properties] Properties to set
         */
        function msg_modify_groupname(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupname new_name.
         * @member {Uint8Array} new_name
         * @memberof net.msg_modify_groupname
         * @instance
         */
        msg_modify_groupname.prototype.new_name = $util.newBuffer([]);

        /**
         * msg_modify_groupname groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupname
         * @instance
         */
        msg_modify_groupname.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_modify_groupname message. Does not implicitly {@link net.msg_modify_groupname.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupname
         * @static
         * @param {net.Imsg_modify_groupname} message msg_modify_groupname message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupname.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.new_name != null && Object.hasOwnProperty.call(message, "new_name"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.new_name);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_modify_groupname message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupname
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupname} msg_modify_groupname
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupname.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupname();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.new_name = reader.bytes();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_modify_groupname;
    })();

    net.msg_modify_groupname_rep = (function() {

        /**
         * Properties of a msg_modify_groupname_rep.
         * @memberof net
         * @interface Imsg_modify_groupname_rep
         * @property {number|null} [result] msg_modify_groupname_rep result
         * @property {number|null} [groupkey] msg_modify_groupname_rep groupkey
         * @property {Uint8Array|null} [new_name] msg_modify_groupname_rep new_name
         */

        /**
         * Constructs a new msg_modify_groupname_rep.
         * @memberof net
         * @classdesc Represents a msg_modify_groupname_rep.
         * @implements Imsg_modify_groupname_rep
         * @constructor
         * @param {net.Imsg_modify_groupname_rep=} [properties] Properties to set
         */
        function msg_modify_groupname_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupname_rep result.
         * @member {number} result
         * @memberof net.msg_modify_groupname_rep
         * @instance
         */
        msg_modify_groupname_rep.prototype.result = 0;

        /**
         * msg_modify_groupname_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupname_rep
         * @instance
         */
        msg_modify_groupname_rep.prototype.groupkey = 0;

        /**
         * msg_modify_groupname_rep new_name.
         * @member {Uint8Array} new_name
         * @memberof net.msg_modify_groupname_rep
         * @instance
         */
        msg_modify_groupname_rep.prototype.new_name = $util.newBuffer([]);

        /**
         * Encodes the specified msg_modify_groupname_rep message. Does not implicitly {@link net.msg_modify_groupname_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {net.Imsg_modify_groupname_rep} message msg_modify_groupname_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupname_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.new_name != null && Object.hasOwnProperty.call(message, "new_name"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.new_name);
            return writer;
        };

        /**
         * Decodes a msg_modify_groupname_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupname_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupname_rep} msg_modify_groupname_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupname_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupname_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.new_name = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_modify_groupname_rep;
    })();

    net.msg_modify_groupnotify = (function() {

        /**
         * Properties of a msg_modify_groupnotify.
         * @memberof net
         * @interface Imsg_modify_groupnotify
         * @property {Uint8Array|null} [new_notify] msg_modify_groupnotify new_notify
         * @property {number|null} [groupkey] msg_modify_groupnotify groupkey
         */

        /**
         * Constructs a new msg_modify_groupnotify.
         * @memberof net
         * @classdesc Represents a msg_modify_groupnotify.
         * @implements Imsg_modify_groupnotify
         * @constructor
         * @param {net.Imsg_modify_groupnotify=} [properties] Properties to set
         */
        function msg_modify_groupnotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupnotify new_notify.
         * @member {Uint8Array} new_notify
         * @memberof net.msg_modify_groupnotify
         * @instance
         */
        msg_modify_groupnotify.prototype.new_notify = $util.newBuffer([]);

        /**
         * msg_modify_groupnotify groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupnotify
         * @instance
         */
        msg_modify_groupnotify.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_modify_groupnotify message. Does not implicitly {@link net.msg_modify_groupnotify.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {net.Imsg_modify_groupnotify} message msg_modify_groupnotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupnotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.new_notify != null && Object.hasOwnProperty.call(message, "new_notify"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.new_notify);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_modify_groupnotify message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupnotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupnotify} msg_modify_groupnotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupnotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupnotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.new_notify = reader.bytes();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_modify_groupnotify;
    })();

    net.msg_modify_groupnotify_rep = (function() {

        /**
         * Properties of a msg_modify_groupnotify_rep.
         * @memberof net
         * @interface Imsg_modify_groupnotify_rep
         * @property {number|null} [result] msg_modify_groupnotify_rep result
         * @property {number|null} [groupkey] msg_modify_groupnotify_rep groupkey
         * @property {Uint8Array|null} [new_notify] msg_modify_groupnotify_rep new_notify
         */

        /**
         * Constructs a new msg_modify_groupnotify_rep.
         * @memberof net
         * @classdesc Represents a msg_modify_groupnotify_rep.
         * @implements Imsg_modify_groupnotify_rep
         * @constructor
         * @param {net.Imsg_modify_groupnotify_rep=} [properties] Properties to set
         */
        function msg_modify_groupnotify_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_modify_groupnotify_rep result.
         * @member {number} result
         * @memberof net.msg_modify_groupnotify_rep
         * @instance
         */
        msg_modify_groupnotify_rep.prototype.result = 0;

        /**
         * msg_modify_groupnotify_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_modify_groupnotify_rep
         * @instance
         */
        msg_modify_groupnotify_rep.prototype.groupkey = 0;

        /**
         * msg_modify_groupnotify_rep new_notify.
         * @member {Uint8Array} new_notify
         * @memberof net.msg_modify_groupnotify_rep
         * @instance
         */
        msg_modify_groupnotify_rep.prototype.new_notify = $util.newBuffer([]);

        /**
         * Encodes the specified msg_modify_groupnotify_rep message. Does not implicitly {@link net.msg_modify_groupnotify_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {net.Imsg_modify_groupnotify_rep} message msg_modify_groupnotify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_modify_groupnotify_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.new_notify != null && Object.hasOwnProperty.call(message, "new_notify"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.new_notify);
            return writer;
        };

        /**
         * Decodes a msg_modify_groupnotify_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_modify_groupnotify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_modify_groupnotify_rep} msg_modify_groupnotify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_modify_groupnotify_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_modify_groupnotify_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.new_notify = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_modify_groupnotify_rep;
    })();

    net.msg_set_groupadmin = (function() {

        /**
         * Properties of a msg_set_groupadmin.
         * @memberof net
         * @interface Imsg_set_groupadmin
         * @property {Array.<number>|null} [uids] msg_set_groupadmin uids
         * @property {number|null} [groupkey] msg_set_groupadmin groupkey
         */

        /**
         * Constructs a new msg_set_groupadmin.
         * @memberof net
         * @classdesc Represents a msg_set_groupadmin.
         * @implements Imsg_set_groupadmin
         * @constructor
         * @param {net.Imsg_set_groupadmin=} [properties] Properties to set
         */
        function msg_set_groupadmin(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadmin uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_set_groupadmin
         * @instance
         */
        msg_set_groupadmin.prototype.uids = $util.emptyArray;

        /**
         * msg_set_groupadmin groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupadmin
         * @instance
         */
        msg_set_groupadmin.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_set_groupadmin message. Does not implicitly {@link net.msg_set_groupadmin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {net.Imsg_set_groupadmin} message msg_set_groupadmin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uids[i]);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_set_groupadmin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadmin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadmin} msg_set_groupadmin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadmin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupadmin;
    })();

    net.msg_set_groupadmin_rep = (function() {

        /**
         * Properties of a msg_set_groupadmin_rep.
         * @memberof net
         * @interface Imsg_set_groupadmin_rep
         * @property {number|null} [result] msg_set_groupadmin_rep result
         */

        /**
         * Constructs a new msg_set_groupadmin_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupadmin_rep.
         * @implements Imsg_set_groupadmin_rep
         * @constructor
         * @param {net.Imsg_set_groupadmin_rep=} [properties] Properties to set
         */
        function msg_set_groupadmin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadmin_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupadmin_rep
         * @instance
         */
        msg_set_groupadmin_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_set_groupadmin_rep message. Does not implicitly {@link net.msg_set_groupadmin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {net.Imsg_set_groupadmin_rep} message msg_set_groupadmin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadmin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_set_groupadmin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadmin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadmin_rep} msg_set_groupadmin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadmin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadmin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupadmin_rep;
    })();

    net.msg_set_groupinfo_limits = (function() {

        /**
         * Properties of a msg_set_groupinfo_limits.
         * @memberof net
         * @interface Imsg_set_groupinfo_limits
         * @property {number|null} [limits] msg_set_groupinfo_limits limits
         * @property {number|null} [groupkey] msg_set_groupinfo_limits groupkey
         */

        /**
         * Constructs a new msg_set_groupinfo_limits.
         * @memberof net
         * @classdesc Represents a msg_set_groupinfo_limits.
         * @implements Imsg_set_groupinfo_limits
         * @constructor
         * @param {net.Imsg_set_groupinfo_limits=} [properties] Properties to set
         */
        function msg_set_groupinfo_limits(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupinfo_limits limits.
         * @member {number} limits
         * @memberof net.msg_set_groupinfo_limits
         * @instance
         */
        msg_set_groupinfo_limits.prototype.limits = 0;

        /**
         * msg_set_groupinfo_limits groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupinfo_limits
         * @instance
         */
        msg_set_groupinfo_limits.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_set_groupinfo_limits message. Does not implicitly {@link net.msg_set_groupinfo_limits.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {net.Imsg_set_groupinfo_limits} message msg_set_groupinfo_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupinfo_limits.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_set_groupinfo_limits message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupinfo_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupinfo_limits} msg_set_groupinfo_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupinfo_limits.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupinfo_limits();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupinfo_limits;
    })();

    net.msg_set_groupinfo_limits_rep = (function() {

        /**
         * Properties of a msg_set_groupinfo_limits_rep.
         * @memberof net
         * @interface Imsg_set_groupinfo_limits_rep
         * @property {number|null} [result] msg_set_groupinfo_limits_rep result
         */

        /**
         * Constructs a new msg_set_groupinfo_limits_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupinfo_limits_rep.
         * @implements Imsg_set_groupinfo_limits_rep
         * @constructor
         * @param {net.Imsg_set_groupinfo_limits_rep=} [properties] Properties to set
         */
        function msg_set_groupinfo_limits_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupinfo_limits_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupinfo_limits_rep
         * @instance
         */
        msg_set_groupinfo_limits_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_set_groupinfo_limits_rep message. Does not implicitly {@link net.msg_set_groupinfo_limits_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {net.Imsg_set_groupinfo_limits_rep} message msg_set_groupinfo_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupinfo_limits_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_set_groupinfo_limits_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupinfo_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupinfo_limits_rep} msg_set_groupinfo_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupinfo_limits_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupinfo_limits_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupinfo_limits_rep;
    })();

    net.msg_set_groupadd_limits = (function() {

        /**
         * Properties of a msg_set_groupadd_limits.
         * @memberof net
         * @interface Imsg_set_groupadd_limits
         * @property {number|null} [limits] msg_set_groupadd_limits limits
         * @property {number|null} [groupkey] msg_set_groupadd_limits groupkey
         */

        /**
         * Constructs a new msg_set_groupadd_limits.
         * @memberof net
         * @classdesc Represents a msg_set_groupadd_limits.
         * @implements Imsg_set_groupadd_limits
         * @constructor
         * @param {net.Imsg_set_groupadd_limits=} [properties] Properties to set
         */
        function msg_set_groupadd_limits(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadd_limits limits.
         * @member {number} limits
         * @memberof net.msg_set_groupadd_limits
         * @instance
         */
        msg_set_groupadd_limits.prototype.limits = 0;

        /**
         * msg_set_groupadd_limits groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupadd_limits
         * @instance
         */
        msg_set_groupadd_limits.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_set_groupadd_limits message. Does not implicitly {@link net.msg_set_groupadd_limits.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {net.Imsg_set_groupadd_limits} message msg_set_groupadd_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadd_limits.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_set_groupadd_limits message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadd_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadd_limits} msg_set_groupadd_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadd_limits.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadd_limits();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupadd_limits;
    })();

    net.msg_set_groupadd_limits_rep = (function() {

        /**
         * Properties of a msg_set_groupadd_limits_rep.
         * @memberof net
         * @interface Imsg_set_groupadd_limits_rep
         * @property {number|null} [result] msg_set_groupadd_limits_rep result
         */

        /**
         * Constructs a new msg_set_groupadd_limits_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupadd_limits_rep.
         * @implements Imsg_set_groupadd_limits_rep
         * @constructor
         * @param {net.Imsg_set_groupadd_limits_rep=} [properties] Properties to set
         */
        function msg_set_groupadd_limits_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupadd_limits_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupadd_limits_rep
         * @instance
         */
        msg_set_groupadd_limits_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_set_groupadd_limits_rep message. Does not implicitly {@link net.msg_set_groupadd_limits_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {net.Imsg_set_groupadd_limits_rep} message msg_set_groupadd_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupadd_limits_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_set_groupadd_limits_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupadd_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupadd_limits_rep} msg_set_groupadd_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupadd_limits_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupadd_limits_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupadd_limits_rep;
    })();

    net.msg_del_groupadmin = (function() {

        /**
         * Properties of a msg_del_groupadmin.
         * @memberof net
         * @interface Imsg_del_groupadmin
         * @property {Array.<number>|null} [uids] msg_del_groupadmin uids
         * @property {number|null} [groupkey] msg_del_groupadmin groupkey
         */

        /**
         * Constructs a new msg_del_groupadmin.
         * @memberof net
         * @classdesc Represents a msg_del_groupadmin.
         * @implements Imsg_del_groupadmin
         * @constructor
         * @param {net.Imsg_del_groupadmin=} [properties] Properties to set
         */
        function msg_del_groupadmin(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_groupadmin uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_del_groupadmin
         * @instance
         */
        msg_del_groupadmin.prototype.uids = $util.emptyArray;

        /**
         * msg_del_groupadmin groupkey.
         * @member {number} groupkey
         * @memberof net.msg_del_groupadmin
         * @instance
         */
        msg_del_groupadmin.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_del_groupadmin message. Does not implicitly {@link net.msg_del_groupadmin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {net.Imsg_del_groupadmin} message msg_del_groupadmin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_groupadmin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uids[i]);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_del_groupadmin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_groupadmin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_groupadmin} msg_del_groupadmin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_groupadmin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_groupadmin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.int32());
                    } else
                        message.uids.push(reader.int32());
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_groupadmin;
    })();

    net.msg_del_groupadmin_rep = (function() {

        /**
         * Properties of a msg_del_groupadmin_rep.
         * @memberof net
         * @interface Imsg_del_groupadmin_rep
         * @property {number|null} [result] msg_del_groupadmin_rep result
         */

        /**
         * Constructs a new msg_del_groupadmin_rep.
         * @memberof net
         * @classdesc Represents a msg_del_groupadmin_rep.
         * @implements Imsg_del_groupadmin_rep
         * @constructor
         * @param {net.Imsg_del_groupadmin_rep=} [properties] Properties to set
         */
        function msg_del_groupadmin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_groupadmin_rep result.
         * @member {number} result
         * @memberof net.msg_del_groupadmin_rep
         * @instance
         */
        msg_del_groupadmin_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_del_groupadmin_rep message. Does not implicitly {@link net.msg_del_groupadmin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {net.Imsg_del_groupadmin_rep} message msg_del_groupadmin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_groupadmin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_del_groupadmin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_groupadmin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_groupadmin_rep} msg_del_groupadmin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_groupadmin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_groupadmin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_groupadmin_rep;
    })();

    net.msg_set_grouplook_limits = (function() {

        /**
         * Properties of a msg_set_grouplook_limits.
         * @memberof net
         * @interface Imsg_set_grouplook_limits
         * @property {number|null} [limits] msg_set_grouplook_limits limits
         * @property {number|null} [groupkey] msg_set_grouplook_limits groupkey
         */

        /**
         * Constructs a new msg_set_grouplook_limits.
         * @memberof net
         * @classdesc Represents a msg_set_grouplook_limits.
         * @implements Imsg_set_grouplook_limits
         * @constructor
         * @param {net.Imsg_set_grouplook_limits=} [properties] Properties to set
         */
        function msg_set_grouplook_limits(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouplook_limits limits.
         * @member {number} limits
         * @memberof net.msg_set_grouplook_limits
         * @instance
         */
        msg_set_grouplook_limits.prototype.limits = 0;

        /**
         * msg_set_grouplook_limits groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_grouplook_limits
         * @instance
         */
        msg_set_grouplook_limits.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_set_grouplook_limits message. Does not implicitly {@link net.msg_set_grouplook_limits.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {net.Imsg_set_grouplook_limits} message msg_set_grouplook_limits message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouplook_limits.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_set_grouplook_limits message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouplook_limits
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouplook_limits} msg_set_grouplook_limits
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouplook_limits.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouplook_limits();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_grouplook_limits;
    })();

    net.msg_set_grouplook_limits_rep = (function() {

        /**
         * Properties of a msg_set_grouplook_limits_rep.
         * @memberof net
         * @interface Imsg_set_grouplook_limits_rep
         * @property {number|null} [result] msg_set_grouplook_limits_rep result
         */

        /**
         * Constructs a new msg_set_grouplook_limits_rep.
         * @memberof net
         * @classdesc Represents a msg_set_grouplook_limits_rep.
         * @implements Imsg_set_grouplook_limits_rep
         * @constructor
         * @param {net.Imsg_set_grouplook_limits_rep=} [properties] Properties to set
         */
        function msg_set_grouplook_limits_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouplook_limits_rep result.
         * @member {number} result
         * @memberof net.msg_set_grouplook_limits_rep
         * @instance
         */
        msg_set_grouplook_limits_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_set_grouplook_limits_rep message. Does not implicitly {@link net.msg_set_grouplook_limits_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {net.Imsg_set_grouplook_limits_rep} message msg_set_grouplook_limits_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouplook_limits_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_set_grouplook_limits_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouplook_limits_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouplook_limits_rep} msg_set_grouplook_limits_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouplook_limits_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouplook_limits_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_grouplook_limits_rep;
    })();

    net.msg_set_groupsendmsg_limit = (function() {

        /**
         * Properties of a msg_set_groupsendmsg_limit.
         * @memberof net
         * @interface Imsg_set_groupsendmsg_limit
         * @property {number|null} [limits] msg_set_groupsendmsg_limit limits
         * @property {number|null} [groupkey] msg_set_groupsendmsg_limit groupkey
         */

        /**
         * Constructs a new msg_set_groupsendmsg_limit.
         * @memberof net
         * @classdesc Represents a msg_set_groupsendmsg_limit.
         * @implements Imsg_set_groupsendmsg_limit
         * @constructor
         * @param {net.Imsg_set_groupsendmsg_limit=} [properties] Properties to set
         */
        function msg_set_groupsendmsg_limit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupsendmsg_limit limits.
         * @member {number} limits
         * @memberof net.msg_set_groupsendmsg_limit
         * @instance
         */
        msg_set_groupsendmsg_limit.prototype.limits = 0;

        /**
         * msg_set_groupsendmsg_limit groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_groupsendmsg_limit
         * @instance
         */
        msg_set_groupsendmsg_limit.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_set_groupsendmsg_limit message. Does not implicitly {@link net.msg_set_groupsendmsg_limit.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit} message msg_set_groupsendmsg_limit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupsendmsg_limit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.limits != null && Object.hasOwnProperty.call(message, "limits"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limits);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_set_groupsendmsg_limit message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupsendmsg_limit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupsendmsg_limit} msg_set_groupsendmsg_limit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupsendmsg_limit.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupsendmsg_limit();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.limits = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupsendmsg_limit;
    })();

    net.msg_set_groupsendmsg_limit_rep = (function() {

        /**
         * Properties of a msg_set_groupsendmsg_limit_rep.
         * @memberof net
         * @interface Imsg_set_groupsendmsg_limit_rep
         * @property {number|null} [result] msg_set_groupsendmsg_limit_rep result
         */

        /**
         * Constructs a new msg_set_groupsendmsg_limit_rep.
         * @memberof net
         * @classdesc Represents a msg_set_groupsendmsg_limit_rep.
         * @implements Imsg_set_groupsendmsg_limit_rep
         * @constructor
         * @param {net.Imsg_set_groupsendmsg_limit_rep=} [properties] Properties to set
         */
        function msg_set_groupsendmsg_limit_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_groupsendmsg_limit_rep result.
         * @member {number} result
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @instance
         */
        msg_set_groupsendmsg_limit_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_set_groupsendmsg_limit_rep message. Does not implicitly {@link net.msg_set_groupsendmsg_limit_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {net.Imsg_set_groupsendmsg_limit_rep} message msg_set_groupsendmsg_limit_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_groupsendmsg_limit_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_set_groupsendmsg_limit_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_groupsendmsg_limit_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_groupsendmsg_limit_rep} msg_set_groupsendmsg_limit_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_groupsendmsg_limit_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_groupsendmsg_limit_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_groupsendmsg_limit_rep;
    })();

    net.msg_set_grouphost = (function() {

        /**
         * Properties of a msg_set_grouphost.
         * @memberof net
         * @interface Imsg_set_grouphost
         * @property {number|null} [uid] msg_set_grouphost uid
         * @property {number|null} [groupkey] msg_set_grouphost groupkey
         */

        /**
         * Constructs a new msg_set_grouphost.
         * @memberof net
         * @classdesc Represents a msg_set_grouphost.
         * @implements Imsg_set_grouphost
         * @constructor
         * @param {net.Imsg_set_grouphost=} [properties] Properties to set
         */
        function msg_set_grouphost(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouphost uid.
         * @member {number} uid
         * @memberof net.msg_set_grouphost
         * @instance
         */
        msg_set_grouphost.prototype.uid = 0;

        /**
         * msg_set_grouphost groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_grouphost
         * @instance
         */
        msg_set_grouphost.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_set_grouphost message. Does not implicitly {@link net.msg_set_grouphost.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouphost
         * @static
         * @param {net.Imsg_set_grouphost} message msg_set_grouphost message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouphost.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_set_grouphost message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouphost
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouphost} msg_set_grouphost
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouphost.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouphost();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_grouphost;
    })();

    net.msg_set_grouphost_rep = (function() {

        /**
         * Properties of a msg_set_grouphost_rep.
         * @memberof net
         * @interface Imsg_set_grouphost_rep
         * @property {number|null} [result] msg_set_grouphost_rep result
         * @property {number|null} [groupkey] msg_set_grouphost_rep groupkey
         * @property {number|null} [uid] msg_set_grouphost_rep uid
         */

        /**
         * Constructs a new msg_set_grouphost_rep.
         * @memberof net
         * @classdesc Represents a msg_set_grouphost_rep.
         * @implements Imsg_set_grouphost_rep
         * @constructor
         * @param {net.Imsg_set_grouphost_rep=} [properties] Properties to set
         */
        function msg_set_grouphost_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_grouphost_rep result.
         * @member {number} result
         * @memberof net.msg_set_grouphost_rep
         * @instance
         */
        msg_set_grouphost_rep.prototype.result = 0;

        /**
         * msg_set_grouphost_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_grouphost_rep
         * @instance
         */
        msg_set_grouphost_rep.prototype.groupkey = 0;

        /**
         * msg_set_grouphost_rep uid.
         * @member {number} uid
         * @memberof net.msg_set_grouphost_rep
         * @instance
         */
        msg_set_grouphost_rep.prototype.uid = 0;

        /**
         * Encodes the specified msg_set_grouphost_rep message. Does not implicitly {@link net.msg_set_grouphost_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {net.Imsg_set_grouphost_rep} message msg_set_grouphost_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_grouphost_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_set_grouphost_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_grouphost_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_grouphost_rep} msg_set_grouphost_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_grouphost_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_grouphost_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_grouphost_rep;
    })();

    net.msg_set_group_headurl = (function() {

        /**
         * Properties of a msg_set_group_headurl.
         * @memberof net
         * @interface Imsg_set_group_headurl
         * @property {Uint8Array|null} [group_headurl] msg_set_group_headurl group_headurl
         * @property {number|null} [groupkey] msg_set_group_headurl groupkey
         */

        /**
         * Constructs a new msg_set_group_headurl.
         * @memberof net
         * @classdesc Represents a msg_set_group_headurl.
         * @implements Imsg_set_group_headurl
         * @constructor
         * @param {net.Imsg_set_group_headurl=} [properties] Properties to set
         */
        function msg_set_group_headurl(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_headurl group_headurl.
         * @member {Uint8Array} group_headurl
         * @memberof net.msg_set_group_headurl
         * @instance
         */
        msg_set_group_headurl.prototype.group_headurl = $util.newBuffer([]);

        /**
         * msg_set_group_headurl groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_headurl
         * @instance
         */
        msg_set_group_headurl.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_set_group_headurl message. Does not implicitly {@link net.msg_set_group_headurl.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {net.Imsg_set_group_headurl} message msg_set_group_headurl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_headurl.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.group_headurl != null && Object.hasOwnProperty.call(message, "group_headurl"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.group_headurl);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_set_group_headurl message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_headurl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_headurl} msg_set_group_headurl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_headurl.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_headurl();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.group_headurl = reader.bytes();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_group_headurl;
    })();

    net.msg_set_group_headurl_rep = (function() {

        /**
         * Properties of a msg_set_group_headurl_rep.
         * @memberof net
         * @interface Imsg_set_group_headurl_rep
         * @property {number|null} [result] msg_set_group_headurl_rep result
         * @property {number|null} [groupkey] msg_set_group_headurl_rep groupkey
         * @property {Uint8Array|null} [group_headurl] msg_set_group_headurl_rep group_headurl
         */

        /**
         * Constructs a new msg_set_group_headurl_rep.
         * @memberof net
         * @classdesc Represents a msg_set_group_headurl_rep.
         * @implements Imsg_set_group_headurl_rep
         * @constructor
         * @param {net.Imsg_set_group_headurl_rep=} [properties] Properties to set
         */
        function msg_set_group_headurl_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_headurl_rep result.
         * @member {number} result
         * @memberof net.msg_set_group_headurl_rep
         * @instance
         */
        msg_set_group_headurl_rep.prototype.result = 0;

        /**
         * msg_set_group_headurl_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_headurl_rep
         * @instance
         */
        msg_set_group_headurl_rep.prototype.groupkey = 0;

        /**
         * msg_set_group_headurl_rep group_headurl.
         * @member {Uint8Array} group_headurl
         * @memberof net.msg_set_group_headurl_rep
         * @instance
         */
        msg_set_group_headurl_rep.prototype.group_headurl = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_group_headurl_rep message. Does not implicitly {@link net.msg_set_group_headurl_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {net.Imsg_set_group_headurl_rep} message msg_set_group_headurl_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_headurl_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.group_headurl != null && Object.hasOwnProperty.call(message, "group_headurl"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.group_headurl);
            return writer;
        };

        /**
         * Decodes a msg_set_group_headurl_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_headurl_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_headurl_rep} msg_set_group_headurl_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_headurl_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_headurl_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.group_headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_group_headurl_rep;
    })();

    net.msg_get_redbag_info = (function() {

        /**
         * Properties of a msg_get_redbag_info.
         * @memberof net
         * @interface Imsg_get_redbag_info
         * @property {number|null} [redbag_id] msg_get_redbag_info redbag_id
         */

        /**
         * Constructs a new msg_get_redbag_info.
         * @memberof net
         * @classdesc Represents a msg_get_redbag_info.
         * @implements Imsg_get_redbag_info
         * @constructor
         * @param {net.Imsg_get_redbag_info=} [properties] Properties to set
         */
        function msg_get_redbag_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag_info redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag_info
         * @instance
         */
        msg_get_redbag_info.prototype.redbag_id = 0;

        /**
         * Encodes the specified msg_get_redbag_info message. Does not implicitly {@link net.msg_get_redbag_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {net.Imsg_get_redbag_info} message msg_get_redbag_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            return writer;
        };

        /**
         * Decodes a msg_get_redbag_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag_info} msg_get_redbag_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_redbag_info;
    })();

    net.msg_get_redbag_info_rep = (function() {

        /**
         * Properties of a msg_get_redbag_info_rep.
         * @memberof net
         * @interface Imsg_get_redbag_info_rep
         * @property {number|null} [redbag_id] msg_get_redbag_info_rep redbag_id
         * @property {number|Long|null} [chatkey] msg_get_redbag_info_rep chatkey
         * @property {number|null} [chatmsgno] msg_get_redbag_info_rep chatmsgno
         * @property {number|null} [uid] msg_get_redbag_info_rep uid
         * @property {number|null} [redbagtype] msg_get_redbag_info_rep redbagtype
         * @property {number|null} [redbagvalue] msg_get_redbag_info_rep redbagvalue
         * @property {number|null} [redbagnum] msg_get_redbag_info_rep redbagnum
         * @property {number|null} [leftnum] msg_get_redbag_info_rep leftnum
         * @property {number|null} [redbagtime] msg_get_redbag_info_rep redbagtime
         * @property {Array.<net.Iredbag_get_record>|null} [records] msg_get_redbag_info_rep records
         * @property {Uint8Array|null} [nickname] msg_get_redbag_info_rep nickname
         * @property {Uint8Array|null} [headurl] msg_get_redbag_info_rep headurl
         * @property {number|null} [cointype] msg_get_redbag_info_rep cointype
         */

        /**
         * Constructs a new msg_get_redbag_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_redbag_info_rep.
         * @implements Imsg_get_redbag_info_rep
         * @constructor
         * @param {net.Imsg_get_redbag_info_rep=} [properties] Properties to set
         */
        function msg_get_redbag_info_rep(properties) {
            this.records = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag_info_rep redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbag_id = 0;

        /**
         * msg_get_redbag_info_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_redbag_info_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.chatmsgno = 0;

        /**
         * msg_get_redbag_info_rep uid.
         * @member {number} uid
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.uid = 0;

        /**
         * msg_get_redbag_info_rep redbagtype.
         * @member {number} redbagtype
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagtype = 0;

        /**
         * msg_get_redbag_info_rep redbagvalue.
         * @member {number} redbagvalue
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagvalue = 0;

        /**
         * msg_get_redbag_info_rep redbagnum.
         * @member {number} redbagnum
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagnum = 0;

        /**
         * msg_get_redbag_info_rep leftnum.
         * @member {number} leftnum
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.leftnum = 0;

        /**
         * msg_get_redbag_info_rep redbagtime.
         * @member {number} redbagtime
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.redbagtime = 0;

        /**
         * msg_get_redbag_info_rep records.
         * @member {Array.<net.Iredbag_get_record>} records
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.records = $util.emptyArray;

        /**
         * msg_get_redbag_info_rep nickname.
         * @member {Uint8Array} nickname
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.nickname = $util.newBuffer([]);

        /**
         * msg_get_redbag_info_rep headurl.
         * @member {Uint8Array} headurl
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.headurl = $util.newBuffer([]);

        /**
         * msg_get_redbag_info_rep cointype.
         * @member {number} cointype
         * @memberof net.msg_get_redbag_info_rep
         * @instance
         */
        msg_get_redbag_info_rep.prototype.cointype = 0;

        /**
         * Encodes the specified msg_get_redbag_info_rep message. Does not implicitly {@link net.msg_get_redbag_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {net.Imsg_get_redbag_info_rep} message msg_get_redbag_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.uid);
            if (message.redbagtype != null && Object.hasOwnProperty.call(message, "redbagtype"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.redbagtype);
            if (message.redbagvalue != null && Object.hasOwnProperty.call(message, "redbagvalue"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.redbagvalue);
            if (message.redbagnum != null && Object.hasOwnProperty.call(message, "redbagnum"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.redbagnum);
            if (message.leftnum != null && Object.hasOwnProperty.call(message, "leftnum"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.leftnum);
            if (message.redbagtime != null && Object.hasOwnProperty.call(message, "redbagtime"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.redbagtime);
            if (message.records != null && message.records.length)
                for (var i = 0; i < message.records.length; ++i)
                    $root.net.redbag_get_record.encode(message.records[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 11, wireType 2 =*/90).bytes(message.nickname);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 12, wireType 2 =*/98).bytes(message.headurl);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.cointype);
            return writer;
        };

        /**
         * Decodes a msg_get_redbag_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag_info_rep} msg_get_redbag_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.chatmsgno = reader.int32();
                    break;
                case 4:
                    message.uid = reader.int32();
                    break;
                case 5:
                    message.redbagtype = reader.int32();
                    break;
                case 6:
                    message.redbagvalue = reader.int32();
                    break;
                case 7:
                    message.redbagnum = reader.int32();
                    break;
                case 8:
                    message.leftnum = reader.int32();
                    break;
                case 9:
                    message.redbagtime = reader.int32();
                    break;
                case 10:
                    if (!(message.records && message.records.length))
                        message.records = [];
                    message.records.push($root.net.redbag_get_record.decode(reader, reader.uint32()));
                    break;
                case 11:
                    message.nickname = reader.bytes();
                    break;
                case 12:
                    message.headurl = reader.bytes();
                    break;
                case 13:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_redbag_info_rep;
    })();

    net.msg_get_redbag = (function() {

        /**
         * Properties of a msg_get_redbag.
         * @memberof net
         * @interface Imsg_get_redbag
         * @property {number|null} [redbag_id] msg_get_redbag redbag_id
         */

        /**
         * Constructs a new msg_get_redbag.
         * @memberof net
         * @classdesc Represents a msg_get_redbag.
         * @implements Imsg_get_redbag
         * @constructor
         * @param {net.Imsg_get_redbag=} [properties] Properties to set
         */
        function msg_get_redbag(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag
         * @instance
         */
        msg_get_redbag.prototype.redbag_id = 0;

        /**
         * Encodes the specified msg_get_redbag message. Does not implicitly {@link net.msg_get_redbag.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag
         * @static
         * @param {net.Imsg_get_redbag} message msg_get_redbag message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.redbag_id);
            return writer;
        };

        /**
         * Decodes a msg_get_redbag message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag} msg_get_redbag
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.redbag_id = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_redbag;
    })();

    net.msg_get_redbag_rep = (function() {

        /**
         * Properties of a msg_get_redbag_rep.
         * @memberof net
         * @interface Imsg_get_redbag_rep
         * @property {number|null} [result] msg_get_redbag_rep result
         * @property {number|null} [redbag_id] msg_get_redbag_rep redbag_id
         */

        /**
         * Constructs a new msg_get_redbag_rep.
         * @memberof net
         * @classdesc Represents a msg_get_redbag_rep.
         * @implements Imsg_get_redbag_rep
         * @constructor
         * @param {net.Imsg_get_redbag_rep=} [properties] Properties to set
         */
        function msg_get_redbag_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_redbag_rep result.
         * @member {number} result
         * @memberof net.msg_get_redbag_rep
         * @instance
         */
        msg_get_redbag_rep.prototype.result = 0;

        /**
         * msg_get_redbag_rep redbag_id.
         * @member {number} redbag_id
         * @memberof net.msg_get_redbag_rep
         * @instance
         */
        msg_get_redbag_rep.prototype.redbag_id = 0;

        /**
         * Encodes the specified msg_get_redbag_rep message. Does not implicitly {@link net.msg_get_redbag_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {net.Imsg_get_redbag_rep} message msg_get_redbag_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_redbag_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.redbag_id != null && Object.hasOwnProperty.call(message, "redbag_id"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.redbag_id);
            return writer;
        };

        /**
         * Decodes a msg_get_redbag_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_redbag_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_redbag_rep} msg_get_redbag_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_redbag_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_redbag_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.redbag_id = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_redbag_rep;
    })();

    net.msg_input_sync = (function() {

        /**
         * Properties of a msg_input_sync.
         * @memberof net
         * @interface Imsg_input_sync
         * @property {number|Long|null} [chatkey] msg_input_sync chatkey
         * @property {number|null} [is_input] msg_input_sync is_input
         */

        /**
         * Constructs a new msg_input_sync.
         * @memberof net
         * @classdesc Represents a msg_input_sync.
         * @implements Imsg_input_sync
         * @constructor
         * @param {net.Imsg_input_sync=} [properties] Properties to set
         */
        function msg_input_sync(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_input_sync chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_input_sync
         * @instance
         */
        msg_input_sync.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_input_sync is_input.
         * @member {number} is_input
         * @memberof net.msg_input_sync
         * @instance
         */
        msg_input_sync.prototype.is_input = 0;

        /**
         * Encodes the specified msg_input_sync message. Does not implicitly {@link net.msg_input_sync.verify|verify} messages.
         * @function encode
         * @memberof net.msg_input_sync
         * @static
         * @param {net.Imsg_input_sync} message msg_input_sync message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_input_sync.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.is_input != null && Object.hasOwnProperty.call(message, "is_input"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_input);
            return writer;
        };

        /**
         * Decodes a msg_input_sync message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_input_sync
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_input_sync} msg_input_sync
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_input_sync.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_input_sync();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.is_input = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_input_sync;
    })();

    net.msg_input_sync_rep = (function() {

        /**
         * Properties of a msg_input_sync_rep.
         * @memberof net
         * @interface Imsg_input_sync_rep
         * @property {number|Long|null} [chatkey] msg_input_sync_rep chatkey
         * @property {number|null} [is_input] msg_input_sync_rep is_input
         */

        /**
         * Constructs a new msg_input_sync_rep.
         * @memberof net
         * @classdesc Represents a msg_input_sync_rep.
         * @implements Imsg_input_sync_rep
         * @constructor
         * @param {net.Imsg_input_sync_rep=} [properties] Properties to set
         */
        function msg_input_sync_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_input_sync_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_input_sync_rep
         * @instance
         */
        msg_input_sync_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_input_sync_rep is_input.
         * @member {number} is_input
         * @memberof net.msg_input_sync_rep
         * @instance
         */
        msg_input_sync_rep.prototype.is_input = 0;

        /**
         * Encodes the specified msg_input_sync_rep message. Does not implicitly {@link net.msg_input_sync_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {net.Imsg_input_sync_rep} message msg_input_sync_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_input_sync_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.is_input != null && Object.hasOwnProperty.call(message, "is_input"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_input);
            return writer;
        };

        /**
         * Decodes a msg_input_sync_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_input_sync_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_input_sync_rep} msg_input_sync_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_input_sync_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_input_sync_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.is_input = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_input_sync_rep;
    })();

    net.msg_get_online_state = (function() {

        /**
         * Properties of a msg_get_online_state.
         * @memberof net
         * @interface Imsg_get_online_state
         * @property {number|null} [uid] msg_get_online_state uid
         */

        /**
         * Constructs a new msg_get_online_state.
         * @memberof net
         * @classdesc Represents a msg_get_online_state.
         * @implements Imsg_get_online_state
         * @constructor
         * @param {net.Imsg_get_online_state=} [properties] Properties to set
         */
        function msg_get_online_state(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_state uid.
         * @member {number} uid
         * @memberof net.msg_get_online_state
         * @instance
         */
        msg_get_online_state.prototype.uid = 0;

        /**
         * Encodes the specified msg_get_online_state message. Does not implicitly {@link net.msg_get_online_state.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_state
         * @static
         * @param {net.Imsg_get_online_state} message msg_get_online_state message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_state.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_get_online_state message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_state
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_state} msg_get_online_state
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_state.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_state();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_online_state;
    })();

    net.msg_get_online_state_rep = (function() {

        /**
         * Properties of a msg_get_online_state_rep.
         * @memberof net
         * @interface Imsg_get_online_state_rep
         * @property {number|null} [uid] msg_get_online_state_rep uid
         * @property {number|null} [lastlogouttime] msg_get_online_state_rep lastlogouttime
         */

        /**
         * Constructs a new msg_get_online_state_rep.
         * @memberof net
         * @classdesc Represents a msg_get_online_state_rep.
         * @implements Imsg_get_online_state_rep
         * @constructor
         * @param {net.Imsg_get_online_state_rep=} [properties] Properties to set
         */
        function msg_get_online_state_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_state_rep uid.
         * @member {number} uid
         * @memberof net.msg_get_online_state_rep
         * @instance
         */
        msg_get_online_state_rep.prototype.uid = 0;

        /**
         * msg_get_online_state_rep lastlogouttime.
         * @member {number} lastlogouttime
         * @memberof net.msg_get_online_state_rep
         * @instance
         */
        msg_get_online_state_rep.prototype.lastlogouttime = 0;

        /**
         * Encodes the specified msg_get_online_state_rep message. Does not implicitly {@link net.msg_get_online_state_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {net.Imsg_get_online_state_rep} message msg_get_online_state_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_state_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.lastlogouttime != null && Object.hasOwnProperty.call(message, "lastlogouttime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.lastlogouttime);
            return writer;
        };

        /**
         * Decodes a msg_get_online_state_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_state_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_state_rep} msg_get_online_state_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_state_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_state_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.lastlogouttime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_online_state_rep;
    })();

    net.msg_get_group_online = (function() {

        /**
         * Properties of a msg_get_group_online.
         * @memberof net
         * @interface Imsg_get_group_online
         * @property {number|null} [groupkey] msg_get_group_online groupkey
         */

        /**
         * Constructs a new msg_get_group_online.
         * @memberof net
         * @classdesc Represents a msg_get_group_online.
         * @implements Imsg_get_group_online
         * @constructor
         * @param {net.Imsg_get_group_online=} [properties] Properties to set
         */
        function msg_get_group_online(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_online groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_online
         * @instance
         */
        msg_get_group_online.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_get_group_online message. Does not implicitly {@link net.msg_get_group_online.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_online
         * @static
         * @param {net.Imsg_get_group_online} message msg_get_group_online message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_online.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_get_group_online message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_online
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_online} msg_get_group_online
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_online.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_online();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_online;
    })();

    net.msg_get_group_online_rep = (function() {

        /**
         * Properties of a msg_get_group_online_rep.
         * @memberof net
         * @interface Imsg_get_group_online_rep
         * @property {number|null} [group_online] msg_get_group_online_rep group_online
         */

        /**
         * Constructs a new msg_get_group_online_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_online_rep.
         * @implements Imsg_get_group_online_rep
         * @constructor
         * @param {net.Imsg_get_group_online_rep=} [properties] Properties to set
         */
        function msg_get_group_online_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_online_rep group_online.
         * @member {number} group_online
         * @memberof net.msg_get_group_online_rep
         * @instance
         */
        msg_get_group_online_rep.prototype.group_online = 0;

        /**
         * Encodes the specified msg_get_group_online_rep message. Does not implicitly {@link net.msg_get_group_online_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {net.Imsg_get_group_online_rep} message msg_get_group_online_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_online_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.group_online != null && Object.hasOwnProperty.call(message, "group_online"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.group_online);
            return writer;
        };

        /**
         * Decodes a msg_get_group_online_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_online_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_online_rep} msg_get_group_online_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_online_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_online_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.group_online = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_online_rep;
    })();

    net.msg_set_mute_notifications = (function() {

        /**
         * Properties of a msg_set_mute_notifications.
         * @memberof net
         * @interface Imsg_set_mute_notifications
         * @property {number|Long|null} [chatkey] msg_set_mute_notifications chatkey
         * @property {number|null} [opertype] msg_set_mute_notifications opertype
         */

        /**
         * Constructs a new msg_set_mute_notifications.
         * @memberof net
         * @classdesc Represents a msg_set_mute_notifications.
         * @implements Imsg_set_mute_notifications
         * @constructor
         * @param {net.Imsg_set_mute_notifications=} [properties] Properties to set
         */
        function msg_set_mute_notifications(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_mute_notifications chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_mute_notifications
         * @instance
         */
        msg_set_mute_notifications.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_mute_notifications opertype.
         * @member {number} opertype
         * @memberof net.msg_set_mute_notifications
         * @instance
         */
        msg_set_mute_notifications.prototype.opertype = 0;

        /**
         * Encodes the specified msg_set_mute_notifications message. Does not implicitly {@link net.msg_set_mute_notifications.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {net.Imsg_set_mute_notifications} message msg_set_mute_notifications message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_mute_notifications.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_set_mute_notifications message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_mute_notifications
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_mute_notifications} msg_set_mute_notifications
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_mute_notifications.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_mute_notifications();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_mute_notifications;
    })();

    net.msg_set_mute_notifications_rep = (function() {

        /**
         * Properties of a msg_set_mute_notifications_rep.
         * @memberof net
         * @interface Imsg_set_mute_notifications_rep
         * @property {number|null} [result] msg_set_mute_notifications_rep result
         * @property {number|Long|null} [chatkey] msg_set_mute_notifications_rep chatkey
         * @property {number|null} [opertype] msg_set_mute_notifications_rep opertype
         */

        /**
         * Constructs a new msg_set_mute_notifications_rep.
         * @memberof net
         * @classdesc Represents a msg_set_mute_notifications_rep.
         * @implements Imsg_set_mute_notifications_rep
         * @constructor
         * @param {net.Imsg_set_mute_notifications_rep=} [properties] Properties to set
         */
        function msg_set_mute_notifications_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_mute_notifications_rep result.
         * @member {number} result
         * @memberof net.msg_set_mute_notifications_rep
         * @instance
         */
        msg_set_mute_notifications_rep.prototype.result = 0;

        /**
         * msg_set_mute_notifications_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_mute_notifications_rep
         * @instance
         */
        msg_set_mute_notifications_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_mute_notifications_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_set_mute_notifications_rep
         * @instance
         */
        msg_set_mute_notifications_rep.prototype.opertype = 0;

        /**
         * Encodes the specified msg_set_mute_notifications_rep message. Does not implicitly {@link net.msg_set_mute_notifications_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {net.Imsg_set_mute_notifications_rep} message msg_set_mute_notifications_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_mute_notifications_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_set_mute_notifications_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_mute_notifications_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_mute_notifications_rep} msg_set_mute_notifications_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_mute_notifications_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_mute_notifications_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_mute_notifications_rep;
    })();

    net.msg_set_chat_on_top = (function() {

        /**
         * Properties of a msg_set_chat_on_top.
         * @memberof net
         * @interface Imsg_set_chat_on_top
         * @property {number|Long|null} [chatkey] msg_set_chat_on_top chatkey
         * @property {number|null} [opertype] msg_set_chat_on_top opertype
         */

        /**
         * Constructs a new msg_set_chat_on_top.
         * @memberof net
         * @classdesc Represents a msg_set_chat_on_top.
         * @implements Imsg_set_chat_on_top
         * @constructor
         * @param {net.Imsg_set_chat_on_top=} [properties] Properties to set
         */
        function msg_set_chat_on_top(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_chat_on_top chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_chat_on_top
         * @instance
         */
        msg_set_chat_on_top.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_chat_on_top opertype.
         * @member {number} opertype
         * @memberof net.msg_set_chat_on_top
         * @instance
         */
        msg_set_chat_on_top.prototype.opertype = 0;

        /**
         * Encodes the specified msg_set_chat_on_top message. Does not implicitly {@link net.msg_set_chat_on_top.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {net.Imsg_set_chat_on_top} message msg_set_chat_on_top message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_chat_on_top.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_set_chat_on_top message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_chat_on_top
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_chat_on_top} msg_set_chat_on_top
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_chat_on_top.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_chat_on_top();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_chat_on_top;
    })();

    net.msg_set_chat_on_top_rep = (function() {

        /**
         * Properties of a msg_set_chat_on_top_rep.
         * @memberof net
         * @interface Imsg_set_chat_on_top_rep
         * @property {number|null} [result] msg_set_chat_on_top_rep result
         * @property {number|Long|null} [chatkey] msg_set_chat_on_top_rep chatkey
         * @property {number|null} [opertype] msg_set_chat_on_top_rep opertype
         * @property {number|null} [opertime] msg_set_chat_on_top_rep opertime
         */

        /**
         * Constructs a new msg_set_chat_on_top_rep.
         * @memberof net
         * @classdesc Represents a msg_set_chat_on_top_rep.
         * @implements Imsg_set_chat_on_top_rep
         * @constructor
         * @param {net.Imsg_set_chat_on_top_rep=} [properties] Properties to set
         */
        function msg_set_chat_on_top_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_chat_on_top_rep result.
         * @member {number} result
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.result = 0;

        /**
         * msg_set_chat_on_top_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_chat_on_top_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.opertype = 0;

        /**
         * msg_set_chat_on_top_rep opertime.
         * @member {number} opertime
         * @memberof net.msg_set_chat_on_top_rep
         * @instance
         */
        msg_set_chat_on_top_rep.prototype.opertime = 0;

        /**
         * Encodes the specified msg_set_chat_on_top_rep message. Does not implicitly {@link net.msg_set_chat_on_top_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {net.Imsg_set_chat_on_top_rep} message msg_set_chat_on_top_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_chat_on_top_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            if (message.opertime != null && Object.hasOwnProperty.call(message, "opertime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.opertime);
            return writer;
        };

        /**
         * Decodes a msg_set_chat_on_top_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_chat_on_top_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_chat_on_top_rep} msg_set_chat_on_top_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_chat_on_top_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_chat_on_top_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                case 4:
                    message.opertime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_chat_on_top_rep;
    })();

    net.msg_get_mute_notify_list = (function() {

        /**
         * Properties of a msg_get_mute_notify_list.
         * @memberof net
         * @interface Imsg_get_mute_notify_list
         */

        /**
         * Constructs a new msg_get_mute_notify_list.
         * @memberof net
         * @classdesc Represents a msg_get_mute_notify_list.
         * @implements Imsg_get_mute_notify_list
         * @constructor
         * @param {net.Imsg_get_mute_notify_list=} [properties] Properties to set
         */
        function msg_get_mute_notify_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_mute_notify_list message. Does not implicitly {@link net.msg_get_mute_notify_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {net.Imsg_get_mute_notify_list} message msg_get_mute_notify_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_mute_notify_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_mute_notify_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_mute_notify_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_mute_notify_list} msg_get_mute_notify_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_mute_notify_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_mute_notify_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_mute_notify_list;
    })();

    net.msg_get_mute_notify_list_rep = (function() {

        /**
         * Properties of a msg_get_mute_notify_list_rep.
         * @memberof net
         * @interface Imsg_get_mute_notify_list_rep
         * @property {Array.<net.Ioper_chatkey_info>|null} [chatkeys] msg_get_mute_notify_list_rep chatkeys
         */

        /**
         * Constructs a new msg_get_mute_notify_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_mute_notify_list_rep.
         * @implements Imsg_get_mute_notify_list_rep
         * @constructor
         * @param {net.Imsg_get_mute_notify_list_rep=} [properties] Properties to set
         */
        function msg_get_mute_notify_list_rep(properties) {
            this.chatkeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_mute_notify_list_rep chatkeys.
         * @member {Array.<net.Ioper_chatkey_info>} chatkeys
         * @memberof net.msg_get_mute_notify_list_rep
         * @instance
         */
        msg_get_mute_notify_list_rep.prototype.chatkeys = $util.emptyArray;

        /**
         * Encodes the specified msg_get_mute_notify_list_rep message. Does not implicitly {@link net.msg_get_mute_notify_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {net.Imsg_get_mute_notify_list_rep} message msg_get_mute_notify_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_mute_notify_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkeys != null && message.chatkeys.length)
                for (var i = 0; i < message.chatkeys.length; ++i)
                    $root.net.oper_chatkey_info.encode(message.chatkeys[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_mute_notify_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_mute_notify_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_mute_notify_list_rep} msg_get_mute_notify_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_mute_notify_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_mute_notify_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.chatkeys && message.chatkeys.length))
                        message.chatkeys = [];
                    message.chatkeys.push($root.net.oper_chatkey_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_mute_notify_list_rep;
    })();

    net.msg_get_chat_on_top_list = (function() {

        /**
         * Properties of a msg_get_chat_on_top_list.
         * @memberof net
         * @interface Imsg_get_chat_on_top_list
         */

        /**
         * Constructs a new msg_get_chat_on_top_list.
         * @memberof net
         * @classdesc Represents a msg_get_chat_on_top_list.
         * @implements Imsg_get_chat_on_top_list
         * @constructor
         * @param {net.Imsg_get_chat_on_top_list=} [properties] Properties to set
         */
        function msg_get_chat_on_top_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_chat_on_top_list message. Does not implicitly {@link net.msg_get_chat_on_top_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {net.Imsg_get_chat_on_top_list} message msg_get_chat_on_top_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chat_on_top_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_chat_on_top_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chat_on_top_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chat_on_top_list} msg_get_chat_on_top_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chat_on_top_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chat_on_top_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chat_on_top_list;
    })();

    net.msg_get_chat_on_top_list_rep = (function() {

        /**
         * Properties of a msg_get_chat_on_top_list_rep.
         * @memberof net
         * @interface Imsg_get_chat_on_top_list_rep
         * @property {Array.<net.Ioper_chatkey_info>|null} [chatkeys] msg_get_chat_on_top_list_rep chatkeys
         */

        /**
         * Constructs a new msg_get_chat_on_top_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chat_on_top_list_rep.
         * @implements Imsg_get_chat_on_top_list_rep
         * @constructor
         * @param {net.Imsg_get_chat_on_top_list_rep=} [properties] Properties to set
         */
        function msg_get_chat_on_top_list_rep(properties) {
            this.chatkeys = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chat_on_top_list_rep chatkeys.
         * @member {Array.<net.Ioper_chatkey_info>} chatkeys
         * @memberof net.msg_get_chat_on_top_list_rep
         * @instance
         */
        msg_get_chat_on_top_list_rep.prototype.chatkeys = $util.emptyArray;

        /**
         * Encodes the specified msg_get_chat_on_top_list_rep message. Does not implicitly {@link net.msg_get_chat_on_top_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {net.Imsg_get_chat_on_top_list_rep} message msg_get_chat_on_top_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chat_on_top_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkeys != null && message.chatkeys.length)
                for (var i = 0; i < message.chatkeys.length; ++i)
                    $root.net.oper_chatkey_info.encode(message.chatkeys[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_chat_on_top_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chat_on_top_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chat_on_top_list_rep} msg_get_chat_on_top_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chat_on_top_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chat_on_top_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.chatkeys && message.chatkeys.length))
                        message.chatkeys = [];
                    message.chatkeys.push($root.net.oper_chatkey_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chat_on_top_list_rep;
    })();

    net.msg_del_chat_msg = (function() {

        /**
         * Properties of a msg_del_chat_msg.
         * @memberof net
         * @interface Imsg_del_chat_msg
         * @property {number|Long|null} [chatkey] msg_del_chat_msg chatkey
         */

        /**
         * Constructs a new msg_del_chat_msg.
         * @memberof net
         * @classdesc Represents a msg_del_chat_msg.
         * @implements Imsg_del_chat_msg
         * @constructor
         * @param {net.Imsg_del_chat_msg=} [properties] Properties to set
         */
        function msg_del_chat_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chat_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_del_chat_msg
         * @instance
         */
        msg_del_chat_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_del_chat_msg message. Does not implicitly {@link net.msg_del_chat_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {net.Imsg_del_chat_msg} message msg_del_chat_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chat_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            return writer;
        };

        /**
         * Decodes a msg_del_chat_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chat_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chat_msg} msg_del_chat_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chat_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chat_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_chat_msg;
    })();

    net.msg_del_chat_msg_rep = (function() {

        /**
         * Properties of a msg_del_chat_msg_rep.
         * @memberof net
         * @interface Imsg_del_chat_msg_rep
         * @property {number|null} [result] msg_del_chat_msg_rep result
         * @property {number|Long|null} [chatkey] msg_del_chat_msg_rep chatkey
         * @property {number|null} [chatmsgno] msg_del_chat_msg_rep chatmsgno
         * @property {number|null} [uid] msg_del_chat_msg_rep uid
         */

        /**
         * Constructs a new msg_del_chat_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_del_chat_msg_rep.
         * @implements Imsg_del_chat_msg_rep
         * @constructor
         * @param {net.Imsg_del_chat_msg_rep=} [properties] Properties to set
         */
        function msg_del_chat_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chat_msg_rep result.
         * @member {number} result
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.result = 0;

        /**
         * msg_del_chat_msg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_del_chat_msg_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.chatmsgno = 0;

        /**
         * msg_del_chat_msg_rep uid.
         * @member {number} uid
         * @memberof net.msg_del_chat_msg_rep
         * @instance
         */
        msg_del_chat_msg_rep.prototype.uid = 0;

        /**
         * Encodes the specified msg_del_chat_msg_rep message. Does not implicitly {@link net.msg_del_chat_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {net.Imsg_del_chat_msg_rep} message msg_del_chat_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chat_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_del_chat_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chat_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chat_msg_rep} msg_del_chat_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chat_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chat_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.chatmsgno = reader.int32();
                    break;
                case 4:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_chat_msg_rep;
    })();

    net.msg_confirm_del_msg = (function() {

        /**
         * Properties of a msg_confirm_del_msg.
         * @memberof net
         * @interface Imsg_confirm_del_msg
         * @property {number|Long|null} [chatkey] msg_confirm_del_msg chatkey
         * @property {number|null} [chatmsgno] msg_confirm_del_msg chatmsgno
         */

        /**
         * Constructs a new msg_confirm_del_msg.
         * @memberof net
         * @classdesc Represents a msg_confirm_del_msg.
         * @implements Imsg_confirm_del_msg
         * @constructor
         * @param {net.Imsg_confirm_del_msg=} [properties] Properties to set
         */
        function msg_confirm_del_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_del_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_del_msg
         * @instance
         */
        msg_confirm_del_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_del_msg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_confirm_del_msg
         * @instance
         */
        msg_confirm_del_msg.prototype.chatmsgno = 0;

        /**
         * Encodes the specified msg_confirm_del_msg message. Does not implicitly {@link net.msg_confirm_del_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {net.Imsg_confirm_del_msg} message msg_confirm_del_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_del_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Decodes a msg_confirm_del_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_del_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_del_msg} msg_confirm_del_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_del_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_del_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_del_msg;
    })();

    net.msg_confirm_del_msg_rep = (function() {

        /**
         * Properties of a msg_confirm_del_msg_rep.
         * @memberof net
         * @interface Imsg_confirm_del_msg_rep
         * @property {number|null} [result] msg_confirm_del_msg_rep result
         * @property {number|Long|null} [chatkey] msg_confirm_del_msg_rep chatkey
         * @property {number|null} [chatmsgno] msg_confirm_del_msg_rep chatmsgno
         */

        /**
         * Constructs a new msg_confirm_del_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_del_msg_rep.
         * @implements Imsg_confirm_del_msg_rep
         * @constructor
         * @param {net.Imsg_confirm_del_msg_rep=} [properties] Properties to set
         */
        function msg_confirm_del_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_del_msg_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_del_msg_rep
         * @instance
         */
        msg_confirm_del_msg_rep.prototype.result = 0;

        /**
         * msg_confirm_del_msg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_del_msg_rep
         * @instance
         */
        msg_confirm_del_msg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_del_msg_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_confirm_del_msg_rep
         * @instance
         */
        msg_confirm_del_msg_rep.prototype.chatmsgno = 0;

        /**
         * Encodes the specified msg_confirm_del_msg_rep message. Does not implicitly {@link net.msg_confirm_del_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {net.Imsg_confirm_del_msg_rep} message msg_confirm_del_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_del_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Decodes a msg_confirm_del_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_del_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_del_msg_rep} msg_confirm_del_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_del_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_del_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_del_msg_rep;
    })();

    net.msg_get_offline_data = (function() {

        /**
         * Properties of a msg_get_offline_data.
         * @memberof net
         * @interface Imsg_get_offline_data
         */

        /**
         * Constructs a new msg_get_offline_data.
         * @memberof net
         * @classdesc Represents a msg_get_offline_data.
         * @implements Imsg_get_offline_data
         * @constructor
         * @param {net.Imsg_get_offline_data=} [properties] Properties to set
         */
        function msg_get_offline_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_offline_data message. Does not implicitly {@link net.msg_get_offline_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_offline_data
         * @static
         * @param {net.Imsg_get_offline_data} message msg_get_offline_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_offline_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_offline_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_offline_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_offline_data} msg_get_offline_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_offline_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_offline_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_offline_data;
    })();

    net.msg_delete_friend = (function() {

        /**
         * Properties of a msg_delete_friend.
         * @memberof net
         * @interface Imsg_delete_friend
         * @property {number|null} [frienduid] msg_delete_friend frienduid
         */

        /**
         * Constructs a new msg_delete_friend.
         * @memberof net
         * @classdesc Represents a msg_delete_friend.
         * @implements Imsg_delete_friend
         * @constructor
         * @param {net.Imsg_delete_friend=} [properties] Properties to set
         */
        function msg_delete_friend(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_delete_friend frienduid.
         * @member {number} frienduid
         * @memberof net.msg_delete_friend
         * @instance
         */
        msg_delete_friend.prototype.frienduid = 0;

        /**
         * Encodes the specified msg_delete_friend message. Does not implicitly {@link net.msg_delete_friend.verify|verify} messages.
         * @function encode
         * @memberof net.msg_delete_friend
         * @static
         * @param {net.Imsg_delete_friend} message msg_delete_friend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_delete_friend.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.frienduid != null && Object.hasOwnProperty.call(message, "frienduid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.frienduid);
            return writer;
        };

        /**
         * Decodes a msg_delete_friend message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_delete_friend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_delete_friend} msg_delete_friend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_delete_friend.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_delete_friend();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.frienduid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_delete_friend;
    })();

    net.msg_delete_friend_rep = (function() {

        /**
         * Properties of a msg_delete_friend_rep.
         * @memberof net
         * @interface Imsg_delete_friend_rep
         * @property {number|null} [result] msg_delete_friend_rep result
         * @property {number|null} [frienduid] msg_delete_friend_rep frienduid
         */

        /**
         * Constructs a new msg_delete_friend_rep.
         * @memberof net
         * @classdesc Represents a msg_delete_friend_rep.
         * @implements Imsg_delete_friend_rep
         * @constructor
         * @param {net.Imsg_delete_friend_rep=} [properties] Properties to set
         */
        function msg_delete_friend_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_delete_friend_rep result.
         * @member {number} result
         * @memberof net.msg_delete_friend_rep
         * @instance
         */
        msg_delete_friend_rep.prototype.result = 0;

        /**
         * msg_delete_friend_rep frienduid.
         * @member {number} frienduid
         * @memberof net.msg_delete_friend_rep
         * @instance
         */
        msg_delete_friend_rep.prototype.frienduid = 0;

        /**
         * Encodes the specified msg_delete_friend_rep message. Does not implicitly {@link net.msg_delete_friend_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {net.Imsg_delete_friend_rep} message msg_delete_friend_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_delete_friend_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.frienduid != null && Object.hasOwnProperty.call(message, "frienduid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.frienduid);
            return writer;
        };

        /**
         * Decodes a msg_delete_friend_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_delete_friend_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_delete_friend_rep} msg_delete_friend_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_delete_friend_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_delete_friend_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.frienduid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_delete_friend_rep;
    })();

    net.msg_set_alias = (function() {

        /**
         * Properties of a msg_set_alias.
         * @memberof net
         * @interface Imsg_set_alias
         * @property {number|null} [fuid] msg_set_alias fuid
         * @property {Uint8Array|null} [alias] msg_set_alias alias
         */

        /**
         * Constructs a new msg_set_alias.
         * @memberof net
         * @classdesc Represents a msg_set_alias.
         * @implements Imsg_set_alias
         * @constructor
         * @param {net.Imsg_set_alias=} [properties] Properties to set
         */
        function msg_set_alias(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_alias fuid.
         * @member {number} fuid
         * @memberof net.msg_set_alias
         * @instance
         */
        msg_set_alias.prototype.fuid = 0;

        /**
         * msg_set_alias alias.
         * @member {Uint8Array} alias
         * @memberof net.msg_set_alias
         * @instance
         */
        msg_set_alias.prototype.alias = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_alias message. Does not implicitly {@link net.msg_set_alias.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_alias
         * @static
         * @param {net.Imsg_set_alias} message msg_set_alias message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_alias.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fuid);
            if (message.alias != null && Object.hasOwnProperty.call(message, "alias"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.alias);
            return writer;
        };

        /**
         * Decodes a msg_set_alias message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_alias
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_alias} msg_set_alias
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_alias.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_alias();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fuid = reader.int32();
                    break;
                case 2:
                    message.alias = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_alias;
    })();

    net.msg_set_alias_rep = (function() {

        /**
         * Properties of a msg_set_alias_rep.
         * @memberof net
         * @interface Imsg_set_alias_rep
         * @property {number|null} [result] msg_set_alias_rep result
         * @property {number|null} [fuid] msg_set_alias_rep fuid
         * @property {Uint8Array|null} [alias] msg_set_alias_rep alias
         */

        /**
         * Constructs a new msg_set_alias_rep.
         * @memberof net
         * @classdesc Represents a msg_set_alias_rep.
         * @implements Imsg_set_alias_rep
         * @constructor
         * @param {net.Imsg_set_alias_rep=} [properties] Properties to set
         */
        function msg_set_alias_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_alias_rep result.
         * @member {number} result
         * @memberof net.msg_set_alias_rep
         * @instance
         */
        msg_set_alias_rep.prototype.result = 0;

        /**
         * msg_set_alias_rep fuid.
         * @member {number} fuid
         * @memberof net.msg_set_alias_rep
         * @instance
         */
        msg_set_alias_rep.prototype.fuid = 0;

        /**
         * msg_set_alias_rep alias.
         * @member {Uint8Array} alias
         * @memberof net.msg_set_alias_rep
         * @instance
         */
        msg_set_alias_rep.prototype.alias = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_alias_rep message. Does not implicitly {@link net.msg_set_alias_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {net.Imsg_set_alias_rep} message msg_set_alias_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_alias_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.fuid != null && Object.hasOwnProperty.call(message, "fuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.fuid);
            if (message.alias != null && Object.hasOwnProperty.call(message, "alias"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.alias);
            return writer;
        };

        /**
         * Decodes a msg_set_alias_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_alias_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_alias_rep} msg_set_alias_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_alias_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_alias_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.fuid = reader.int32();
                    break;
                case 3:
                    message.alias = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_alias_rep;
    })();

    net.msg_getalias_list = (function() {

        /**
         * Properties of a msg_getalias_list.
         * @memberof net
         * @interface Imsg_getalias_list
         */

        /**
         * Constructs a new msg_getalias_list.
         * @memberof net
         * @classdesc Represents a msg_getalias_list.
         * @implements Imsg_getalias_list
         * @constructor
         * @param {net.Imsg_getalias_list=} [properties] Properties to set
         */
        function msg_getalias_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_getalias_list message. Does not implicitly {@link net.msg_getalias_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_getalias_list
         * @static
         * @param {net.Imsg_getalias_list} message msg_getalias_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_getalias_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_getalias_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_getalias_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_getalias_list} msg_getalias_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_getalias_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_getalias_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_getalias_list;
    })();

    net.msg_getalias_list_rep = (function() {

        /**
         * Properties of a msg_getalias_list_rep.
         * @memberof net
         * @interface Imsg_getalias_list_rep
         * @property {Array.<net.Ialias_info>|null} [alias_list] msg_getalias_list_rep alias_list
         */

        /**
         * Constructs a new msg_getalias_list_rep.
         * @memberof net
         * @classdesc Represents a msg_getalias_list_rep.
         * @implements Imsg_getalias_list_rep
         * @constructor
         * @param {net.Imsg_getalias_list_rep=} [properties] Properties to set
         */
        function msg_getalias_list_rep(properties) {
            this.alias_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_getalias_list_rep alias_list.
         * @member {Array.<net.Ialias_info>} alias_list
         * @memberof net.msg_getalias_list_rep
         * @instance
         */
        msg_getalias_list_rep.prototype.alias_list = $util.emptyArray;

        /**
         * Encodes the specified msg_getalias_list_rep message. Does not implicitly {@link net.msg_getalias_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {net.Imsg_getalias_list_rep} message msg_getalias_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_getalias_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.alias_list != null && message.alias_list.length)
                for (var i = 0; i < message.alias_list.length; ++i)
                    $root.net.alias_info.encode(message.alias_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_getalias_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_getalias_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_getalias_list_rep} msg_getalias_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_getalias_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_getalias_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.alias_list && message.alias_list.length))
                        message.alias_list = [];
                    message.alias_list.push($root.net.alias_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_getalias_list_rep;
    })();

    net.msg_set_sign = (function() {

        /**
         * Properties of a msg_set_sign.
         * @memberof net
         * @interface Imsg_set_sign
         * @property {Uint8Array|null} [sign] msg_set_sign sign
         */

        /**
         * Constructs a new msg_set_sign.
         * @memberof net
         * @classdesc Represents a msg_set_sign.
         * @implements Imsg_set_sign
         * @constructor
         * @param {net.Imsg_set_sign=} [properties] Properties to set
         */
        function msg_set_sign(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_sign sign.
         * @member {Uint8Array} sign
         * @memberof net.msg_set_sign
         * @instance
         */
        msg_set_sign.prototype.sign = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_sign message. Does not implicitly {@link net.msg_set_sign.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_sign
         * @static
         * @param {net.Imsg_set_sign} message msg_set_sign message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_sign.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.sign);
            return writer;
        };

        /**
         * Decodes a msg_set_sign message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_sign
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_sign} msg_set_sign
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_sign.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_sign();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.sign = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_sign;
    })();

    net.msg_set_sign_rep = (function() {

        /**
         * Properties of a msg_set_sign_rep.
         * @memberof net
         * @interface Imsg_set_sign_rep
         * @property {number|null} [result] msg_set_sign_rep result
         * @property {Uint8Array|null} [sign] msg_set_sign_rep sign
         */

        /**
         * Constructs a new msg_set_sign_rep.
         * @memberof net
         * @classdesc Represents a msg_set_sign_rep.
         * @implements Imsg_set_sign_rep
         * @constructor
         * @param {net.Imsg_set_sign_rep=} [properties] Properties to set
         */
        function msg_set_sign_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_sign_rep result.
         * @member {number} result
         * @memberof net.msg_set_sign_rep
         * @instance
         */
        msg_set_sign_rep.prototype.result = 0;

        /**
         * msg_set_sign_rep sign.
         * @member {Uint8Array} sign
         * @memberof net.msg_set_sign_rep
         * @instance
         */
        msg_set_sign_rep.prototype.sign = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_sign_rep message. Does not implicitly {@link net.msg_set_sign_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {net.Imsg_set_sign_rep} message msg_set_sign_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_sign_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.sign);
            return writer;
        };

        /**
         * Decodes a msg_set_sign_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_sign_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_sign_rep} msg_set_sign_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_sign_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_sign_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.sign = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_sign_rep;
    })();

    net.msg_set_region = (function() {

        /**
         * Properties of a msg_set_region.
         * @memberof net
         * @interface Imsg_set_region
         * @property {Uint8Array|null} [region] msg_set_region region
         */

        /**
         * Constructs a new msg_set_region.
         * @memberof net
         * @classdesc Represents a msg_set_region.
         * @implements Imsg_set_region
         * @constructor
         * @param {net.Imsg_set_region=} [properties] Properties to set
         */
        function msg_set_region(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_region region.
         * @member {Uint8Array} region
         * @memberof net.msg_set_region
         * @instance
         */
        msg_set_region.prototype.region = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_region message. Does not implicitly {@link net.msg_set_region.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_region
         * @static
         * @param {net.Imsg_set_region} message msg_set_region message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_region.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.region);
            return writer;
        };

        /**
         * Decodes a msg_set_region message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_region
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_region} msg_set_region
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_region.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_region();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.region = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_region;
    })();

    net.msg_set_region_rep = (function() {

        /**
         * Properties of a msg_set_region_rep.
         * @memberof net
         * @interface Imsg_set_region_rep
         * @property {number|null} [result] msg_set_region_rep result
         * @property {Uint8Array|null} [region] msg_set_region_rep region
         */

        /**
         * Constructs a new msg_set_region_rep.
         * @memberof net
         * @classdesc Represents a msg_set_region_rep.
         * @implements Imsg_set_region_rep
         * @constructor
         * @param {net.Imsg_set_region_rep=} [properties] Properties to set
         */
        function msg_set_region_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_region_rep result.
         * @member {number} result
         * @memberof net.msg_set_region_rep
         * @instance
         */
        msg_set_region_rep.prototype.result = 0;

        /**
         * msg_set_region_rep region.
         * @member {Uint8Array} region
         * @memberof net.msg_set_region_rep
         * @instance
         */
        msg_set_region_rep.prototype.region = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_region_rep message. Does not implicitly {@link net.msg_set_region_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_region_rep
         * @static
         * @param {net.Imsg_set_region_rep} message msg_set_region_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_region_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.region);
            return writer;
        };

        /**
         * Decodes a msg_set_region_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_region_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_region_rep} msg_set_region_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_region_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_region_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.region = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_region_rep;
    })();

    net.msg_set_headurl = (function() {

        /**
         * Properties of a msg_set_headurl.
         * @memberof net
         * @interface Imsg_set_headurl
         * @property {Uint8Array|null} [headurl] msg_set_headurl headurl
         */

        /**
         * Constructs a new msg_set_headurl.
         * @memberof net
         * @classdesc Represents a msg_set_headurl.
         * @implements Imsg_set_headurl
         * @constructor
         * @param {net.Imsg_set_headurl=} [properties] Properties to set
         */
        function msg_set_headurl(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_headurl headurl.
         * @member {Uint8Array} headurl
         * @memberof net.msg_set_headurl
         * @instance
         */
        msg_set_headurl.prototype.headurl = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_headurl message. Does not implicitly {@link net.msg_set_headurl.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_headurl
         * @static
         * @param {net.Imsg_set_headurl} message msg_set_headurl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_headurl.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.headurl);
            return writer;
        };

        /**
         * Decodes a msg_set_headurl message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_headurl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_headurl} msg_set_headurl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_headurl.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_headurl();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_headurl;
    })();

    net.msg_set_headurl_rep = (function() {

        /**
         * Properties of a msg_set_headurl_rep.
         * @memberof net
         * @interface Imsg_set_headurl_rep
         * @property {number|null} [result] msg_set_headurl_rep result
         * @property {Uint8Array|null} [headurl] msg_set_headurl_rep headurl
         */

        /**
         * Constructs a new msg_set_headurl_rep.
         * @memberof net
         * @classdesc Represents a msg_set_headurl_rep.
         * @implements Imsg_set_headurl_rep
         * @constructor
         * @param {net.Imsg_set_headurl_rep=} [properties] Properties to set
         */
        function msg_set_headurl_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_headurl_rep result.
         * @member {number} result
         * @memberof net.msg_set_headurl_rep
         * @instance
         */
        msg_set_headurl_rep.prototype.result = 0;

        /**
         * msg_set_headurl_rep headurl.
         * @member {Uint8Array} headurl
         * @memberof net.msg_set_headurl_rep
         * @instance
         */
        msg_set_headurl_rep.prototype.headurl = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_headurl_rep message. Does not implicitly {@link net.msg_set_headurl_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {net.Imsg_set_headurl_rep} message msg_set_headurl_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_headurl_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.headurl != null && Object.hasOwnProperty.call(message, "headurl"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.headurl);
            return writer;
        };

        /**
         * Decodes a msg_set_headurl_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_headurl_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_headurl_rep} msg_set_headurl_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_headurl_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_headurl_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.headurl = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_headurl_rep;
    })();

    net.msg_set_name = (function() {

        /**
         * Properties of a msg_set_name.
         * @memberof net
         * @interface Imsg_set_name
         * @property {Uint8Array|null} [name] msg_set_name name
         */

        /**
         * Constructs a new msg_set_name.
         * @memberof net
         * @classdesc Represents a msg_set_name.
         * @implements Imsg_set_name
         * @constructor
         * @param {net.Imsg_set_name=} [properties] Properties to set
         */
        function msg_set_name(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_name name.
         * @member {Uint8Array} name
         * @memberof net.msg_set_name
         * @instance
         */
        msg_set_name.prototype.name = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_name message. Does not implicitly {@link net.msg_set_name.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_name
         * @static
         * @param {net.Imsg_set_name} message msg_set_name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_name.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.name);
            return writer;
        };

        /**
         * Decodes a msg_set_name message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_name} msg_set_name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_name.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_name();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_name;
    })();

    net.msg_set_name_rep = (function() {

        /**
         * Properties of a msg_set_name_rep.
         * @memberof net
         * @interface Imsg_set_name_rep
         * @property {number|null} [result] msg_set_name_rep result
         * @property {Uint8Array|null} [name] msg_set_name_rep name
         */

        /**
         * Constructs a new msg_set_name_rep.
         * @memberof net
         * @classdesc Represents a msg_set_name_rep.
         * @implements Imsg_set_name_rep
         * @constructor
         * @param {net.Imsg_set_name_rep=} [properties] Properties to set
         */
        function msg_set_name_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_name_rep result.
         * @member {number} result
         * @memberof net.msg_set_name_rep
         * @instance
         */
        msg_set_name_rep.prototype.result = 0;

        /**
         * msg_set_name_rep name.
         * @member {Uint8Array} name
         * @memberof net.msg_set_name_rep
         * @instance
         */
        msg_set_name_rep.prototype.name = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_name_rep message. Does not implicitly {@link net.msg_set_name_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_name_rep
         * @static
         * @param {net.Imsg_set_name_rep} message msg_set_name_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_name_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.name);
            return writer;
        };

        /**
         * Decodes a msg_set_name_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_name_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_name_rep} msg_set_name_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_name_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_name_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.name = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_name_rep;
    })();

    net.msg_total_redbag_record = (function() {

        /**
         * Properties of a msg_total_redbag_record.
         * @memberof net
         * @interface Imsg_total_redbag_record
         */

        /**
         * Constructs a new msg_total_redbag_record.
         * @memberof net
         * @classdesc Represents a msg_total_redbag_record.
         * @implements Imsg_total_redbag_record
         * @constructor
         * @param {net.Imsg_total_redbag_record=} [properties] Properties to set
         */
        function msg_total_redbag_record(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_total_redbag_record message. Does not implicitly {@link net.msg_total_redbag_record.verify|verify} messages.
         * @function encode
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {net.Imsg_total_redbag_record} message msg_total_redbag_record message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_total_redbag_record.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_total_redbag_record message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_total_redbag_record
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_total_redbag_record} msg_total_redbag_record
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_total_redbag_record.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_total_redbag_record();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_total_redbag_record;
    })();

    net.msg_total_redbag_record_resp = (function() {

        /**
         * Properties of a msg_total_redbag_record_resp.
         * @memberof net
         * @interface Imsg_total_redbag_record_resp
         * @property {Array.<net.Iredbag_base_info>|null} [sendlist] msg_total_redbag_record_resp sendlist
         * @property {Array.<net.Iredbag_base_info>|null} [recvlist] msg_total_redbag_record_resp recvlist
         */

        /**
         * Constructs a new msg_total_redbag_record_resp.
         * @memberof net
         * @classdesc Represents a msg_total_redbag_record_resp.
         * @implements Imsg_total_redbag_record_resp
         * @constructor
         * @param {net.Imsg_total_redbag_record_resp=} [properties] Properties to set
         */
        function msg_total_redbag_record_resp(properties) {
            this.sendlist = [];
            this.recvlist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_total_redbag_record_resp sendlist.
         * @member {Array.<net.Iredbag_base_info>} sendlist
         * @memberof net.msg_total_redbag_record_resp
         * @instance
         */
        msg_total_redbag_record_resp.prototype.sendlist = $util.emptyArray;

        /**
         * msg_total_redbag_record_resp recvlist.
         * @member {Array.<net.Iredbag_base_info>} recvlist
         * @memberof net.msg_total_redbag_record_resp
         * @instance
         */
        msg_total_redbag_record_resp.prototype.recvlist = $util.emptyArray;

        /**
         * Encodes the specified msg_total_redbag_record_resp message. Does not implicitly {@link net.msg_total_redbag_record_resp.verify|verify} messages.
         * @function encode
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {net.Imsg_total_redbag_record_resp} message msg_total_redbag_record_resp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_total_redbag_record_resp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sendlist != null && message.sendlist.length)
                for (var i = 0; i < message.sendlist.length; ++i)
                    $root.net.redbag_base_info.encode(message.sendlist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.recvlist != null && message.recvlist.length)
                for (var i = 0; i < message.recvlist.length; ++i)
                    $root.net.redbag_base_info.encode(message.recvlist[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_total_redbag_record_resp message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_total_redbag_record_resp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_total_redbag_record_resp} msg_total_redbag_record_resp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_total_redbag_record_resp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_total_redbag_record_resp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.sendlist && message.sendlist.length))
                        message.sendlist = [];
                    message.sendlist.push($root.net.redbag_base_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.recvlist && message.recvlist.length))
                        message.recvlist = [];
                    message.recvlist.push($root.net.redbag_base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_total_redbag_record_resp;
    })();

    net.msg_upload_addressbook = (function() {

        /**
         * Properties of a msg_upload_addressbook.
         * @memberof net
         * @interface Imsg_upload_addressbook
         * @property {Uint8Array|null} [addressbook] msg_upload_addressbook addressbook
         * @property {number|null} [is_end] msg_upload_addressbook is_end
         */

        /**
         * Constructs a new msg_upload_addressbook.
         * @memberof net
         * @classdesc Represents a msg_upload_addressbook.
         * @implements Imsg_upload_addressbook
         * @constructor
         * @param {net.Imsg_upload_addressbook=} [properties] Properties to set
         */
        function msg_upload_addressbook(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_upload_addressbook addressbook.
         * @member {Uint8Array} addressbook
         * @memberof net.msg_upload_addressbook
         * @instance
         */
        msg_upload_addressbook.prototype.addressbook = $util.newBuffer([]);

        /**
         * msg_upload_addressbook is_end.
         * @member {number} is_end
         * @memberof net.msg_upload_addressbook
         * @instance
         */
        msg_upload_addressbook.prototype.is_end = 0;

        /**
         * Encodes the specified msg_upload_addressbook message. Does not implicitly {@link net.msg_upload_addressbook.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {net.Imsg_upload_addressbook} message msg_upload_addressbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_addressbook.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addressbook != null && Object.hasOwnProperty.call(message, "addressbook"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.addressbook);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_end);
            return writer;
        };

        /**
         * Decodes a msg_upload_addressbook message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_addressbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_addressbook} msg_upload_addressbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_addressbook.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_addressbook();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.addressbook = reader.bytes();
                    break;
                case 2:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_upload_addressbook;
    })();

    net.msg_upload_addressbook_rep = (function() {

        /**
         * Properties of a msg_upload_addressbook_rep.
         * @memberof net
         * @interface Imsg_upload_addressbook_rep
         * @property {number|null} [result] msg_upload_addressbook_rep result
         * @property {number|null} [is_end] msg_upload_addressbook_rep is_end
         */

        /**
         * Constructs a new msg_upload_addressbook_rep.
         * @memberof net
         * @classdesc Represents a msg_upload_addressbook_rep.
         * @implements Imsg_upload_addressbook_rep
         * @constructor
         * @param {net.Imsg_upload_addressbook_rep=} [properties] Properties to set
         */
        function msg_upload_addressbook_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_upload_addressbook_rep result.
         * @member {number} result
         * @memberof net.msg_upload_addressbook_rep
         * @instance
         */
        msg_upload_addressbook_rep.prototype.result = 0;

        /**
         * msg_upload_addressbook_rep is_end.
         * @member {number} is_end
         * @memberof net.msg_upload_addressbook_rep
         * @instance
         */
        msg_upload_addressbook_rep.prototype.is_end = 0;

        /**
         * Encodes the specified msg_upload_addressbook_rep message. Does not implicitly {@link net.msg_upload_addressbook_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {net.Imsg_upload_addressbook_rep} message msg_upload_addressbook_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_addressbook_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_end);
            return writer;
        };

        /**
         * Decodes a msg_upload_addressbook_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_addressbook_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_addressbook_rep} msg_upload_addressbook_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_addressbook_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_addressbook_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_upload_addressbook_rep;
    })();

    net.msg_get_addressbook = (function() {

        /**
         * Properties of a msg_get_addressbook.
         * @memberof net
         * @interface Imsg_get_addressbook
         */

        /**
         * Constructs a new msg_get_addressbook.
         * @memberof net
         * @classdesc Represents a msg_get_addressbook.
         * @implements Imsg_get_addressbook
         * @constructor
         * @param {net.Imsg_get_addressbook=} [properties] Properties to set
         */
        function msg_get_addressbook(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_addressbook message. Does not implicitly {@link net.msg_get_addressbook.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_addressbook
         * @static
         * @param {net.Imsg_get_addressbook} message msg_get_addressbook message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_addressbook.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_addressbook message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_addressbook
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_addressbook} msg_get_addressbook
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_addressbook.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_addressbook();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_addressbook;
    })();

    net.msg_get_addressbook_rep = (function() {

        /**
         * Properties of a msg_get_addressbook_rep.
         * @memberof net
         * @interface Imsg_get_addressbook_rep
         * @property {Uint8Array|null} [addressbook] msg_get_addressbook_rep addressbook
         * @property {number|null} [is_end] msg_get_addressbook_rep is_end
         */

        /**
         * Constructs a new msg_get_addressbook_rep.
         * @memberof net
         * @classdesc Represents a msg_get_addressbook_rep.
         * @implements Imsg_get_addressbook_rep
         * @constructor
         * @param {net.Imsg_get_addressbook_rep=} [properties] Properties to set
         */
        function msg_get_addressbook_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_addressbook_rep addressbook.
         * @member {Uint8Array} addressbook
         * @memberof net.msg_get_addressbook_rep
         * @instance
         */
        msg_get_addressbook_rep.prototype.addressbook = $util.newBuffer([]);

        /**
         * msg_get_addressbook_rep is_end.
         * @member {number} is_end
         * @memberof net.msg_get_addressbook_rep
         * @instance
         */
        msg_get_addressbook_rep.prototype.is_end = 0;

        /**
         * Encodes the specified msg_get_addressbook_rep message. Does not implicitly {@link net.msg_get_addressbook_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {net.Imsg_get_addressbook_rep} message msg_get_addressbook_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_addressbook_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addressbook != null && Object.hasOwnProperty.call(message, "addressbook"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.addressbook);
            if (message.is_end != null && Object.hasOwnProperty.call(message, "is_end"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.is_end);
            return writer;
        };

        /**
         * Decodes a msg_get_addressbook_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_addressbook_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_addressbook_rep} msg_get_addressbook_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_addressbook_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_addressbook_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.addressbook = reader.bytes();
                    break;
                case 2:
                    message.is_end = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_addressbook_rep;
    })();

    net.msg_upload_pushid = (function() {

        /**
         * Properties of a msg_upload_pushid.
         * @memberof net
         * @interface Imsg_upload_pushid
         * @property {Uint8Array|null} [pushid] msg_upload_pushid pushid
         * @property {number|null} [pushchannel] msg_upload_pushid pushchannel
         */

        /**
         * Constructs a new msg_upload_pushid.
         * @memberof net
         * @classdesc Represents a msg_upload_pushid.
         * @implements Imsg_upload_pushid
         * @constructor
         * @param {net.Imsg_upload_pushid=} [properties] Properties to set
         */
        function msg_upload_pushid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_upload_pushid pushid.
         * @member {Uint8Array} pushid
         * @memberof net.msg_upload_pushid
         * @instance
         */
        msg_upload_pushid.prototype.pushid = $util.newBuffer([]);

        /**
         * msg_upload_pushid pushchannel.
         * @member {number} pushchannel
         * @memberof net.msg_upload_pushid
         * @instance
         */
        msg_upload_pushid.prototype.pushchannel = 0;

        /**
         * Encodes the specified msg_upload_pushid message. Does not implicitly {@link net.msg_upload_pushid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_pushid
         * @static
         * @param {net.Imsg_upload_pushid} message msg_upload_pushid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_pushid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pushid != null && Object.hasOwnProperty.call(message, "pushid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.pushid);
            if (message.pushchannel != null && Object.hasOwnProperty.call(message, "pushchannel"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pushchannel);
            return writer;
        };

        /**
         * Decodes a msg_upload_pushid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_pushid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_pushid} msg_upload_pushid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_pushid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_pushid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pushid = reader.bytes();
                    break;
                case 2:
                    message.pushchannel = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_upload_pushid;
    })();

    net.msg_upload_pushid_rep = (function() {

        /**
         * Properties of a msg_upload_pushid_rep.
         * @memberof net
         * @interface Imsg_upload_pushid_rep
         */

        /**
         * Constructs a new msg_upload_pushid_rep.
         * @memberof net
         * @classdesc Represents a msg_upload_pushid_rep.
         * @implements Imsg_upload_pushid_rep
         * @constructor
         * @param {net.Imsg_upload_pushid_rep=} [properties] Properties to set
         */
        function msg_upload_pushid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_upload_pushid_rep message. Does not implicitly {@link net.msg_upload_pushid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {net.Imsg_upload_pushid_rep} message msg_upload_pushid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_upload_pushid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_upload_pushid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_upload_pushid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_upload_pushid_rep} msg_upload_pushid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_upload_pushid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_upload_pushid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_upload_pushid_rep;
    })();

    net.msg_set_background = (function() {

        /**
         * Properties of a msg_set_background.
         * @memberof net
         * @interface Imsg_set_background
         * @property {number|null} [is_back] msg_set_background is_back
         */

        /**
         * Constructs a new msg_set_background.
         * @memberof net
         * @classdesc Represents a msg_set_background.
         * @implements Imsg_set_background
         * @constructor
         * @param {net.Imsg_set_background=} [properties] Properties to set
         */
        function msg_set_background(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_background is_back.
         * @member {number} is_back
         * @memberof net.msg_set_background
         * @instance
         */
        msg_set_background.prototype.is_back = 0;

        /**
         * Encodes the specified msg_set_background message. Does not implicitly {@link net.msg_set_background.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_background
         * @static
         * @param {net.Imsg_set_background} message msg_set_background message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_background.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.is_back != null && Object.hasOwnProperty.call(message, "is_back"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.is_back);
            return writer;
        };

        /**
         * Decodes a msg_set_background message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_background
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_background} msg_set_background
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_background.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_background();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.is_back = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_background;
    })();

    net.msg_confirm_hasread_msg = (function() {

        /**
         * Properties of a msg_confirm_hasread_msg.
         * @memberof net
         * @interface Imsg_confirm_hasread_msg
         * @property {number|Long|null} [chatkey] msg_confirm_hasread_msg chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_confirm_hasread_msg chatmsgno_list
         */

        /**
         * Constructs a new msg_confirm_hasread_msg.
         * @memberof net
         * @classdesc Represents a msg_confirm_hasread_msg.
         * @implements Imsg_confirm_hasread_msg
         * @constructor
         * @param {net.Imsg_confirm_hasread_msg=} [properties] Properties to set
         */
        function msg_confirm_hasread_msg(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_hasread_msg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_hasread_msg
         * @instance
         */
        msg_confirm_hasread_msg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_hasread_msg chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_confirm_hasread_msg
         * @instance
         */
        msg_confirm_hasread_msg.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Encodes the specified msg_confirm_hasread_msg message. Does not implicitly {@link net.msg_confirm_hasread_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {net.Imsg_confirm_hasread_msg} message msg_confirm_hasread_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_hasread_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Decodes a msg_confirm_hasread_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_hasread_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_hasread_msg} msg_confirm_hasread_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_hasread_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_hasread_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_hasread_msg;
    })();

    net.msg_confirm_hasread_msg_rep = (function() {

        /**
         * Properties of a msg_confirm_hasread_msg_rep.
         * @memberof net
         * @interface Imsg_confirm_hasread_msg_rep
         * @property {number|null} [result] msg_confirm_hasread_msg_rep result
         * @property {number|Long|null} [chatkey] msg_confirm_hasread_msg_rep chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_confirm_hasread_msg_rep chatmsgno_list
         */

        /**
         * Constructs a new msg_confirm_hasread_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_hasread_msg_rep.
         * @implements Imsg_confirm_hasread_msg_rep
         * @constructor
         * @param {net.Imsg_confirm_hasread_msg_rep=} [properties] Properties to set
         */
        function msg_confirm_hasread_msg_rep(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_hasread_msg_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_hasread_msg_rep
         * @instance
         */
        msg_confirm_hasread_msg_rep.prototype.result = 0;

        /**
         * msg_confirm_hasread_msg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_confirm_hasread_msg_rep
         * @instance
         */
        msg_confirm_hasread_msg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_confirm_hasread_msg_rep chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_confirm_hasread_msg_rep
         * @instance
         */
        msg_confirm_hasread_msg_rep.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Encodes the specified msg_confirm_hasread_msg_rep message. Does not implicitly {@link net.msg_confirm_hasread_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {net.Imsg_confirm_hasread_msg_rep} message msg_confirm_hasread_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_hasread_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Decodes a msg_confirm_hasread_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_hasread_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_hasread_msg_rep} msg_confirm_hasread_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_hasread_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_hasread_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_hasread_msg_rep;
    })();

    net.msg_get_hasread_list = (function() {

        /**
         * Properties of a msg_get_hasread_list.
         * @memberof net
         * @interface Imsg_get_hasread_list
         * @property {number|Long|null} [chatkey] msg_get_hasread_list chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_get_hasread_list chatmsgno_list
         */

        /**
         * Constructs a new msg_get_hasread_list.
         * @memberof net
         * @classdesc Represents a msg_get_hasread_list.
         * @implements Imsg_get_hasread_list
         * @constructor
         * @param {net.Imsg_get_hasread_list=} [properties] Properties to set
         */
        function msg_get_hasread_list(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_hasread_list chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_hasread_list
         * @instance
         */
        msg_get_hasread_list.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_hasread_list chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_get_hasread_list
         * @instance
         */
        msg_get_hasread_list.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Encodes the specified msg_get_hasread_list message. Does not implicitly {@link net.msg_get_hasread_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {net.Imsg_get_hasread_list} message msg_get_hasread_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_hasread_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Decodes a msg_get_hasread_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_hasread_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_hasread_list} msg_get_hasread_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_hasread_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_hasread_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_hasread_list;
    })();

    net.msg_get_hasread_list_rep = (function() {

        /**
         * Properties of a msg_get_hasread_list_rep.
         * @memberof net
         * @interface Imsg_get_hasread_list_rep
         * @property {number|Long|null} [chatkey] msg_get_hasread_list_rep chatkey
         * @property {Array.<number>|null} [chatmsgno_list] msg_get_hasread_list_rep chatmsgno_list
         */

        /**
         * Constructs a new msg_get_hasread_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_hasread_list_rep.
         * @implements Imsg_get_hasread_list_rep
         * @constructor
         * @param {net.Imsg_get_hasread_list_rep=} [properties] Properties to set
         */
        function msg_get_hasread_list_rep(properties) {
            this.chatmsgno_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_hasread_list_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_hasread_list_rep
         * @instance
         */
        msg_get_hasread_list_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_hasread_list_rep chatmsgno_list.
         * @member {Array.<number>} chatmsgno_list
         * @memberof net.msg_get_hasread_list_rep
         * @instance
         */
        msg_get_hasread_list_rep.prototype.chatmsgno_list = $util.emptyArray;

        /**
         * Encodes the specified msg_get_hasread_list_rep message. Does not implicitly {@link net.msg_get_hasread_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {net.Imsg_get_hasread_list_rep} message msg_get_hasread_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_hasread_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno_list != null && message.chatmsgno_list.length)
                for (var i = 0; i < message.chatmsgno_list.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno_list[i]);
            return writer;
        };

        /**
         * Decodes a msg_get_hasread_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_hasread_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_hasread_list_rep} msg_get_hasread_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_hasread_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_hasread_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    if (!(message.chatmsgno_list && message.chatmsgno_list.length))
                        message.chatmsgno_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.chatmsgno_list.push(reader.int32());
                    } else
                        message.chatmsgno_list.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_hasread_list_rep;
    })();

    net.msg_transfer_account = (function() {

        /**
         * Properties of a msg_transfer_account.
         * @memberof net
         * @interface Imsg_transfer_account
         * @property {Uint8Array|null} [target_phonenum] msg_transfer_account target_phonenum
         * @property {number|null} [trans_type] msg_transfer_account trans_type
         * @property {number|null} [trans_amount] msg_transfer_account trans_amount
         * @property {Uint8Array|null} [remarks] msg_transfer_account remarks
         * @property {Uint8Array|null} [authcode] msg_transfer_account authcode
         * @property {number|null} [cointype] msg_transfer_account cointype
         */

        /**
         * Constructs a new msg_transfer_account.
         * @memberof net
         * @classdesc Represents a msg_transfer_account.
         * @implements Imsg_transfer_account
         * @constructor
         * @param {net.Imsg_transfer_account=} [properties] Properties to set
         */
        function msg_transfer_account(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_transfer_account target_phonenum.
         * @member {Uint8Array} target_phonenum
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.target_phonenum = $util.newBuffer([]);

        /**
         * msg_transfer_account trans_type.
         * @member {number} trans_type
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.trans_type = 0;

        /**
         * msg_transfer_account trans_amount.
         * @member {number} trans_amount
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.trans_amount = 0;

        /**
         * msg_transfer_account remarks.
         * @member {Uint8Array} remarks
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.remarks = $util.newBuffer([]);

        /**
         * msg_transfer_account authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.authcode = $util.newBuffer([]);

        /**
         * msg_transfer_account cointype.
         * @member {number} cointype
         * @memberof net.msg_transfer_account
         * @instance
         */
        msg_transfer_account.prototype.cointype = 0;

        /**
         * Encodes the specified msg_transfer_account message. Does not implicitly {@link net.msg_transfer_account.verify|verify} messages.
         * @function encode
         * @memberof net.msg_transfer_account
         * @static
         * @param {net.Imsg_transfer_account} message msg_transfer_account message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_transfer_account.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.target_phonenum != null && Object.hasOwnProperty.call(message, "target_phonenum"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.target_phonenum);
            if (message.trans_type != null && Object.hasOwnProperty.call(message, "trans_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.trans_type);
            if (message.trans_amount != null && Object.hasOwnProperty.call(message, "trans_amount"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.trans_amount);
            if (message.remarks != null && Object.hasOwnProperty.call(message, "remarks"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.remarks);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.authcode);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.cointype);
            return writer;
        };

        /**
         * Decodes a msg_transfer_account message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_transfer_account
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_transfer_account} msg_transfer_account
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_transfer_account.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_transfer_account();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.target_phonenum = reader.bytes();
                    break;
                case 2:
                    message.trans_type = reader.int32();
                    break;
                case 3:
                    message.trans_amount = reader.int32();
                    break;
                case 4:
                    message.remarks = reader.bytes();
                    break;
                case 5:
                    message.authcode = reader.bytes();
                    break;
                case 6:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_transfer_account;
    })();

    net.msg_transfer_account_rep = (function() {

        /**
         * Properties of a msg_transfer_account_rep.
         * @memberof net
         * @interface Imsg_transfer_account_rep
         * @property {number|null} [result] msg_transfer_account_rep result
         */

        /**
         * Constructs a new msg_transfer_account_rep.
         * @memberof net
         * @classdesc Represents a msg_transfer_account_rep.
         * @implements Imsg_transfer_account_rep
         * @constructor
         * @param {net.Imsg_transfer_account_rep=} [properties] Properties to set
         */
        function msg_transfer_account_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_transfer_account_rep result.
         * @member {number} result
         * @memberof net.msg_transfer_account_rep
         * @instance
         */
        msg_transfer_account_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_transfer_account_rep message. Does not implicitly {@link net.msg_transfer_account_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {net.Imsg_transfer_account_rep} message msg_transfer_account_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_transfer_account_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_transfer_account_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_transfer_account_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_transfer_account_rep} msg_transfer_account_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_transfer_account_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_transfer_account_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_transfer_account_rep;
    })();

    net.msg_get_online_list = (function() {

        /**
         * Properties of a msg_get_online_list.
         * @memberof net
         * @interface Imsg_get_online_list
         * @property {Array.<number>|null} [uidlist] msg_get_online_list uidlist
         */

        /**
         * Constructs a new msg_get_online_list.
         * @memberof net
         * @classdesc Represents a msg_get_online_list.
         * @implements Imsg_get_online_list
         * @constructor
         * @param {net.Imsg_get_online_list=} [properties] Properties to set
         */
        function msg_get_online_list(properties) {
            this.uidlist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_list uidlist.
         * @member {Array.<number>} uidlist
         * @memberof net.msg_get_online_list
         * @instance
         */
        msg_get_online_list.prototype.uidlist = $util.emptyArray;

        /**
         * Encodes the specified msg_get_online_list message. Does not implicitly {@link net.msg_get_online_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_list
         * @static
         * @param {net.Imsg_get_online_list} message msg_get_online_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uidlist != null && message.uidlist.length)
                for (var i = 0; i < message.uidlist.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uidlist[i]);
            return writer;
        };

        /**
         * Decodes a msg_get_online_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_list} msg_get_online_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uidlist && message.uidlist.length))
                        message.uidlist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uidlist.push(reader.int32());
                    } else
                        message.uidlist.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_online_list;
    })();

    net.msg_get_online_list_rep = (function() {

        /**
         * Properties of a msg_get_online_list_rep.
         * @memberof net
         * @interface Imsg_get_online_list_rep
         * @property {Array.<number>|null} [onlinelist] msg_get_online_list_rep onlinelist
         */

        /**
         * Constructs a new msg_get_online_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_online_list_rep.
         * @implements Imsg_get_online_list_rep
         * @constructor
         * @param {net.Imsg_get_online_list_rep=} [properties] Properties to set
         */
        function msg_get_online_list_rep(properties) {
            this.onlinelist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_online_list_rep onlinelist.
         * @member {Array.<number>} onlinelist
         * @memberof net.msg_get_online_list_rep
         * @instance
         */
        msg_get_online_list_rep.prototype.onlinelist = $util.emptyArray;

        /**
         * Encodes the specified msg_get_online_list_rep message. Does not implicitly {@link net.msg_get_online_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {net.Imsg_get_online_list_rep} message msg_get_online_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_online_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.onlinelist != null && message.onlinelist.length)
                for (var i = 0; i < message.onlinelist.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.onlinelist[i]);
            return writer;
        };

        /**
         * Decodes a msg_get_online_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_online_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_online_list_rep} msg_get_online_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_online_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_online_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.onlinelist && message.onlinelist.length))
                        message.onlinelist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.onlinelist.push(reader.int32());
                    } else
                        message.onlinelist.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_online_list_rep;
    })();

    net.msg_get_money_change_list = (function() {

        /**
         * Properties of a msg_get_money_change_list.
         * @memberof net
         * @interface Imsg_get_money_change_list
         */

        /**
         * Constructs a new msg_get_money_change_list.
         * @memberof net
         * @classdesc Represents a msg_get_money_change_list.
         * @implements Imsg_get_money_change_list
         * @constructor
         * @param {net.Imsg_get_money_change_list=} [properties] Properties to set
         */
        function msg_get_money_change_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_money_change_list message. Does not implicitly {@link net.msg_get_money_change_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {net.Imsg_get_money_change_list} message msg_get_money_change_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_money_change_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_money_change_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_money_change_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_money_change_list} msg_get_money_change_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_money_change_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_money_change_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_money_change_list;
    })();

    net.msg_get_money_change_list_rep = (function() {

        /**
         * Properties of a msg_get_money_change_list_rep.
         * @memberof net
         * @interface Imsg_get_money_change_list_rep
         * @property {Array.<net.Imoney_change_info>|null} [money_list] msg_get_money_change_list_rep money_list
         */

        /**
         * Constructs a new msg_get_money_change_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_money_change_list_rep.
         * @implements Imsg_get_money_change_list_rep
         * @constructor
         * @param {net.Imsg_get_money_change_list_rep=} [properties] Properties to set
         */
        function msg_get_money_change_list_rep(properties) {
            this.money_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_money_change_list_rep money_list.
         * @member {Array.<net.Imoney_change_info>} money_list
         * @memberof net.msg_get_money_change_list_rep
         * @instance
         */
        msg_get_money_change_list_rep.prototype.money_list = $util.emptyArray;

        /**
         * Encodes the specified msg_get_money_change_list_rep message. Does not implicitly {@link net.msg_get_money_change_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {net.Imsg_get_money_change_list_rep} message msg_get_money_change_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_money_change_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.money_list != null && message.money_list.length)
                for (var i = 0; i < message.money_list.length; ++i)
                    $root.net.money_change_info.encode(message.money_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_money_change_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_money_change_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_money_change_list_rep} msg_get_money_change_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_money_change_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_money_change_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.money_list && message.money_list.length))
                        message.money_list = [];
                    message.money_list.push($root.net.money_change_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_money_change_list_rep;
    })();

    net.msg_get_pay_auth_code = (function() {

        /**
         * Properties of a msg_get_pay_auth_code.
         * @memberof net
         * @interface Imsg_get_pay_auth_code
         * @property {Uint8Array|null} [paypasswd] msg_get_pay_auth_code paypasswd
         */

        /**
         * Constructs a new msg_get_pay_auth_code.
         * @memberof net
         * @classdesc Represents a msg_get_pay_auth_code.
         * @implements Imsg_get_pay_auth_code
         * @constructor
         * @param {net.Imsg_get_pay_auth_code=} [properties] Properties to set
         */
        function msg_get_pay_auth_code(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_pay_auth_code paypasswd.
         * @member {Uint8Array} paypasswd
         * @memberof net.msg_get_pay_auth_code
         * @instance
         */
        msg_get_pay_auth_code.prototype.paypasswd = $util.newBuffer([]);

        /**
         * Encodes the specified msg_get_pay_auth_code message. Does not implicitly {@link net.msg_get_pay_auth_code.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {net.Imsg_get_pay_auth_code} message msg_get_pay_auth_code message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_pay_auth_code.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.paypasswd != null && Object.hasOwnProperty.call(message, "paypasswd"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.paypasswd);
            return writer;
        };

        /**
         * Decodes a msg_get_pay_auth_code message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_pay_auth_code
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_pay_auth_code} msg_get_pay_auth_code
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_pay_auth_code.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_pay_auth_code();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.paypasswd = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_pay_auth_code;
    })();

    net.msg_get_pay_auth_code_rep = (function() {

        /**
         * Properties of a msg_get_pay_auth_code_rep.
         * @memberof net
         * @interface Imsg_get_pay_auth_code_rep
         * @property {number|null} [result] msg_get_pay_auth_code_rep result
         * @property {Uint8Array|null} [auth_code] msg_get_pay_auth_code_rep auth_code
         */

        /**
         * Constructs a new msg_get_pay_auth_code_rep.
         * @memberof net
         * @classdesc Represents a msg_get_pay_auth_code_rep.
         * @implements Imsg_get_pay_auth_code_rep
         * @constructor
         * @param {net.Imsg_get_pay_auth_code_rep=} [properties] Properties to set
         */
        function msg_get_pay_auth_code_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_pay_auth_code_rep result.
         * @member {number} result
         * @memberof net.msg_get_pay_auth_code_rep
         * @instance
         */
        msg_get_pay_auth_code_rep.prototype.result = 0;

        /**
         * msg_get_pay_auth_code_rep auth_code.
         * @member {Uint8Array} auth_code
         * @memberof net.msg_get_pay_auth_code_rep
         * @instance
         */
        msg_get_pay_auth_code_rep.prototype.auth_code = $util.newBuffer([]);

        /**
         * Encodes the specified msg_get_pay_auth_code_rep message. Does not implicitly {@link net.msg_get_pay_auth_code_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {net.Imsg_get_pay_auth_code_rep} message msg_get_pay_auth_code_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_pay_auth_code_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.auth_code != null && Object.hasOwnProperty.call(message, "auth_code"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.auth_code);
            return writer;
        };

        /**
         * Decodes a msg_get_pay_auth_code_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_pay_auth_code_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_pay_auth_code_rep} msg_get_pay_auth_code_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_pay_auth_code_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_pay_auth_code_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.auth_code = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_pay_auth_code_rep;
    })();

    net.msg_joingroup_byqrcode = (function() {

        /**
         * Properties of a msg_joingroup_byqrcode.
         * @memberof net
         * @interface Imsg_joingroup_byqrcode
         * @property {number|null} [groupkey] msg_joingroup_byqrcode groupkey
         * @property {number|null} [otheruid] msg_joingroup_byqrcode otheruid
         * @property {Uint8Array|null} [verify] msg_joingroup_byqrcode verify
         */

        /**
         * Constructs a new msg_joingroup_byqrcode.
         * @memberof net
         * @classdesc Represents a msg_joingroup_byqrcode.
         * @implements Imsg_joingroup_byqrcode
         * @constructor
         * @param {net.Imsg_joingroup_byqrcode=} [properties] Properties to set
         */
        function msg_joingroup_byqrcode(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_joingroup_byqrcode groupkey.
         * @member {number} groupkey
         * @memberof net.msg_joingroup_byqrcode
         * @instance
         */
        msg_joingroup_byqrcode.prototype.groupkey = 0;

        /**
         * msg_joingroup_byqrcode otheruid.
         * @member {number} otheruid
         * @memberof net.msg_joingroup_byqrcode
         * @instance
         */
        msg_joingroup_byqrcode.prototype.otheruid = 0;

        /**
         * msg_joingroup_byqrcode verify.
         * @member {Uint8Array} verify
         * @memberof net.msg_joingroup_byqrcode
         * @instance
         */
        msg_joingroup_byqrcode.prototype.verify = $util.newBuffer([]);

        /**
         * Encodes the specified msg_joingroup_byqrcode message. Does not implicitly {@link net.msg_joingroup_byqrcode.verify|verify} messages.
         * @function encode
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {net.Imsg_joingroup_byqrcode} message msg_joingroup_byqrcode message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_joingroup_byqrcode.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.verify != null && Object.hasOwnProperty.call(message, "verify"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.verify);
            return writer;
        };

        /**
         * Decodes a msg_joingroup_byqrcode message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_joingroup_byqrcode
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_joingroup_byqrcode} msg_joingroup_byqrcode
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_joingroup_byqrcode.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_joingroup_byqrcode();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.verify = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_joingroup_byqrcode;
    })();

    net.msg_joingroup_byqrcode_rep = (function() {

        /**
         * Properties of a msg_joingroup_byqrcode_rep.
         * @memberof net
         * @interface Imsg_joingroup_byqrcode_rep
         * @property {number|null} [result] msg_joingroup_byqrcode_rep result
         */

        /**
         * Constructs a new msg_joingroup_byqrcode_rep.
         * @memberof net
         * @classdesc Represents a msg_joingroup_byqrcode_rep.
         * @implements Imsg_joingroup_byqrcode_rep
         * @constructor
         * @param {net.Imsg_joingroup_byqrcode_rep=} [properties] Properties to set
         */
        function msg_joingroup_byqrcode_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_joingroup_byqrcode_rep result.
         * @member {number} result
         * @memberof net.msg_joingroup_byqrcode_rep
         * @instance
         */
        msg_joingroup_byqrcode_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_joingroup_byqrcode_rep message. Does not implicitly {@link net.msg_joingroup_byqrcode_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {net.Imsg_joingroup_byqrcode_rep} message msg_joingroup_byqrcode_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_joingroup_byqrcode_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_joingroup_byqrcode_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_joingroup_byqrcode_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_joingroup_byqrcode_rep} msg_joingroup_byqrcode_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_joingroup_byqrcode_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_joingroup_byqrcode_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_joingroup_byqrcode_rep;
    })();

    net.msg_create_goods = (function() {

        /**
         * Properties of a msg_create_goods.
         * @memberof net
         * @interface Imsg_create_goods
         * @property {number|null} [goodsvalue] msg_create_goods goodsvalue
         * @property {number|null} [minlimit] msg_create_goods minlimit
         * @property {number|null} [maxlimit] msg_create_goods maxlimit
         * @property {Array.<number>|null} [paylist] msg_create_goods paylist
         * @property {number|null} [cointype] msg_create_goods cointype
         * @property {number|null} [rate] msg_create_goods rate
         * @property {number|null} [status] msg_create_goods status
         * @property {number|null} [goodstype] msg_create_goods goodstype
         * @property {number|null} [outcointype] msg_create_goods outcointype
         */

        /**
         * Constructs a new msg_create_goods.
         * @memberof net
         * @classdesc Represents a msg_create_goods.
         * @implements Imsg_create_goods
         * @constructor
         * @param {net.Imsg_create_goods=} [properties] Properties to set
         */
        function msg_create_goods(properties) {
            this.paylist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_goods goodsvalue.
         * @member {number} goodsvalue
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.goodsvalue = 0;

        /**
         * msg_create_goods minlimit.
         * @member {number} minlimit
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.minlimit = 0;

        /**
         * msg_create_goods maxlimit.
         * @member {number} maxlimit
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.maxlimit = 0;

        /**
         * msg_create_goods paylist.
         * @member {Array.<number>} paylist
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.paylist = $util.emptyArray;

        /**
         * msg_create_goods cointype.
         * @member {number} cointype
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.cointype = 0;

        /**
         * msg_create_goods rate.
         * @member {number} rate
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.rate = 0;

        /**
         * msg_create_goods status.
         * @member {number} status
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.status = 0;

        /**
         * msg_create_goods goodstype.
         * @member {number} goodstype
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.goodstype = 0;

        /**
         * msg_create_goods outcointype.
         * @member {number} outcointype
         * @memberof net.msg_create_goods
         * @instance
         */
        msg_create_goods.prototype.outcointype = 0;

        /**
         * Encodes the specified msg_create_goods message. Does not implicitly {@link net.msg_create_goods.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_goods
         * @static
         * @param {net.Imsg_create_goods} message msg_create_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_goods.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodsvalue != null && Object.hasOwnProperty.call(message, "goodsvalue"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.goodsvalue);
            if (message.minlimit != null && Object.hasOwnProperty.call(message, "minlimit"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minlimit);
            if (message.maxlimit != null && Object.hasOwnProperty.call(message, "maxlimit"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxlimit);
            if (message.paylist != null && message.paylist.length)
                for (var i = 0; i < message.paylist.length; ++i)
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.paylist[i]);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.cointype);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.rate);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
            if (message.goodstype != null && Object.hasOwnProperty.call(message, "goodstype"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.goodstype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.outcointype);
            return writer;
        };

        /**
         * Decodes a msg_create_goods message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_goods} msg_create_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_goods.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_goods();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.goodsvalue = reader.int32();
                    break;
                case 2:
                    message.minlimit = reader.int32();
                    break;
                case 3:
                    message.maxlimit = reader.int32();
                    break;
                case 4:
                    if (!(message.paylist && message.paylist.length))
                        message.paylist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.paylist.push(reader.int32());
                    } else
                        message.paylist.push(reader.int32());
                    break;
                case 5:
                    message.cointype = reader.int32();
                    break;
                case 6:
                    message.rate = reader.int32();
                    break;
                case 7:
                    message.status = reader.int32();
                    break;
                case 8:
                    message.goodstype = reader.int32();
                    break;
                case 9:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_create_goods;
    })();

    net.msg_create_goods_rep = (function() {

        /**
         * Properties of a msg_create_goods_rep.
         * @memberof net
         * @interface Imsg_create_goods_rep
         * @property {number|null} [result] msg_create_goods_rep result
         * @property {number|null} [cointype] msg_create_goods_rep cointype
         * @property {number|null} [outcointype] msg_create_goods_rep outcointype
         */

        /**
         * Constructs a new msg_create_goods_rep.
         * @memberof net
         * @classdesc Represents a msg_create_goods_rep.
         * @implements Imsg_create_goods_rep
         * @constructor
         * @param {net.Imsg_create_goods_rep=} [properties] Properties to set
         */
        function msg_create_goods_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_goods_rep result.
         * @member {number} result
         * @memberof net.msg_create_goods_rep
         * @instance
         */
        msg_create_goods_rep.prototype.result = 0;

        /**
         * msg_create_goods_rep cointype.
         * @member {number} cointype
         * @memberof net.msg_create_goods_rep
         * @instance
         */
        msg_create_goods_rep.prototype.cointype = 0;

        /**
         * msg_create_goods_rep outcointype.
         * @member {number} outcointype
         * @memberof net.msg_create_goods_rep
         * @instance
         */
        msg_create_goods_rep.prototype.outcointype = 0;

        /**
         * Encodes the specified msg_create_goods_rep message. Does not implicitly {@link net.msg_create_goods_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {net.Imsg_create_goods_rep} message msg_create_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_goods_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.outcointype);
            return writer;
        };

        /**
         * Decodes a msg_create_goods_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_goods_rep} msg_create_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_goods_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_goods_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.cointype = reader.int32();
                    break;
                case 3:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_create_goods_rep;
    })();

    net.msg_get_my_goods = (function() {

        /**
         * Properties of a msg_get_my_goods.
         * @memberof net
         * @interface Imsg_get_my_goods
         */

        /**
         * Constructs a new msg_get_my_goods.
         * @memberof net
         * @classdesc Represents a msg_get_my_goods.
         * @implements Imsg_get_my_goods
         * @constructor
         * @param {net.Imsg_get_my_goods=} [properties] Properties to set
         */
        function msg_get_my_goods(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_my_goods message. Does not implicitly {@link net.msg_get_my_goods.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_goods
         * @static
         * @param {net.Imsg_get_my_goods} message msg_get_my_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_goods.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_my_goods message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_goods} msg_get_my_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_goods.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_goods();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_my_goods;
    })();

    net.msg_get_my_goods_rep = (function() {

        /**
         * Properties of a msg_get_my_goods_rep.
         * @memberof net
         * @interface Imsg_get_my_goods_rep
         * @property {Array.<net.Igoods_info>|null} [g_info] msg_get_my_goods_rep g_info
         */

        /**
         * Constructs a new msg_get_my_goods_rep.
         * @memberof net
         * @classdesc Represents a msg_get_my_goods_rep.
         * @implements Imsg_get_my_goods_rep
         * @constructor
         * @param {net.Imsg_get_my_goods_rep=} [properties] Properties to set
         */
        function msg_get_my_goods_rep(properties) {
            this.g_info = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_my_goods_rep g_info.
         * @member {Array.<net.Igoods_info>} g_info
         * @memberof net.msg_get_my_goods_rep
         * @instance
         */
        msg_get_my_goods_rep.prototype.g_info = $util.emptyArray;

        /**
         * Encodes the specified msg_get_my_goods_rep message. Does not implicitly {@link net.msg_get_my_goods_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {net.Imsg_get_my_goods_rep} message msg_get_my_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_goods_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.g_info != null && message.g_info.length)
                for (var i = 0; i < message.g_info.length; ++i)
                    $root.net.goods_info.encode(message.g_info[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_my_goods_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_goods_rep} msg_get_my_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_goods_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_goods_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.g_info && message.g_info.length))
                        message.g_info = [];
                    message.g_info.push($root.net.goods_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_my_goods_rep;
    })();

    net.msg_get_goods = (function() {

        /**
         * Properties of a msg_get_goods.
         * @memberof net
         * @interface Imsg_get_goods
         * @property {number|null} [paytype] msg_get_goods paytype
         * @property {number|null} [opertype] msg_get_goods opertype
         * @property {number|null} [value] msg_get_goods value
         * @property {number|null} [cointype] msg_get_goods cointype
         * @property {number|null} [outcointype] msg_get_goods outcointype
         */

        /**
         * Constructs a new msg_get_goods.
         * @memberof net
         * @classdesc Represents a msg_get_goods.
         * @implements Imsg_get_goods
         * @constructor
         * @param {net.Imsg_get_goods=} [properties] Properties to set
         */
        function msg_get_goods(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods paytype.
         * @member {number} paytype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.paytype = 0;

        /**
         * msg_get_goods opertype.
         * @member {number} opertype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.opertype = 0;

        /**
         * msg_get_goods value.
         * @member {number} value
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.value = 0;

        /**
         * msg_get_goods cointype.
         * @member {number} cointype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.cointype = 0;

        /**
         * msg_get_goods outcointype.
         * @member {number} outcointype
         * @memberof net.msg_get_goods
         * @instance
         */
        msg_get_goods.prototype.outcointype = 0;

        /**
         * Encodes the specified msg_get_goods message. Does not implicitly {@link net.msg_get_goods.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods
         * @static
         * @param {net.Imsg_get_goods} message msg_get_goods message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.paytype);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.value);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.cointype);
            if (message.outcointype != null && Object.hasOwnProperty.call(message, "outcointype"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.outcointype);
            return writer;
        };

        /**
         * Decodes a msg_get_goods message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods} msg_get_goods
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.paytype = reader.int32();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                case 3:
                    message.value = reader.int32();
                    break;
                case 4:
                    message.cointype = reader.int32();
                    break;
                case 5:
                    message.outcointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods;
    })();

    net.msg_get_goods_rep = (function() {

        /**
         * Properties of a msg_get_goods_rep.
         * @memberof net
         * @interface Imsg_get_goods_rep
         * @property {Array.<net.Igoods_info>|null} [goodslist] msg_get_goods_rep goodslist
         */

        /**
         * Constructs a new msg_get_goods_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_rep.
         * @implements Imsg_get_goods_rep
         * @constructor
         * @param {net.Imsg_get_goods_rep=} [properties] Properties to set
         */
        function msg_get_goods_rep(properties) {
            this.goodslist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_rep goodslist.
         * @member {Array.<net.Igoods_info>} goodslist
         * @memberof net.msg_get_goods_rep
         * @instance
         */
        msg_get_goods_rep.prototype.goodslist = $util.emptyArray;

        /**
         * Encodes the specified msg_get_goods_rep message. Does not implicitly {@link net.msg_get_goods_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {net.Imsg_get_goods_rep} message msg_get_goods_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodslist != null && message.goodslist.length)
                for (var i = 0; i < message.goodslist.length; ++i)
                    $root.net.goods_info.encode(message.goodslist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_goods_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_rep} msg_get_goods_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.goodslist && message.goodslist.length))
                        message.goodslist = [];
                    message.goodslist.push($root.net.goods_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods_rep;
    })();

    net.msg_create_order = (function() {

        /**
         * Properties of a msg_create_order.
         * @memberof net
         * @interface Imsg_create_order
         * @property {number|null} [opertype] msg_create_order opertype
         * @property {number|Long|null} [goodsid] msg_create_order goodsid
         * @property {number|null} [ordervalue] msg_create_order ordervalue
         * @property {number|null} [paytype] msg_create_order paytype
         * @property {number|null} [paytypeid] msg_create_order paytypeid
         */

        /**
         * Constructs a new msg_create_order.
         * @memberof net
         * @classdesc Represents a msg_create_order.
         * @implements Imsg_create_order
         * @constructor
         * @param {net.Imsg_create_order=} [properties] Properties to set
         */
        function msg_create_order(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_order opertype.
         * @member {number} opertype
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.opertype = 0;

        /**
         * msg_create_order goodsid.
         * @member {number|Long} goodsid
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_create_order ordervalue.
         * @member {number} ordervalue
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.ordervalue = 0;

        /**
         * msg_create_order paytype.
         * @member {number} paytype
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.paytype = 0;

        /**
         * msg_create_order paytypeid.
         * @member {number} paytypeid
         * @memberof net.msg_create_order
         * @instance
         */
        msg_create_order.prototype.paytypeid = 0;

        /**
         * Encodes the specified msg_create_order message. Does not implicitly {@link net.msg_create_order.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_order
         * @static
         * @param {net.Imsg_create_order} message msg_create_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_order.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opertype);
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.goodsid);
            if (message.ordervalue != null && Object.hasOwnProperty.call(message, "ordervalue"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ordervalue);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.paytype);
            if (message.paytypeid != null && Object.hasOwnProperty.call(message, "paytypeid"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.paytypeid);
            return writer;
        };

        /**
         * Decodes a msg_create_order message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_order} msg_create_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_order.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_order();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.opertype = reader.int32();
                    break;
                case 2:
                    message.goodsid = reader.int64();
                    break;
                case 3:
                    message.ordervalue = reader.int32();
                    break;
                case 4:
                    message.paytype = reader.int32();
                    break;
                case 5:
                    message.paytypeid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_create_order;
    })();

    net.msg_create_order_rep = (function() {

        /**
         * Properties of a msg_create_order_rep.
         * @memberof net
         * @interface Imsg_create_order_rep
         * @property {number|null} [result] msg_create_order_rep result
         * @property {number|null} [otheruid] msg_create_order_rep otheruid
         */

        /**
         * Constructs a new msg_create_order_rep.
         * @memberof net
         * @classdesc Represents a msg_create_order_rep.
         * @implements Imsg_create_order_rep
         * @constructor
         * @param {net.Imsg_create_order_rep=} [properties] Properties to set
         */
        function msg_create_order_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_create_order_rep result.
         * @member {number} result
         * @memberof net.msg_create_order_rep
         * @instance
         */
        msg_create_order_rep.prototype.result = 0;

        /**
         * msg_create_order_rep otheruid.
         * @member {number} otheruid
         * @memberof net.msg_create_order_rep
         * @instance
         */
        msg_create_order_rep.prototype.otheruid = 0;

        /**
         * Encodes the specified msg_create_order_rep message. Does not implicitly {@link net.msg_create_order_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_create_order_rep
         * @static
         * @param {net.Imsg_create_order_rep} message msg_create_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_create_order_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            return writer;
        };

        /**
         * Decodes a msg_create_order_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_create_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_create_order_rep} msg_create_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_create_order_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_create_order_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_create_order_rep;
    })();

    net.msg_confirm_order = (function() {

        /**
         * Properties of a msg_confirm_order.
         * @memberof net
         * @interface Imsg_confirm_order
         * @property {number|Long|null} [orderid] msg_confirm_order orderid
         */

        /**
         * Constructs a new msg_confirm_order.
         * @memberof net
         * @classdesc Represents a msg_confirm_order.
         * @implements Imsg_confirm_order
         * @constructor
         * @param {net.Imsg_confirm_order=} [properties] Properties to set
         */
        function msg_confirm_order(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_order orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_confirm_order
         * @instance
         */
        msg_confirm_order.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_confirm_order message. Does not implicitly {@link net.msg_confirm_order.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_order
         * @static
         * @param {net.Imsg_confirm_order} message msg_confirm_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_order.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            return writer;
        };

        /**
         * Decodes a msg_confirm_order message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_order} msg_confirm_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_order.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_order();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_order;
    })();

    net.msg_confirm_order_rep = (function() {

        /**
         * Properties of a msg_confirm_order_rep.
         * @memberof net
         * @interface Imsg_confirm_order_rep
         * @property {number|null} [result] msg_confirm_order_rep result
         * @property {number|null} [buyer] msg_confirm_order_rep buyer
         * @property {number|null} [seller] msg_confirm_order_rep seller
         * @property {number|null} [status] msg_confirm_order_rep status
         */

        /**
         * Constructs a new msg_confirm_order_rep.
         * @memberof net
         * @classdesc Represents a msg_confirm_order_rep.
         * @implements Imsg_confirm_order_rep
         * @constructor
         * @param {net.Imsg_confirm_order_rep=} [properties] Properties to set
         */
        function msg_confirm_order_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_confirm_order_rep result.
         * @member {number} result
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.result = 0;

        /**
         * msg_confirm_order_rep buyer.
         * @member {number} buyer
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.buyer = 0;

        /**
         * msg_confirm_order_rep seller.
         * @member {number} seller
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.seller = 0;

        /**
         * msg_confirm_order_rep status.
         * @member {number} status
         * @memberof net.msg_confirm_order_rep
         * @instance
         */
        msg_confirm_order_rep.prototype.status = 0;

        /**
         * Encodes the specified msg_confirm_order_rep message. Does not implicitly {@link net.msg_confirm_order_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {net.Imsg_confirm_order_rep} message msg_confirm_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_confirm_order_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.buyer != null && Object.hasOwnProperty.call(message, "buyer"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.buyer);
            if (message.seller != null && Object.hasOwnProperty.call(message, "seller"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.seller);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
            return writer;
        };

        /**
         * Decodes a msg_confirm_order_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_confirm_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_confirm_order_rep} msg_confirm_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_confirm_order_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_confirm_order_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.buyer = reader.int32();
                    break;
                case 3:
                    message.seller = reader.int32();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_confirm_order_rep;
    })();

    net.msg_get_my_orders = (function() {

        /**
         * Properties of a msg_get_my_orders.
         * @memberof net
         * @interface Imsg_get_my_orders
         */

        /**
         * Constructs a new msg_get_my_orders.
         * @memberof net
         * @classdesc Represents a msg_get_my_orders.
         * @implements Imsg_get_my_orders
         * @constructor
         * @param {net.Imsg_get_my_orders=} [properties] Properties to set
         */
        function msg_get_my_orders(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_my_orders message. Does not implicitly {@link net.msg_get_my_orders.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_orders
         * @static
         * @param {net.Imsg_get_my_orders} message msg_get_my_orders message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_orders.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_my_orders message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_orders
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_orders} msg_get_my_orders
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_orders.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_orders();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_my_orders;
    })();

    net.msg_get_my_orders_rep = (function() {

        /**
         * Properties of a msg_get_my_orders_rep.
         * @memberof net
         * @interface Imsg_get_my_orders_rep
         * @property {Array.<net.Iorder_info>|null} [orders] msg_get_my_orders_rep orders
         */

        /**
         * Constructs a new msg_get_my_orders_rep.
         * @memberof net
         * @classdesc Represents a msg_get_my_orders_rep.
         * @implements Imsg_get_my_orders_rep
         * @constructor
         * @param {net.Imsg_get_my_orders_rep=} [properties] Properties to set
         */
        function msg_get_my_orders_rep(properties) {
            this.orders = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_my_orders_rep orders.
         * @member {Array.<net.Iorder_info>} orders
         * @memberof net.msg_get_my_orders_rep
         * @instance
         */
        msg_get_my_orders_rep.prototype.orders = $util.emptyArray;

        /**
         * Encodes the specified msg_get_my_orders_rep message. Does not implicitly {@link net.msg_get_my_orders_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {net.Imsg_get_my_orders_rep} message msg_get_my_orders_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_my_orders_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orders != null && message.orders.length)
                for (var i = 0; i < message.orders.length; ++i)
                    $root.net.order_info.encode(message.orders[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_my_orders_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_my_orders_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_my_orders_rep} msg_get_my_orders_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_my_orders_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_my_orders_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.orders && message.orders.length))
                        message.orders = [];
                    message.orders.push($root.net.order_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_my_orders_rep;
    })();

    net.msg_get_order_info = (function() {

        /**
         * Properties of a msg_get_order_info.
         * @memberof net
         * @interface Imsg_get_order_info
         * @property {number|null} [otheruid] msg_get_order_info otheruid
         */

        /**
         * Constructs a new msg_get_order_info.
         * @memberof net
         * @classdesc Represents a msg_get_order_info.
         * @implements Imsg_get_order_info
         * @constructor
         * @param {net.Imsg_get_order_info=} [properties] Properties to set
         */
        function msg_get_order_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info otheruid.
         * @member {number} otheruid
         * @memberof net.msg_get_order_info
         * @instance
         */
        msg_get_order_info.prototype.otheruid = 0;

        /**
         * Encodes the specified msg_get_order_info message. Does not implicitly {@link net.msg_get_order_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info
         * @static
         * @param {net.Imsg_get_order_info} message msg_get_order_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.otheruid);
            return writer;
        };

        /**
         * Decodes a msg_get_order_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info} msg_get_order_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.otheruid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_order_info;
    })();

    net.msg_get_order_info_rep = (function() {

        /**
         * Properties of a msg_get_order_info_rep.
         * @memberof net
         * @interface Imsg_get_order_info_rep
         * @property {number|null} [result] msg_get_order_info_rep result
         * @property {net.Iorder_info|null} [order] msg_get_order_info_rep order
         */

        /**
         * Constructs a new msg_get_order_info_rep.
         * @memberof net
         * @classdesc Represents a msg_get_order_info_rep.
         * @implements Imsg_get_order_info_rep
         * @constructor
         * @param {net.Imsg_get_order_info_rep=} [properties] Properties to set
         */
        function msg_get_order_info_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info_rep result.
         * @member {number} result
         * @memberof net.msg_get_order_info_rep
         * @instance
         */
        msg_get_order_info_rep.prototype.result = 0;

        /**
         * msg_get_order_info_rep order.
         * @member {net.Iorder_info|null|undefined} order
         * @memberof net.msg_get_order_info_rep
         * @instance
         */
        msg_get_order_info_rep.prototype.order = null;

        /**
         * Encodes the specified msg_get_order_info_rep message. Does not implicitly {@link net.msg_get_order_info_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {net.Imsg_get_order_info_rep} message msg_get_order_info_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                $root.net.order_info.encode(message.order, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_order_info_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info_rep} msg_get_order_info_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.order = $root.net.order_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_order_info_rep;
    })();

    net.msg_set_order_paytypeid = (function() {

        /**
         * Properties of a msg_set_order_paytypeid.
         * @memberof net
         * @interface Imsg_set_order_paytypeid
         * @property {number|Long|null} [orderid] msg_set_order_paytypeid orderid
         * @property {number|null} [paytype] msg_set_order_paytypeid paytype
         * @property {number|null} [paytypeid] msg_set_order_paytypeid paytypeid
         */

        /**
         * Constructs a new msg_set_order_paytypeid.
         * @memberof net
         * @classdesc Represents a msg_set_order_paytypeid.
         * @implements Imsg_set_order_paytypeid
         * @constructor
         * @param {net.Imsg_set_order_paytypeid=} [properties] Properties to set
         */
        function msg_set_order_paytypeid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_order_paytypeid orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_set_order_paytypeid
         * @instance
         */
        msg_set_order_paytypeid.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_order_paytypeid paytype.
         * @member {number} paytype
         * @memberof net.msg_set_order_paytypeid
         * @instance
         */
        msg_set_order_paytypeid.prototype.paytype = 0;

        /**
         * msg_set_order_paytypeid paytypeid.
         * @member {number} paytypeid
         * @memberof net.msg_set_order_paytypeid
         * @instance
         */
        msg_set_order_paytypeid.prototype.paytypeid = 0;

        /**
         * Encodes the specified msg_set_order_paytypeid message. Does not implicitly {@link net.msg_set_order_paytypeid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {net.Imsg_set_order_paytypeid} message msg_set_order_paytypeid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_order_paytypeid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.paytype);
            if (message.paytypeid != null && Object.hasOwnProperty.call(message, "paytypeid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.paytypeid);
            return writer;
        };

        /**
         * Decodes a msg_set_order_paytypeid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_order_paytypeid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_order_paytypeid} msg_set_order_paytypeid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_order_paytypeid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_order_paytypeid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                case 2:
                    message.paytype = reader.int32();
                    break;
                case 3:
                    message.paytypeid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_order_paytypeid;
    })();

    net.msg_set_order_paytypeid_rep = (function() {

        /**
         * Properties of a msg_set_order_paytypeid_rep.
         * @memberof net
         * @interface Imsg_set_order_paytypeid_rep
         * @property {number|null} [result] msg_set_order_paytypeid_rep result
         * @property {number|Long|null} [orderid] msg_set_order_paytypeid_rep orderid
         * @property {number|null} [paytype] msg_set_order_paytypeid_rep paytype
         * @property {number|null} [paytypeid] msg_set_order_paytypeid_rep paytypeid
         */

        /**
         * Constructs a new msg_set_order_paytypeid_rep.
         * @memberof net
         * @classdesc Represents a msg_set_order_paytypeid_rep.
         * @implements Imsg_set_order_paytypeid_rep
         * @constructor
         * @param {net.Imsg_set_order_paytypeid_rep=} [properties] Properties to set
         */
        function msg_set_order_paytypeid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_order_paytypeid_rep result.
         * @member {number} result
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.result = 0;

        /**
         * msg_set_order_paytypeid_rep orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_order_paytypeid_rep paytype.
         * @member {number} paytype
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.paytype = 0;

        /**
         * msg_set_order_paytypeid_rep paytypeid.
         * @member {number} paytypeid
         * @memberof net.msg_set_order_paytypeid_rep
         * @instance
         */
        msg_set_order_paytypeid_rep.prototype.paytypeid = 0;

        /**
         * Encodes the specified msg_set_order_paytypeid_rep message. Does not implicitly {@link net.msg_set_order_paytypeid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {net.Imsg_set_order_paytypeid_rep} message msg_set_order_paytypeid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_order_paytypeid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.orderid);
            if (message.paytype != null && Object.hasOwnProperty.call(message, "paytype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.paytype);
            if (message.paytypeid != null && Object.hasOwnProperty.call(message, "paytypeid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.paytypeid);
            return writer;
        };

        /**
         * Decodes a msg_set_order_paytypeid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_order_paytypeid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_order_paytypeid_rep} msg_set_order_paytypeid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_order_paytypeid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_order_paytypeid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.orderid = reader.int64();
                    break;
                case 3:
                    message.paytype = reader.int32();
                    break;
                case 4:
                    message.paytypeid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_order_paytypeid_rep;
    })();

    net.msg_get_goods_byid = (function() {

        /**
         * Properties of a msg_get_goods_byid.
         * @memberof net
         * @interface Imsg_get_goods_byid
         * @property {number|Long|null} [goodsid] msg_get_goods_byid goodsid
         */

        /**
         * Constructs a new msg_get_goods_byid.
         * @memberof net
         * @classdesc Represents a msg_get_goods_byid.
         * @implements Imsg_get_goods_byid
         * @constructor
         * @param {net.Imsg_get_goods_byid=} [properties] Properties to set
         */
        function msg_get_goods_byid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_byid goodsid.
         * @member {number|Long} goodsid
         * @memberof net.msg_get_goods_byid
         * @instance
         */
        msg_get_goods_byid.prototype.goodsid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_get_goods_byid message. Does not implicitly {@link net.msg_get_goods_byid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {net.Imsg_get_goods_byid} message msg_get_goods_byid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_byid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.goodsid != null && Object.hasOwnProperty.call(message, "goodsid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.goodsid);
            return writer;
        };

        /**
         * Decodes a msg_get_goods_byid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_byid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_byid} msg_get_goods_byid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_byid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_byid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.goodsid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods_byid;
    })();

    net.msg_get_goods_byid_rep = (function() {

        /**
         * Properties of a msg_get_goods_byid_rep.
         * @memberof net
         * @interface Imsg_get_goods_byid_rep
         * @property {net.Igoods_info|null} [g_info] msg_get_goods_byid_rep g_info
         */

        /**
         * Constructs a new msg_get_goods_byid_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_byid_rep.
         * @implements Imsg_get_goods_byid_rep
         * @constructor
         * @param {net.Imsg_get_goods_byid_rep=} [properties] Properties to set
         */
        function msg_get_goods_byid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_byid_rep g_info.
         * @member {net.Igoods_info|null|undefined} g_info
         * @memberof net.msg_get_goods_byid_rep
         * @instance
         */
        msg_get_goods_byid_rep.prototype.g_info = null;

        /**
         * Encodes the specified msg_get_goods_byid_rep message. Does not implicitly {@link net.msg_get_goods_byid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {net.Imsg_get_goods_byid_rep} message msg_get_goods_byid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_byid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.g_info != null && Object.hasOwnProperty.call(message, "g_info"))
                $root.net.goods_info.encode(message.g_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_goods_byid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_byid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_byid_rep} msg_get_goods_byid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_byid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_byid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.g_info = $root.net.goods_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods_byid_rep;
    })();

    net.msg_withdraw_chatmsg = (function() {

        /**
         * Properties of a msg_withdraw_chatmsg.
         * @memberof net
         * @interface Imsg_withdraw_chatmsg
         * @property {number|Long|null} [chatkey] msg_withdraw_chatmsg chatkey
         * @property {number|null} [chatmsgno] msg_withdraw_chatmsg chatmsgno
         */

        /**
         * Constructs a new msg_withdraw_chatmsg.
         * @memberof net
         * @classdesc Represents a msg_withdraw_chatmsg.
         * @implements Imsg_withdraw_chatmsg
         * @constructor
         * @param {net.Imsg_withdraw_chatmsg=} [properties] Properties to set
         */
        function msg_withdraw_chatmsg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_withdraw_chatmsg chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_withdraw_chatmsg
         * @instance
         */
        msg_withdraw_chatmsg.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_withdraw_chatmsg chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_withdraw_chatmsg
         * @instance
         */
        msg_withdraw_chatmsg.prototype.chatmsgno = 0;

        /**
         * Encodes the specified msg_withdraw_chatmsg message. Does not implicitly {@link net.msg_withdraw_chatmsg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {net.Imsg_withdraw_chatmsg} message msg_withdraw_chatmsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_withdraw_chatmsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Decodes a msg_withdraw_chatmsg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_withdraw_chatmsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_withdraw_chatmsg} msg_withdraw_chatmsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_withdraw_chatmsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_withdraw_chatmsg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_withdraw_chatmsg;
    })();

    net.msg_withdraw_chatmsg_rep = (function() {

        /**
         * Properties of a msg_withdraw_chatmsg_rep.
         * @memberof net
         * @interface Imsg_withdraw_chatmsg_rep
         * @property {number|Long|null} [chatkey] msg_withdraw_chatmsg_rep chatkey
         * @property {number|null} [chatmsgno] msg_withdraw_chatmsg_rep chatmsgno
         */

        /**
         * Constructs a new msg_withdraw_chatmsg_rep.
         * @memberof net
         * @classdesc Represents a msg_withdraw_chatmsg_rep.
         * @implements Imsg_withdraw_chatmsg_rep
         * @constructor
         * @param {net.Imsg_withdraw_chatmsg_rep=} [properties] Properties to set
         */
        function msg_withdraw_chatmsg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_withdraw_chatmsg_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_withdraw_chatmsg_rep
         * @instance
         */
        msg_withdraw_chatmsg_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_withdraw_chatmsg_rep chatmsgno.
         * @member {number} chatmsgno
         * @memberof net.msg_withdraw_chatmsg_rep
         * @instance
         */
        msg_withdraw_chatmsg_rep.prototype.chatmsgno = 0;

        /**
         * Encodes the specified msg_withdraw_chatmsg_rep message. Does not implicitly {@link net.msg_withdraw_chatmsg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {net.Imsg_withdraw_chatmsg_rep} message msg_withdraw_chatmsg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_withdraw_chatmsg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.chatmsgno != null && Object.hasOwnProperty.call(message, "chatmsgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.chatmsgno);
            return writer;
        };

        /**
         * Decodes a msg_withdraw_chatmsg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_withdraw_chatmsg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_withdraw_chatmsg_rep} msg_withdraw_chatmsg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_withdraw_chatmsg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_withdraw_chatmsg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.chatmsgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_withdraw_chatmsg_rep;
    })();

    net.msg_cancel_order = (function() {

        /**
         * Properties of a msg_cancel_order.
         * @memberof net
         * @interface Imsg_cancel_order
         * @property {number|Long|null} [orderid] msg_cancel_order orderid
         */

        /**
         * Constructs a new msg_cancel_order.
         * @memberof net
         * @classdesc Represents a msg_cancel_order.
         * @implements Imsg_cancel_order
         * @constructor
         * @param {net.Imsg_cancel_order=} [properties] Properties to set
         */
        function msg_cancel_order(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_cancel_order orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_cancel_order
         * @instance
         */
        msg_cancel_order.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_cancel_order message. Does not implicitly {@link net.msg_cancel_order.verify|verify} messages.
         * @function encode
         * @memberof net.msg_cancel_order
         * @static
         * @param {net.Imsg_cancel_order} message msg_cancel_order message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_cancel_order.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            return writer;
        };

        /**
         * Decodes a msg_cancel_order message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_cancel_order
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_cancel_order} msg_cancel_order
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_cancel_order.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_cancel_order();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_cancel_order;
    })();

    net.msg_cancel_order_rep = (function() {

        /**
         * Properties of a msg_cancel_order_rep.
         * @memberof net
         * @interface Imsg_cancel_order_rep
         * @property {number|null} [result] msg_cancel_order_rep result
         * @property {number|Long|null} [orderid] msg_cancel_order_rep orderid
         * @property {number|null} [buyer] msg_cancel_order_rep buyer
         * @property {number|null} [seller] msg_cancel_order_rep seller
         */

        /**
         * Constructs a new msg_cancel_order_rep.
         * @memberof net
         * @classdesc Represents a msg_cancel_order_rep.
         * @implements Imsg_cancel_order_rep
         * @constructor
         * @param {net.Imsg_cancel_order_rep=} [properties] Properties to set
         */
        function msg_cancel_order_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_cancel_order_rep result.
         * @member {number} result
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.result = 0;

        /**
         * msg_cancel_order_rep orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_cancel_order_rep buyer.
         * @member {number} buyer
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.buyer = 0;

        /**
         * msg_cancel_order_rep seller.
         * @member {number} seller
         * @memberof net.msg_cancel_order_rep
         * @instance
         */
        msg_cancel_order_rep.prototype.seller = 0;

        /**
         * Encodes the specified msg_cancel_order_rep message. Does not implicitly {@link net.msg_cancel_order_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {net.Imsg_cancel_order_rep} message msg_cancel_order_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_cancel_order_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.orderid);
            if (message.buyer != null && Object.hasOwnProperty.call(message, "buyer"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.buyer);
            if (message.seller != null && Object.hasOwnProperty.call(message, "seller"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.seller);
            return writer;
        };

        /**
         * Decodes a msg_cancel_order_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_cancel_order_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_cancel_order_rep} msg_cancel_order_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_cancel_order_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_cancel_order_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.orderid = reader.int64();
                    break;
                case 3:
                    message.buyer = reader.int32();
                    break;
                case 4:
                    message.seller = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_cancel_order_rep;
    })();

    net.msg_get_group_nickname_list = (function() {

        /**
         * Properties of a msg_get_group_nickname_list.
         * @memberof net
         * @interface Imsg_get_group_nickname_list
         * @property {number|null} [groupkey] msg_get_group_nickname_list groupkey
         */

        /**
         * Constructs a new msg_get_group_nickname_list.
         * @memberof net
         * @classdesc Represents a msg_get_group_nickname_list.
         * @implements Imsg_get_group_nickname_list
         * @constructor
         * @param {net.Imsg_get_group_nickname_list=} [properties] Properties to set
         */
        function msg_get_group_nickname_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_nickname_list groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_nickname_list
         * @instance
         */
        msg_get_group_nickname_list.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_get_group_nickname_list message. Does not implicitly {@link net.msg_get_group_nickname_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {net.Imsg_get_group_nickname_list} message msg_get_group_nickname_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_nickname_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_get_group_nickname_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_nickname_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_nickname_list} msg_get_group_nickname_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_nickname_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_nickname_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_nickname_list;
    })();

    net.msg_get_group_nickname_list_rep = (function() {

        /**
         * Properties of a msg_get_group_nickname_list_rep.
         * @memberof net
         * @interface Imsg_get_group_nickname_list_rep
         * @property {number|null} [groupkey] msg_get_group_nickname_list_rep groupkey
         * @property {Array.<net.Igroup_nickname_info>|null} [name_list] msg_get_group_nickname_list_rep name_list
         */

        /**
         * Constructs a new msg_get_group_nickname_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_nickname_list_rep.
         * @implements Imsg_get_group_nickname_list_rep
         * @constructor
         * @param {net.Imsg_get_group_nickname_list_rep=} [properties] Properties to set
         */
        function msg_get_group_nickname_list_rep(properties) {
            this.name_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_nickname_list_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_nickname_list_rep
         * @instance
         */
        msg_get_group_nickname_list_rep.prototype.groupkey = 0;

        /**
         * msg_get_group_nickname_list_rep name_list.
         * @member {Array.<net.Igroup_nickname_info>} name_list
         * @memberof net.msg_get_group_nickname_list_rep
         * @instance
         */
        msg_get_group_nickname_list_rep.prototype.name_list = $util.emptyArray;

        /**
         * Encodes the specified msg_get_group_nickname_list_rep message. Does not implicitly {@link net.msg_get_group_nickname_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {net.Imsg_get_group_nickname_list_rep} message msg_get_group_nickname_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_nickname_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.name_list != null && message.name_list.length)
                for (var i = 0; i < message.name_list.length; ++i)
                    $root.net.group_nickname_info.encode(message.name_list[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_group_nickname_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_nickname_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_nickname_list_rep} msg_get_group_nickname_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_nickname_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_nickname_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    if (!(message.name_list && message.name_list.length))
                        message.name_list = [];
                    message.name_list.push($root.net.group_nickname_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_nickname_list_rep;
    })();

    net.msg_set_group_nickname = (function() {

        /**
         * Properties of a msg_set_group_nickname.
         * @memberof net
         * @interface Imsg_set_group_nickname
         * @property {number|null} [groupkey] msg_set_group_nickname groupkey
         * @property {Uint8Array|null} [nickname] msg_set_group_nickname nickname
         */

        /**
         * Constructs a new msg_set_group_nickname.
         * @memberof net
         * @classdesc Represents a msg_set_group_nickname.
         * @implements Imsg_set_group_nickname
         * @constructor
         * @param {net.Imsg_set_group_nickname=} [properties] Properties to set
         */
        function msg_set_group_nickname(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_nickname groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_nickname
         * @instance
         */
        msg_set_group_nickname.prototype.groupkey = 0;

        /**
         * msg_set_group_nickname nickname.
         * @member {Uint8Array} nickname
         * @memberof net.msg_set_group_nickname
         * @instance
         */
        msg_set_group_nickname.prototype.nickname = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_group_nickname message. Does not implicitly {@link net.msg_set_group_nickname.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {net.Imsg_set_group_nickname} message msg_set_group_nickname message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_nickname.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            return writer;
        };

        /**
         * Decodes a msg_set_group_nickname message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_nickname
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_nickname} msg_set_group_nickname
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_nickname.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_nickname();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_group_nickname;
    })();

    net.msg_set_group_nickname_rep = (function() {

        /**
         * Properties of a msg_set_group_nickname_rep.
         * @memberof net
         * @interface Imsg_set_group_nickname_rep
         * @property {number|null} [groupkey] msg_set_group_nickname_rep groupkey
         * @property {Uint8Array|null} [nickname] msg_set_group_nickname_rep nickname
         * @property {number|null} [uid] msg_set_group_nickname_rep uid
         */

        /**
         * Constructs a new msg_set_group_nickname_rep.
         * @memberof net
         * @classdesc Represents a msg_set_group_nickname_rep.
         * @implements Imsg_set_group_nickname_rep
         * @constructor
         * @param {net.Imsg_set_group_nickname_rep=} [properties] Properties to set
         */
        function msg_set_group_nickname_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_group_nickname_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_group_nickname_rep
         * @instance
         */
        msg_set_group_nickname_rep.prototype.groupkey = 0;

        /**
         * msg_set_group_nickname_rep nickname.
         * @member {Uint8Array} nickname
         * @memberof net.msg_set_group_nickname_rep
         * @instance
         */
        msg_set_group_nickname_rep.prototype.nickname = $util.newBuffer([]);

        /**
         * msg_set_group_nickname_rep uid.
         * @member {number} uid
         * @memberof net.msg_set_group_nickname_rep
         * @instance
         */
        msg_set_group_nickname_rep.prototype.uid = 0;

        /**
         * Encodes the specified msg_set_group_nickname_rep message. Does not implicitly {@link net.msg_set_group_nickname_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {net.Imsg_set_group_nickname_rep} message msg_set_group_nickname_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_group_nickname_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.nickname);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_set_group_nickname_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_group_nickname_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_group_nickname_rep} msg_set_group_nickname_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_group_nickname_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_group_nickname_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.nickname = reader.bytes();
                    break;
                case 3:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_group_nickname_rep;
    })();

    net.msg_get_goods_data = (function() {

        /**
         * Properties of a msg_get_goods_data.
         * @memberof net
         * @interface Imsg_get_goods_data
         */

        /**
         * Constructs a new msg_get_goods_data.
         * @memberof net
         * @classdesc Represents a msg_get_goods_data.
         * @implements Imsg_get_goods_data
         * @constructor
         * @param {net.Imsg_get_goods_data=} [properties] Properties to set
         */
        function msg_get_goods_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_goods_data message. Does not implicitly {@link net.msg_get_goods_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_data
         * @static
         * @param {net.Imsg_get_goods_data} message msg_get_goods_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_goods_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_data} msg_get_goods_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods_data;
    })();

    net.msg_get_goods_data_rep = (function() {

        /**
         * Properties of a msg_get_goods_data_rep.
         * @memberof net
         * @interface Imsg_get_goods_data_rep
         * @property {Array.<net.Igoods_deal_data>|null} [datalist] msg_get_goods_data_rep datalist
         */

        /**
         * Constructs a new msg_get_goods_data_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_data_rep.
         * @implements Imsg_get_goods_data_rep
         * @constructor
         * @param {net.Imsg_get_goods_data_rep=} [properties] Properties to set
         */
        function msg_get_goods_data_rep(properties) {
            this.datalist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_data_rep datalist.
         * @member {Array.<net.Igoods_deal_data>} datalist
         * @memberof net.msg_get_goods_data_rep
         * @instance
         */
        msg_get_goods_data_rep.prototype.datalist = $util.emptyArray;

        /**
         * Encodes the specified msg_get_goods_data_rep message. Does not implicitly {@link net.msg_get_goods_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {net.Imsg_get_goods_data_rep} message msg_get_goods_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.datalist != null && message.datalist.length)
                for (var i = 0; i < message.datalist.length; ++i)
                    $root.net.goods_deal_data.encode(message.datalist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_goods_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_data_rep} msg_get_goods_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.datalist && message.datalist.length))
                        message.datalist = [];
                    message.datalist.push($root.net.goods_deal_data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods_data_rep;
    })();

    net.msg_get_goods_detail_data = (function() {

        /**
         * Properties of a msg_get_goods_detail_data.
         * @memberof net
         * @interface Imsg_get_goods_detail_data
         */

        /**
         * Constructs a new msg_get_goods_detail_data.
         * @memberof net
         * @classdesc Represents a msg_get_goods_detail_data.
         * @implements Imsg_get_goods_detail_data
         * @constructor
         * @param {net.Imsg_get_goods_detail_data=} [properties] Properties to set
         */
        function msg_get_goods_detail_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_goods_detail_data message. Does not implicitly {@link net.msg_get_goods_detail_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {net.Imsg_get_goods_detail_data} message msg_get_goods_detail_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_detail_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_goods_detail_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_detail_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_detail_data} msg_get_goods_detail_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_detail_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_detail_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods_detail_data;
    })();

    net.msg_get_goods_detail_data_rep = (function() {

        /**
         * Properties of a msg_get_goods_detail_data_rep.
         * @memberof net
         * @interface Imsg_get_goods_detail_data_rep
         * @property {Array.<net.Imoney_change_info>|null} [bill_list] msg_get_goods_detail_data_rep bill_list
         */

        /**
         * Constructs a new msg_get_goods_detail_data_rep.
         * @memberof net
         * @classdesc Represents a msg_get_goods_detail_data_rep.
         * @implements Imsg_get_goods_detail_data_rep
         * @constructor
         * @param {net.Imsg_get_goods_detail_data_rep=} [properties] Properties to set
         */
        function msg_get_goods_detail_data_rep(properties) {
            this.bill_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_goods_detail_data_rep bill_list.
         * @member {Array.<net.Imoney_change_info>} bill_list
         * @memberof net.msg_get_goods_detail_data_rep
         * @instance
         */
        msg_get_goods_detail_data_rep.prototype.bill_list = $util.emptyArray;

        /**
         * Encodes the specified msg_get_goods_detail_data_rep message. Does not implicitly {@link net.msg_get_goods_detail_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {net.Imsg_get_goods_detail_data_rep} message msg_get_goods_detail_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_goods_detail_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.bill_list != null && message.bill_list.length)
                for (var i = 0; i < message.bill_list.length; ++i)
                    $root.net.money_change_info.encode(message.bill_list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_goods_detail_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_goods_detail_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_goods_detail_data_rep} msg_get_goods_detail_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_goods_detail_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_goods_detail_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.bill_list && message.bill_list.length))
                        message.bill_list = [];
                    message.bill_list.push($root.net.money_change_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_goods_detail_data_rep;
    })();

    net.msg_oper_shopcoin = (function() {

        /**
         * Properties of a msg_oper_shopcoin.
         * @memberof net
         * @interface Imsg_oper_shopcoin
         * @property {number|null} [opertype] msg_oper_shopcoin opertype
         * @property {number|null} [amount] msg_oper_shopcoin amount
         * @property {Uint8Array|null} [authcode] msg_oper_shopcoin authcode
         * @property {number|null} [cointype] msg_oper_shopcoin cointype
         */

        /**
         * Constructs a new msg_oper_shopcoin.
         * @memberof net
         * @classdesc Represents a msg_oper_shopcoin.
         * @implements Imsg_oper_shopcoin
         * @constructor
         * @param {net.Imsg_oper_shopcoin=} [properties] Properties to set
         */
        function msg_oper_shopcoin(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_shopcoin opertype.
         * @member {number} opertype
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.opertype = 0;

        /**
         * msg_oper_shopcoin amount.
         * @member {number} amount
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.amount = 0;

        /**
         * msg_oper_shopcoin authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.authcode = $util.newBuffer([]);

        /**
         * msg_oper_shopcoin cointype.
         * @member {number} cointype
         * @memberof net.msg_oper_shopcoin
         * @instance
         */
        msg_oper_shopcoin.prototype.cointype = 0;

        /**
         * Encodes the specified msg_oper_shopcoin message. Does not implicitly {@link net.msg_oper_shopcoin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {net.Imsg_oper_shopcoin} message msg_oper_shopcoin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_shopcoin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opertype);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.amount);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.authcode);
            if (message.cointype != null && Object.hasOwnProperty.call(message, "cointype"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.cointype);
            return writer;
        };

        /**
         * Decodes a msg_oper_shopcoin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_shopcoin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_shopcoin} msg_oper_shopcoin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_shopcoin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_shopcoin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.opertype = reader.int32();
                    break;
                case 2:
                    message.amount = reader.int32();
                    break;
                case 3:
                    message.authcode = reader.bytes();
                    break;
                case 4:
                    message.cointype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_oper_shopcoin;
    })();

    net.msg_oper_shopcoin_rep = (function() {

        /**
         * Properties of a msg_oper_shopcoin_rep.
         * @memberof net
         * @interface Imsg_oper_shopcoin_rep
         * @property {number|null} [result] msg_oper_shopcoin_rep result
         */

        /**
         * Constructs a new msg_oper_shopcoin_rep.
         * @memberof net
         * @classdesc Represents a msg_oper_shopcoin_rep.
         * @implements Imsg_oper_shopcoin_rep
         * @constructor
         * @param {net.Imsg_oper_shopcoin_rep=} [properties] Properties to set
         */
        function msg_oper_shopcoin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_shopcoin_rep result.
         * @member {number} result
         * @memberof net.msg_oper_shopcoin_rep
         * @instance
         */
        msg_oper_shopcoin_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_oper_shopcoin_rep message. Does not implicitly {@link net.msg_oper_shopcoin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {net.Imsg_oper_shopcoin_rep} message msg_oper_shopcoin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_shopcoin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_oper_shopcoin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_shopcoin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_shopcoin_rep} msg_oper_shopcoin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_shopcoin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_shopcoin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_oper_shopcoin_rep;
    })();

    net.msg_set_snapchat = (function() {

        /**
         * Properties of a msg_set_snapchat.
         * @memberof net
         * @interface Imsg_set_snapchat
         * @property {number|Long|null} [chatkey] msg_set_snapchat chatkey
         * @property {number|null} [snaptime] msg_set_snapchat snaptime
         */

        /**
         * Constructs a new msg_set_snapchat.
         * @memberof net
         * @classdesc Represents a msg_set_snapchat.
         * @implements Imsg_set_snapchat
         * @constructor
         * @param {net.Imsg_set_snapchat=} [properties] Properties to set
         */
        function msg_set_snapchat(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_snapchat chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_snapchat
         * @instance
         */
        msg_set_snapchat.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_snapchat snaptime.
         * @member {number} snaptime
         * @memberof net.msg_set_snapchat
         * @instance
         */
        msg_set_snapchat.prototype.snaptime = 0;

        /**
         * Encodes the specified msg_set_snapchat message. Does not implicitly {@link net.msg_set_snapchat.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_snapchat
         * @static
         * @param {net.Imsg_set_snapchat} message msg_set_snapchat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_snapchat.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.snaptime);
            return writer;
        };

        /**
         * Decodes a msg_set_snapchat message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_snapchat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_snapchat} msg_set_snapchat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_snapchat.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_snapchat();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.snaptime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_snapchat;
    })();

    net.msg_set_snapchat_rep = (function() {

        /**
         * Properties of a msg_set_snapchat_rep.
         * @memberof net
         * @interface Imsg_set_snapchat_rep
         * @property {number|null} [result] msg_set_snapchat_rep result
         * @property {number|Long|null} [chatkey] msg_set_snapchat_rep chatkey
         * @property {number|null} [snaptime] msg_set_snapchat_rep snaptime
         */

        /**
         * Constructs a new msg_set_snapchat_rep.
         * @memberof net
         * @classdesc Represents a msg_set_snapchat_rep.
         * @implements Imsg_set_snapchat_rep
         * @constructor
         * @param {net.Imsg_set_snapchat_rep=} [properties] Properties to set
         */
        function msg_set_snapchat_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_snapchat_rep result.
         * @member {number} result
         * @memberof net.msg_set_snapchat_rep
         * @instance
         */
        msg_set_snapchat_rep.prototype.result = 0;

        /**
         * msg_set_snapchat_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_snapchat_rep
         * @instance
         */
        msg_set_snapchat_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_snapchat_rep snaptime.
         * @member {number} snaptime
         * @memberof net.msg_set_snapchat_rep
         * @instance
         */
        msg_set_snapchat_rep.prototype.snaptime = 0;

        /**
         * Encodes the specified msg_set_snapchat_rep message. Does not implicitly {@link net.msg_set_snapchat_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {net.Imsg_set_snapchat_rep} message msg_set_snapchat_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_snapchat_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.snaptime != null && Object.hasOwnProperty.call(message, "snaptime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.snaptime);
            return writer;
        };

        /**
         * Decodes a msg_set_snapchat_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_snapchat_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_snapchat_rep} msg_set_snapchat_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_snapchat_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_snapchat_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.snaptime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_snapchat_rep;
    })();

    net.msg_get_snap_list = (function() {

        /**
         * Properties of a msg_get_snap_list.
         * @memberof net
         * @interface Imsg_get_snap_list
         */

        /**
         * Constructs a new msg_get_snap_list.
         * @memberof net
         * @classdesc Represents a msg_get_snap_list.
         * @implements Imsg_get_snap_list
         * @constructor
         * @param {net.Imsg_get_snap_list=} [properties] Properties to set
         */
        function msg_get_snap_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_snap_list message. Does not implicitly {@link net.msg_get_snap_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_snap_list
         * @static
         * @param {net.Imsg_get_snap_list} message msg_get_snap_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_snap_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_snap_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_snap_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_snap_list} msg_get_snap_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_snap_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_snap_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_snap_list;
    })();

    net.msg_get_snap_list_rep = (function() {

        /**
         * Properties of a msg_get_snap_list_rep.
         * @memberof net
         * @interface Imsg_get_snap_list_rep
         * @property {Array.<net.Isnap_chatkey_info>|null} [snaplist] msg_get_snap_list_rep snaplist
         */

        /**
         * Constructs a new msg_get_snap_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_snap_list_rep.
         * @implements Imsg_get_snap_list_rep
         * @constructor
         * @param {net.Imsg_get_snap_list_rep=} [properties] Properties to set
         */
        function msg_get_snap_list_rep(properties) {
            this.snaplist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_snap_list_rep snaplist.
         * @member {Array.<net.Isnap_chatkey_info>} snaplist
         * @memberof net.msg_get_snap_list_rep
         * @instance
         */
        msg_get_snap_list_rep.prototype.snaplist = $util.emptyArray;

        /**
         * Encodes the specified msg_get_snap_list_rep message. Does not implicitly {@link net.msg_get_snap_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {net.Imsg_get_snap_list_rep} message msg_get_snap_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_snap_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.snaplist != null && message.snaplist.length)
                for (var i = 0; i < message.snaplist.length; ++i)
                    $root.net.snap_chatkey_info.encode(message.snaplist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_snap_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_snap_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_snap_list_rep} msg_get_snap_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_snap_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_snap_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.snaplist && message.snaplist.length))
                        message.snaplist = [];
                    message.snaplist.push($root.net.snap_chatkey_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_snap_list_rep;
    })();

    net.msg_get_screenshot = (function() {

        /**
         * Properties of a msg_get_screenshot.
         * @memberof net
         * @interface Imsg_get_screenshot
         * @property {number|Long|null} [chatkey] msg_get_screenshot chatkey
         */

        /**
         * Constructs a new msg_get_screenshot.
         * @memberof net
         * @classdesc Represents a msg_get_screenshot.
         * @implements Imsg_get_screenshot
         * @constructor
         * @param {net.Imsg_get_screenshot=} [properties] Properties to set
         */
        function msg_get_screenshot(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_screenshot chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_screenshot
         * @instance
         */
        msg_get_screenshot.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_get_screenshot message. Does not implicitly {@link net.msg_get_screenshot.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_screenshot
         * @static
         * @param {net.Imsg_get_screenshot} message msg_get_screenshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_screenshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            return writer;
        };

        /**
         * Decodes a msg_get_screenshot message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_screenshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_screenshot} msg_get_screenshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_screenshot.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_screenshot();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_screenshot;
    })();

    net.msg_get_screenshot_rep = (function() {

        /**
         * Properties of a msg_get_screenshot_rep.
         * @memberof net
         * @interface Imsg_get_screenshot_rep
         * @property {number|Long|null} [chatkey] msg_get_screenshot_rep chatkey
         * @property {number|null} [screenshot] msg_get_screenshot_rep screenshot
         */

        /**
         * Constructs a new msg_get_screenshot_rep.
         * @memberof net
         * @classdesc Represents a msg_get_screenshot_rep.
         * @implements Imsg_get_screenshot_rep
         * @constructor
         * @param {net.Imsg_get_screenshot_rep=} [properties] Properties to set
         */
        function msg_get_screenshot_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_screenshot_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_get_screenshot_rep
         * @instance
         */
        msg_get_screenshot_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_get_screenshot_rep screenshot.
         * @member {number} screenshot
         * @memberof net.msg_get_screenshot_rep
         * @instance
         */
        msg_get_screenshot_rep.prototype.screenshot = 0;

        /**
         * Encodes the specified msg_get_screenshot_rep message. Does not implicitly {@link net.msg_get_screenshot_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {net.Imsg_get_screenshot_rep} message msg_get_screenshot_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_screenshot_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.screenshot != null && Object.hasOwnProperty.call(message, "screenshot"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.screenshot);
            return writer;
        };

        /**
         * Decodes a msg_get_screenshot_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_screenshot_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_screenshot_rep} msg_get_screenshot_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_screenshot_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_screenshot_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.screenshot = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_screenshot_rep;
    })();

    net.msg_set_screenshot = (function() {

        /**
         * Properties of a msg_set_screenshot.
         * @memberof net
         * @interface Imsg_set_screenshot
         * @property {number|Long|null} [chatkey] msg_set_screenshot chatkey
         * @property {number|null} [flag] msg_set_screenshot flag
         */

        /**
         * Constructs a new msg_set_screenshot.
         * @memberof net
         * @classdesc Represents a msg_set_screenshot.
         * @implements Imsg_set_screenshot
         * @constructor
         * @param {net.Imsg_set_screenshot=} [properties] Properties to set
         */
        function msg_set_screenshot(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_screenshot chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_screenshot
         * @instance
         */
        msg_set_screenshot.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_screenshot flag.
         * @member {number} flag
         * @memberof net.msg_set_screenshot
         * @instance
         */
        msg_set_screenshot.prototype.flag = 0;

        /**
         * Encodes the specified msg_set_screenshot message. Does not implicitly {@link net.msg_set_screenshot.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_screenshot
         * @static
         * @param {net.Imsg_set_screenshot} message msg_set_screenshot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_screenshot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.flag != null && Object.hasOwnProperty.call(message, "flag"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.flag);
            return writer;
        };

        /**
         * Decodes a msg_set_screenshot message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_screenshot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_screenshot} msg_set_screenshot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_screenshot.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_screenshot();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.flag = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_screenshot;
    })();

    net.msg_set_screenshot_rep = (function() {

        /**
         * Properties of a msg_set_screenshot_rep.
         * @memberof net
         * @interface Imsg_set_screenshot_rep
         * @property {number|null} [result] msg_set_screenshot_rep result
         * @property {number|Long|null} [chatkey] msg_set_screenshot_rep chatkey
         * @property {number|null} [screenshot] msg_set_screenshot_rep screenshot
         * @property {number|null} [uid] msg_set_screenshot_rep uid
         */

        /**
         * Constructs a new msg_set_screenshot_rep.
         * @memberof net
         * @classdesc Represents a msg_set_screenshot_rep.
         * @implements Imsg_set_screenshot_rep
         * @constructor
         * @param {net.Imsg_set_screenshot_rep=} [properties] Properties to set
         */
        function msg_set_screenshot_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_screenshot_rep result.
         * @member {number} result
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.result = 0;

        /**
         * msg_set_screenshot_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_set_screenshot_rep screenshot.
         * @member {number} screenshot
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.screenshot = 0;

        /**
         * msg_set_screenshot_rep uid.
         * @member {number} uid
         * @memberof net.msg_set_screenshot_rep
         * @instance
         */
        msg_set_screenshot_rep.prototype.uid = 0;

        /**
         * Encodes the specified msg_set_screenshot_rep message. Does not implicitly {@link net.msg_set_screenshot_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {net.Imsg_set_screenshot_rep} message msg_set_screenshot_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_screenshot_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.screenshot != null && Object.hasOwnProperty.call(message, "screenshot"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.screenshot);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_set_screenshot_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_screenshot_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_screenshot_rep} msg_set_screenshot_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_screenshot_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_screenshot_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.screenshot = reader.int32();
                    break;
                case 4:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_screenshot_rep;
    })();

    net.msg_get_order_info_byid = (function() {

        /**
         * Properties of a msg_get_order_info_byid.
         * @memberof net
         * @interface Imsg_get_order_info_byid
         * @property {number|Long|null} [orderid] msg_get_order_info_byid orderid
         */

        /**
         * Constructs a new msg_get_order_info_byid.
         * @memberof net
         * @classdesc Represents a msg_get_order_info_byid.
         * @implements Imsg_get_order_info_byid
         * @constructor
         * @param {net.Imsg_get_order_info_byid=} [properties] Properties to set
         */
        function msg_get_order_info_byid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info_byid orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_get_order_info_byid
         * @instance
         */
        msg_get_order_info_byid.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_get_order_info_byid message. Does not implicitly {@link net.msg_get_order_info_byid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {net.Imsg_get_order_info_byid} message msg_get_order_info_byid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_byid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            return writer;
        };

        /**
         * Decodes a msg_get_order_info_byid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info_byid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info_byid} msg_get_order_info_byid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_byid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info_byid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_order_info_byid;
    })();

    net.msg_get_order_info_byid_req = (function() {

        /**
         * Properties of a msg_get_order_info_byid_req.
         * @memberof net
         * @interface Imsg_get_order_info_byid_req
         * @property {number|null} [result] msg_get_order_info_byid_req result
         * @property {net.Iorder_info|null} [order] msg_get_order_info_byid_req order
         */

        /**
         * Constructs a new msg_get_order_info_byid_req.
         * @memberof net
         * @classdesc Represents a msg_get_order_info_byid_req.
         * @implements Imsg_get_order_info_byid_req
         * @constructor
         * @param {net.Imsg_get_order_info_byid_req=} [properties] Properties to set
         */
        function msg_get_order_info_byid_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_order_info_byid_req result.
         * @member {number} result
         * @memberof net.msg_get_order_info_byid_req
         * @instance
         */
        msg_get_order_info_byid_req.prototype.result = 0;

        /**
         * msg_get_order_info_byid_req order.
         * @member {net.Iorder_info|null|undefined} order
         * @memberof net.msg_get_order_info_byid_req
         * @instance
         */
        msg_get_order_info_byid_req.prototype.order = null;

        /**
         * Encodes the specified msg_get_order_info_byid_req message. Does not implicitly {@link net.msg_get_order_info_byid_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {net.Imsg_get_order_info_byid_req} message msg_get_order_info_byid_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_order_info_byid_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                $root.net.order_info.encode(message.order, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_order_info_byid_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_order_info_byid_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_order_info_byid_req} msg_get_order_info_byid_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_order_info_byid_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_order_info_byid_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.order = $root.net.order_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_order_info_byid_req;
    })();

    net.msg_get_black_list = (function() {

        /**
         * Properties of a msg_get_black_list.
         * @memberof net
         * @interface Imsg_get_black_list
         */

        /**
         * Constructs a new msg_get_black_list.
         * @memberof net
         * @classdesc Represents a msg_get_black_list.
         * @implements Imsg_get_black_list
         * @constructor
         * @param {net.Imsg_get_black_list=} [properties] Properties to set
         */
        function msg_get_black_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_black_list message. Does not implicitly {@link net.msg_get_black_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_black_list
         * @static
         * @param {net.Imsg_get_black_list} message msg_get_black_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_black_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_black_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_black_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_black_list} msg_get_black_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_black_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_black_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_black_list;
    })();

    net.msg_get_black_list_rep = (function() {

        /**
         * Properties of a msg_get_black_list_rep.
         * @memberof net
         * @interface Imsg_get_black_list_rep
         * @property {Array.<net.Ibase_info>|null} [blacklist] msg_get_black_list_rep blacklist
         */

        /**
         * Constructs a new msg_get_black_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_black_list_rep.
         * @implements Imsg_get_black_list_rep
         * @constructor
         * @param {net.Imsg_get_black_list_rep=} [properties] Properties to set
         */
        function msg_get_black_list_rep(properties) {
            this.blacklist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_black_list_rep blacklist.
         * @member {Array.<net.Ibase_info>} blacklist
         * @memberof net.msg_get_black_list_rep
         * @instance
         */
        msg_get_black_list_rep.prototype.blacklist = $util.emptyArray;

        /**
         * Encodes the specified msg_get_black_list_rep message. Does not implicitly {@link net.msg_get_black_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {net.Imsg_get_black_list_rep} message msg_get_black_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_black_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.blacklist != null && message.blacklist.length)
                for (var i = 0; i < message.blacklist.length; ++i)
                    $root.net.base_info.encode(message.blacklist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_black_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_black_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_black_list_rep} msg_get_black_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_black_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_black_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.blacklist && message.blacklist.length))
                        message.blacklist = [];
                    message.blacklist.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_black_list_rep;
    })();

    net.msg_set_black_list = (function() {

        /**
         * Properties of a msg_set_black_list.
         * @memberof net
         * @interface Imsg_set_black_list
         * @property {number|null} [otheruid] msg_set_black_list otheruid
         * @property {number|null} [opertype] msg_set_black_list opertype
         */

        /**
         * Constructs a new msg_set_black_list.
         * @memberof net
         * @classdesc Represents a msg_set_black_list.
         * @implements Imsg_set_black_list
         * @constructor
         * @param {net.Imsg_set_black_list=} [properties] Properties to set
         */
        function msg_set_black_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_black_list otheruid.
         * @member {number} otheruid
         * @memberof net.msg_set_black_list
         * @instance
         */
        msg_set_black_list.prototype.otheruid = 0;

        /**
         * msg_set_black_list opertype.
         * @member {number} opertype
         * @memberof net.msg_set_black_list
         * @instance
         */
        msg_set_black_list.prototype.opertype = 0;

        /**
         * Encodes the specified msg_set_black_list message. Does not implicitly {@link net.msg_set_black_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_black_list
         * @static
         * @param {net.Imsg_set_black_list} message msg_set_black_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_black_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.otheruid);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_set_black_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_black_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_black_list} msg_set_black_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_black_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_black_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.otheruid = reader.int32();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_black_list;
    })();

    net.msg_set_black_list_rep = (function() {

        /**
         * Properties of a msg_set_black_list_rep.
         * @memberof net
         * @interface Imsg_set_black_list_rep
         * @property {number|null} [result] msg_set_black_list_rep result
         * @property {number|null} [otheruid] msg_set_black_list_rep otheruid
         * @property {number|null} [opertype] msg_set_black_list_rep opertype
         */

        /**
         * Constructs a new msg_set_black_list_rep.
         * @memberof net
         * @classdesc Represents a msg_set_black_list_rep.
         * @implements Imsg_set_black_list_rep
         * @constructor
         * @param {net.Imsg_set_black_list_rep=} [properties] Properties to set
         */
        function msg_set_black_list_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_black_list_rep result.
         * @member {number} result
         * @memberof net.msg_set_black_list_rep
         * @instance
         */
        msg_set_black_list_rep.prototype.result = 0;

        /**
         * msg_set_black_list_rep otheruid.
         * @member {number} otheruid
         * @memberof net.msg_set_black_list_rep
         * @instance
         */
        msg_set_black_list_rep.prototype.otheruid = 0;

        /**
         * msg_set_black_list_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_set_black_list_rep
         * @instance
         */
        msg_set_black_list_rep.prototype.opertype = 0;

        /**
         * Encodes the specified msg_set_black_list_rep message. Does not implicitly {@link net.msg_set_black_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {net.Imsg_set_black_list_rep} message msg_set_black_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_black_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.otheruid);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_set_black_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_black_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_black_list_rep} msg_set_black_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_black_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_black_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.int32();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_black_list_rep;
    })();

    net.msg_third_pay = (function() {

        /**
         * Properties of a msg_third_pay.
         * @memberof net
         * @interface Imsg_third_pay
         * @property {number|Long|null} [orderid] msg_third_pay orderid
         * @property {Uint8Array|null} [authcode] msg_third_pay authcode
         */

        /**
         * Constructs a new msg_third_pay.
         * @memberof net
         * @classdesc Represents a msg_third_pay.
         * @implements Imsg_third_pay
         * @constructor
         * @param {net.Imsg_third_pay=} [properties] Properties to set
         */
        function msg_third_pay(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_third_pay orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_third_pay
         * @instance
         */
        msg_third_pay.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_third_pay authcode.
         * @member {Uint8Array} authcode
         * @memberof net.msg_third_pay
         * @instance
         */
        msg_third_pay.prototype.authcode = $util.newBuffer([]);

        /**
         * Encodes the specified msg_third_pay message. Does not implicitly {@link net.msg_third_pay.verify|verify} messages.
         * @function encode
         * @memberof net.msg_third_pay
         * @static
         * @param {net.Imsg_third_pay} message msg_third_pay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_third_pay.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.orderid);
            if (message.authcode != null && Object.hasOwnProperty.call(message, "authcode"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.authcode);
            return writer;
        };

        /**
         * Decodes a msg_third_pay message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_third_pay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_third_pay} msg_third_pay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_third_pay.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_third_pay();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.orderid = reader.int64();
                    break;
                case 2:
                    message.authcode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_third_pay;
    })();

    net.msg_third_pay_rep = (function() {

        /**
         * Properties of a msg_third_pay_rep.
         * @memberof net
         * @interface Imsg_third_pay_rep
         * @property {number|null} [result] msg_third_pay_rep result
         */

        /**
         * Constructs a new msg_third_pay_rep.
         * @memberof net
         * @classdesc Represents a msg_third_pay_rep.
         * @implements Imsg_third_pay_rep
         * @constructor
         * @param {net.Imsg_third_pay_rep=} [properties] Properties to set
         */
        function msg_third_pay_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_third_pay_rep result.
         * @member {number} result
         * @memberof net.msg_third_pay_rep
         * @instance
         */
        msg_third_pay_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_third_pay_rep message. Does not implicitly {@link net.msg_third_pay_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {net.Imsg_third_pay_rep} message msg_third_pay_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_third_pay_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_third_pay_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_third_pay_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_third_pay_rep} msg_third_pay_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_third_pay_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_third_pay_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_third_pay_rep;
    })();

    net.msg_pcauth = (function() {

        /**
         * Properties of a msg_pcauth.
         * @memberof net
         * @interface Imsg_pcauth
         * @property {number|null} [pcflow] msg_pcauth pcflow
         * @property {Uint8Array|null} [pckey] msg_pcauth pckey
         */

        /**
         * Constructs a new msg_pcauth.
         * @memberof net
         * @classdesc Represents a msg_pcauth.
         * @implements Imsg_pcauth
         * @constructor
         * @param {net.Imsg_pcauth=} [properties] Properties to set
         */
        function msg_pcauth(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pcauth pcflow.
         * @member {number} pcflow
         * @memberof net.msg_pcauth
         * @instance
         */
        msg_pcauth.prototype.pcflow = 0;

        /**
         * msg_pcauth pckey.
         * @member {Uint8Array} pckey
         * @memberof net.msg_pcauth
         * @instance
         */
        msg_pcauth.prototype.pckey = $util.newBuffer([]);

        /**
         * Encodes the specified msg_pcauth message. Does not implicitly {@link net.msg_pcauth.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pcauth
         * @static
         * @param {net.Imsg_pcauth} message msg_pcauth message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pcauth.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pcflow != null && Object.hasOwnProperty.call(message, "pcflow"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pcflow);
            if (message.pckey != null && Object.hasOwnProperty.call(message, "pckey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.pckey);
            return writer;
        };

        /**
         * Decodes a msg_pcauth message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pcauth
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pcauth} msg_pcauth
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pcauth.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pcauth();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pcflow = reader.int32();
                    break;
                case 2:
                    message.pckey = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_pcauth;
    })();

    net.msg_pcauth_rep = (function() {

        /**
         * Properties of a msg_pcauth_rep.
         * @memberof net
         * @interface Imsg_pcauth_rep
         * @property {number|null} [result] msg_pcauth_rep result
         */

        /**
         * Constructs a new msg_pcauth_rep.
         * @memberof net
         * @classdesc Represents a msg_pcauth_rep.
         * @implements Imsg_pcauth_rep
         * @constructor
         * @param {net.Imsg_pcauth_rep=} [properties] Properties to set
         */
        function msg_pcauth_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pcauth_rep result.
         * @member {number} result
         * @memberof net.msg_pcauth_rep
         * @instance
         */
        msg_pcauth_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_pcauth_rep message. Does not implicitly {@link net.msg_pcauth_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {net.Imsg_pcauth_rep} message msg_pcauth_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pcauth_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_pcauth_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pcauth_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pcauth_rep} msg_pcauth_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pcauth_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pcauth_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_pcauth_rep;
    })();

    net.msg_pclogin_req = (function() {

        /**
         * Properties of a msg_pclogin_req.
         * @memberof net
         * @interface Imsg_pclogin_req
         * @property {number|null} [uid] msg_pclogin_req uid
         * @property {Uint8Array|null} [fastkey] msg_pclogin_req fastkey
         * @property {Uint8Array|null} [deviceid] msg_pclogin_req deviceid
         * @property {Uint8Array|null} [version] msg_pclogin_req version
         */

        /**
         * Constructs a new msg_pclogin_req.
         * @memberof net
         * @classdesc Represents a msg_pclogin_req.
         * @implements Imsg_pclogin_req
         * @constructor
         * @param {net.Imsg_pclogin_req=} [properties] Properties to set
         */
        function msg_pclogin_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pclogin_req uid.
         * @member {number} uid
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.uid = 0;

        /**
         * msg_pclogin_req fastkey.
         * @member {Uint8Array} fastkey
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.fastkey = $util.newBuffer([]);

        /**
         * msg_pclogin_req deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.deviceid = $util.newBuffer([]);

        /**
         * msg_pclogin_req version.
         * @member {Uint8Array} version
         * @memberof net.msg_pclogin_req
         * @instance
         */
        msg_pclogin_req.prototype.version = $util.newBuffer([]);

        /**
         * Encodes the specified msg_pclogin_req message. Does not implicitly {@link net.msg_pclogin_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pclogin_req
         * @static
         * @param {net.Imsg_pclogin_req} message msg_pclogin_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pclogin_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.fastkey != null && Object.hasOwnProperty.call(message, "fastkey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.fastkey);
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.deviceid);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.version);
            return writer;
        };

        /**
         * Decodes a msg_pclogin_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pclogin_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pclogin_req} msg_pclogin_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pclogin_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pclogin_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.fastkey = reader.bytes();
                    break;
                case 3:
                    message.deviceid = reader.bytes();
                    break;
                case 4:
                    message.version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_pclogin_req;
    })();

    net.msg_pclogin_rep = (function() {

        /**
         * Properties of a msg_pclogin_rep.
         * @memberof net
         * @interface Imsg_pclogin_rep
         * @property {number|null} [result] msg_pclogin_rep result
         * @property {number|null} [server_time] msg_pclogin_rep server_time
         * @property {Array.<net.Icustomer_info>|null} [customer_list] msg_pclogin_rep customer_list
         */

        /**
         * Constructs a new msg_pclogin_rep.
         * @memberof net
         * @classdesc Represents a msg_pclogin_rep.
         * @implements Imsg_pclogin_rep
         * @constructor
         * @param {net.Imsg_pclogin_rep=} [properties] Properties to set
         */
        function msg_pclogin_rep(properties) {
            this.customer_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pclogin_rep result.
         * @member {number} result
         * @memberof net.msg_pclogin_rep
         * @instance
         */
        msg_pclogin_rep.prototype.result = 0;

        /**
         * msg_pclogin_rep server_time.
         * @member {number} server_time
         * @memberof net.msg_pclogin_rep
         * @instance
         */
        msg_pclogin_rep.prototype.server_time = 0;

        /**
         * msg_pclogin_rep customer_list.
         * @member {Array.<net.Icustomer_info>} customer_list
         * @memberof net.msg_pclogin_rep
         * @instance
         */
        msg_pclogin_rep.prototype.customer_list = $util.emptyArray;

        /**
         * Encodes the specified msg_pclogin_rep message. Does not implicitly {@link net.msg_pclogin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {net.Imsg_pclogin_rep} message msg_pclogin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pclogin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.server_time != null && Object.hasOwnProperty.call(message, "server_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.server_time);
            if (message.customer_list != null && message.customer_list.length)
                for (var i = 0; i < message.customer_list.length; ++i)
                    $root.net.customer_info.encode(message.customer_list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_pclogin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pclogin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pclogin_rep} msg_pclogin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pclogin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pclogin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.server_time = reader.uint32();
                    break;
                case 3:
                    if (!(message.customer_list && message.customer_list.length))
                        message.customer_list = [];
                    message.customer_list.push($root.net.customer_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_pclogin_rep;
    })();

    net.msg_h5login_req = (function() {

        /**
         * Properties of a msg_h5login_req.
         * @memberof net
         * @interface Imsg_h5login_req
         * @property {number|null} [uid] msg_h5login_req uid
         * @property {Uint8Array|null} [fastkey] msg_h5login_req fastkey
         * @property {Uint8Array|null} [deviceid] msg_h5login_req deviceid
         * @property {Uint8Array|null} [version] msg_h5login_req version
         */

        /**
         * Constructs a new msg_h5login_req.
         * @memberof net
         * @classdesc Represents a msg_h5login_req.
         * @implements Imsg_h5login_req
         * @constructor
         * @param {net.Imsg_h5login_req=} [properties] Properties to set
         */
        function msg_h5login_req(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_h5login_req uid.
         * @member {number} uid
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.uid = 0;

        /**
         * msg_h5login_req fastkey.
         * @member {Uint8Array} fastkey
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.fastkey = $util.newBuffer([]);

        /**
         * msg_h5login_req deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.deviceid = $util.newBuffer([]);

        /**
         * msg_h5login_req version.
         * @member {Uint8Array} version
         * @memberof net.msg_h5login_req
         * @instance
         */
        msg_h5login_req.prototype.version = $util.newBuffer([]);

        /**
         * Encodes the specified msg_h5login_req message. Does not implicitly {@link net.msg_h5login_req.verify|verify} messages.
         * @function encode
         * @memberof net.msg_h5login_req
         * @static
         * @param {net.Imsg_h5login_req} message msg_h5login_req message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_h5login_req.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.fastkey != null && Object.hasOwnProperty.call(message, "fastkey"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.fastkey);
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.deviceid);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.version);
            return writer;
        };

        /**
         * Decodes a msg_h5login_req message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_h5login_req
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_h5login_req} msg_h5login_req
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_h5login_req.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_h5login_req();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.fastkey = reader.bytes();
                    break;
                case 3:
                    message.deviceid = reader.bytes();
                    break;
                case 4:
                    message.version = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_h5login_req;
    })();

    net.msg_h5login_rep = (function() {

        /**
         * Properties of a msg_h5login_rep.
         * @memberof net
         * @interface Imsg_h5login_rep
         * @property {number|null} [result] msg_h5login_rep result
         * @property {number|null} [server_time] msg_h5login_rep server_time
         * @property {Array.<net.Icustomer_info>|null} [customer_list] msg_h5login_rep customer_list
         */

        /**
         * Constructs a new msg_h5login_rep.
         * @memberof net
         * @classdesc Represents a msg_h5login_rep.
         * @implements Imsg_h5login_rep
         * @constructor
         * @param {net.Imsg_h5login_rep=} [properties] Properties to set
         */
        function msg_h5login_rep(properties) {
            this.customer_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_h5login_rep result.
         * @member {number} result
         * @memberof net.msg_h5login_rep
         * @instance
         */
        msg_h5login_rep.prototype.result = 0;

        /**
         * msg_h5login_rep server_time.
         * @member {number} server_time
         * @memberof net.msg_h5login_rep
         * @instance
         */
        msg_h5login_rep.prototype.server_time = 0;

        /**
         * msg_h5login_rep customer_list.
         * @member {Array.<net.Icustomer_info>} customer_list
         * @memberof net.msg_h5login_rep
         * @instance
         */
        msg_h5login_rep.prototype.customer_list = $util.emptyArray;

        /**
         * Encodes the specified msg_h5login_rep message. Does not implicitly {@link net.msg_h5login_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_h5login_rep
         * @static
         * @param {net.Imsg_h5login_rep} message msg_h5login_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_h5login_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.server_time != null && Object.hasOwnProperty.call(message, "server_time"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.server_time);
            if (message.customer_list != null && message.customer_list.length)
                for (var i = 0; i < message.customer_list.length; ++i)
                    $root.net.customer_info.encode(message.customer_list[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_h5login_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_h5login_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_h5login_rep} msg_h5login_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_h5login_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_h5login_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.server_time = reader.uint32();
                    break;
                case 3:
                    if (!(message.customer_list && message.customer_list.length))
                        message.customer_list = [];
                    message.customer_list.push($root.net.customer_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_h5login_rep;
    })();

    net.msg_voice_call = (function() {

        /**
         * Properties of a msg_voice_call.
         * @memberof net
         * @interface Imsg_voice_call
         * @property {number|Long|null} [chatkey] msg_voice_call chatkey
         * @property {Uint8Array|null} [token] msg_voice_call token
         */

        /**
         * Constructs a new msg_voice_call.
         * @memberof net
         * @classdesc Represents a msg_voice_call.
         * @implements Imsg_voice_call
         * @constructor
         * @param {net.Imsg_voice_call=} [properties] Properties to set
         */
        function msg_voice_call(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_call chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_call
         * @instance
         */
        msg_voice_call.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_call token.
         * @member {Uint8Array} token
         * @memberof net.msg_voice_call
         * @instance
         */
        msg_voice_call.prototype.token = $util.newBuffer([]);

        /**
         * Encodes the specified msg_voice_call message. Does not implicitly {@link net.msg_voice_call.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_call
         * @static
         * @param {net.Imsg_voice_call} message msg_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.token);
            return writer;
        };

        /**
         * Decodes a msg_voice_call message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_call} msg_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_call();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.token = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_voice_call;
    })();

    net.msg_voice_call_rep = (function() {

        /**
         * Properties of a msg_voice_call_rep.
         * @memberof net
         * @interface Imsg_voice_call_rep
         * @property {number|null} [result] msg_voice_call_rep result
         */

        /**
         * Constructs a new msg_voice_call_rep.
         * @memberof net
         * @classdesc Represents a msg_voice_call_rep.
         * @implements Imsg_voice_call_rep
         * @constructor
         * @param {net.Imsg_voice_call_rep=} [properties] Properties to set
         */
        function msg_voice_call_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_call_rep result.
         * @member {number} result
         * @memberof net.msg_voice_call_rep
         * @instance
         */
        msg_voice_call_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_voice_call_rep message. Does not implicitly {@link net.msg_voice_call_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {net.Imsg_voice_call_rep} message msg_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_voice_call_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_call_rep} msg_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_call_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_voice_call_rep;
    })();

    net.msg_oper_voice_call = (function() {

        /**
         * Properties of a msg_oper_voice_call.
         * @memberof net
         * @interface Imsg_oper_voice_call
         * @property {number|Long|null} [chatkey] msg_oper_voice_call chatkey
         * @property {number|null} [opertype] msg_oper_voice_call opertype
         */

        /**
         * Constructs a new msg_oper_voice_call.
         * @memberof net
         * @classdesc Represents a msg_oper_voice_call.
         * @implements Imsg_oper_voice_call
         * @constructor
         * @param {net.Imsg_oper_voice_call=} [properties] Properties to set
         */
        function msg_oper_voice_call(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_voice_call chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_oper_voice_call
         * @instance
         */
        msg_oper_voice_call.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_oper_voice_call opertype.
         * @member {number} opertype
         * @memberof net.msg_oper_voice_call
         * @instance
         */
        msg_oper_voice_call.prototype.opertype = 0;

        /**
         * Encodes the specified msg_oper_voice_call message. Does not implicitly {@link net.msg_oper_voice_call.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {net.Imsg_oper_voice_call} message msg_oper_voice_call message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_voice_call.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_oper_voice_call message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_voice_call
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_voice_call} msg_oper_voice_call
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_voice_call.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_voice_call();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_oper_voice_call;
    })();

    net.msg_oper_voice_call_rep = (function() {

        /**
         * Properties of a msg_oper_voice_call_rep.
         * @memberof net
         * @interface Imsg_oper_voice_call_rep
         * @property {number|null} [result] msg_oper_voice_call_rep result
         * @property {number|Long|null} [chatkey] msg_oper_voice_call_rep chatkey
         * @property {number|null} [opertype] msg_oper_voice_call_rep opertype
         */

        /**
         * Constructs a new msg_oper_voice_call_rep.
         * @memberof net
         * @classdesc Represents a msg_oper_voice_call_rep.
         * @implements Imsg_oper_voice_call_rep
         * @constructor
         * @param {net.Imsg_oper_voice_call_rep=} [properties] Properties to set
         */
        function msg_oper_voice_call_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_oper_voice_call_rep result.
         * @member {number} result
         * @memberof net.msg_oper_voice_call_rep
         * @instance
         */
        msg_oper_voice_call_rep.prototype.result = 0;

        /**
         * msg_oper_voice_call_rep chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_oper_voice_call_rep
         * @instance
         */
        msg_oper_voice_call_rep.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_oper_voice_call_rep opertype.
         * @member {number} opertype
         * @memberof net.msg_oper_voice_call_rep
         * @instance
         */
        msg_oper_voice_call_rep.prototype.opertype = 0;

        /**
         * Encodes the specified msg_oper_voice_call_rep message. Does not implicitly {@link net.msg_oper_voice_call_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {net.Imsg_oper_voice_call_rep} message msg_oper_voice_call_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_oper_voice_call_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_oper_voice_call_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_oper_voice_call_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_oper_voice_call_rep} msg_oper_voice_call_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_oper_voice_call_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_oper_voice_call_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_oper_voice_call_rep;
    })();

    net.msg_voice_data = (function() {

        /**
         * Properties of a msg_voice_data.
         * @memberof net
         * @interface Imsg_voice_data
         * @property {number|Long|null} [chatkey] msg_voice_data chatkey
         * @property {Uint8Array|null} [voice_data] msg_voice_data voice_data
         * @property {number|Long|null} [ptime] msg_voice_data ptime
         */

        /**
         * Constructs a new msg_voice_data.
         * @memberof net
         * @classdesc Represents a msg_voice_data.
         * @implements Imsg_voice_data
         * @constructor
         * @param {net.Imsg_voice_data=} [properties] Properties to set
         */
        function msg_voice_data(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_data chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_data
         * @instance
         */
        msg_voice_data.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_data voice_data.
         * @member {Uint8Array} voice_data
         * @memberof net.msg_voice_data
         * @instance
         */
        msg_voice_data.prototype.voice_data = $util.newBuffer([]);

        /**
         * msg_voice_data ptime.
         * @member {number|Long} ptime
         * @memberof net.msg_voice_data
         * @instance
         */
        msg_voice_data.prototype.ptime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_voice_data message. Does not implicitly {@link net.msg_voice_data.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_data
         * @static
         * @param {net.Imsg_voice_data} message msg_voice_data message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.voice_data != null && Object.hasOwnProperty.call(message, "voice_data"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.voice_data);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ptime);
            return writer;
        };

        /**
         * Decodes a msg_voice_data message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_data
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_data} msg_voice_data
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_data();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.voice_data = reader.bytes();
                    break;
                case 3:
                    message.ptime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_voice_data;
    })();

    net.msg_voice_data_rep = (function() {

        /**
         * Properties of a msg_voice_data_rep.
         * @memberof net
         * @interface Imsg_voice_data_rep
         * @property {number|null} [result] msg_voice_data_rep result
         */

        /**
         * Constructs a new msg_voice_data_rep.
         * @memberof net
         * @classdesc Represents a msg_voice_data_rep.
         * @implements Imsg_voice_data_rep
         * @constructor
         * @param {net.Imsg_voice_data_rep=} [properties] Properties to set
         */
        function msg_voice_data_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_data_rep result.
         * @member {number} result
         * @memberof net.msg_voice_data_rep
         * @instance
         */
        msg_voice_data_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_voice_data_rep message. Does not implicitly {@link net.msg_voice_data_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {net.Imsg_voice_data_rep} message msg_voice_data_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_voice_data_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_data_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_data_rep} msg_voice_data_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_data_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_voice_data_rep;
    })();

    net.msg_need_read_group_notify = (function() {

        /**
         * Properties of a msg_need_read_group_notify.
         * @memberof net
         * @interface Imsg_need_read_group_notify
         * @property {number|null} [groupkey] msg_need_read_group_notify groupkey
         */

        /**
         * Constructs a new msg_need_read_group_notify.
         * @memberof net
         * @classdesc Represents a msg_need_read_group_notify.
         * @implements Imsg_need_read_group_notify
         * @constructor
         * @param {net.Imsg_need_read_group_notify=} [properties] Properties to set
         */
        function msg_need_read_group_notify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_need_read_group_notify groupkey.
         * @member {number} groupkey
         * @memberof net.msg_need_read_group_notify
         * @instance
         */
        msg_need_read_group_notify.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_need_read_group_notify message. Does not implicitly {@link net.msg_need_read_group_notify.verify|verify} messages.
         * @function encode
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {net.Imsg_need_read_group_notify} message msg_need_read_group_notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_need_read_group_notify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_need_read_group_notify message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_need_read_group_notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_need_read_group_notify} msg_need_read_group_notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_need_read_group_notify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_need_read_group_notify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_need_read_group_notify;
    })();

    net.msg_need_read_group_notify_rep = (function() {

        /**
         * Properties of a msg_need_read_group_notify_rep.
         * @memberof net
         * @interface Imsg_need_read_group_notify_rep
         * @property {number|null} [is_need] msg_need_read_group_notify_rep is_need
         */

        /**
         * Constructs a new msg_need_read_group_notify_rep.
         * @memberof net
         * @classdesc Represents a msg_need_read_group_notify_rep.
         * @implements Imsg_need_read_group_notify_rep
         * @constructor
         * @param {net.Imsg_need_read_group_notify_rep=} [properties] Properties to set
         */
        function msg_need_read_group_notify_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_need_read_group_notify_rep is_need.
         * @member {number} is_need
         * @memberof net.msg_need_read_group_notify_rep
         * @instance
         */
        msg_need_read_group_notify_rep.prototype.is_need = 0;

        /**
         * Encodes the specified msg_need_read_group_notify_rep message. Does not implicitly {@link net.msg_need_read_group_notify_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {net.Imsg_need_read_group_notify_rep} message msg_need_read_group_notify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_need_read_group_notify_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.is_need != null && Object.hasOwnProperty.call(message, "is_need"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.is_need);
            return writer;
        };

        /**
         * Decodes a msg_need_read_group_notify_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_need_read_group_notify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_need_read_group_notify_rep} msg_need_read_group_notify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_need_read_group_notify_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_need_read_group_notify_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.is_need = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_need_read_group_notify_rep;
    })();

    net.msg_read_group_notify = (function() {

        /**
         * Properties of a msg_read_group_notify.
         * @memberof net
         * @interface Imsg_read_group_notify
         * @property {number|null} [groupkey] msg_read_group_notify groupkey
         * @property {number|null} [notifyversion] msg_read_group_notify notifyversion
         */

        /**
         * Constructs a new msg_read_group_notify.
         * @memberof net
         * @classdesc Represents a msg_read_group_notify.
         * @implements Imsg_read_group_notify
         * @constructor
         * @param {net.Imsg_read_group_notify=} [properties] Properties to set
         */
        function msg_read_group_notify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_read_group_notify groupkey.
         * @member {number} groupkey
         * @memberof net.msg_read_group_notify
         * @instance
         */
        msg_read_group_notify.prototype.groupkey = 0;

        /**
         * msg_read_group_notify notifyversion.
         * @member {number} notifyversion
         * @memberof net.msg_read_group_notify
         * @instance
         */
        msg_read_group_notify.prototype.notifyversion = 0;

        /**
         * Encodes the specified msg_read_group_notify message. Does not implicitly {@link net.msg_read_group_notify.verify|verify} messages.
         * @function encode
         * @memberof net.msg_read_group_notify
         * @static
         * @param {net.Imsg_read_group_notify} message msg_read_group_notify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_read_group_notify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            if (message.notifyversion != null && Object.hasOwnProperty.call(message, "notifyversion"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.notifyversion);
            return writer;
        };

        /**
         * Decodes a msg_read_group_notify message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_read_group_notify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_read_group_notify} msg_read_group_notify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_read_group_notify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_read_group_notify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                case 2:
                    message.notifyversion = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_read_group_notify;
    })();

    net.msg_read_group_notify_rep = (function() {

        /**
         * Properties of a msg_read_group_notify_rep.
         * @memberof net
         * @interface Imsg_read_group_notify_rep
         * @property {number|null} [result] msg_read_group_notify_rep result
         */

        /**
         * Constructs a new msg_read_group_notify_rep.
         * @memberof net
         * @classdesc Represents a msg_read_group_notify_rep.
         * @implements Imsg_read_group_notify_rep
         * @constructor
         * @param {net.Imsg_read_group_notify_rep=} [properties] Properties to set
         */
        function msg_read_group_notify_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_read_group_notify_rep result.
         * @member {number} result
         * @memberof net.msg_read_group_notify_rep
         * @instance
         */
        msg_read_group_notify_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_read_group_notify_rep message. Does not implicitly {@link net.msg_read_group_notify_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {net.Imsg_read_group_notify_rep} message msg_read_group_notify_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_read_group_notify_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_read_group_notify_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_read_group_notify_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_read_group_notify_rep} msg_read_group_notify_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_read_group_notify_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_read_group_notify_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_read_group_notify_rep;
    })();

    net.msg_set_forbid_tm = (function() {

        /**
         * Properties of a msg_set_forbid_tm.
         * @memberof net
         * @interface Imsg_set_forbid_tm
         * @property {number|null} [groupkey] msg_set_forbid_tm groupkey
         * @property {number|null} [forbidbegintm] msg_set_forbid_tm forbidbegintm
         * @property {number|null} [forbidendtm] msg_set_forbid_tm forbidendtm
         * @property {number|null} [isforbid] msg_set_forbid_tm isforbid
         */

        /**
         * Constructs a new msg_set_forbid_tm.
         * @memberof net
         * @classdesc Represents a msg_set_forbid_tm.
         * @implements Imsg_set_forbid_tm
         * @constructor
         * @param {net.Imsg_set_forbid_tm=} [properties] Properties to set
         */
        function msg_set_forbid_tm(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_forbid_tm groupkey.
         * @member {number} groupkey
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.groupkey = 0;

        /**
         * msg_set_forbid_tm forbidbegintm.
         * @member {number} forbidbegintm
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.forbidbegintm = 0;

        /**
         * msg_set_forbid_tm forbidendtm.
         * @member {number} forbidendtm
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.forbidendtm = 0;

        /**
         * msg_set_forbid_tm isforbid.
         * @member {number} isforbid
         * @memberof net.msg_set_forbid_tm
         * @instance
         */
        msg_set_forbid_tm.prototype.isforbid = 0;

        /**
         * Encodes the specified msg_set_forbid_tm message. Does not implicitly {@link net.msg_set_forbid_tm.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {net.Imsg_set_forbid_tm} message msg_set_forbid_tm message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_forbid_tm.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            if (message.forbidbegintm != null && Object.hasOwnProperty.call(message, "forbidbegintm"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.forbidbegintm);
            if (message.forbidendtm != null && Object.hasOwnProperty.call(message, "forbidendtm"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.forbidendtm);
            if (message.isforbid != null && Object.hasOwnProperty.call(message, "isforbid"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.isforbid);
            return writer;
        };

        /**
         * Decodes a msg_set_forbid_tm message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_forbid_tm
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_forbid_tm} msg_set_forbid_tm
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_forbid_tm.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_forbid_tm();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                case 2:
                    message.forbidbegintm = reader.uint32();
                    break;
                case 3:
                    message.forbidendtm = reader.uint32();
                    break;
                case 4:
                    message.isforbid = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_forbid_tm;
    })();

    net.msg_set_forbid_tm_rep = (function() {

        /**
         * Properties of a msg_set_forbid_tm_rep.
         * @memberof net
         * @interface Imsg_set_forbid_tm_rep
         * @property {number|null} [result] msg_set_forbid_tm_rep result
         */

        /**
         * Constructs a new msg_set_forbid_tm_rep.
         * @memberof net
         * @classdesc Represents a msg_set_forbid_tm_rep.
         * @implements Imsg_set_forbid_tm_rep
         * @constructor
         * @param {net.Imsg_set_forbid_tm_rep=} [properties] Properties to set
         */
        function msg_set_forbid_tm_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_forbid_tm_rep result.
         * @member {number} result
         * @memberof net.msg_set_forbid_tm_rep
         * @instance
         */
        msg_set_forbid_tm_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_set_forbid_tm_rep message. Does not implicitly {@link net.msg_set_forbid_tm_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {net.Imsg_set_forbid_tm_rep} message msg_set_forbid_tm_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_forbid_tm_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_set_forbid_tm_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_forbid_tm_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_forbid_tm_rep} msg_set_forbid_tm_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_forbid_tm_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_forbid_tm_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_forbid_tm_rep;
    })();

    net.msg_get_group_member_list = (function() {

        /**
         * Properties of a msg_get_group_member_list.
         * @memberof net
         * @interface Imsg_get_group_member_list
         * @property {number|null} [groupkey] msg_get_group_member_list groupkey
         */

        /**
         * Constructs a new msg_get_group_member_list.
         * @memberof net
         * @classdesc Represents a msg_get_group_member_list.
         * @implements Imsg_get_group_member_list
         * @constructor
         * @param {net.Imsg_get_group_member_list=} [properties] Properties to set
         */
        function msg_get_group_member_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_member_list groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_member_list
         * @instance
         */
        msg_get_group_member_list.prototype.groupkey = 0;

        /**
         * Encodes the specified msg_get_group_member_list message. Does not implicitly {@link net.msg_get_group_member_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {net.Imsg_get_group_member_list} message msg_get_group_member_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_member_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.groupkey);
            return writer;
        };

        /**
         * Decodes a msg_get_group_member_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_member_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_member_list} msg_get_group_member_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_member_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_member_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_member_list;
    })();

    net.msg_get_group_member_list_rep = (function() {

        /**
         * Properties of a msg_get_group_member_list_rep.
         * @memberof net
         * @interface Imsg_get_group_member_list_rep
         * @property {number|null} [groupkey] msg_get_group_member_list_rep groupkey
         * @property {number|null} [isfirst] msg_get_group_member_list_rep isfirst
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_group_member_list_rep users
         * @property {number|null} [isend] msg_get_group_member_list_rep isend
         */

        /**
         * Constructs a new msg_get_group_member_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_group_member_list_rep.
         * @implements Imsg_get_group_member_list_rep
         * @constructor
         * @param {net.Imsg_get_group_member_list_rep=} [properties] Properties to set
         */
        function msg_get_group_member_list_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_group_member_list_rep groupkey.
         * @member {number} groupkey
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.groupkey = 0;

        /**
         * msg_get_group_member_list_rep isfirst.
         * @member {number} isfirst
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.isfirst = 0;

        /**
         * msg_get_group_member_list_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.users = $util.emptyArray;

        /**
         * msg_get_group_member_list_rep isend.
         * @member {number} isend
         * @memberof net.msg_get_group_member_list_rep
         * @instance
         */
        msg_get_group_member_list_rep.prototype.isend = 0;

        /**
         * Encodes the specified msg_get_group_member_list_rep message. Does not implicitly {@link net.msg_get_group_member_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {net.Imsg_get_group_member_list_rep} message msg_get_group_member_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_group_member_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.isend);
            return writer;
        };

        /**
         * Decodes a msg_get_group_member_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_group_member_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_group_member_list_rep} msg_get_group_member_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_group_member_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_group_member_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.isend = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_group_member_list_rep;
    })();

    net.msg_get_friend_incr_list = (function() {

        /**
         * Properties of a msg_get_friend_incr_list.
         * @memberof net
         * @interface Imsg_get_friend_incr_list
         * @property {number|null} [version] msg_get_friend_incr_list version
         */

        /**
         * Constructs a new msg_get_friend_incr_list.
         * @memberof net
         * @classdesc Represents a msg_get_friend_incr_list.
         * @implements Imsg_get_friend_incr_list
         * @constructor
         * @param {net.Imsg_get_friend_incr_list=} [properties] Properties to set
         */
        function msg_get_friend_incr_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_friend_incr_list version.
         * @member {number} version
         * @memberof net.msg_get_friend_incr_list
         * @instance
         */
        msg_get_friend_incr_list.prototype.version = 0;

        /**
         * Encodes the specified msg_get_friend_incr_list message. Does not implicitly {@link net.msg_get_friend_incr_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {net.Imsg_get_friend_incr_list} message msg_get_friend_incr_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_friend_incr_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.version);
            return writer;
        };

        /**
         * Decodes a msg_get_friend_incr_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_friend_incr_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_friend_incr_list} msg_get_friend_incr_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_friend_incr_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_friend_incr_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_friend_incr_list;
    })();

    net.msg_get_friend_incr_list_rep = (function() {

        /**
         * Properties of a msg_get_friend_incr_list_rep.
         * @memberof net
         * @interface Imsg_get_friend_incr_list_rep
         * @property {Array.<net.Ibase_info>|null} [addlist] msg_get_friend_incr_list_rep addlist
         * @property {Array.<number>|null} [dellist] msg_get_friend_incr_list_rep dellist
         * @property {number|null} [isfirst] msg_get_friend_incr_list_rep isfirst
         * @property {number|null} [isend] msg_get_friend_incr_list_rep isend
         * @property {number|null} [version] msg_get_friend_incr_list_rep version
         */

        /**
         * Constructs a new msg_get_friend_incr_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_friend_incr_list_rep.
         * @implements Imsg_get_friend_incr_list_rep
         * @constructor
         * @param {net.Imsg_get_friend_incr_list_rep=} [properties] Properties to set
         */
        function msg_get_friend_incr_list_rep(properties) {
            this.addlist = [];
            this.dellist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_friend_incr_list_rep addlist.
         * @member {Array.<net.Ibase_info>} addlist
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.addlist = $util.emptyArray;

        /**
         * msg_get_friend_incr_list_rep dellist.
         * @member {Array.<number>} dellist
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.dellist = $util.emptyArray;

        /**
         * msg_get_friend_incr_list_rep isfirst.
         * @member {number} isfirst
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.isfirst = 0;

        /**
         * msg_get_friend_incr_list_rep isend.
         * @member {number} isend
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.isend = 0;

        /**
         * msg_get_friend_incr_list_rep version.
         * @member {number} version
         * @memberof net.msg_get_friend_incr_list_rep
         * @instance
         */
        msg_get_friend_incr_list_rep.prototype.version = 0;

        /**
         * Encodes the specified msg_get_friend_incr_list_rep message. Does not implicitly {@link net.msg_get_friend_incr_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {net.Imsg_get_friend_incr_list_rep} message msg_get_friend_incr_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_friend_incr_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.addlist != null && message.addlist.length)
                for (var i = 0; i < message.addlist.length; ++i)
                    $root.net.base_info.encode(message.addlist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.dellist != null && message.dellist.length)
                for (var i = 0; i < message.dellist.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dellist[i]);
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.isfirst);
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.isend);
            if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.version);
            return writer;
        };

        /**
         * Decodes a msg_get_friend_incr_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_friend_incr_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_friend_incr_list_rep} msg_get_friend_incr_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_friend_incr_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_friend_incr_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.addlist && message.addlist.length))
                        message.addlist = [];
                    message.addlist.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.dellist && message.dellist.length))
                        message.dellist = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.dellist.push(reader.int32());
                    } else
                        message.dellist.push(reader.int32());
                    break;
                case 3:
                    message.isfirst = reader.int32();
                    break;
                case 4:
                    message.isend = reader.int32();
                    break;
                case 5:
                    message.version = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_friend_incr_list_rep;
    })();

    net.msg_bind_openid = (function() {

        /**
         * Properties of a msg_bind_openid.
         * @memberof net
         * @interface Imsg_bind_openid
         * @property {number|null} [channel] msg_bind_openid channel
         * @property {number|null} [thirduid] msg_bind_openid thirduid
         */

        /**
         * Constructs a new msg_bind_openid.
         * @memberof net
         * @classdesc Represents a msg_bind_openid.
         * @implements Imsg_bind_openid
         * @constructor
         * @param {net.Imsg_bind_openid=} [properties] Properties to set
         */
        function msg_bind_openid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_bind_openid channel.
         * @member {number} channel
         * @memberof net.msg_bind_openid
         * @instance
         */
        msg_bind_openid.prototype.channel = 0;

        /**
         * msg_bind_openid thirduid.
         * @member {number} thirduid
         * @memberof net.msg_bind_openid
         * @instance
         */
        msg_bind_openid.prototype.thirduid = 0;

        /**
         * Encodes the specified msg_bind_openid message. Does not implicitly {@link net.msg_bind_openid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_bind_openid
         * @static
         * @param {net.Imsg_bind_openid} message msg_bind_openid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_bind_openid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.channel);
            if (message.thirduid != null && Object.hasOwnProperty.call(message, "thirduid"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.thirduid);
            return writer;
        };

        /**
         * Decodes a msg_bind_openid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_bind_openid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_bind_openid} msg_bind_openid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_bind_openid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_bind_openid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.channel = reader.uint32();
                    break;
                case 2:
                    message.thirduid = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_bind_openid;
    })();

    net.msg_bind_openid_rep = (function() {

        /**
         * Properties of a msg_bind_openid_rep.
         * @memberof net
         * @interface Imsg_bind_openid_rep
         * @property {number|null} [result] msg_bind_openid_rep result
         */

        /**
         * Constructs a new msg_bind_openid_rep.
         * @memberof net
         * @classdesc Represents a msg_bind_openid_rep.
         * @implements Imsg_bind_openid_rep
         * @constructor
         * @param {net.Imsg_bind_openid_rep=} [properties] Properties to set
         */
        function msg_bind_openid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_bind_openid_rep result.
         * @member {number} result
         * @memberof net.msg_bind_openid_rep
         * @instance
         */
        msg_bind_openid_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_bind_openid_rep message. Does not implicitly {@link net.msg_bind_openid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {net.Imsg_bind_openid_rep} message msg_bind_openid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_bind_openid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_bind_openid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_bind_openid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_bind_openid_rep} msg_bind_openid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_bind_openid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_bind_openid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_bind_openid_rep;
    })();

    net.msg_add_friend_byfid = (function() {

        /**
         * Properties of a msg_add_friend_byfid.
         * @memberof net
         * @interface Imsg_add_friend_byfid
         * @property {number|null} [fid] msg_add_friend_byfid fid
         * @property {Uint8Array|null} [hellomsg] msg_add_friend_byfid hellomsg
         */

        /**
         * Constructs a new msg_add_friend_byfid.
         * @memberof net
         * @classdesc Represents a msg_add_friend_byfid.
         * @implements Imsg_add_friend_byfid
         * @constructor
         * @param {net.Imsg_add_friend_byfid=} [properties] Properties to set
         */
        function msg_add_friend_byfid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_byfid fid.
         * @member {number} fid
         * @memberof net.msg_add_friend_byfid
         * @instance
         */
        msg_add_friend_byfid.prototype.fid = 0;

        /**
         * msg_add_friend_byfid hellomsg.
         * @member {Uint8Array} hellomsg
         * @memberof net.msg_add_friend_byfid
         * @instance
         */
        msg_add_friend_byfid.prototype.hellomsg = $util.newBuffer([]);

        /**
         * Encodes the specified msg_add_friend_byfid message. Does not implicitly {@link net.msg_add_friend_byfid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {net.Imsg_add_friend_byfid} message msg_add_friend_byfid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_byfid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fid != null && Object.hasOwnProperty.call(message, "fid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fid);
            if (message.hellomsg != null && Object.hasOwnProperty.call(message, "hellomsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.hellomsg);
            return writer;
        };

        /**
         * Decodes a msg_add_friend_byfid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_byfid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_byfid} msg_add_friend_byfid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_byfid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_byfid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.fid = reader.int32();
                    break;
                case 2:
                    message.hellomsg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_add_friend_byfid;
    })();

    net.msg_add_friend_byfid_rep = (function() {

        /**
         * Properties of a msg_add_friend_byfid_rep.
         * @memberof net
         * @interface Imsg_add_friend_byfid_rep
         * @property {number|null} [result] msg_add_friend_byfid_rep result
         */

        /**
         * Constructs a new msg_add_friend_byfid_rep.
         * @memberof net
         * @classdesc Represents a msg_add_friend_byfid_rep.
         * @implements Imsg_add_friend_byfid_rep
         * @constructor
         * @param {net.Imsg_add_friend_byfid_rep=} [properties] Properties to set
         */
        function msg_add_friend_byfid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_add_friend_byfid_rep result.
         * @member {number} result
         * @memberof net.msg_add_friend_byfid_rep
         * @instance
         */
        msg_add_friend_byfid_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_add_friend_byfid_rep message. Does not implicitly {@link net.msg_add_friend_byfid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {net.Imsg_add_friend_byfid_rep} message msg_add_friend_byfid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_add_friend_byfid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_add_friend_byfid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_add_friend_byfid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_add_friend_byfid_rep} msg_add_friend_byfid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_add_friend_byfid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_add_friend_byfid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_add_friend_byfid_rep;
    })();

    net.msg_set_complete_name = (function() {

        /**
         * Properties of a msg_set_complete_name.
         * @memberof net
         * @interface Imsg_set_complete_name
         * @property {Uint8Array|null} [firstname] msg_set_complete_name firstname
         * @property {Uint8Array|null} [lastname] msg_set_complete_name lastname
         */

        /**
         * Constructs a new msg_set_complete_name.
         * @memberof net
         * @classdesc Represents a msg_set_complete_name.
         * @implements Imsg_set_complete_name
         * @constructor
         * @param {net.Imsg_set_complete_name=} [properties] Properties to set
         */
        function msg_set_complete_name(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_complete_name firstname.
         * @member {Uint8Array} firstname
         * @memberof net.msg_set_complete_name
         * @instance
         */
        msg_set_complete_name.prototype.firstname = $util.newBuffer([]);

        /**
         * msg_set_complete_name lastname.
         * @member {Uint8Array} lastname
         * @memberof net.msg_set_complete_name
         * @instance
         */
        msg_set_complete_name.prototype.lastname = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_complete_name message. Does not implicitly {@link net.msg_set_complete_name.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_complete_name
         * @static
         * @param {net.Imsg_set_complete_name} message msg_set_complete_name message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_complete_name.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.lastname);
            return writer;
        };

        /**
         * Decodes a msg_set_complete_name message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_complete_name
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_complete_name} msg_set_complete_name
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_complete_name.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_complete_name();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.firstname = reader.bytes();
                    break;
                case 2:
                    message.lastname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_complete_name;
    })();

    net.msg_set_complete_name_rep = (function() {

        /**
         * Properties of a msg_set_complete_name_rep.
         * @memberof net
         * @interface Imsg_set_complete_name_rep
         * @property {number|null} [result] msg_set_complete_name_rep result
         * @property {Uint8Array|null} [firstname] msg_set_complete_name_rep firstname
         * @property {Uint8Array|null} [lastname] msg_set_complete_name_rep lastname
         */

        /**
         * Constructs a new msg_set_complete_name_rep.
         * @memberof net
         * @classdesc Represents a msg_set_complete_name_rep.
         * @implements Imsg_set_complete_name_rep
         * @constructor
         * @param {net.Imsg_set_complete_name_rep=} [properties] Properties to set
         */
        function msg_set_complete_name_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_complete_name_rep result.
         * @member {number} result
         * @memberof net.msg_set_complete_name_rep
         * @instance
         */
        msg_set_complete_name_rep.prototype.result = 0;

        /**
         * msg_set_complete_name_rep firstname.
         * @member {Uint8Array} firstname
         * @memberof net.msg_set_complete_name_rep
         * @instance
         */
        msg_set_complete_name_rep.prototype.firstname = $util.newBuffer([]);

        /**
         * msg_set_complete_name_rep lastname.
         * @member {Uint8Array} lastname
         * @memberof net.msg_set_complete_name_rep
         * @instance
         */
        msg_set_complete_name_rep.prototype.lastname = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_complete_name_rep message. Does not implicitly {@link net.msg_set_complete_name_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {net.Imsg_set_complete_name_rep} message msg_set_complete_name_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_complete_name_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.firstname);
            if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.lastname);
            return writer;
        };

        /**
         * Decodes a msg_set_complete_name_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_complete_name_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_complete_name_rep} msg_set_complete_name_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_complete_name_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_complete_name_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.firstname = reader.bytes();
                    break;
                case 3:
                    message.lastname = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_complete_name_rep;
    })();

    net.msg_set_phonenum = (function() {

        /**
         * Properties of a msg_set_phonenum.
         * @memberof net
         * @interface Imsg_set_phonenum
         * @property {Uint8Array|null} [zone] msg_set_phonenum zone
         * @property {Uint8Array|null} [phonenum] msg_set_phonenum phonenum
         * @property {Uint8Array|null} [verifycode] msg_set_phonenum verifycode
         */

        /**
         * Constructs a new msg_set_phonenum.
         * @memberof net
         * @classdesc Represents a msg_set_phonenum.
         * @implements Imsg_set_phonenum
         * @constructor
         * @param {net.Imsg_set_phonenum=} [properties] Properties to set
         */
        function msg_set_phonenum(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_phonenum zone.
         * @member {Uint8Array} zone
         * @memberof net.msg_set_phonenum
         * @instance
         */
        msg_set_phonenum.prototype.zone = $util.newBuffer([]);

        /**
         * msg_set_phonenum phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_set_phonenum
         * @instance
         */
        msg_set_phonenum.prototype.phonenum = $util.newBuffer([]);

        /**
         * msg_set_phonenum verifycode.
         * @member {Uint8Array} verifycode
         * @memberof net.msg_set_phonenum
         * @instance
         */
        msg_set_phonenum.prototype.verifycode = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_phonenum message. Does not implicitly {@link net.msg_set_phonenum.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_phonenum
         * @static
         * @param {net.Imsg_set_phonenum} message msg_set_phonenum message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_phonenum.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.zone);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.phonenum);
            if (message.verifycode != null && Object.hasOwnProperty.call(message, "verifycode"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.verifycode);
            return writer;
        };

        /**
         * Decodes a msg_set_phonenum message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_phonenum
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_phonenum} msg_set_phonenum
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_phonenum.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_phonenum();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.zone = reader.bytes();
                    break;
                case 2:
                    message.phonenum = reader.bytes();
                    break;
                case 3:
                    message.verifycode = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_phonenum;
    })();

    net.msg_set_phonenum_rep = (function() {

        /**
         * Properties of a msg_set_phonenum_rep.
         * @memberof net
         * @interface Imsg_set_phonenum_rep
         * @property {number|null} [result] msg_set_phonenum_rep result
         * @property {Uint8Array|null} [zone] msg_set_phonenum_rep zone
         * @property {Uint8Array|null} [phonenum] msg_set_phonenum_rep phonenum
         */

        /**
         * Constructs a new msg_set_phonenum_rep.
         * @memberof net
         * @classdesc Represents a msg_set_phonenum_rep.
         * @implements Imsg_set_phonenum_rep
         * @constructor
         * @param {net.Imsg_set_phonenum_rep=} [properties] Properties to set
         */
        function msg_set_phonenum_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_phonenum_rep result.
         * @member {number} result
         * @memberof net.msg_set_phonenum_rep
         * @instance
         */
        msg_set_phonenum_rep.prototype.result = 0;

        /**
         * msg_set_phonenum_rep zone.
         * @member {Uint8Array} zone
         * @memberof net.msg_set_phonenum_rep
         * @instance
         */
        msg_set_phonenum_rep.prototype.zone = $util.newBuffer([]);

        /**
         * msg_set_phonenum_rep phonenum.
         * @member {Uint8Array} phonenum
         * @memberof net.msg_set_phonenum_rep
         * @instance
         */
        msg_set_phonenum_rep.prototype.phonenum = $util.newBuffer([]);

        /**
         * Encodes the specified msg_set_phonenum_rep message. Does not implicitly {@link net.msg_set_phonenum_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {net.Imsg_set_phonenum_rep} message msg_set_phonenum_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_phonenum_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.zone != null && Object.hasOwnProperty.call(message, "zone"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.zone);
            if (message.phonenum != null && Object.hasOwnProperty.call(message, "phonenum"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.phonenum);
            return writer;
        };

        /**
         * Decodes a msg_set_phonenum_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_phonenum_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_phonenum_rep} msg_set_phonenum_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_phonenum_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_phonenum_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.zone = reader.bytes();
                    break;
                case 3:
                    message.phonenum = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_phonenum_rep;
    })();

    net.msg_set_privacy = (function() {

        /**
         * Properties of a msg_set_privacy.
         * @memberof net
         * @interface Imsg_set_privacy
         * @property {number|null} [ptype] msg_set_privacy ptype
         * @property {number|null} [flagval] msg_set_privacy flagval
         */

        /**
         * Constructs a new msg_set_privacy.
         * @memberof net
         * @classdesc Represents a msg_set_privacy.
         * @implements Imsg_set_privacy
         * @constructor
         * @param {net.Imsg_set_privacy=} [properties] Properties to set
         */
        function msg_set_privacy(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_privacy ptype.
         * @member {number} ptype
         * @memberof net.msg_set_privacy
         * @instance
         */
        msg_set_privacy.prototype.ptype = 0;

        /**
         * msg_set_privacy flagval.
         * @member {number} flagval
         * @memberof net.msg_set_privacy
         * @instance
         */
        msg_set_privacy.prototype.flagval = 0;

        /**
         * Encodes the specified msg_set_privacy message. Does not implicitly {@link net.msg_set_privacy.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_privacy
         * @static
         * @param {net.Imsg_set_privacy} message msg_set_privacy message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_privacy.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ptype != null && Object.hasOwnProperty.call(message, "ptype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ptype);
            if (message.flagval != null && Object.hasOwnProperty.call(message, "flagval"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.flagval);
            return writer;
        };

        /**
         * Decodes a msg_set_privacy message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_privacy
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_privacy} msg_set_privacy
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_privacy.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_privacy();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ptype = reader.int32();
                    break;
                case 2:
                    message.flagval = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_privacy;
    })();

    net.msg_set_privacy_rep = (function() {

        /**
         * Properties of a msg_set_privacy_rep.
         * @memberof net
         * @interface Imsg_set_privacy_rep
         * @property {number|null} [result] msg_set_privacy_rep result
         * @property {number|null} [ptype] msg_set_privacy_rep ptype
         * @property {number|null} [flagval] msg_set_privacy_rep flagval
         * @property {number|Long|null} [privacy] msg_set_privacy_rep privacy
         */

        /**
         * Constructs a new msg_set_privacy_rep.
         * @memberof net
         * @classdesc Represents a msg_set_privacy_rep.
         * @implements Imsg_set_privacy_rep
         * @constructor
         * @param {net.Imsg_set_privacy_rep=} [properties] Properties to set
         */
        function msg_set_privacy_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_set_privacy_rep result.
         * @member {number} result
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.result = 0;

        /**
         * msg_set_privacy_rep ptype.
         * @member {number} ptype
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.ptype = 0;

        /**
         * msg_set_privacy_rep flagval.
         * @member {number} flagval
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.flagval = 0;

        /**
         * msg_set_privacy_rep privacy.
         * @member {number|Long} privacy
         * @memberof net.msg_set_privacy_rep
         * @instance
         */
        msg_set_privacy_rep.prototype.privacy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_set_privacy_rep message. Does not implicitly {@link net.msg_set_privacy_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {net.Imsg_set_privacy_rep} message msg_set_privacy_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_set_privacy_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.ptype != null && Object.hasOwnProperty.call(message, "ptype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ptype);
            if (message.flagval != null && Object.hasOwnProperty.call(message, "flagval"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.flagval);
            if (message.privacy != null && Object.hasOwnProperty.call(message, "privacy"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.privacy);
            return writer;
        };

        /**
         * Decodes a msg_set_privacy_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_set_privacy_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_set_privacy_rep} msg_set_privacy_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_set_privacy_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_set_privacy_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.ptype = reader.int32();
                    break;
                case 3:
                    message.flagval = reader.int32();
                    break;
                case 4:
                    message.privacy = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_set_privacy_rep;
    })();

    net.msg_red_nty = (function() {

        /**
         * Properties of a msg_red_nty.
         * @memberof net
         * @interface Imsg_red_nty
         * @property {net.Ired_info|null} [red] msg_red_nty red
         */

        /**
         * Constructs a new msg_red_nty.
         * @memberof net
         * @classdesc Represents a msg_red_nty.
         * @implements Imsg_red_nty
         * @constructor
         * @param {net.Imsg_red_nty=} [properties] Properties to set
         */
        function msg_red_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_red_nty red.
         * @member {net.Ired_info|null|undefined} red
         * @memberof net.msg_red_nty
         * @instance
         */
        msg_red_nty.prototype.red = null;

        /**
         * Encodes the specified msg_red_nty message. Does not implicitly {@link net.msg_red_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_red_nty
         * @static
         * @param {net.Imsg_red_nty} message msg_red_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_red_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.red != null && Object.hasOwnProperty.call(message, "red"))
                $root.net.red_info.encode(message.red, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_red_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_red_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_red_nty} msg_red_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_red_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_red_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.red = $root.net.red_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_red_nty;
    })();

    net.msg_login_other_nty = (function() {

        /**
         * Properties of a msg_login_other_nty.
         * @memberof net
         * @interface Imsg_login_other_nty
         * @property {Uint8Array|null} [deviceid] msg_login_other_nty deviceid
         */

        /**
         * Constructs a new msg_login_other_nty.
         * @memberof net
         * @classdesc Represents a msg_login_other_nty.
         * @implements Imsg_login_other_nty
         * @constructor
         * @param {net.Imsg_login_other_nty=} [properties] Properties to set
         */
        function msg_login_other_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_login_other_nty deviceid.
         * @member {Uint8Array} deviceid
         * @memberof net.msg_login_other_nty
         * @instance
         */
        msg_login_other_nty.prototype.deviceid = $util.newBuffer([]);

        /**
         * Encodes the specified msg_login_other_nty message. Does not implicitly {@link net.msg_login_other_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_login_other_nty
         * @static
         * @param {net.Imsg_login_other_nty} message msg_login_other_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_login_other_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.deviceid != null && Object.hasOwnProperty.call(message, "deviceid"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.deviceid);
            return writer;
        };

        /**
         * Decodes a msg_login_other_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_login_other_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_login_other_nty} msg_login_other_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_login_other_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_login_other_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.deviceid = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_login_other_nty;
    })();

    net.msg_group_base_nty = (function() {

        /**
         * Properties of a msg_group_base_nty.
         * @memberof net
         * @interface Imsg_group_base_nty
         * @property {Array.<net.Igroup_base_info>|null} [grouplist] msg_group_base_nty grouplist
         */

        /**
         * Constructs a new msg_group_base_nty.
         * @memberof net
         * @classdesc Represents a msg_group_base_nty.
         * @implements Imsg_group_base_nty
         * @constructor
         * @param {net.Imsg_group_base_nty=} [properties] Properties to set
         */
        function msg_group_base_nty(properties) {
            this.grouplist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_base_nty grouplist.
         * @member {Array.<net.Igroup_base_info>} grouplist
         * @memberof net.msg_group_base_nty
         * @instance
         */
        msg_group_base_nty.prototype.grouplist = $util.emptyArray;

        /**
         * Encodes the specified msg_group_base_nty message. Does not implicitly {@link net.msg_group_base_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_base_nty
         * @static
         * @param {net.Imsg_group_base_nty} message msg_group_base_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_base_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.grouplist != null && message.grouplist.length)
                for (var i = 0; i < message.grouplist.length; ++i)
                    $root.net.group_base_info.encode(message.grouplist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_group_base_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_base_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_base_nty} msg_group_base_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_base_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_base_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.grouplist && message.grouplist.length))
                        message.grouplist = [];
                    message.grouplist.push($root.net.group_base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_group_base_nty;
    })();

    net.msg_group_oper_nty = (function() {

        /**
         * Properties of a msg_group_oper_nty.
         * @memberof net
         * @interface Imsg_group_oper_nty
         * @property {number|null} [groupkey] msg_group_oper_nty groupkey
         * @property {number|null} [opertype] msg_group_oper_nty opertype
         */

        /**
         * Constructs a new msg_group_oper_nty.
         * @memberof net
         * @classdesc Represents a msg_group_oper_nty.
         * @implements Imsg_group_oper_nty
         * @constructor
         * @param {net.Imsg_group_oper_nty=} [properties] Properties to set
         */
        function msg_group_oper_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_oper_nty groupkey.
         * @member {number} groupkey
         * @memberof net.msg_group_oper_nty
         * @instance
         */
        msg_group_oper_nty.prototype.groupkey = 0;

        /**
         * msg_group_oper_nty opertype.
         * @member {number} opertype
         * @memberof net.msg_group_oper_nty
         * @instance
         */
        msg_group_oper_nty.prototype.opertype = 0;

        /**
         * Encodes the specified msg_group_oper_nty message. Does not implicitly {@link net.msg_group_oper_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {net.Imsg_group_oper_nty} message msg_group_oper_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_oper_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_group_oper_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_oper_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_oper_nty} msg_group_oper_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_oper_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_oper_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.opertype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_group_oper_nty;
    })();

    net.msg_handle_friend_nty = (function() {

        /**
         * Properties of a msg_handle_friend_nty.
         * @memberof net
         * @interface Imsg_handle_friend_nty
         * @property {net.Ibase_info|null} [friend_info] msg_handle_friend_nty friend_info
         */

        /**
         * Constructs a new msg_handle_friend_nty.
         * @memberof net
         * @classdesc Represents a msg_handle_friend_nty.
         * @implements Imsg_handle_friend_nty
         * @constructor
         * @param {net.Imsg_handle_friend_nty=} [properties] Properties to set
         */
        function msg_handle_friend_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_handle_friend_nty friend_info.
         * @member {net.Ibase_info|null|undefined} friend_info
         * @memberof net.msg_handle_friend_nty
         * @instance
         */
        msg_handle_friend_nty.prototype.friend_info = null;

        /**
         * Encodes the specified msg_handle_friend_nty message. Does not implicitly {@link net.msg_handle_friend_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {net.Imsg_handle_friend_nty} message msg_handle_friend_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_handle_friend_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.friend_info != null && Object.hasOwnProperty.call(message, "friend_info"))
                $root.net.base_info.encode(message.friend_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_handle_friend_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_handle_friend_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_handle_friend_nty} msg_handle_friend_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_handle_friend_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_handle_friend_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.friend_info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_handle_friend_nty;
    })();

    net.msg_new_order_nty = (function() {

        /**
         * Properties of a msg_new_order_nty.
         * @memberof net
         * @interface Imsg_new_order_nty
         * @property {number|null} [uid] msg_new_order_nty uid
         * @property {number|Long|null} [orderid] msg_new_order_nty orderid
         */

        /**
         * Constructs a new msg_new_order_nty.
         * @memberof net
         * @classdesc Represents a msg_new_order_nty.
         * @implements Imsg_new_order_nty
         * @constructor
         * @param {net.Imsg_new_order_nty=} [properties] Properties to set
         */
        function msg_new_order_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_new_order_nty uid.
         * @member {number} uid
         * @memberof net.msg_new_order_nty
         * @instance
         */
        msg_new_order_nty.prototype.uid = 0;

        /**
         * msg_new_order_nty orderid.
         * @member {number|Long} orderid
         * @memberof net.msg_new_order_nty
         * @instance
         */
        msg_new_order_nty.prototype.orderid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_new_order_nty message. Does not implicitly {@link net.msg_new_order_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_new_order_nty
         * @static
         * @param {net.Imsg_new_order_nty} message msg_new_order_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_new_order_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.orderid != null && Object.hasOwnProperty.call(message, "orderid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.orderid);
            return writer;
        };

        /**
         * Decodes a msg_new_order_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_new_order_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_new_order_nty} msg_new_order_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_new_order_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_new_order_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.orderid = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_new_order_nty;
    })();

    net.msg_group_member_list_nty = (function() {

        /**
         * Properties of a msg_group_member_list_nty.
         * @memberof net
         * @interface Imsg_group_member_list_nty
         * @property {number|null} [groupkey] msg_group_member_list_nty groupkey
         * @property {number|null} [isfirst] msg_group_member_list_nty isfirst
         * @property {Array.<net.Ibase_info>|null} [users] msg_group_member_list_nty users
         */

        /**
         * Constructs a new msg_group_member_list_nty.
         * @memberof net
         * @classdesc Represents a msg_group_member_list_nty.
         * @implements Imsg_group_member_list_nty
         * @constructor
         * @param {net.Imsg_group_member_list_nty=} [properties] Properties to set
         */
        function msg_group_member_list_nty(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_group_member_list_nty groupkey.
         * @member {number} groupkey
         * @memberof net.msg_group_member_list_nty
         * @instance
         */
        msg_group_member_list_nty.prototype.groupkey = 0;

        /**
         * msg_group_member_list_nty isfirst.
         * @member {number} isfirst
         * @memberof net.msg_group_member_list_nty
         * @instance
         */
        msg_group_member_list_nty.prototype.isfirst = 0;

        /**
         * msg_group_member_list_nty users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_group_member_list_nty
         * @instance
         */
        msg_group_member_list_nty.prototype.users = $util.emptyArray;

        /**
         * Encodes the specified msg_group_member_list_nty message. Does not implicitly {@link net.msg_group_member_list_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {net.Imsg_group_member_list_nty} message msg_group_member_list_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_group_member_list_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.groupkey);
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_group_member_list_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_group_member_list_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_group_member_list_nty} msg_group_member_list_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_group_member_list_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_group_member_list_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.groupkey = reader.int32();
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_group_member_list_nty;
    })();

    net.msg_rate_nty = (function() {

        /**
         * Properties of a msg_rate_nty.
         * @memberof net
         * @interface Imsg_rate_nty
         * @property {Array.<net.Irate_info>|null} [ratelist] msg_rate_nty ratelist
         */

        /**
         * Constructs a new msg_rate_nty.
         * @memberof net
         * @classdesc Represents a msg_rate_nty.
         * @implements Imsg_rate_nty
         * @constructor
         * @param {net.Imsg_rate_nty=} [properties] Properties to set
         */
        function msg_rate_nty(properties) {
            this.ratelist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_rate_nty ratelist.
         * @member {Array.<net.Irate_info>} ratelist
         * @memberof net.msg_rate_nty
         * @instance
         */
        msg_rate_nty.prototype.ratelist = $util.emptyArray;

        /**
         * Encodes the specified msg_rate_nty message. Does not implicitly {@link net.msg_rate_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_rate_nty
         * @static
         * @param {net.Imsg_rate_nty} message msg_rate_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_rate_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ratelist != null && message.ratelist.length)
                for (var i = 0; i < message.ratelist.length; ++i)
                    $root.net.rate_info.encode(message.ratelist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_rate_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_rate_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_rate_nty} msg_rate_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_rate_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_rate_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.ratelist && message.ratelist.length))
                        message.ratelist = [];
                    message.ratelist.push($root.net.rate_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_rate_nty;
    })();

    net.msg_pc_flow_nty = (function() {

        /**
         * Properties of a msg_pc_flow_nty.
         * @memberof net
         * @interface Imsg_pc_flow_nty
         * @property {number|null} [pcflow] msg_pc_flow_nty pcflow
         */

        /**
         * Constructs a new msg_pc_flow_nty.
         * @memberof net
         * @classdesc Represents a msg_pc_flow_nty.
         * @implements Imsg_pc_flow_nty
         * @constructor
         * @param {net.Imsg_pc_flow_nty=} [properties] Properties to set
         */
        function msg_pc_flow_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pc_flow_nty pcflow.
         * @member {number} pcflow
         * @memberof net.msg_pc_flow_nty
         * @instance
         */
        msg_pc_flow_nty.prototype.pcflow = 0;

        /**
         * Encodes the specified msg_pc_flow_nty message. Does not implicitly {@link net.msg_pc_flow_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {net.Imsg_pc_flow_nty} message msg_pc_flow_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pc_flow_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pcflow != null && Object.hasOwnProperty.call(message, "pcflow"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pcflow);
            return writer;
        };

        /**
         * Decodes a msg_pc_flow_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pc_flow_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pc_flow_nty} msg_pc_flow_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pc_flow_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pc_flow_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.pcflow = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_pc_flow_nty;
    })();

    net.msg_pc_data_nty = (function() {

        /**
         * Properties of a msg_pc_data_nty.
         * @memberof net
         * @interface Imsg_pc_data_nty
         * @property {number|null} [uid] msg_pc_data_nty uid
         */

        /**
         * Constructs a new msg_pc_data_nty.
         * @memberof net
         * @classdesc Represents a msg_pc_data_nty.
         * @implements Imsg_pc_data_nty
         * @constructor
         * @param {net.Imsg_pc_data_nty=} [properties] Properties to set
         */
        function msg_pc_data_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_pc_data_nty uid.
         * @member {number} uid
         * @memberof net.msg_pc_data_nty
         * @instance
         */
        msg_pc_data_nty.prototype.uid = 0;

        /**
         * Encodes the specified msg_pc_data_nty message. Does not implicitly {@link net.msg_pc_data_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {net.Imsg_pc_data_nty} message msg_pc_data_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_pc_data_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_pc_data_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_pc_data_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_pc_data_nty} msg_pc_data_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_pc_data_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_pc_data_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_pc_data_nty;
    })();

    net.msg_voice_call_nty = (function() {

        /**
         * Properties of a msg_voice_call_nty.
         * @memberof net
         * @interface Imsg_voice_call_nty
         * @property {number|null} [srcuid] msg_voice_call_nty srcuid
         * @property {number|null} [destuid] msg_voice_call_nty destuid
         * @property {number|null} [state] msg_voice_call_nty state
         * @property {number|Long|null} [chatkey] msg_voice_call_nty chatkey
         * @property {Uint8Array|null} [token] msg_voice_call_nty token
         */

        /**
         * Constructs a new msg_voice_call_nty.
         * @memberof net
         * @classdesc Represents a msg_voice_call_nty.
         * @implements Imsg_voice_call_nty
         * @constructor
         * @param {net.Imsg_voice_call_nty=} [properties] Properties to set
         */
        function msg_voice_call_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_call_nty srcuid.
         * @member {number} srcuid
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.srcuid = 0;

        /**
         * msg_voice_call_nty destuid.
         * @member {number} destuid
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.destuid = 0;

        /**
         * msg_voice_call_nty state.
         * @member {number} state
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.state = 0;

        /**
         * msg_voice_call_nty chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_call_nty token.
         * @member {Uint8Array} token
         * @memberof net.msg_voice_call_nty
         * @instance
         */
        msg_voice_call_nty.prototype.token = $util.newBuffer([]);

        /**
         * Encodes the specified msg_voice_call_nty message. Does not implicitly {@link net.msg_voice_call_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {net.Imsg_voice_call_nty} message msg_voice_call_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_call_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.srcuid != null && Object.hasOwnProperty.call(message, "srcuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.srcuid);
            if (message.destuid != null && Object.hasOwnProperty.call(message, "destuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.destuid);
            if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.chatkey);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.token);
            return writer;
        };

        /**
         * Decodes a msg_voice_call_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_call_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_call_nty} msg_voice_call_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_call_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_call_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.srcuid = reader.int32();
                    break;
                case 2:
                    message.destuid = reader.int32();
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.chatkey = reader.int64();
                    break;
                case 5:
                    message.token = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_voice_call_nty;
    })();

    net.msg_voice_data_nty = (function() {

        /**
         * Properties of a msg_voice_data_nty.
         * @memberof net
         * @interface Imsg_voice_data_nty
         * @property {number|null} [srcuid] msg_voice_data_nty srcuid
         * @property {number|Long|null} [chatkey] msg_voice_data_nty chatkey
         * @property {Uint8Array|null} [voice_data] msg_voice_data_nty voice_data
         * @property {number|Long|null} [ptime] msg_voice_data_nty ptime
         */

        /**
         * Constructs a new msg_voice_data_nty.
         * @memberof net
         * @classdesc Represents a msg_voice_data_nty.
         * @implements Imsg_voice_data_nty
         * @constructor
         * @param {net.Imsg_voice_data_nty=} [properties] Properties to set
         */
        function msg_voice_data_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_voice_data_nty srcuid.
         * @member {number} srcuid
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.srcuid = 0;

        /**
         * msg_voice_data_nty chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_voice_data_nty voice_data.
         * @member {Uint8Array} voice_data
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.voice_data = $util.newBuffer([]);

        /**
         * msg_voice_data_nty ptime.
         * @member {number|Long} ptime
         * @memberof net.msg_voice_data_nty
         * @instance
         */
        msg_voice_data_nty.prototype.ptime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_voice_data_nty message. Does not implicitly {@link net.msg_voice_data_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {net.Imsg_voice_data_nty} message msg_voice_data_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_voice_data_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.srcuid != null && Object.hasOwnProperty.call(message, "srcuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.srcuid);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            if (message.voice_data != null && Object.hasOwnProperty.call(message, "voice_data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.voice_data);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ptime);
            return writer;
        };

        /**
         * Decodes a msg_voice_data_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_voice_data_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_voice_data_nty} msg_voice_data_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_voice_data_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_voice_data_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.srcuid = reader.int32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                case 3:
                    message.voice_data = reader.bytes();
                    break;
                case 4:
                    message.ptime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_voice_data_nty;
    })();

    net.msg_friend_state_nty = (function() {

        /**
         * Properties of a msg_friend_state_nty.
         * @memberof net
         * @interface Imsg_friend_state_nty
         * @property {Array.<net.Ifriend_state_info>|null} [flist] msg_friend_state_nty flist
         * @property {number|null} [isfirst] msg_friend_state_nty isfirst
         * @property {number|null} [isend] msg_friend_state_nty isend
         */

        /**
         * Constructs a new msg_friend_state_nty.
         * @memberof net
         * @classdesc Represents a msg_friend_state_nty.
         * @implements Imsg_friend_state_nty
         * @constructor
         * @param {net.Imsg_friend_state_nty=} [properties] Properties to set
         */
        function msg_friend_state_nty(properties) {
            this.flist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_friend_state_nty flist.
         * @member {Array.<net.Ifriend_state_info>} flist
         * @memberof net.msg_friend_state_nty
         * @instance
         */
        msg_friend_state_nty.prototype.flist = $util.emptyArray;

        /**
         * msg_friend_state_nty isfirst.
         * @member {number} isfirst
         * @memberof net.msg_friend_state_nty
         * @instance
         */
        msg_friend_state_nty.prototype.isfirst = 0;

        /**
         * msg_friend_state_nty isend.
         * @member {number} isend
         * @memberof net.msg_friend_state_nty
         * @instance
         */
        msg_friend_state_nty.prototype.isend = 0;

        /**
         * Encodes the specified msg_friend_state_nty message. Does not implicitly {@link net.msg_friend_state_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {net.Imsg_friend_state_nty} message msg_friend_state_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_friend_state_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.flist != null && message.flist.length)
                for (var i = 0; i < message.flist.length; ++i)
                    $root.net.friend_state_info.encode(message.flist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.isfirst != null && Object.hasOwnProperty.call(message, "isfirst"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.isfirst);
            if (message.isend != null && Object.hasOwnProperty.call(message, "isend"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.isend);
            return writer;
        };

        /**
         * Decodes a msg_friend_state_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_friend_state_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_friend_state_nty} msg_friend_state_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_friend_state_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_friend_state_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.flist && message.flist.length))
                        message.flist = [];
                    message.flist.push($root.net.friend_state_info.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.isfirst = reader.int32();
                    break;
                case 3:
                    message.isend = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_friend_state_nty;
    })();

    net.msg_get_chatroom_list = (function() {

        /**
         * Properties of a msg_get_chatroom_list.
         * @memberof net
         * @interface Imsg_get_chatroom_list
         */

        /**
         * Constructs a new msg_get_chatroom_list.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_list.
         * @implements Imsg_get_chatroom_list
         * @constructor
         * @param {net.Imsg_get_chatroom_list=} [properties] Properties to set
         */
        function msg_get_chatroom_list(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Encodes the specified msg_get_chatroom_list message. Does not implicitly {@link net.msg_get_chatroom_list.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {net.Imsg_get_chatroom_list} message msg_get_chatroom_list message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_list.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a msg_get_chatroom_list message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_list
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_list} msg_get_chatroom_list
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_list.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_list();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chatroom_list;
    })();

    net.msg_get_chatroom_list_rep = (function() {

        /**
         * Properties of a msg_get_chatroom_list_rep.
         * @memberof net
         * @interface Imsg_get_chatroom_list_rep
         * @property {Array.<net.Ichat_room_info>|null} [roomlist] msg_get_chatroom_list_rep roomlist
         */

        /**
         * Constructs a new msg_get_chatroom_list_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_list_rep.
         * @implements Imsg_get_chatroom_list_rep
         * @constructor
         * @param {net.Imsg_get_chatroom_list_rep=} [properties] Properties to set
         */
        function msg_get_chatroom_list_rep(properties) {
            this.roomlist = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_list_rep roomlist.
         * @member {Array.<net.Ichat_room_info>} roomlist
         * @memberof net.msg_get_chatroom_list_rep
         * @instance
         */
        msg_get_chatroom_list_rep.prototype.roomlist = $util.emptyArray;

        /**
         * Encodes the specified msg_get_chatroom_list_rep message. Does not implicitly {@link net.msg_get_chatroom_list_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {net.Imsg_get_chatroom_list_rep} message msg_get_chatroom_list_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_list_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomlist != null && message.roomlist.length)
                for (var i = 0; i < message.roomlist.length; ++i)
                    $root.net.chat_room_info.encode(message.roomlist[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_chatroom_list_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_list_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_list_rep} msg_get_chatroom_list_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_list_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_list_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.roomlist && message.roomlist.length))
                        message.roomlist = [];
                    message.roomlist.push($root.net.chat_room_info.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chatroom_list_rep;
    })();

    net.msg_get_chatroom_members = (function() {

        /**
         * Properties of a msg_get_chatroom_members.
         * @memberof net
         * @interface Imsg_get_chatroom_members
         * @property {number|null} [roomkey] msg_get_chatroom_members roomkey
         * @property {number|null} [page] msg_get_chatroom_members page
         * @property {number|null} [limit] msg_get_chatroom_members limit
         */

        /**
         * Constructs a new msg_get_chatroom_members.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_members.
         * @implements Imsg_get_chatroom_members
         * @constructor
         * @param {net.Imsg_get_chatroom_members=} [properties] Properties to set
         */
        function msg_get_chatroom_members(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_members roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_members
         * @instance
         */
        msg_get_chatroom_members.prototype.roomkey = 0;

        /**
         * msg_get_chatroom_members page.
         * @member {number} page
         * @memberof net.msg_get_chatroom_members
         * @instance
         */
        msg_get_chatroom_members.prototype.page = 0;

        /**
         * msg_get_chatroom_members limit.
         * @member {number} limit
         * @memberof net.msg_get_chatroom_members
         * @instance
         */
        msg_get_chatroom_members.prototype.limit = 0;

        /**
         * Encodes the specified msg_get_chatroom_members message. Does not implicitly {@link net.msg_get_chatroom_members.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {net.Imsg_get_chatroom_members} message msg_get_chatroom_members message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_members.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.page);
            if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.limit);
            return writer;
        };

        /**
         * Decodes a msg_get_chatroom_members message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_members
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_members} msg_get_chatroom_members
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_members.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_members();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.page = reader.int32();
                    break;
                case 3:
                    message.limit = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chatroom_members;
    })();

    net.msg_get_chatroom_members_rep = (function() {

        /**
         * Properties of a msg_get_chatroom_members_rep.
         * @memberof net
         * @interface Imsg_get_chatroom_members_rep
         * @property {number|null} [result] msg_get_chatroom_members_rep result
         * @property {Array.<net.Ibase_info>|null} [users] msg_get_chatroom_members_rep users
         * @property {number|null} [usercnt] msg_get_chatroom_members_rep usercnt
         */

        /**
         * Constructs a new msg_get_chatroom_members_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_members_rep.
         * @implements Imsg_get_chatroom_members_rep
         * @constructor
         * @param {net.Imsg_get_chatroom_members_rep=} [properties] Properties to set
         */
        function msg_get_chatroom_members_rep(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_members_rep result.
         * @member {number} result
         * @memberof net.msg_get_chatroom_members_rep
         * @instance
         */
        msg_get_chatroom_members_rep.prototype.result = 0;

        /**
         * msg_get_chatroom_members_rep users.
         * @member {Array.<net.Ibase_info>} users
         * @memberof net.msg_get_chatroom_members_rep
         * @instance
         */
        msg_get_chatroom_members_rep.prototype.users = $util.emptyArray;

        /**
         * msg_get_chatroom_members_rep usercnt.
         * @member {number} usercnt
         * @memberof net.msg_get_chatroom_members_rep
         * @instance
         */
        msg_get_chatroom_members_rep.prototype.usercnt = 0;

        /**
         * Encodes the specified msg_get_chatroom_members_rep message. Does not implicitly {@link net.msg_get_chatroom_members_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {net.Imsg_get_chatroom_members_rep} message msg_get_chatroom_members_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_members_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.net.base_info.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.usercnt != null && Object.hasOwnProperty.call(message, "usercnt"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.usercnt);
            return writer;
        };

        /**
         * Decodes a msg_get_chatroom_members_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_members_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_members_rep} msg_get_chatroom_members_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_members_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_members_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.net.base_info.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.usercnt = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chatroom_members_rep;
    })();

    net.msg_join_chatroom = (function() {

        /**
         * Properties of a msg_join_chatroom.
         * @memberof net
         * @interface Imsg_join_chatroom
         * @property {number|null} [roomkey] msg_join_chatroom roomkey
         */

        /**
         * Constructs a new msg_join_chatroom.
         * @memberof net
         * @classdesc Represents a msg_join_chatroom.
         * @implements Imsg_join_chatroom
         * @constructor
         * @param {net.Imsg_join_chatroom=} [properties] Properties to set
         */
        function msg_join_chatroom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_chatroom roomkey.
         * @member {number} roomkey
         * @memberof net.msg_join_chatroom
         * @instance
         */
        msg_join_chatroom.prototype.roomkey = 0;

        /**
         * Encodes the specified msg_join_chatroom message. Does not implicitly {@link net.msg_join_chatroom.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_chatroom
         * @static
         * @param {net.Imsg_join_chatroom} message msg_join_chatroom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            return writer;
        };

        /**
         * Decodes a msg_join_chatroom message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_chatroom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_chatroom} msg_join_chatroom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_chatroom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_join_chatroom;
    })();

    net.msg_join_chatroom_rep = (function() {

        /**
         * Properties of a msg_join_chatroom_rep.
         * @memberof net
         * @interface Imsg_join_chatroom_rep
         * @property {number|null} [result] msg_join_chatroom_rep result
         * @property {net.Ichat_room_info|null} [room_info] msg_join_chatroom_rep room_info
         */

        /**
         * Constructs a new msg_join_chatroom_rep.
         * @memberof net
         * @classdesc Represents a msg_join_chatroom_rep.
         * @implements Imsg_join_chatroom_rep
         * @constructor
         * @param {net.Imsg_join_chatroom_rep=} [properties] Properties to set
         */
        function msg_join_chatroom_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_chatroom_rep result.
         * @member {number} result
         * @memberof net.msg_join_chatroom_rep
         * @instance
         */
        msg_join_chatroom_rep.prototype.result = 0;

        /**
         * msg_join_chatroom_rep room_info.
         * @member {net.Ichat_room_info|null|undefined} room_info
         * @memberof net.msg_join_chatroom_rep
         * @instance
         */
        msg_join_chatroom_rep.prototype.room_info = null;

        /**
         * Encodes the specified msg_join_chatroom_rep message. Does not implicitly {@link net.msg_join_chatroom_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {net.Imsg_join_chatroom_rep} message msg_join_chatroom_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.room_info != null && Object.hasOwnProperty.call(message, "room_info"))
                $root.net.chat_room_info.encode(message.room_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_join_chatroom_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_chatroom_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_chatroom_rep} msg_join_chatroom_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_chatroom_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.room_info = $root.net.chat_room_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_join_chatroom_rep;
    })();

    net.msg_quit_chatroom = (function() {

        /**
         * Properties of a msg_quit_chatroom.
         * @memberof net
         * @interface Imsg_quit_chatroom
         * @property {number|null} [roomkey] msg_quit_chatroom roomkey
         */

        /**
         * Constructs a new msg_quit_chatroom.
         * @memberof net
         * @classdesc Represents a msg_quit_chatroom.
         * @implements Imsg_quit_chatroom
         * @constructor
         * @param {net.Imsg_quit_chatroom=} [properties] Properties to set
         */
        function msg_quit_chatroom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_quit_chatroom roomkey.
         * @member {number} roomkey
         * @memberof net.msg_quit_chatroom
         * @instance
         */
        msg_quit_chatroom.prototype.roomkey = 0;

        /**
         * Encodes the specified msg_quit_chatroom message. Does not implicitly {@link net.msg_quit_chatroom.verify|verify} messages.
         * @function encode
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {net.Imsg_quit_chatroom} message msg_quit_chatroom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_quit_chatroom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            return writer;
        };

        /**
         * Decodes a msg_quit_chatroom message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_quit_chatroom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_quit_chatroom} msg_quit_chatroom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_quit_chatroom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_quit_chatroom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_quit_chatroom;
    })();

    net.msg_quit_chatroom_rep = (function() {

        /**
         * Properties of a msg_quit_chatroom_rep.
         * @memberof net
         * @interface Imsg_quit_chatroom_rep
         * @property {number|null} [result] msg_quit_chatroom_rep result
         */

        /**
         * Constructs a new msg_quit_chatroom_rep.
         * @memberof net
         * @classdesc Represents a msg_quit_chatroom_rep.
         * @implements Imsg_quit_chatroom_rep
         * @constructor
         * @param {net.Imsg_quit_chatroom_rep=} [properties] Properties to set
         */
        function msg_quit_chatroom_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_quit_chatroom_rep result.
         * @member {number} result
         * @memberof net.msg_quit_chatroom_rep
         * @instance
         */
        msg_quit_chatroom_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_quit_chatroom_rep message. Does not implicitly {@link net.msg_quit_chatroom_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {net.Imsg_quit_chatroom_rep} message msg_quit_chatroom_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_quit_chatroom_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_quit_chatroom_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_quit_chatroom_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_quit_chatroom_rep} msg_quit_chatroom_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_quit_chatroom_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_quit_chatroom_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_quit_chatroom_rep;
    })();

    net.msg_send_chatroom_msg = (function() {

        /**
         * Properties of a msg_send_chatroom_msg.
         * @memberof net
         * @interface Imsg_send_chatroom_msg
         * @property {number|null} [roomkey] msg_send_chatroom_msg roomkey
         * @property {number|null} [msg_type] msg_send_chatroom_msg msg_type
         * @property {Uint8Array|null} [content] msg_send_chatroom_msg content
         */

        /**
         * Constructs a new msg_send_chatroom_msg.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_msg.
         * @implements Imsg_send_chatroom_msg
         * @constructor
         * @param {net.Imsg_send_chatroom_msg=} [properties] Properties to set
         */
        function msg_send_chatroom_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_msg roomkey.
         * @member {number} roomkey
         * @memberof net.msg_send_chatroom_msg
         * @instance
         */
        msg_send_chatroom_msg.prototype.roomkey = 0;

        /**
         * msg_send_chatroom_msg msg_type.
         * @member {number} msg_type
         * @memberof net.msg_send_chatroom_msg
         * @instance
         */
        msg_send_chatroom_msg.prototype.msg_type = 0;

        /**
         * msg_send_chatroom_msg content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_chatroom_msg
         * @instance
         */
        msg_send_chatroom_msg.prototype.content = $util.newBuffer([]);

        /**
         * Encodes the specified msg_send_chatroom_msg message. Does not implicitly {@link net.msg_send_chatroom_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {net.Imsg_send_chatroom_msg} message msg_send_chatroom_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.msg_type != null && Object.hasOwnProperty.call(message, "msg_type"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msg_type);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
            return writer;
        };

        /**
         * Decodes a msg_send_chatroom_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_msg} msg_send_chatroom_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.msg_type = reader.int32();
                    break;
                case 3:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_chatroom_msg;
    })();

    net.msg_send_chatroom_msg_rep = (function() {

        /**
         * Properties of a msg_send_chatroom_msg_rep.
         * @memberof net
         * @interface Imsg_send_chatroom_msg_rep
         * @property {number|null} [result] msg_send_chatroom_msg_rep result
         * @property {net.Ichat_msg|null} [msg_info] msg_send_chatroom_msg_rep msg_info
         */

        /**
         * Constructs a new msg_send_chatroom_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_msg_rep.
         * @implements Imsg_send_chatroom_msg_rep
         * @constructor
         * @param {net.Imsg_send_chatroom_msg_rep=} [properties] Properties to set
         */
        function msg_send_chatroom_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_msg_rep result.
         * @member {number} result
         * @memberof net.msg_send_chatroom_msg_rep
         * @instance
         */
        msg_send_chatroom_msg_rep.prototype.result = 0;

        /**
         * msg_send_chatroom_msg_rep msg_info.
         * @member {net.Ichat_msg|null|undefined} msg_info
         * @memberof net.msg_send_chatroom_msg_rep
         * @instance
         */
        msg_send_chatroom_msg_rep.prototype.msg_info = null;

        /**
         * Encodes the specified msg_send_chatroom_msg_rep message. Does not implicitly {@link net.msg_send_chatroom_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {net.Imsg_send_chatroom_msg_rep} message msg_send_chatroom_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.msg_info != null && Object.hasOwnProperty.call(message, "msg_info"))
                $root.net.chat_msg.encode(message.msg_info, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_send_chatroom_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_msg_rep} msg_send_chatroom_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.msg_info = $root.net.chat_msg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_chatroom_msg_rep;
    })();

    net.msg_chatroom_kickout = (function() {

        /**
         * Properties of a msg_chatroom_kickout.
         * @memberof net
         * @interface Imsg_chatroom_kickout
         * @property {number|null} [roomkey] msg_chatroom_kickout roomkey
         * @property {number|null} [kickuid] msg_chatroom_kickout kickuid
         */

        /**
         * Constructs a new msg_chatroom_kickout.
         * @memberof net
         * @classdesc Represents a msg_chatroom_kickout.
         * @implements Imsg_chatroom_kickout
         * @constructor
         * @param {net.Imsg_chatroom_kickout=} [properties] Properties to set
         */
        function msg_chatroom_kickout(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_kickout roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_kickout
         * @instance
         */
        msg_chatroom_kickout.prototype.roomkey = 0;

        /**
         * msg_chatroom_kickout kickuid.
         * @member {number} kickuid
         * @memberof net.msg_chatroom_kickout
         * @instance
         */
        msg_chatroom_kickout.prototype.kickuid = 0;

        /**
         * Encodes the specified msg_chatroom_kickout message. Does not implicitly {@link net.msg_chatroom_kickout.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {net.Imsg_chatroom_kickout} message msg_chatroom_kickout message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_kickout.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.kickuid != null && Object.hasOwnProperty.call(message, "kickuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.kickuid);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_kickout message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_kickout
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_kickout} msg_chatroom_kickout
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_kickout.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_kickout();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.kickuid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_kickout;
    })();

    net.msg_chatroom_kickout_rep = (function() {

        /**
         * Properties of a msg_chatroom_kickout_rep.
         * @memberof net
         * @interface Imsg_chatroom_kickout_rep
         * @property {number|null} [result] msg_chatroom_kickout_rep result
         * @property {number|null} [kickuid] msg_chatroom_kickout_rep kickuid
         */

        /**
         * Constructs a new msg_chatroom_kickout_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_kickout_rep.
         * @implements Imsg_chatroom_kickout_rep
         * @constructor
         * @param {net.Imsg_chatroom_kickout_rep=} [properties] Properties to set
         */
        function msg_chatroom_kickout_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_kickout_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_kickout_rep
         * @instance
         */
        msg_chatroom_kickout_rep.prototype.result = 0;

        /**
         * msg_chatroom_kickout_rep kickuid.
         * @member {number} kickuid
         * @memberof net.msg_chatroom_kickout_rep
         * @instance
         */
        msg_chatroom_kickout_rep.prototype.kickuid = 0;

        /**
         * Encodes the specified msg_chatroom_kickout_rep message. Does not implicitly {@link net.msg_chatroom_kickout_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {net.Imsg_chatroom_kickout_rep} message msg_chatroom_kickout_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_kickout_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.kickuid != null && Object.hasOwnProperty.call(message, "kickuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.kickuid);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_kickout_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_kickout_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_kickout_rep} msg_chatroom_kickout_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_kickout_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_kickout_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.kickuid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_kickout_rep;
    })();

    net.msg_chatroom_forbid = (function() {

        /**
         * Properties of a msg_chatroom_forbid.
         * @memberof net
         * @interface Imsg_chatroom_forbid
         * @property {number|null} [roomkey] msg_chatroom_forbid roomkey
         * @property {number|null} [uid] msg_chatroom_forbid uid
         * @property {number|null} [is_set] msg_chatroom_forbid is_set
         */

        /**
         * Constructs a new msg_chatroom_forbid.
         * @memberof net
         * @classdesc Represents a msg_chatroom_forbid.
         * @implements Imsg_chatroom_forbid
         * @constructor
         * @param {net.Imsg_chatroom_forbid=} [properties] Properties to set
         */
        function msg_chatroom_forbid(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_forbid roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_forbid
         * @instance
         */
        msg_chatroom_forbid.prototype.roomkey = 0;

        /**
         * msg_chatroom_forbid uid.
         * @member {number} uid
         * @memberof net.msg_chatroom_forbid
         * @instance
         */
        msg_chatroom_forbid.prototype.uid = 0;

        /**
         * msg_chatroom_forbid is_set.
         * @member {number} is_set
         * @memberof net.msg_chatroom_forbid
         * @instance
         */
        msg_chatroom_forbid.prototype.is_set = 0;

        /**
         * Encodes the specified msg_chatroom_forbid message. Does not implicitly {@link net.msg_chatroom_forbid.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {net.Imsg_chatroom_forbid} message msg_chatroom_forbid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_forbid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.is_set != null && Object.hasOwnProperty.call(message, "is_set"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_set);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_forbid message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_forbid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_forbid} msg_chatroom_forbid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_forbid.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_forbid();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.is_set = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_forbid;
    })();

    net.msg_chatroom_forbid_rep = (function() {

        /**
         * Properties of a msg_chatroom_forbid_rep.
         * @memberof net
         * @interface Imsg_chatroom_forbid_rep
         * @property {number|null} [result] msg_chatroom_forbid_rep result
         */

        /**
         * Constructs a new msg_chatroom_forbid_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_forbid_rep.
         * @implements Imsg_chatroom_forbid_rep
         * @constructor
         * @param {net.Imsg_chatroom_forbid_rep=} [properties] Properties to set
         */
        function msg_chatroom_forbid_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_forbid_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_forbid_rep
         * @instance
         */
        msg_chatroom_forbid_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_chatroom_forbid_rep message. Does not implicitly {@link net.msg_chatroom_forbid_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {net.Imsg_chatroom_forbid_rep} message msg_chatroom_forbid_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_forbid_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_forbid_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_forbid_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_forbid_rep} msg_chatroom_forbid_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_forbid_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_forbid_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_forbid_rep;
    })();

    net.msg_chatroom_admin = (function() {

        /**
         * Properties of a msg_chatroom_admin.
         * @memberof net
         * @interface Imsg_chatroom_admin
         * @property {number|null} [roomkey] msg_chatroom_admin roomkey
         * @property {number|null} [uid] msg_chatroom_admin uid
         * @property {number|null} [is_set] msg_chatroom_admin is_set
         */

        /**
         * Constructs a new msg_chatroom_admin.
         * @memberof net
         * @classdesc Represents a msg_chatroom_admin.
         * @implements Imsg_chatroom_admin
         * @constructor
         * @param {net.Imsg_chatroom_admin=} [properties] Properties to set
         */
        function msg_chatroom_admin(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_admin roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_admin
         * @instance
         */
        msg_chatroom_admin.prototype.roomkey = 0;

        /**
         * msg_chatroom_admin uid.
         * @member {number} uid
         * @memberof net.msg_chatroom_admin
         * @instance
         */
        msg_chatroom_admin.prototype.uid = 0;

        /**
         * msg_chatroom_admin is_set.
         * @member {number} is_set
         * @memberof net.msg_chatroom_admin
         * @instance
         */
        msg_chatroom_admin.prototype.is_set = 0;

        /**
         * Encodes the specified msg_chatroom_admin message. Does not implicitly {@link net.msg_chatroom_admin.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {net.Imsg_chatroom_admin} message msg_chatroom_admin message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_admin.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid);
            if (message.is_set != null && Object.hasOwnProperty.call(message, "is_set"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.is_set);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_admin message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_admin
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_admin} msg_chatroom_admin
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_admin.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_admin();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.uid = reader.int32();
                    break;
                case 3:
                    message.is_set = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_admin;
    })();

    net.msg_chatroom_admin_rep = (function() {

        /**
         * Properties of a msg_chatroom_admin_rep.
         * @memberof net
         * @interface Imsg_chatroom_admin_rep
         * @property {number|null} [result] msg_chatroom_admin_rep result
         */

        /**
         * Constructs a new msg_chatroom_admin_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_admin_rep.
         * @implements Imsg_chatroom_admin_rep
         * @constructor
         * @param {net.Imsg_chatroom_admin_rep=} [properties] Properties to set
         */
        function msg_chatroom_admin_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_admin_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_admin_rep
         * @instance
         */
        msg_chatroom_admin_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_chatroom_admin_rep message. Does not implicitly {@link net.msg_chatroom_admin_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {net.Imsg_chatroom_admin_rep} message msg_chatroom_admin_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_admin_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_admin_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_admin_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_admin_rep} msg_chatroom_admin_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_admin_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_admin_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_admin_rep;
    })();

    net.msg_del_chatroom_msg = (function() {

        /**
         * Properties of a msg_del_chatroom_msg.
         * @memberof net
         * @interface Imsg_del_chatroom_msg
         * @property {number|null} [roomkey] msg_del_chatroom_msg roomkey
         * @property {number|null} [msgno] msg_del_chatroom_msg msgno
         */

        /**
         * Constructs a new msg_del_chatroom_msg.
         * @memberof net
         * @classdesc Represents a msg_del_chatroom_msg.
         * @implements Imsg_del_chatroom_msg
         * @constructor
         * @param {net.Imsg_del_chatroom_msg=} [properties] Properties to set
         */
        function msg_del_chatroom_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chatroom_msg roomkey.
         * @member {number} roomkey
         * @memberof net.msg_del_chatroom_msg
         * @instance
         */
        msg_del_chatroom_msg.prototype.roomkey = 0;

        /**
         * msg_del_chatroom_msg msgno.
         * @member {number} msgno
         * @memberof net.msg_del_chatroom_msg
         * @instance
         */
        msg_del_chatroom_msg.prototype.msgno = 0;

        /**
         * Encodes the specified msg_del_chatroom_msg message. Does not implicitly {@link net.msg_del_chatroom_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {net.Imsg_del_chatroom_msg} message msg_del_chatroom_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chatroom_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.msgno != null && Object.hasOwnProperty.call(message, "msgno"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.msgno);
            return writer;
        };

        /**
         * Decodes a msg_del_chatroom_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chatroom_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chatroom_msg} msg_del_chatroom_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chatroom_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chatroom_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.msgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_chatroom_msg;
    })();

    net.msg_del_chatroom_msg_rep = (function() {

        /**
         * Properties of a msg_del_chatroom_msg_rep.
         * @memberof net
         * @interface Imsg_del_chatroom_msg_rep
         * @property {number|null} [result] msg_del_chatroom_msg_rep result
         * @property {number|null} [roomkey] msg_del_chatroom_msg_rep roomkey
         * @property {number|null} [msgno] msg_del_chatroom_msg_rep msgno
         */

        /**
         * Constructs a new msg_del_chatroom_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_del_chatroom_msg_rep.
         * @implements Imsg_del_chatroom_msg_rep
         * @constructor
         * @param {net.Imsg_del_chatroom_msg_rep=} [properties] Properties to set
         */
        function msg_del_chatroom_msg_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_del_chatroom_msg_rep result.
         * @member {number} result
         * @memberof net.msg_del_chatroom_msg_rep
         * @instance
         */
        msg_del_chatroom_msg_rep.prototype.result = 0;

        /**
         * msg_del_chatroom_msg_rep roomkey.
         * @member {number} roomkey
         * @memberof net.msg_del_chatroom_msg_rep
         * @instance
         */
        msg_del_chatroom_msg_rep.prototype.roomkey = 0;

        /**
         * msg_del_chatroom_msg_rep msgno.
         * @member {number} msgno
         * @memberof net.msg_del_chatroom_msg_rep
         * @instance
         */
        msg_del_chatroom_msg_rep.prototype.msgno = 0;

        /**
         * Encodes the specified msg_del_chatroom_msg_rep message. Does not implicitly {@link net.msg_del_chatroom_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {net.Imsg_del_chatroom_msg_rep} message msg_del_chatroom_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_del_chatroom_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.roomkey);
            if (message.msgno != null && Object.hasOwnProperty.call(message, "msgno"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.msgno);
            return writer;
        };

        /**
         * Decodes a msg_del_chatroom_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_del_chatroom_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_del_chatroom_msg_rep} msg_del_chatroom_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_del_chatroom_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_del_chatroom_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                case 2:
                    message.roomkey = reader.int32();
                    break;
                case 3:
                    message.msgno = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_del_chatroom_msg_rep;
    })();

    net.msg_get_chatroom_history_msg = (function() {

        /**
         * Properties of a msg_get_chatroom_history_msg.
         * @memberof net
         * @interface Imsg_get_chatroom_history_msg
         * @property {number|null} [roomkey] msg_get_chatroom_history_msg roomkey
         */

        /**
         * Constructs a new msg_get_chatroom_history_msg.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_history_msg.
         * @implements Imsg_get_chatroom_history_msg
         * @constructor
         * @param {net.Imsg_get_chatroom_history_msg=} [properties] Properties to set
         */
        function msg_get_chatroom_history_msg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_history_msg roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_history_msg
         * @instance
         */
        msg_get_chatroom_history_msg.prototype.roomkey = 0;

        /**
         * Encodes the specified msg_get_chatroom_history_msg message. Does not implicitly {@link net.msg_get_chatroom_history_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {net.Imsg_get_chatroom_history_msg} message msg_get_chatroom_history_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_history_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            return writer;
        };

        /**
         * Decodes a msg_get_chatroom_history_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_history_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_history_msg} msg_get_chatroom_history_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_history_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_history_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chatroom_history_msg;
    })();

    net.msg_get_chatroom_history_msg_rep = (function() {

        /**
         * Properties of a msg_get_chatroom_history_msg_rep.
         * @memberof net
         * @interface Imsg_get_chatroom_history_msg_rep
         * @property {number|null} [roomkey] msg_get_chatroom_history_msg_rep roomkey
         * @property {Array.<net.Ichat_msg>|null} [msg_list] msg_get_chatroom_history_msg_rep msg_list
         */

        /**
         * Constructs a new msg_get_chatroom_history_msg_rep.
         * @memberof net
         * @classdesc Represents a msg_get_chatroom_history_msg_rep.
         * @implements Imsg_get_chatroom_history_msg_rep
         * @constructor
         * @param {net.Imsg_get_chatroom_history_msg_rep=} [properties] Properties to set
         */
        function msg_get_chatroom_history_msg_rep(properties) {
            this.msg_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_get_chatroom_history_msg_rep roomkey.
         * @member {number} roomkey
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @instance
         */
        msg_get_chatroom_history_msg_rep.prototype.roomkey = 0;

        /**
         * msg_get_chatroom_history_msg_rep msg_list.
         * @member {Array.<net.Ichat_msg>} msg_list
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @instance
         */
        msg_get_chatroom_history_msg_rep.prototype.msg_list = $util.emptyArray;

        /**
         * Encodes the specified msg_get_chatroom_history_msg_rep message. Does not implicitly {@link net.msg_get_chatroom_history_msg_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {net.Imsg_get_chatroom_history_msg_rep} message msg_get_chatroom_history_msg_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_get_chatroom_history_msg_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.msg_list != null && message.msg_list.length)
                for (var i = 0; i < message.msg_list.length; ++i)
                    $root.net.chat_msg.encode(message.msg_list[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_get_chatroom_history_msg_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_get_chatroom_history_msg_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_get_chatroom_history_msg_rep} msg_get_chatroom_history_msg_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_get_chatroom_history_msg_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_get_chatroom_history_msg_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    if (!(message.msg_list && message.msg_list.length))
                        message.msg_list = [];
                    message.msg_list.push($root.net.chat_msg.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_get_chatroom_history_msg_rep;
    })();

    net.msg_join_chatroom_nty = (function() {

        /**
         * Properties of a msg_join_chatroom_nty.
         * @memberof net
         * @interface Imsg_join_chatroom_nty
         * @property {number|null} [roomkey] msg_join_chatroom_nty roomkey
         * @property {net.Ibase_info|null} [base_data] msg_join_chatroom_nty base_data
         */

        /**
         * Constructs a new msg_join_chatroom_nty.
         * @memberof net
         * @classdesc Represents a msg_join_chatroom_nty.
         * @implements Imsg_join_chatroom_nty
         * @constructor
         * @param {net.Imsg_join_chatroom_nty=} [properties] Properties to set
         */
        function msg_join_chatroom_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_join_chatroom_nty roomkey.
         * @member {number} roomkey
         * @memberof net.msg_join_chatroom_nty
         * @instance
         */
        msg_join_chatroom_nty.prototype.roomkey = 0;

        /**
         * msg_join_chatroom_nty base_data.
         * @member {net.Ibase_info|null|undefined} base_data
         * @memberof net.msg_join_chatroom_nty
         * @instance
         */
        msg_join_chatroom_nty.prototype.base_data = null;

        /**
         * Encodes the specified msg_join_chatroom_nty message. Does not implicitly {@link net.msg_join_chatroom_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {net.Imsg_join_chatroom_nty} message msg_join_chatroom_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_join_chatroom_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.base_data != null && Object.hasOwnProperty.call(message, "base_data"))
                $root.net.base_info.encode(message.base_data, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_join_chatroom_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_join_chatroom_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_join_chatroom_nty} msg_join_chatroom_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_join_chatroom_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_join_chatroom_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.base_data = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_join_chatroom_nty;
    })();

    net.msg_chatroom_nty_msg_toall = (function() {

        /**
         * Properties of a msg_chatroom_nty_msg_toall.
         * @memberof net
         * @interface Imsg_chatroom_nty_msg_toall
         * @property {number|null} [roomkey] msg_chatroom_nty_msg_toall roomkey
         * @property {Uint8Array|null} [content] msg_chatroom_nty_msg_toall content
         */

        /**
         * Constructs a new msg_chatroom_nty_msg_toall.
         * @memberof net
         * @classdesc Represents a msg_chatroom_nty_msg_toall.
         * @implements Imsg_chatroom_nty_msg_toall
         * @constructor
         * @param {net.Imsg_chatroom_nty_msg_toall=} [properties] Properties to set
         */
        function msg_chatroom_nty_msg_toall(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_nty_msg_toall roomkey.
         * @member {number} roomkey
         * @memberof net.msg_chatroom_nty_msg_toall
         * @instance
         */
        msg_chatroom_nty_msg_toall.prototype.roomkey = 0;

        /**
         * msg_chatroom_nty_msg_toall content.
         * @member {Uint8Array} content
         * @memberof net.msg_chatroom_nty_msg_toall
         * @instance
         */
        msg_chatroom_nty_msg_toall.prototype.content = $util.newBuffer([]);

        /**
         * Encodes the specified msg_chatroom_nty_msg_toall message. Does not implicitly {@link net.msg_chatroom_nty_msg_toall.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall} message msg_chatroom_nty_msg_toall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_nty_msg_toall.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_nty_msg_toall message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_nty_msg_toall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_nty_msg_toall} msg_chatroom_nty_msg_toall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_nty_msg_toall.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_nty_msg_toall();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_nty_msg_toall;
    })();

    net.msg_chatroom_nty_msg_toall_rep = (function() {

        /**
         * Properties of a msg_chatroom_nty_msg_toall_rep.
         * @memberof net
         * @interface Imsg_chatroom_nty_msg_toall_rep
         * @property {number|null} [result] msg_chatroom_nty_msg_toall_rep result
         */

        /**
         * Constructs a new msg_chatroom_nty_msg_toall_rep.
         * @memberof net
         * @classdesc Represents a msg_chatroom_nty_msg_toall_rep.
         * @implements Imsg_chatroom_nty_msg_toall_rep
         * @constructor
         * @param {net.Imsg_chatroom_nty_msg_toall_rep=} [properties] Properties to set
         */
        function msg_chatroom_nty_msg_toall_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatroom_nty_msg_toall_rep result.
         * @member {number} result
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @instance
         */
        msg_chatroom_nty_msg_toall_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_chatroom_nty_msg_toall_rep message. Does not implicitly {@link net.msg_chatroom_nty_msg_toall_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {net.Imsg_chatroom_nty_msg_toall_rep} message msg_chatroom_nty_msg_toall_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatroom_nty_msg_toall_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_chatroom_nty_msg_toall_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatroom_nty_msg_toall_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatroom_nty_msg_toall_rep} msg_chatroom_nty_msg_toall_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatroom_nty_msg_toall_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatroom_nty_msg_toall_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatroom_nty_msg_toall_rep;
    })();

    net.msg_send_chatroom_ad = (function() {

        /**
         * Properties of a msg_send_chatroom_ad.
         * @memberof net
         * @interface Imsg_send_chatroom_ad
         * @property {number|null} [roomkey] msg_send_chatroom_ad roomkey
         * @property {Uint8Array|null} [content] msg_send_chatroom_ad content
         */

        /**
         * Constructs a new msg_send_chatroom_ad.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_ad.
         * @implements Imsg_send_chatroom_ad
         * @constructor
         * @param {net.Imsg_send_chatroom_ad=} [properties] Properties to set
         */
        function msg_send_chatroom_ad(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_ad roomkey.
         * @member {number} roomkey
         * @memberof net.msg_send_chatroom_ad
         * @instance
         */
        msg_send_chatroom_ad.prototype.roomkey = 0;

        /**
         * msg_send_chatroom_ad content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_chatroom_ad
         * @instance
         */
        msg_send_chatroom_ad.prototype.content = $util.newBuffer([]);

        /**
         * Encodes the specified msg_send_chatroom_ad message. Does not implicitly {@link net.msg_send_chatroom_ad.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {net.Imsg_send_chatroom_ad} message msg_send_chatroom_ad message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_ad.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
            return writer;
        };

        /**
         * Decodes a msg_send_chatroom_ad message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_ad
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_ad} msg_send_chatroom_ad
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_ad.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_ad();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_chatroom_ad;
    })();

    net.msg_send_chatroom_ad_rep = (function() {

        /**
         * Properties of a msg_send_chatroom_ad_rep.
         * @memberof net
         * @interface Imsg_send_chatroom_ad_rep
         * @property {number|null} [roomkey] msg_send_chatroom_ad_rep roomkey
         * @property {Uint8Array|null} [content] msg_send_chatroom_ad_rep content
         */

        /**
         * Constructs a new msg_send_chatroom_ad_rep.
         * @memberof net
         * @classdesc Represents a msg_send_chatroom_ad_rep.
         * @implements Imsg_send_chatroom_ad_rep
         * @constructor
         * @param {net.Imsg_send_chatroom_ad_rep=} [properties] Properties to set
         */
        function msg_send_chatroom_ad_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_send_chatroom_ad_rep roomkey.
         * @member {number} roomkey
         * @memberof net.msg_send_chatroom_ad_rep
         * @instance
         */
        msg_send_chatroom_ad_rep.prototype.roomkey = 0;

        /**
         * msg_send_chatroom_ad_rep content.
         * @member {Uint8Array} content
         * @memberof net.msg_send_chatroom_ad_rep
         * @instance
         */
        msg_send_chatroom_ad_rep.prototype.content = $util.newBuffer([]);

        /**
         * Encodes the specified msg_send_chatroom_ad_rep message. Does not implicitly {@link net.msg_send_chatroom_ad_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {net.Imsg_send_chatroom_ad_rep} message msg_send_chatroom_ad_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_send_chatroom_ad_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomkey != null && Object.hasOwnProperty.call(message, "roomkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomkey);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.content);
            return writer;
        };

        /**
         * Decodes a msg_send_chatroom_ad_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_send_chatroom_ad_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_send_chatroom_ad_rep} msg_send_chatroom_ad_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_send_chatroom_ad_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_send_chatroom_ad_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomkey = reader.int32();
                    break;
                case 2:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_send_chatroom_ad_rep;
    })();

    /**
     * RESULT_CODE enum.
     * @name net.RESULT_CODE
     * @enum {number}
     * @property {number} RESULT_CODE_FAIL=0 RESULT_CODE_FAIL value
     * @property {number} RESULT_CODE_SUCCESS=1 RESULT_CODE_SUCCESS value
     * @property {number} RESULT_CODE_INVALID_PHONENUM=2 RESULT_CODE_INVALID_PHONENUM value
     * @property {number} RESULT_CODE_PHONENUM_ERROR=3 RESULT_CODE_PHONENUM_ERROR value
     * @property {number} RESULT_CODE_REDBAG_EMPTY=4 RESULT_CODE_REDBAG_EMPTY value
     * @property {number} RESULT_CODE_ALREADY_GET_REDBAG=5 RESULT_CODE_ALREADY_GET_REDBAG value
     * @property {number} RESULT_CODE_NOT_YOUR_FRIEND=6 RESULT_CODE_NOT_YOUR_FRIEND value
     * @property {number} RESULT_CODE_INVALID_NICKNANME=7 RESULT_CODE_INVALID_NICKNANME value
     * @property {number} RESULT_CODE_EXPIRE_REDBAG=8 RESULT_CODE_EXPIRE_REDBAG value
     * @property {number} RESULT_CODE_FASTKEY_ERROR=9 RESULT_CODE_FASTKEY_ERROR value
     * @property {number} RESULT_CODE_MONEY_NOT_ENOUGH=10 RESULT_CODE_MONEY_NOT_ENOUGH value
     * @property {number} RESULT_CODE_PWD_ERROR=11 RESULT_CODE_PWD_ERROR value
     * @property {number} RESULT_CODE_INVALID_AUTHCODE=12 RESULT_CODE_INVALID_AUTHCODE value
     * @property {number} RESULT_CODE_PWD_NOT_SET=13 RESULT_CODE_PWD_NOT_SET value
     * @property {number} RESULT_CODE_GROUP_NEED_VERIFY=14 RESULT_CODE_GROUP_NEED_VERIFY value
     * @property {number} RESULT_CODE_CANT_DEAL_WITHSELF=15 RESULT_CODE_CANT_DEAL_WITHSELF value
     * @property {number} RESULT_CODE_NOT_SUPPORT_DEAL=16 RESULT_CODE_NOT_SUPPORT_DEAL value
     * @property {number} RESULT_CODE_GOODS_NOT_ENOUGH=17 RESULT_CODE_GOODS_NOT_ENOUGH value
     * @property {number} RESULT_CODE_GOODS_NOT_EXIST=18 RESULT_CODE_GOODS_NOT_EXIST value
     * @property {number} RESULT_CODE_ORDER_NOT_EXIST=19 RESULT_CODE_ORDER_NOT_EXIST value
     * @property {number} RESULT_CODE_INVALID_GQRCODE=20 RESULT_CODE_INVALID_GQRCODE value
     * @property {number} RESULT_CODE_HAS_UNFINISHED_ORDER=21 RESULT_CODE_HAS_UNFINISHED_ORDER value
     * @property {number} RESULT_CODE_NO_PAYTYPE=22 RESULT_CODE_NO_PAYTYPE value
     * @property {number} RESULT_CODE_ORDER_CONFIRMED=23 RESULT_CODE_ORDER_CONFIRMED value
     * @property {number} RESULT_CODE_GROUP_FULL=24 RESULT_CODE_GROUP_FULL value
     * @property {number} RESULT_CODE_ALREADY_FRIEND=25 RESULT_CODE_ALREADY_FRIEND value
     * @property {number} RESULT_CODE_ORDER_COMPLETE=26 RESULT_CODE_ORDER_COMPLETE value
     * @property {number} RESULT_CODE_GOODS_STATUS_ERROR=27 RESULT_CODE_GOODS_STATUS_ERROR value
     * @property {number} RESULT_CODE_IN_BLACK_LIST=28 RESULT_CODE_IN_BLACK_LIST value
     * @property {number} RESULT_CODE_ORDER_STATUS_ERROR=29 RESULT_CODE_ORDER_STATUS_ERROR value
     * @property {number} RESULT_CODE_ORDER_EXPIRE=30 RESULT_CODE_ORDER_EXPIRE value
     * @property {number} RESULT_CODE_PCQRCODE_ERROR=31 RESULT_CODE_PCQRCODE_ERROR value
     * @property {number} RESULT_CODE_IS_CALLING=32 RESULT_CODE_IS_CALLING value
     * @property {number} RESULT_CODE_VOICECALL_ERROR=33 RESULT_CODE_VOICECALL_ERROR value
     * @property {number} RESULT_CODE_ALREADY_BIND=34 RESULT_CODE_ALREADY_BIND value
     * @property {number} RESULT_CODE_IN_CHATROOM=35 RESULT_CODE_IN_CHATROOM value
     * @property {number} RESULT_CODE_NOT_IN_CHATROOM=36 RESULT_CODE_NOT_IN_CHATROOM value
     * @property {number} RESULT_CODE_NOT_ADMIN=37 RESULT_CODE_NOT_ADMIN value
     * @property {number} RESULT_CODE_IS_FORBID=38 RESULT_CODE_IS_FORBID value
     * @property {number} RESULT_CODE_CHATROOM_NOTEXIST=39 RESULT_CODE_CHATROOM_NOTEXIST value
     * @property {number} RESULT_CODE_NOT_ROOMHOST=40 RESULT_CODE_NOT_ROOMHOST value
     * @property {number} RESULT_CODE_FID_NOT_EXIST=41 RESULT_CODE_FID_NOT_EXIST value
     * @property {number} RESULT_CODE_CANNOT_VIP_REWARD=42 RESULT_CODE_CANNOT_VIP_REWARD value
     * @property {number} RESULT_CODE_NOT_GROUP_MEMBER=43 RESULT_CODE_NOT_GROUP_MEMBER value
     * @property {number} RESULT_CODE_VERIFYCODE_ERROR=44 RESULT_CODE_VERIFYCODE_ERROR value
     */
    net.RESULT_CODE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RESULT_CODE_FAIL"] = 0;
        values[valuesById[1] = "RESULT_CODE_SUCCESS"] = 1;
        values[valuesById[2] = "RESULT_CODE_INVALID_PHONENUM"] = 2;
        values[valuesById[3] = "RESULT_CODE_PHONENUM_ERROR"] = 3;
        values[valuesById[4] = "RESULT_CODE_REDBAG_EMPTY"] = 4;
        values[valuesById[5] = "RESULT_CODE_ALREADY_GET_REDBAG"] = 5;
        values[valuesById[6] = "RESULT_CODE_NOT_YOUR_FRIEND"] = 6;
        values[valuesById[7] = "RESULT_CODE_INVALID_NICKNANME"] = 7;
        values[valuesById[8] = "RESULT_CODE_EXPIRE_REDBAG"] = 8;
        values[valuesById[9] = "RESULT_CODE_FASTKEY_ERROR"] = 9;
        values[valuesById[10] = "RESULT_CODE_MONEY_NOT_ENOUGH"] = 10;
        values[valuesById[11] = "RESULT_CODE_PWD_ERROR"] = 11;
        values[valuesById[12] = "RESULT_CODE_INVALID_AUTHCODE"] = 12;
        values[valuesById[13] = "RESULT_CODE_PWD_NOT_SET"] = 13;
        values[valuesById[14] = "RESULT_CODE_GROUP_NEED_VERIFY"] = 14;
        values[valuesById[15] = "RESULT_CODE_CANT_DEAL_WITHSELF"] = 15;
        values[valuesById[16] = "RESULT_CODE_NOT_SUPPORT_DEAL"] = 16;
        values[valuesById[17] = "RESULT_CODE_GOODS_NOT_ENOUGH"] = 17;
        values[valuesById[18] = "RESULT_CODE_GOODS_NOT_EXIST"] = 18;
        values[valuesById[19] = "RESULT_CODE_ORDER_NOT_EXIST"] = 19;
        values[valuesById[20] = "RESULT_CODE_INVALID_GQRCODE"] = 20;
        values[valuesById[21] = "RESULT_CODE_HAS_UNFINISHED_ORDER"] = 21;
        values[valuesById[22] = "RESULT_CODE_NO_PAYTYPE"] = 22;
        values[valuesById[23] = "RESULT_CODE_ORDER_CONFIRMED"] = 23;
        values[valuesById[24] = "RESULT_CODE_GROUP_FULL"] = 24;
        values[valuesById[25] = "RESULT_CODE_ALREADY_FRIEND"] = 25;
        values[valuesById[26] = "RESULT_CODE_ORDER_COMPLETE"] = 26;
        values[valuesById[27] = "RESULT_CODE_GOODS_STATUS_ERROR"] = 27;
        values[valuesById[28] = "RESULT_CODE_IN_BLACK_LIST"] = 28;
        values[valuesById[29] = "RESULT_CODE_ORDER_STATUS_ERROR"] = 29;
        values[valuesById[30] = "RESULT_CODE_ORDER_EXPIRE"] = 30;
        values[valuesById[31] = "RESULT_CODE_PCQRCODE_ERROR"] = 31;
        values[valuesById[32] = "RESULT_CODE_IS_CALLING"] = 32;
        values[valuesById[33] = "RESULT_CODE_VOICECALL_ERROR"] = 33;
        values[valuesById[34] = "RESULT_CODE_ALREADY_BIND"] = 34;
        values[valuesById[35] = "RESULT_CODE_IN_CHATROOM"] = 35;
        values[valuesById[36] = "RESULT_CODE_NOT_IN_CHATROOM"] = 36;
        values[valuesById[37] = "RESULT_CODE_NOT_ADMIN"] = 37;
        values[valuesById[38] = "RESULT_CODE_IS_FORBID"] = 38;
        values[valuesById[39] = "RESULT_CODE_CHATROOM_NOTEXIST"] = 39;
        values[valuesById[40] = "RESULT_CODE_NOT_ROOMHOST"] = 40;
        values[valuesById[41] = "RESULT_CODE_FID_NOT_EXIST"] = 41;
        values[valuesById[42] = "RESULT_CODE_CANNOT_VIP_REWARD"] = 42;
        values[valuesById[43] = "RESULT_CODE_NOT_GROUP_MEMBER"] = 43;
        values[valuesById[44] = "RESULT_CODE_VERIFYCODE_ERROR"] = 44;
        return values;
    })();

    /**
     * MESSAGE_TYPE enum.
     * @name net.MESSAGE_TYPE
     * @enum {number}
     * @property {number} MESSAGE_TYPE_TXT=1 MESSAGE_TYPE_TXT value
     * @property {number} MESSAGE_TYPE_VOICE=2 MESSAGE_TYPE_VOICE value
     * @property {number} MESSAGE_TYPE_VIDEO=3 MESSAGE_TYPE_VIDEO value
     * @property {number} MESSAGE_TYPE_IMAGE=4 MESSAGE_TYPE_IMAGE value
     * @property {number} MESSAGE_TYPE_REDBAG=5 MESSAGE_TYPE_REDBAG value
     * @property {number} MESSAGE_TYPE_SHARE_LINK=6 MESSAGE_TYPE_SHARE_LINK value
     * @property {number} MESSAGE_TYPE_CARD=7 MESSAGE_TYPE_CARD value
     * @property {number} MESSAGE_TYPE_GET_REDBAG=8 MESSAGE_TYPE_GET_REDBAG value
     * @property {number} MESSAGE_TYPE_VOICE_CHAT_START=9 MESSAGE_TYPE_VOICE_CHAT_START value
     * @property {number} MESSAGE_TYPE_TRANS_MONEY=10 MESSAGE_TYPE_TRANS_MONEY value
     * @property {number} MESSAGE_TYPE_GROUP_CARD=11 MESSAGE_TYPE_GROUP_CARD value
     * @property {number} MESSAGE_TYPE_WITHDRAW_CHATMSG=12 MESSAGE_TYPE_WITHDRAW_CHATMSG value
     * @property {number} MESSAGE_TYPE_CONFIRM_ORDER=13 MESSAGE_TYPE_CONFIRM_ORDER value
     * @property {number} MESSAGE_TYPE_SERVER_TXT=14 MESSAGE_TYPE_SERVER_TXT value
     * @property {number} MESSAGE_TYPE_FILE=15 MESSAGE_TYPE_FILE value
     * @property {number} MESSAGE_TYPE_AT=16 MESSAGE_TYPE_AT value
     * @property {number} MESSAGE_TYPE_MONEY_LOG=17 MESSAGE_TYPE_MONEY_LOG value
     * @property {number} MESSAGE_TYPE_PROGRAME=18 MESSAGE_TYPE_PROGRAME value
     * @property {number} MESSAGE_TYPE_AD=19 MESSAGE_TYPE_AD value
     * @property {number} MESSAGE_TYPE_VOICE_CHAT1=102 MESSAGE_TYPE_VOICE_CHAT1 value
     * @property {number} MESSAGE_TYPE_CENTER_TIP=10000 MESSAGE_TYPE_CENTER_TIP value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_CONFIRM=10001 MESSAGE_TYPE_CENTER_TIP_CONFIRM value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_CONFIRM1=10002 MESSAGE_TYPE_CENTER_TIP_CONFIRM1 value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_CONFIRM2=10003 MESSAGE_TYPE_CENTER_TIP_CONFIRM2 value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_GROUP_CODE=10011 MESSAGE_TYPE_CENTER_TIP_GROUP_CODE value
     * @property {number} MESSAGE_TYPE_CENTER_TIP_AGORO=20000 MESSAGE_TYPE_CENTER_TIP_AGORO value
     */
    net.MESSAGE_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "MESSAGE_TYPE_TXT"] = 1;
        values[valuesById[2] = "MESSAGE_TYPE_VOICE"] = 2;
        values[valuesById[3] = "MESSAGE_TYPE_VIDEO"] = 3;
        values[valuesById[4] = "MESSAGE_TYPE_IMAGE"] = 4;
        values[valuesById[5] = "MESSAGE_TYPE_REDBAG"] = 5;
        values[valuesById[6] = "MESSAGE_TYPE_SHARE_LINK"] = 6;
        values[valuesById[7] = "MESSAGE_TYPE_CARD"] = 7;
        values[valuesById[8] = "MESSAGE_TYPE_GET_REDBAG"] = 8;
        values[valuesById[9] = "MESSAGE_TYPE_VOICE_CHAT_START"] = 9;
        values[valuesById[10] = "MESSAGE_TYPE_TRANS_MONEY"] = 10;
        values[valuesById[11] = "MESSAGE_TYPE_GROUP_CARD"] = 11;
        values[valuesById[12] = "MESSAGE_TYPE_WITHDRAW_CHATMSG"] = 12;
        values[valuesById[13] = "MESSAGE_TYPE_CONFIRM_ORDER"] = 13;
        values[valuesById[14] = "MESSAGE_TYPE_SERVER_TXT"] = 14;
        values[valuesById[15] = "MESSAGE_TYPE_FILE"] = 15;
        values[valuesById[16] = "MESSAGE_TYPE_AT"] = 16;
        values[valuesById[17] = "MESSAGE_TYPE_MONEY_LOG"] = 17;
        values[valuesById[18] = "MESSAGE_TYPE_PROGRAME"] = 18;
        values[valuesById[19] = "MESSAGE_TYPE_AD"] = 19;
        values[valuesById[102] = "MESSAGE_TYPE_VOICE_CHAT1"] = 102;
        values[valuesById[10000] = "MESSAGE_TYPE_CENTER_TIP"] = 10000;
        values[valuesById[10001] = "MESSAGE_TYPE_CENTER_TIP_CONFIRM"] = 10001;
        values[valuesById[10002] = "MESSAGE_TYPE_CENTER_TIP_CONFIRM1"] = 10002;
        values[valuesById[10003] = "MESSAGE_TYPE_CENTER_TIP_CONFIRM2"] = 10003;
        values[valuesById[10011] = "MESSAGE_TYPE_CENTER_TIP_GROUP_CODE"] = 10011;
        values[valuesById[20000] = "MESSAGE_TYPE_CENTER_TIP_AGORO"] = 20000;
        return values;
    })();

    /**
     * PUSH_CHANNEL enum.
     * @name net.PUSH_CHANNEL
     * @enum {number}
     * @property {number} PUSH_CHANNEL_JG=1 PUSH_CHANNEL_JG value
     * @property {number} PUSH_CHANNEL_HW=2 PUSH_CHANNEL_HW value
     * @property {number} PUSH_CHANNEL_XM=3 PUSH_CHANNEL_XM value
     * @property {number} PUSH_CHANNEL_IOS=4 PUSH_CHANNEL_IOS value
     * @property {number} PUSH_CHANNEL_IOS_AUTHKEY=5 PUSH_CHANNEL_IOS_AUTHKEY value
     * @property {number} PUSH_CHANNEL_67JG=6 PUSH_CHANNEL_67JG value
     */
    net.PUSH_CHANNEL = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "PUSH_CHANNEL_JG"] = 1;
        values[valuesById[2] = "PUSH_CHANNEL_HW"] = 2;
        values[valuesById[3] = "PUSH_CHANNEL_XM"] = 3;
        values[valuesById[4] = "PUSH_CHANNEL_IOS"] = 4;
        values[valuesById[5] = "PUSH_CHANNEL_IOS_AUTHKEY"] = 5;
        values[valuesById[6] = "PUSH_CHANNEL_67JG"] = 6;
        return values;
    })();

    /**
     * MONEY_TYPE enum.
     * @name net.MONEY_TYPE
     * @enum {number}
     * @property {number} MONEY_TYPE_TRANSFER_BYCODE=1 MONEY_TYPE_TRANSFER_BYCODE value
     * @property {number} MONEY_TYPE_TRANSFER=2 MONEY_TYPE_TRANSFER value
     * @property {number} MONEY_TYPE_REDBAG=3 MONEY_TYPE_REDBAG value
     * @property {number} MONEY_TYPE_RECHARGE=4 MONEY_TYPE_RECHARGE value
     * @property {number} MONEY_TYPE_WITHDRAW=5 MONEY_TYPE_WITHDRAW value
     * @property {number} MONEY_TYPE_REDBAG_BACK=6 MONEY_TYPE_REDBAG_BACK value
     * @property {number} MONEY_TYPE_GOODS=7 MONEY_TYPE_GOODS value
     * @property {number} MONEY_TYPE_ORDER_BACK=8 MONEY_TYPE_ORDER_BACK value
     * @property {number} MONEY_TYPE_TRANSFER_BYNO=9 MONEY_TYPE_TRANSFER_BYNO value
     * @property {number} MONEY_TYPE_EXCHANGE=10 MONEY_TYPE_EXCHANGE value
     * @property {number} MONEY_TYPE_THIRD_PAY=11 MONEY_TYPE_THIRD_PAY value
     * @property {number} MONEY_TYPE_BACKSITE_OPER=12 MONEY_TYPE_BACKSITE_OPER value
     * @property {number} MONEY_TYPE_SIGNIN=13 MONEY_TYPE_SIGNIN value
     * @property {number} MONEY_TYPE_EXCHANGE_GOODS=14 MONEY_TYPE_EXCHANGE_GOODS value
     * @property {number} MONEY_TYPE_ROOM_SPEAK=15 MONEY_TYPE_ROOM_SPEAK value
     * @property {number} MONEY_TYPE_WATCH_MATCH=16 MONEY_TYPE_WATCH_MATCH value
     * @property {number} MONEY_TYPE_VIP_REWARD=17 MONEY_TYPE_VIP_REWARD value
     * @property {number} MONEY_TYPE_INVITE_REWARD=18 MONEY_TYPE_INVITE_REWARD value
     */
    net.MONEY_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "MONEY_TYPE_TRANSFER_BYCODE"] = 1;
        values[valuesById[2] = "MONEY_TYPE_TRANSFER"] = 2;
        values[valuesById[3] = "MONEY_TYPE_REDBAG"] = 3;
        values[valuesById[4] = "MONEY_TYPE_RECHARGE"] = 4;
        values[valuesById[5] = "MONEY_TYPE_WITHDRAW"] = 5;
        values[valuesById[6] = "MONEY_TYPE_REDBAG_BACK"] = 6;
        values[valuesById[7] = "MONEY_TYPE_GOODS"] = 7;
        values[valuesById[8] = "MONEY_TYPE_ORDER_BACK"] = 8;
        values[valuesById[9] = "MONEY_TYPE_TRANSFER_BYNO"] = 9;
        values[valuesById[10] = "MONEY_TYPE_EXCHANGE"] = 10;
        values[valuesById[11] = "MONEY_TYPE_THIRD_PAY"] = 11;
        values[valuesById[12] = "MONEY_TYPE_BACKSITE_OPER"] = 12;
        values[valuesById[13] = "MONEY_TYPE_SIGNIN"] = 13;
        values[valuesById[14] = "MONEY_TYPE_EXCHANGE_GOODS"] = 14;
        values[valuesById[15] = "MONEY_TYPE_ROOM_SPEAK"] = 15;
        values[valuesById[16] = "MONEY_TYPE_WATCH_MATCH"] = 16;
        values[valuesById[17] = "MONEY_TYPE_VIP_REWARD"] = 17;
        values[valuesById[18] = "MONEY_TYPE_INVITE_REWARD"] = 18;
        return values;
    })();

    /**
     * FREEZE_MONEY_TYPE enum.
     * @name net.FREEZE_MONEY_TYPE
     * @enum {number}
     * @property {number} FREEZE_MONEY_TYPE_RECHARGE=1 FREEZE_MONEY_TYPE_RECHARGE value
     * @property {number} FREEZE_MONEY_TYPE_WITHDRAW=2 FREEZE_MONEY_TYPE_WITHDRAW value
     * @property {number} FREEZE_MONEY_TYPE_USER_RECHARGE=3 FREEZE_MONEY_TYPE_USER_RECHARGE value
     * @property {number} FREEZE_MONEY_TYPE_USER_WITHDRAW=4 FREEZE_MONEY_TYPE_USER_WITHDRAW value
     * @property {number} FREEZE_MONEY_TYPE_ORDER_BACK=5 FREEZE_MONEY_TYPE_ORDER_BACK value
     * @property {number} FREEZE_MONEY_TYPE_GOODS=6 FREEZE_MONEY_TYPE_GOODS value
     * @property {number} FREEZE_MONEY_TYPE_GOODS_WITHDRAW=7 FREEZE_MONEY_TYPE_GOODS_WITHDRAW value
     */
    net.FREEZE_MONEY_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "FREEZE_MONEY_TYPE_RECHARGE"] = 1;
        values[valuesById[2] = "FREEZE_MONEY_TYPE_WITHDRAW"] = 2;
        values[valuesById[3] = "FREEZE_MONEY_TYPE_USER_RECHARGE"] = 3;
        values[valuesById[4] = "FREEZE_MONEY_TYPE_USER_WITHDRAW"] = 4;
        values[valuesById[5] = "FREEZE_MONEY_TYPE_ORDER_BACK"] = 5;
        values[valuesById[6] = "FREEZE_MONEY_TYPE_GOODS"] = 6;
        values[valuesById[7] = "FREEZE_MONEY_TYPE_GOODS_WITHDRAW"] = 7;
        return values;
    })();

    /**
     * SERVICE_FID enum.
     * @name net.SERVICE_FID
     * @enum {number}
     * @property {number} SERVICE_FID_BEGIN=9999 SERVICE_FID_BEGIN value
     * @property {number} SERVICE_FID_UNIQUE=10000 SERVICE_FID_UNIQUE value
     * @property {number} SERVICE_FID_PAY=10001 SERVICE_FID_PAY value
     * @property {number} SERVICE_FID_C01=10010 SERVICE_FID_C01 value
     */
    net.SERVICE_FID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[9999] = "SERVICE_FID_BEGIN"] = 9999;
        values[valuesById[10000] = "SERVICE_FID_UNIQUE"] = 10000;
        values[valuesById[10001] = "SERVICE_FID_PAY"] = 10001;
        values[valuesById[10010] = "SERVICE_FID_C01"] = 10010;
        return values;
    })();

    /**
     * SERVICE_TYPE enum.
     * @name net.SERVICE_TYPE
     * @enum {number}
     * @property {number} SERVICE_TYPE_CUSTOMER=1 SERVICE_TYPE_CUSTOMER value
     * @property {number} SERVICE_TYPE_PAY=2 SERVICE_TYPE_PAY value
     */
    net.SERVICE_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "SERVICE_TYPE_CUSTOMER"] = 1;
        values[valuesById[2] = "SERVICE_TYPE_PAY"] = 2;
        return values;
    })();

    /**
     * COIN_TYPE enum.
     * @name net.COIN_TYPE
     * @enum {number}
     * @property {number} COIN_TYPE_CNY=0 COIN_TYPE_CNY value
     * @property {number} COIN_TYPE_USD=1 COIN_TYPE_USD value
     * @property {number} COIN_TYPE_BUK=2 COIN_TYPE_BUK value
     * @property {number} COIN_TYPE_MYR=3 COIN_TYPE_MYR value
     * @property {number} COIN_TYPE_PHP=4 COIN_TYPE_PHP value
     * @property {number} COIN_TYPE_TWD=5 COIN_TYPE_TWD value
     */
    net.COIN_TYPE = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "COIN_TYPE_CNY"] = 0;
        values[valuesById[1] = "COIN_TYPE_USD"] = 1;
        values[valuesById[2] = "COIN_TYPE_BUK"] = 2;
        values[valuesById[3] = "COIN_TYPE_MYR"] = 3;
        values[valuesById[4] = "COIN_TYPE_PHP"] = 4;
        values[valuesById[5] = "COIN_TYPE_TWD"] = 5;
        return values;
    })();

    /**
     * THIRD_CHANNEL enum.
     * @name net.THIRD_CHANNEL
     * @enum {number}
     * @property {number} THIRD_CHANNEL_SIX=1 THIRD_CHANNEL_SIX value
     * @property {number} THIRD_CHANNEL_BBQ=2 THIRD_CHANNEL_BBQ value
     * @property {number} THIRD_CHANNEL_BQD=3 THIRD_CHANNEL_BQD value
     * @property {number} THIRD_CHANNEL_F7=4 THIRD_CHANNEL_F7 value
     */
    net.THIRD_CHANNEL = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "THIRD_CHANNEL_SIX"] = 1;
        values[valuesById[2] = "THIRD_CHANNEL_BBQ"] = 2;
        values[valuesById[3] = "THIRD_CHANNEL_BQD"] = 3;
        values[valuesById[4] = "THIRD_CHANNEL_F7"] = 4;
        return values;
    })();

    /**
     * CLIENT_MSG_ID enum.
     * @name net.CLIENT_MSG_ID
     * @enum {number}
     * @property {number} C2S_MSG_HEART=1000 C2S_MSG_HEART value
     * @property {number} C2S_MSG_LOGIN=1001 C2S_MSG_LOGIN value
     * @property {number} S2C_MSG_LOGIN_REP=1002 S2C_MSG_LOGIN_REP value
     * @property {number} S2C_MSG_USER_INFO=1003 S2C_MSG_USER_INFO value
     * @property {number} S2C_MSG_ADD_FRIEND_NTY=1004 S2C_MSG_ADD_FRIEND_NTY value
     * @property {number} C2S_MSG_ADD_FRIEND=1005 C2S_MSG_ADD_FRIEND value
     * @property {number} S2C_MSG_ADD_FRIEND_REP=1006 S2C_MSG_ADD_FRIEND_REP value
     * @property {number} C2S_MSG_HANDLE_FRIEND_APPLY=1007 C2S_MSG_HANDLE_FRIEND_APPLY value
     * @property {number} S2C_MSG_HANDLE_FRIEND_APPLY_REP=1008 S2C_MSG_HANDLE_FRIEND_APPLY_REP value
     * @property {number} C2S_MSG_FRIEND_APPLY_LIST=1009 C2S_MSG_FRIEND_APPLY_LIST value
     * @property {number} S2C_MSG_FRIEND_APPLY_LIST_REP=1010 S2C_MSG_FRIEND_APPLY_LIST_REP value
     * @property {number} C2S_MSG_FRIEND_LIST=1011 C2S_MSG_FRIEND_LIST value
     * @property {number} S2C_MSG_FRIEND_LIST_REP=1012 S2C_MSG_FRIEND_LIST_REP value
     * @property {number} C2S_MSG_GET_USER_INFO=1013 C2S_MSG_GET_USER_INFO value
     * @property {number} S2C_MSG_GET_USER_INFO_REP=1014 S2C_MSG_GET_USER_INFO_REP value
     * @property {number} C2S_MSG_SEND_PRIVATE_MSG=1015 C2S_MSG_SEND_PRIVATE_MSG value
     * @property {number} S2C_MSG_SEND_PRIVATE_MSG_REP=1016 S2C_MSG_SEND_PRIVATE_MSG_REP value
     * @property {number} C2S_MSG_GET_MSG_LIST=1017 C2S_MSG_GET_MSG_LIST value
     * @property {number} S2C_MSG_GET_MSG_LIST_REP=1018 S2C_MSG_GET_MSG_LIST_REP value
     * @property {number} C2S_MSG_CONFIRM_READ_MSG=1019 C2S_MSG_CONFIRM_READ_MSG value
     * @property {number} S2C_MSG_CONFIRM_READ_MSG_REP=1020 S2C_MSG_CONFIRM_READ_MSG_REP value
     * @property {number} C2S_MSG_CREATE_GROUP_CHAT=1021 C2S_MSG_CREATE_GROUP_CHAT value
     * @property {number} S2C_MSG_CREATE_GROUP_CHAT_REP=1022 S2C_MSG_CREATE_GROUP_CHAT_REP value
     * @property {number} C2S_MSG_ADD_GROUP_MEMBER=1023 C2S_MSG_ADD_GROUP_MEMBER value
     * @property {number} S2C_MSG_ADD_GROUP_MEMBER_REP=1024 S2C_MSG_ADD_GROUP_MEMBER_REP value
     * @property {number} C2S_MSG_DEL_GROUP_MEMBER=1025 C2S_MSG_DEL_GROUP_MEMBER value
     * @property {number} S2C_MSG_DEL_GROUP_MEMBER_REP=1026 S2C_MSG_DEL_GROUP_MEMBER_REP value
     * @property {number} C2S_MSG_DISMISS_GROUP=1027 C2S_MSG_DISMISS_GROUP value
     * @property {number} S2C_MSG_DISMISS_GROUP_REP=1028 S2C_MSG_DISMISS_GROUP_REP value
     * @property {number} C2S_MSG_SEND_GROUP_MSG=1029 C2S_MSG_SEND_GROUP_MSG value
     * @property {number} S2C_MSG_SEND_GROUP_MSG_REP=1030 S2C_MSG_SEND_GROUP_MSG_REP value
     * @property {number} C2S_MSG_GET_GROUP_INFO=1031 C2S_MSG_GET_GROUP_INFO value
     * @property {number} S2C_MSG_GET_GROUP_INFO_REP=1032 S2C_MSG_GET_GROUP_INFO_REP value
     * @property {number} C2S_MSG_CONFIRM_GROUP_INFO=1033 C2S_MSG_CONFIRM_GROUP_INFO value
     * @property {number} S2C_MSG_CONFIRM_GROUP_INFO_REP=1034 S2C_MSG_CONFIRM_GROUP_INFO_REP value
     * @property {number} C2S_MSG_GET_REDBAG_INFO=1035 C2S_MSG_GET_REDBAG_INFO value
     * @property {number} S2C_MSG_GET_REDBAG_INFO_REP=1036 S2C_MSG_GET_REDBAG_INFO_REP value
     * @property {number} C2S_MSG_MODIFY_GROUPNAME=1037 C2S_MSG_MODIFY_GROUPNAME value
     * @property {number} S2C_MSG_MODIFY_GROUPNAME_REP=1038 S2C_MSG_MODIFY_GROUPNAME_REP value
     * @property {number} C2S_MSG_MODIFY_GROUPNOTIFY=1039 C2S_MSG_MODIFY_GROUPNOTIFY value
     * @property {number} S2C_MSG_MODIFY_GROUPNOTIFY_REP=1040 S2C_MSG_MODIFY_GROUPNOTIFY_REP value
     * @property {number} C2S_MSG_SET_GROUPADMIN=1041 C2S_MSG_SET_GROUPADMIN value
     * @property {number} S2C_MSG_SET_GROUPADMIN_REP=1042 S2C_MSG_SET_GROUPADMIN_REP value
     * @property {number} C2S_MSG_SET_GROUPINFO_LIMITS=1043 C2S_MSG_SET_GROUPINFO_LIMITS value
     * @property {number} S2C_MSG_SET_GROUPINFO_LIMITS_REP=1044 S2C_MSG_SET_GROUPINFO_LIMITS_REP value
     * @property {number} C2S_MSG_SET_GROUPADD_LIMITS=1045 C2S_MSG_SET_GROUPADD_LIMITS value
     * @property {number} S2C_MSG_SET_GROUPADD_LIMITS_REP=1046 S2C_MSG_SET_GROUPADD_LIMITS_REP value
     * @property {number} C2S_MSG_DEL_GROUPADMIN=1047 C2S_MSG_DEL_GROUPADMIN value
     * @property {number} S2C_MSG_DEL_GROUPADMIN_REP=1048 S2C_MSG_DEL_GROUPADMIN_REP value
     * @property {number} C2S_MSG_SET_GROUPLOOK_LIMITS=1049 C2S_MSG_SET_GROUPLOOK_LIMITS value
     * @property {number} S2C_MSG_SET_GROUPLOOK_LIMITS_REP=1050 S2C_MSG_SET_GROUPLOOK_LIMITS_REP value
     * @property {number} C2S_MSG_SET_GROUPHOST=1051 C2S_MSG_SET_GROUPHOST value
     * @property {number} S2C_MSG_SET_GROUPHOST_REP=1052 S2C_MSG_SET_GROUPHOST_REP value
     * @property {number} C2S_MSG_GET_REDBAG=1053 C2S_MSG_GET_REDBAG value
     * @property {number} S2C_MSG_GET_REDBAG_REP=1054 S2C_MSG_GET_REDBAG_REP value
     * @property {number} C2S_MSG_INPUT_SYNC=1055 C2S_MSG_INPUT_SYNC value
     * @property {number} S2C_MSG_INPUT_SYNC_REP=1056 S2C_MSG_INPUT_SYNC_REP value
     * @property {number} C2S_MSG_GET_ONLINE_STATE=1057 C2S_MSG_GET_ONLINE_STATE value
     * @property {number} S2C_MSG_GET_ONLINE_STATE_REP=1058 S2C_MSG_GET_ONLINE_STATE_REP value
     * @property {number} C2S_MSG_GET_GROUP_ONLINE=1059 C2S_MSG_GET_GROUP_ONLINE value
     * @property {number} S2C_MSG_GET_GROUP_ONLINE_REP=1060 S2C_MSG_GET_GROUP_ONLINE_REP value
     * @property {number} C2S_MSG_SET_MUTE_NOTIFICATIONS=1061 C2S_MSG_SET_MUTE_NOTIFICATIONS value
     * @property {number} S2C_MSG_SET_MUTE_NOTIFICATIONS_REP=1062 S2C_MSG_SET_MUTE_NOTIFICATIONS_REP value
     * @property {number} C2S_MSG_SET_CHAT_ON_TOP=1063 C2S_MSG_SET_CHAT_ON_TOP value
     * @property {number} S2C_MSG_SET_CHAT_ON_TOP_REP=1064 S2C_MSG_SET_CHAT_ON_TOP_REP value
     * @property {number} C2S_MSG_GET_MUTE_NOTIFY_LIST=1065 C2S_MSG_GET_MUTE_NOTIFY_LIST value
     * @property {number} S2C_MSG_GET_MUTE_NOTIFY_LIST_REP=1066 S2C_MSG_GET_MUTE_NOTIFY_LIST_REP value
     * @property {number} C2S_MSG_GET_CHAT_ON_TOP_LIST=1067 C2S_MSG_GET_CHAT_ON_TOP_LIST value
     * @property {number} S2C_MSG_GET_CHAT_ON_TOP_LIST_REP=1068 S2C_MSG_GET_CHAT_ON_TOP_LIST_REP value
     * @property {number} C2S_MSG_DEL_CHAT_MSG=1069 C2S_MSG_DEL_CHAT_MSG value
     * @property {number} S2C_MSG_DEL_CHAT_MSG_REP=1070 S2C_MSG_DEL_CHAT_MSG_REP value
     * @property {number} C2S_MSG_CONFIRM_DEL_MSG=1071 C2S_MSG_CONFIRM_DEL_MSG value
     * @property {number} S2C_MSG_CONFIRM_DEL_MSG_REP=1072 S2C_MSG_CONFIRM_DEL_MSG_REP value
     * @property {number} C2S_MSG_GET_OFFLINE_DATA=1073 C2S_MSG_GET_OFFLINE_DATA value
     * @property {number} C2S_MSG_DELETE_FRIEND=1075 C2S_MSG_DELETE_FRIEND value
     * @property {number} S2C_MSG_DELETE_FRIEND_REP=1076 S2C_MSG_DELETE_FRIEND_REP value
     * @property {number} C2S_MSG_SET_ALIAS=1077 C2S_MSG_SET_ALIAS value
     * @property {number} S2C_MSG_SET_ALIAS_REP=1078 S2C_MSG_SET_ALIAS_REP value
     * @property {number} C2S_MSG_GET_ALIAS_LIST=1079 C2S_MSG_GET_ALIAS_LIST value
     * @property {number} S2C_MSG_GET_ALIAS_LIST_REP=1080 S2C_MSG_GET_ALIAS_LIST_REP value
     * @property {number} C2S_MSG_SET_SIGN=1081 C2S_MSG_SET_SIGN value
     * @property {number} S2C_MSG_SET_SIGN_REP=1082 S2C_MSG_SET_SIGN_REP value
     * @property {number} C2S_MSG_SET_REGION=1083 C2S_MSG_SET_REGION value
     * @property {number} S2C_MSG_SET_REGION_REP=1084 S2C_MSG_SET_REGION_REP value
     * @property {number} C2S_MSG_SET_HEADURL=1085 C2S_MSG_SET_HEADURL value
     * @property {number} S2C_MSG_SET_HEADURL_REP=1086 S2C_MSG_SET_HEADURL_REP value
     * @property {number} C2S_MSG_SET_NAME=1087 C2S_MSG_SET_NAME value
     * @property {number} S2C_MSG_SET_NAME_REP=1088 S2C_MSG_SET_NAME_REP value
     * @property {number} C2S_MSG_TOTAL_REDBAG_RECORD=1089 C2S_MSG_TOTAL_REDBAG_RECORD value
     * @property {number} S2C_MSG_TOTAL_REDBAG_RECORD_RESP=1090 S2C_MSG_TOTAL_REDBAG_RECORD_RESP value
     * @property {number} C2S_MSG_UPLOAD_ADDRESSBOOK=1091 C2S_MSG_UPLOAD_ADDRESSBOOK value
     * @property {number} S2C_MSG_UPLOAD_ADDRESSBOOK_REP=1092 S2C_MSG_UPLOAD_ADDRESSBOOK_REP value
     * @property {number} C2S_MSG_GET_ADDRESSBOOK=1093 C2S_MSG_GET_ADDRESSBOOK value
     * @property {number} S2C_MSG_GET_ADDRESSBOOK_REP=1094 S2C_MSG_GET_ADDRESSBOOK_REP value
     * @property {number} C2S_MSG_UPLOAD_PUSHID=1095 C2S_MSG_UPLOAD_PUSHID value
     * @property {number} S2C_MSG_UPLOAD_PUSHID_REP=1096 S2C_MSG_UPLOAD_PUSHID_REP value
     * @property {number} C2S_MSG_SET_BACKGROUND=1097 C2S_MSG_SET_BACKGROUND value
     * @property {number} S2C_MSG_SET_BACKGROUND_REP=1098 S2C_MSG_SET_BACKGROUND_REP value
     * @property {number} C2S_MSG_CONFIRM_HASREAD_MSG=1099 C2S_MSG_CONFIRM_HASREAD_MSG value
     * @property {number} S2C_MSG_CONFIRM_HASREAD_MSG_REP=1100 S2C_MSG_CONFIRM_HASREAD_MSG_REP value
     * @property {number} C2S_MSG_GET_HASREAD_LIST=1101 C2S_MSG_GET_HASREAD_LIST value
     * @property {number} S2C_MSG_GET_HASREAD_LIST_REP=1102 S2C_MSG_GET_HASREAD_LIST_REP value
     * @property {number} C2S_MSG_TRANSFER_ACCOUNT=1103 C2S_MSG_TRANSFER_ACCOUNT value
     * @property {number} S2C_MSG_TRANSFER_ACCOUNT_REP=1104 S2C_MSG_TRANSFER_ACCOUNT_REP value
     * @property {number} C2S_MSG_GET_ONLINE_LIST=1105 C2S_MSG_GET_ONLINE_LIST value
     * @property {number} S2C_MSG_GET_ONLINE_LIST_REP=1106 S2C_MSG_GET_ONLINE_LIST_REP value
     * @property {number} C2S_MSG_GET_MONEY_CHANGE_LIST=1107 C2S_MSG_GET_MONEY_CHANGE_LIST value
     * @property {number} S2C_MSG_GET_MONEY_CHANGE_LIST_REP=1108 S2C_MSG_GET_MONEY_CHANGE_LIST_REP value
     * @property {number} C2S_MSG_GET_PAY_AUTH_CODE=1109 C2S_MSG_GET_PAY_AUTH_CODE value
     * @property {number} S2C_MSG_GET_PAY_AUTH_CODE_REP=1110 S2C_MSG_GET_PAY_AUTH_CODE_REP value
     * @property {number} C2S_MSG_JOINGROUP_BYQRCODE=1111 C2S_MSG_JOINGROUP_BYQRCODE value
     * @property {number} S2C_MSG_JOINGROUP_BYQRCODE_REP=1112 S2C_MSG_JOINGROUP_BYQRCODE_REP value
     * @property {number} C2S_MSG_CREATE_GOODS=1113 C2S_MSG_CREATE_GOODS value
     * @property {number} S2C_MSG_CREATE_GOODS_REP=1114 S2C_MSG_CREATE_GOODS_REP value
     * @property {number} C2S_MSG_GET_MY_GOODS=1115 C2S_MSG_GET_MY_GOODS value
     * @property {number} S2C_MSG_GET_MY_GOODS_REP=1116 S2C_MSG_GET_MY_GOODS_REP value
     * @property {number} C2S_MSG_GET_GOODS=1117 C2S_MSG_GET_GOODS value
     * @property {number} S2C_MSG_GET_GOODS_REP=1118 S2C_MSG_GET_GOODS_REP value
     * @property {number} C2S_MSG_CREATE_ORDER=1119 C2S_MSG_CREATE_ORDER value
     * @property {number} S2C_MSG_CREATE_ORDER_REP=1120 S2C_MSG_CREATE_ORDER_REP value
     * @property {number} C2S_MSG_CONFIRM_ORDER=1121 C2S_MSG_CONFIRM_ORDER value
     * @property {number} S2C_MSG_CONFIRM_ORDER_REP=1122 S2C_MSG_CONFIRM_ORDER_REP value
     * @property {number} C2S_MSG_GET_MY_ORDERS=1123 C2S_MSG_GET_MY_ORDERS value
     * @property {number} S2C_MSG_GET_MY_ORDERS_REP=1124 S2C_MSG_GET_MY_ORDERS_REP value
     * @property {number} C2S_MSG_GET_ORDER_INFO=1125 C2S_MSG_GET_ORDER_INFO value
     * @property {number} S2C_MSG_GET_ORDER_INFO_REP=1126 S2C_MSG_GET_ORDER_INFO_REP value
     * @property {number} C2S_MSG_GET_GOODS_BYID=1127 C2S_MSG_GET_GOODS_BYID value
     * @property {number} S2C_MSG_GET_GOODS_BYID_REP=1128 S2C_MSG_GET_GOODS_BYID_REP value
     * @property {number} C2S_MSG_WITHDRAW_CHATMSG=1129 C2S_MSG_WITHDRAW_CHATMSG value
     * @property {number} S2C_MSG_WITHDRAW_CHATMSG_REP=1130 S2C_MSG_WITHDRAW_CHATMSG_REP value
     * @property {number} C2S_MSG_CANCEL_ORDER=1131 C2S_MSG_CANCEL_ORDER value
     * @property {number} S2C_MSG_CANCEL_ORDER_REP=1132 S2C_MSG_CANCEL_ORDER_REP value
     * @property {number} C2S_MSG_GET_GROUP_NICKNAME_LIST=1133 C2S_MSG_GET_GROUP_NICKNAME_LIST value
     * @property {number} S2C_MSG_GET_GROUP_NICKNAME_LIST_REP=1134 S2C_MSG_GET_GROUP_NICKNAME_LIST_REP value
     * @property {number} C2S_MSG_SET_GROUP_NICKNAME=1135 C2S_MSG_SET_GROUP_NICKNAME value
     * @property {number} S2C_MSG_SET_GROUP_NICKNAME_REP=1136 S2C_MSG_SET_GROUP_NICKNAME_REP value
     * @property {number} C2S_MSG_SET_ORDER_PAYTYPEID=1137 C2S_MSG_SET_ORDER_PAYTYPEID value
     * @property {number} S2C_MSG_SET_ORDER_PAYTYPEID_REP=1138 S2C_MSG_SET_ORDER_PAYTYPEID_REP value
     * @property {number} C2S_MSG_GET_GOODS_DATA=1139 C2S_MSG_GET_GOODS_DATA value
     * @property {number} S2C_MSG_GET_GOODS_DATA_REP=1140 S2C_MSG_GET_GOODS_DATA_REP value
     * @property {number} C2S_MSG_GET_GOODS_DETAIL_DATA=1141 C2S_MSG_GET_GOODS_DETAIL_DATA value
     * @property {number} S2C_MSG_GET_GOODS_DETAIL_DATA_REP=1142 S2C_MSG_GET_GOODS_DETAIL_DATA_REP value
     * @property {number} C2S_MSG_OPER_SHOPCOIN=1143 C2S_MSG_OPER_SHOPCOIN value
     * @property {number} S2C_MSG_OPER_SHOPCOIN_REP=1144 S2C_MSG_OPER_SHOPCOIN_REP value
     * @property {number} C2S_MSG_SET_SNAPCHAT=1145 C2S_MSG_SET_SNAPCHAT value
     * @property {number} S2C_MSG_SET_SNAPCHAT_REP=1146 S2C_MSG_SET_SNAPCHAT_REP value
     * @property {number} C2S_MSG_GET_SNAPCHAT_LIST=1147 C2S_MSG_GET_SNAPCHAT_LIST value
     * @property {number} S2C_MSG_GET_SNAPCHAT_LIST_REP=1148 S2C_MSG_GET_SNAPCHAT_LIST_REP value
     * @property {number} C2S_MSG_GET_SCREENSHOT=1149 C2S_MSG_GET_SCREENSHOT value
     * @property {number} S2C_MSG_GET_SCREENSHOT_REP=1150 S2C_MSG_GET_SCREENSHOT_REP value
     * @property {number} C2S_MSG_SET_SCREENSHOT=1151 C2S_MSG_SET_SCREENSHOT value
     * @property {number} S2C_MSG_SET_SCREENSHOT_REP=1152 S2C_MSG_SET_SCREENSHOT_REP value
     * @property {number} C2S_MSG_SET_GROUPSENDMSG_LIMIT=1153 C2S_MSG_SET_GROUPSENDMSG_LIMIT value
     * @property {number} S2C_MSG_SET_GROUPSENDMSG_LIMIT_REP=1154 S2C_MSG_SET_GROUPSENDMSG_LIMIT_REP value
     * @property {number} C2S_MSG_GET_ORDER_INFO_BYID=1155 C2S_MSG_GET_ORDER_INFO_BYID value
     * @property {number} S2C_MSG_GET_ORDER_INFO_BYID_REP=1156 S2C_MSG_GET_ORDER_INFO_BYID_REP value
     * @property {number} C2S_MSG_GET_BLACK_LIST=1157 C2S_MSG_GET_BLACK_LIST value
     * @property {number} SC2_MSG_GET_BLACK_LIST_REP=1158 SC2_MSG_GET_BLACK_LIST_REP value
     * @property {number} C2S_MSG_SET_BLACK_LIST=1159 C2S_MSG_SET_BLACK_LIST value
     * @property {number} SC2_MSG_SET_BLACK_LIST_REP=1160 SC2_MSG_SET_BLACK_LIST_REP value
     * @property {number} C2S_MSG_THIRD_PAY=1161 C2S_MSG_THIRD_PAY value
     * @property {number} S2C_MSG_THIRD_PAY_REP=1162 S2C_MSG_THIRD_PAY_REP value
     * @property {number} C2S_MSG_PCAUTH=1163 C2S_MSG_PCAUTH value
     * @property {number} S2C_MSG_PCAUTH_REP=1164 S2C_MSG_PCAUTH_REP value
     * @property {number} C2S_MSG_PCLOGIN=1165 C2S_MSG_PCLOGIN value
     * @property {number} S2C_MSG_PCLOGIN_REP=1166 S2C_MSG_PCLOGIN_REP value
     * @property {number} C2S_MSG_VOICE_CALL=1167 C2S_MSG_VOICE_CALL value
     * @property {number} S2C_MSG_VOICE_CALL_REP=1168 S2C_MSG_VOICE_CALL_REP value
     * @property {number} C2S_MSG_OPER_VOICE_CALL=1169 C2S_MSG_OPER_VOICE_CALL value
     * @property {number} S2C_MSG_OPER_VOICE_CALL_REP=1170 S2C_MSG_OPER_VOICE_CALL_REP value
     * @property {number} C2S_MSG_VOICE_DATA=1171 C2S_MSG_VOICE_DATA value
     * @property {number} S2C_MSG_VOICE_DATA_REP=1172 S2C_MSG_VOICE_DATA_REP value
     * @property {number} C2S_MSG_NEED_READ_GROUP_NOTIFY=1173 C2S_MSG_NEED_READ_GROUP_NOTIFY value
     * @property {number} S2C_MSG_NEED_READ_GROUP_NOTIFY_REP=1174 S2C_MSG_NEED_READ_GROUP_NOTIFY_REP value
     * @property {number} C2S_MSG_READ_GROUP_NOTIFY=1175 C2S_MSG_READ_GROUP_NOTIFY value
     * @property {number} S2C_MSG_READ_GROUP_NOTIFY_REP=1176 S2C_MSG_READ_GROUP_NOTIFY_REP value
     * @property {number} C2S_MSG_SET_FORBID_TM=1177 C2S_MSG_SET_FORBID_TM value
     * @property {number} S2C_MSG_SET_FORBID_TM_REP=1178 S2C_MSG_SET_FORBID_TM_REP value
     * @property {number} C2S_MSG_GET_GROUP_MEMBER_LIST=1179 C2S_MSG_GET_GROUP_MEMBER_LIST value
     * @property {number} S2C_MSG_GET_GROUP_MEMBER_LIST_REP=1180 S2C_MSG_GET_GROUP_MEMBER_LIST_REP value
     * @property {number} C2S_MSG_GET_FRIEND_INCR_LIST=1181 C2S_MSG_GET_FRIEND_INCR_LIST value
     * @property {number} S2C_MSG_GET_FRIEND_INCR_LIST_REP=1182 S2C_MSG_GET_FRIEND_INCR_LIST_REP value
     * @property {number} C2S_MSG_BIND_OPENID=1183 C2S_MSG_BIND_OPENID value
     * @property {number} S2C_MSG_BING_OPENID_REP=1184 S2C_MSG_BING_OPENID_REP value
     * @property {number} C2S_MSG_H5LOGIN=1185 C2S_MSG_H5LOGIN value
     * @property {number} S2C_MSG_H5LOGIN_REP=1186 S2C_MSG_H5LOGIN_REP value
     * @property {number} C2S_MSG_ADD_FRIEND_BYFID=1187 C2S_MSG_ADD_FRIEND_BYFID value
     * @property {number} S2C_MSG_ADD_FRIEND_BYFID_REP=1188 S2C_MSG_ADD_FRIEND_BYFID_REP value
     * @property {number} C2S_MSG_SET_GROUP_HEADURL=1189 C2S_MSG_SET_GROUP_HEADURL value
     * @property {number} S2C_MSG_SET_GROUP_HEADURL_REP=1190 S2C_MSG_SET_GROUP_HEADURL_REP value
     * @property {number} C2S_MSG_SET_COMPLETE_NAME=1191 C2S_MSG_SET_COMPLETE_NAME value
     * @property {number} S2C_MSG_SET_COMPLETE_NAME_REP=1192 S2C_MSG_SET_COMPLETE_NAME_REP value
     * @property {number} C2S_MSG_SET_PHONENUM=1193 C2S_MSG_SET_PHONENUM value
     * @property {number} S2C_MSG_SET_PHONENUM_REP=1194 S2C_MSG_SET_PHONENUM_REP value
     * @property {number} C2S_MSG_SET_PRIVACY=1195 C2S_MSG_SET_PRIVACY value
     * @property {number} S2C_MSG_SET_PRIVACY_REP=1196 S2C_MSG_SET_PRIVACY_REP value
     * @property {number} C2S_MSG_GET_CHATROOM_LIST=1301 C2S_MSG_GET_CHATROOM_LIST value
     * @property {number} S2C_MSG_GET_CHATROOM_LIST_REP=1302 S2C_MSG_GET_CHATROOM_LIST_REP value
     * @property {number} C2S_MSG_GET_CHATROOM_MEMBERS=1303 C2S_MSG_GET_CHATROOM_MEMBERS value
     * @property {number} S2C_MSG_GET_CHATROOM_MEMBERS_REP=1304 S2C_MSG_GET_CHATROOM_MEMBERS_REP value
     * @property {number} C2S_MSG_JOIN_CHATROOM=1305 C2S_MSG_JOIN_CHATROOM value
     * @property {number} S2C_MSG_JOIN_CHATROOM_REP=1306 S2C_MSG_JOIN_CHATROOM_REP value
     * @property {number} C2S_MSG_QUIT_CHATROOM=1307 C2S_MSG_QUIT_CHATROOM value
     * @property {number} S2C_MSG_QUIT_CHATROOM_REP=1308 S2C_MSG_QUIT_CHATROOM_REP value
     * @property {number} C2S_MSG_SEND_CHATROOM_MSG=1309 C2S_MSG_SEND_CHATROOM_MSG value
     * @property {number} S2C_MSG_SEND_CHATROOM_MSG_REP=1310 S2C_MSG_SEND_CHATROOM_MSG_REP value
     * @property {number} C2S_MSG_CHATROOM_KICKOUT=1311 C2S_MSG_CHATROOM_KICKOUT value
     * @property {number} S2C_MSG_CHATROOM_KICKOUT_REP=1312 S2C_MSG_CHATROOM_KICKOUT_REP value
     * @property {number} C2S_MSG_CHATROOM_FORBID=1313 C2S_MSG_CHATROOM_FORBID value
     * @property {number} S2C_MSG_CHATROOM_FORBID_REP=1314 S2C_MSG_CHATROOM_FORBID_REP value
     * @property {number} C2S_MSG_DEL_CHATROOM_MSG=1315 C2S_MSG_DEL_CHATROOM_MSG value
     * @property {number} S2C_MSG_DEL_CHATROOM_MSG_REP=1316 S2C_MSG_DEL_CHATROOM_MSG_REP value
     * @property {number} C2S_MSG_CHATROOM_SET_ADMIN=1317 C2S_MSG_CHATROOM_SET_ADMIN value
     * @property {number} S2C_MSG_CHATROOM_SET_ADMIN_REP=1318 S2C_MSG_CHATROOM_SET_ADMIN_REP value
     * @property {number} C2S_MSG_GET_CHATROOM_HISTORY_MSG=1319 C2S_MSG_GET_CHATROOM_HISTORY_MSG value
     * @property {number} S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP=1320 S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP value
     * @property {number} S2C_MSG_JOIN_CHATROOM_NTY=1321 S2C_MSG_JOIN_CHATROOM_NTY value
     * @property {number} C2S_MSG_CHATROOM_NTY_MSG_TOALL=1323 C2S_MSG_CHATROOM_NTY_MSG_TOALL value
     * @property {number} S2C_MSG_CHATROOM_NTY_MSG_TOALL_REP=1324 S2C_MSG_CHATROOM_NTY_MSG_TOALL_REP value
     * @property {number} C2S_MSG_SEND_CHATROOM_AD=1325 C2S_MSG_SEND_CHATROOM_AD value
     * @property {number} S2C_MSG_SEND_CHATROOM_AD_REP=1326 S2C_MSG_SEND_CHATROOM_AD_REP value
     * @property {number} S2C_MSG_RED_NTY=1200 S2C_MSG_RED_NTY value
     * @property {number} S2C_MSG_LOGIN_OTHER_NTY=1201 S2C_MSG_LOGIN_OTHER_NTY value
     * @property {number} S2C_MSG_GROUP_BASE_NTY=1202 S2C_MSG_GROUP_BASE_NTY value
     * @property {number} S2C_MSG_GROUP_OPER_NTY=1203 S2C_MSG_GROUP_OPER_NTY value
     * @property {number} S2C_MSG_HANDLE_FRIEND_NTY=1204 S2C_MSG_HANDLE_FRIEND_NTY value
     * @property {number} S2C_MSG_NEW_ORDER_NTY=1205 S2C_MSG_NEW_ORDER_NTY value
     * @property {number} S2C_MSG_GROUP_MEMBER_LIST_NTY=1206 S2C_MSG_GROUP_MEMBER_LIST_NTY value
     * @property {number} S2C_MSG_RATE_NTY=1207 S2C_MSG_RATE_NTY value
     * @property {number} S2C_MSG_PC_FLOW_NTY=1208 S2C_MSG_PC_FLOW_NTY value
     * @property {number} S2C_MSG_PC_DATA_NTY=1209 S2C_MSG_PC_DATA_NTY value
     * @property {number} S2C_MSG_VOICE_CALL_NTY=1210 S2C_MSG_VOICE_CALL_NTY value
     * @property {number} S2C_MSG_VOICE_DATA_NTY=1211 S2C_MSG_VOICE_DATA_NTY value
     * @property {number} S2C_MSG_FRIEND_STATE_NTY=1212 S2C_MSG_FRIEND_STATE_NTY value
     */
    net.CLIENT_MSG_ID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1000] = "C2S_MSG_HEART"] = 1000;
        values[valuesById[1001] = "C2S_MSG_LOGIN"] = 1001;
        values[valuesById[1002] = "S2C_MSG_LOGIN_REP"] = 1002;
        values[valuesById[1003] = "S2C_MSG_USER_INFO"] = 1003;
        values[valuesById[1004] = "S2C_MSG_ADD_FRIEND_NTY"] = 1004;
        values[valuesById[1005] = "C2S_MSG_ADD_FRIEND"] = 1005;
        values[valuesById[1006] = "S2C_MSG_ADD_FRIEND_REP"] = 1006;
        values[valuesById[1007] = "C2S_MSG_HANDLE_FRIEND_APPLY"] = 1007;
        values[valuesById[1008] = "S2C_MSG_HANDLE_FRIEND_APPLY_REP"] = 1008;
        values[valuesById[1009] = "C2S_MSG_FRIEND_APPLY_LIST"] = 1009;
        values[valuesById[1010] = "S2C_MSG_FRIEND_APPLY_LIST_REP"] = 1010;
        values[valuesById[1011] = "C2S_MSG_FRIEND_LIST"] = 1011;
        values[valuesById[1012] = "S2C_MSG_FRIEND_LIST_REP"] = 1012;
        values[valuesById[1013] = "C2S_MSG_GET_USER_INFO"] = 1013;
        values[valuesById[1014] = "S2C_MSG_GET_USER_INFO_REP"] = 1014;
        values[valuesById[1015] = "C2S_MSG_SEND_PRIVATE_MSG"] = 1015;
        values[valuesById[1016] = "S2C_MSG_SEND_PRIVATE_MSG_REP"] = 1016;
        values[valuesById[1017] = "C2S_MSG_GET_MSG_LIST"] = 1017;
        values[valuesById[1018] = "S2C_MSG_GET_MSG_LIST_REP"] = 1018;
        values[valuesById[1019] = "C2S_MSG_CONFIRM_READ_MSG"] = 1019;
        values[valuesById[1020] = "S2C_MSG_CONFIRM_READ_MSG_REP"] = 1020;
        values[valuesById[1021] = "C2S_MSG_CREATE_GROUP_CHAT"] = 1021;
        values[valuesById[1022] = "S2C_MSG_CREATE_GROUP_CHAT_REP"] = 1022;
        values[valuesById[1023] = "C2S_MSG_ADD_GROUP_MEMBER"] = 1023;
        values[valuesById[1024] = "S2C_MSG_ADD_GROUP_MEMBER_REP"] = 1024;
        values[valuesById[1025] = "C2S_MSG_DEL_GROUP_MEMBER"] = 1025;
        values[valuesById[1026] = "S2C_MSG_DEL_GROUP_MEMBER_REP"] = 1026;
        values[valuesById[1027] = "C2S_MSG_DISMISS_GROUP"] = 1027;
        values[valuesById[1028] = "S2C_MSG_DISMISS_GROUP_REP"] = 1028;
        values[valuesById[1029] = "C2S_MSG_SEND_GROUP_MSG"] = 1029;
        values[valuesById[1030] = "S2C_MSG_SEND_GROUP_MSG_REP"] = 1030;
        values[valuesById[1031] = "C2S_MSG_GET_GROUP_INFO"] = 1031;
        values[valuesById[1032] = "S2C_MSG_GET_GROUP_INFO_REP"] = 1032;
        values[valuesById[1033] = "C2S_MSG_CONFIRM_GROUP_INFO"] = 1033;
        values[valuesById[1034] = "S2C_MSG_CONFIRM_GROUP_INFO_REP"] = 1034;
        values[valuesById[1035] = "C2S_MSG_GET_REDBAG_INFO"] = 1035;
        values[valuesById[1036] = "S2C_MSG_GET_REDBAG_INFO_REP"] = 1036;
        values[valuesById[1037] = "C2S_MSG_MODIFY_GROUPNAME"] = 1037;
        values[valuesById[1038] = "S2C_MSG_MODIFY_GROUPNAME_REP"] = 1038;
        values[valuesById[1039] = "C2S_MSG_MODIFY_GROUPNOTIFY"] = 1039;
        values[valuesById[1040] = "S2C_MSG_MODIFY_GROUPNOTIFY_REP"] = 1040;
        values[valuesById[1041] = "C2S_MSG_SET_GROUPADMIN"] = 1041;
        values[valuesById[1042] = "S2C_MSG_SET_GROUPADMIN_REP"] = 1042;
        values[valuesById[1043] = "C2S_MSG_SET_GROUPINFO_LIMITS"] = 1043;
        values[valuesById[1044] = "S2C_MSG_SET_GROUPINFO_LIMITS_REP"] = 1044;
        values[valuesById[1045] = "C2S_MSG_SET_GROUPADD_LIMITS"] = 1045;
        values[valuesById[1046] = "S2C_MSG_SET_GROUPADD_LIMITS_REP"] = 1046;
        values[valuesById[1047] = "C2S_MSG_DEL_GROUPADMIN"] = 1047;
        values[valuesById[1048] = "S2C_MSG_DEL_GROUPADMIN_REP"] = 1048;
        values[valuesById[1049] = "C2S_MSG_SET_GROUPLOOK_LIMITS"] = 1049;
        values[valuesById[1050] = "S2C_MSG_SET_GROUPLOOK_LIMITS_REP"] = 1050;
        values[valuesById[1051] = "C2S_MSG_SET_GROUPHOST"] = 1051;
        values[valuesById[1052] = "S2C_MSG_SET_GROUPHOST_REP"] = 1052;
        values[valuesById[1053] = "C2S_MSG_GET_REDBAG"] = 1053;
        values[valuesById[1054] = "S2C_MSG_GET_REDBAG_REP"] = 1054;
        values[valuesById[1055] = "C2S_MSG_INPUT_SYNC"] = 1055;
        values[valuesById[1056] = "S2C_MSG_INPUT_SYNC_REP"] = 1056;
        values[valuesById[1057] = "C2S_MSG_GET_ONLINE_STATE"] = 1057;
        values[valuesById[1058] = "S2C_MSG_GET_ONLINE_STATE_REP"] = 1058;
        values[valuesById[1059] = "C2S_MSG_GET_GROUP_ONLINE"] = 1059;
        values[valuesById[1060] = "S2C_MSG_GET_GROUP_ONLINE_REP"] = 1060;
        values[valuesById[1061] = "C2S_MSG_SET_MUTE_NOTIFICATIONS"] = 1061;
        values[valuesById[1062] = "S2C_MSG_SET_MUTE_NOTIFICATIONS_REP"] = 1062;
        values[valuesById[1063] = "C2S_MSG_SET_CHAT_ON_TOP"] = 1063;
        values[valuesById[1064] = "S2C_MSG_SET_CHAT_ON_TOP_REP"] = 1064;
        values[valuesById[1065] = "C2S_MSG_GET_MUTE_NOTIFY_LIST"] = 1065;
        values[valuesById[1066] = "S2C_MSG_GET_MUTE_NOTIFY_LIST_REP"] = 1066;
        values[valuesById[1067] = "C2S_MSG_GET_CHAT_ON_TOP_LIST"] = 1067;
        values[valuesById[1068] = "S2C_MSG_GET_CHAT_ON_TOP_LIST_REP"] = 1068;
        values[valuesById[1069] = "C2S_MSG_DEL_CHAT_MSG"] = 1069;
        values[valuesById[1070] = "S2C_MSG_DEL_CHAT_MSG_REP"] = 1070;
        values[valuesById[1071] = "C2S_MSG_CONFIRM_DEL_MSG"] = 1071;
        values[valuesById[1072] = "S2C_MSG_CONFIRM_DEL_MSG_REP"] = 1072;
        values[valuesById[1073] = "C2S_MSG_GET_OFFLINE_DATA"] = 1073;
        values[valuesById[1075] = "C2S_MSG_DELETE_FRIEND"] = 1075;
        values[valuesById[1076] = "S2C_MSG_DELETE_FRIEND_REP"] = 1076;
        values[valuesById[1077] = "C2S_MSG_SET_ALIAS"] = 1077;
        values[valuesById[1078] = "S2C_MSG_SET_ALIAS_REP"] = 1078;
        values[valuesById[1079] = "C2S_MSG_GET_ALIAS_LIST"] = 1079;
        values[valuesById[1080] = "S2C_MSG_GET_ALIAS_LIST_REP"] = 1080;
        values[valuesById[1081] = "C2S_MSG_SET_SIGN"] = 1081;
        values[valuesById[1082] = "S2C_MSG_SET_SIGN_REP"] = 1082;
        values[valuesById[1083] = "C2S_MSG_SET_REGION"] = 1083;
        values[valuesById[1084] = "S2C_MSG_SET_REGION_REP"] = 1084;
        values[valuesById[1085] = "C2S_MSG_SET_HEADURL"] = 1085;
        values[valuesById[1086] = "S2C_MSG_SET_HEADURL_REP"] = 1086;
        values[valuesById[1087] = "C2S_MSG_SET_NAME"] = 1087;
        values[valuesById[1088] = "S2C_MSG_SET_NAME_REP"] = 1088;
        values[valuesById[1089] = "C2S_MSG_TOTAL_REDBAG_RECORD"] = 1089;
        values[valuesById[1090] = "S2C_MSG_TOTAL_REDBAG_RECORD_RESP"] = 1090;
        values[valuesById[1091] = "C2S_MSG_UPLOAD_ADDRESSBOOK"] = 1091;
        values[valuesById[1092] = "S2C_MSG_UPLOAD_ADDRESSBOOK_REP"] = 1092;
        values[valuesById[1093] = "C2S_MSG_GET_ADDRESSBOOK"] = 1093;
        values[valuesById[1094] = "S2C_MSG_GET_ADDRESSBOOK_REP"] = 1094;
        values[valuesById[1095] = "C2S_MSG_UPLOAD_PUSHID"] = 1095;
        values[valuesById[1096] = "S2C_MSG_UPLOAD_PUSHID_REP"] = 1096;
        values[valuesById[1097] = "C2S_MSG_SET_BACKGROUND"] = 1097;
        values[valuesById[1098] = "S2C_MSG_SET_BACKGROUND_REP"] = 1098;
        values[valuesById[1099] = "C2S_MSG_CONFIRM_HASREAD_MSG"] = 1099;
        values[valuesById[1100] = "S2C_MSG_CONFIRM_HASREAD_MSG_REP"] = 1100;
        values[valuesById[1101] = "C2S_MSG_GET_HASREAD_LIST"] = 1101;
        values[valuesById[1102] = "S2C_MSG_GET_HASREAD_LIST_REP"] = 1102;
        values[valuesById[1103] = "C2S_MSG_TRANSFER_ACCOUNT"] = 1103;
        values[valuesById[1104] = "S2C_MSG_TRANSFER_ACCOUNT_REP"] = 1104;
        values[valuesById[1105] = "C2S_MSG_GET_ONLINE_LIST"] = 1105;
        values[valuesById[1106] = "S2C_MSG_GET_ONLINE_LIST_REP"] = 1106;
        values[valuesById[1107] = "C2S_MSG_GET_MONEY_CHANGE_LIST"] = 1107;
        values[valuesById[1108] = "S2C_MSG_GET_MONEY_CHANGE_LIST_REP"] = 1108;
        values[valuesById[1109] = "C2S_MSG_GET_PAY_AUTH_CODE"] = 1109;
        values[valuesById[1110] = "S2C_MSG_GET_PAY_AUTH_CODE_REP"] = 1110;
        values[valuesById[1111] = "C2S_MSG_JOINGROUP_BYQRCODE"] = 1111;
        values[valuesById[1112] = "S2C_MSG_JOINGROUP_BYQRCODE_REP"] = 1112;
        values[valuesById[1113] = "C2S_MSG_CREATE_GOODS"] = 1113;
        values[valuesById[1114] = "S2C_MSG_CREATE_GOODS_REP"] = 1114;
        values[valuesById[1115] = "C2S_MSG_GET_MY_GOODS"] = 1115;
        values[valuesById[1116] = "S2C_MSG_GET_MY_GOODS_REP"] = 1116;
        values[valuesById[1117] = "C2S_MSG_GET_GOODS"] = 1117;
        values[valuesById[1118] = "S2C_MSG_GET_GOODS_REP"] = 1118;
        values[valuesById[1119] = "C2S_MSG_CREATE_ORDER"] = 1119;
        values[valuesById[1120] = "S2C_MSG_CREATE_ORDER_REP"] = 1120;
        values[valuesById[1121] = "C2S_MSG_CONFIRM_ORDER"] = 1121;
        values[valuesById[1122] = "S2C_MSG_CONFIRM_ORDER_REP"] = 1122;
        values[valuesById[1123] = "C2S_MSG_GET_MY_ORDERS"] = 1123;
        values[valuesById[1124] = "S2C_MSG_GET_MY_ORDERS_REP"] = 1124;
        values[valuesById[1125] = "C2S_MSG_GET_ORDER_INFO"] = 1125;
        values[valuesById[1126] = "S2C_MSG_GET_ORDER_INFO_REP"] = 1126;
        values[valuesById[1127] = "C2S_MSG_GET_GOODS_BYID"] = 1127;
        values[valuesById[1128] = "S2C_MSG_GET_GOODS_BYID_REP"] = 1128;
        values[valuesById[1129] = "C2S_MSG_WITHDRAW_CHATMSG"] = 1129;
        values[valuesById[1130] = "S2C_MSG_WITHDRAW_CHATMSG_REP"] = 1130;
        values[valuesById[1131] = "C2S_MSG_CANCEL_ORDER"] = 1131;
        values[valuesById[1132] = "S2C_MSG_CANCEL_ORDER_REP"] = 1132;
        values[valuesById[1133] = "C2S_MSG_GET_GROUP_NICKNAME_LIST"] = 1133;
        values[valuesById[1134] = "S2C_MSG_GET_GROUP_NICKNAME_LIST_REP"] = 1134;
        values[valuesById[1135] = "C2S_MSG_SET_GROUP_NICKNAME"] = 1135;
        values[valuesById[1136] = "S2C_MSG_SET_GROUP_NICKNAME_REP"] = 1136;
        values[valuesById[1137] = "C2S_MSG_SET_ORDER_PAYTYPEID"] = 1137;
        values[valuesById[1138] = "S2C_MSG_SET_ORDER_PAYTYPEID_REP"] = 1138;
        values[valuesById[1139] = "C2S_MSG_GET_GOODS_DATA"] = 1139;
        values[valuesById[1140] = "S2C_MSG_GET_GOODS_DATA_REP"] = 1140;
        values[valuesById[1141] = "C2S_MSG_GET_GOODS_DETAIL_DATA"] = 1141;
        values[valuesById[1142] = "S2C_MSG_GET_GOODS_DETAIL_DATA_REP"] = 1142;
        values[valuesById[1143] = "C2S_MSG_OPER_SHOPCOIN"] = 1143;
        values[valuesById[1144] = "S2C_MSG_OPER_SHOPCOIN_REP"] = 1144;
        values[valuesById[1145] = "C2S_MSG_SET_SNAPCHAT"] = 1145;
        values[valuesById[1146] = "S2C_MSG_SET_SNAPCHAT_REP"] = 1146;
        values[valuesById[1147] = "C2S_MSG_GET_SNAPCHAT_LIST"] = 1147;
        values[valuesById[1148] = "S2C_MSG_GET_SNAPCHAT_LIST_REP"] = 1148;
        values[valuesById[1149] = "C2S_MSG_GET_SCREENSHOT"] = 1149;
        values[valuesById[1150] = "S2C_MSG_GET_SCREENSHOT_REP"] = 1150;
        values[valuesById[1151] = "C2S_MSG_SET_SCREENSHOT"] = 1151;
        values[valuesById[1152] = "S2C_MSG_SET_SCREENSHOT_REP"] = 1152;
        values[valuesById[1153] = "C2S_MSG_SET_GROUPSENDMSG_LIMIT"] = 1153;
        values[valuesById[1154] = "S2C_MSG_SET_GROUPSENDMSG_LIMIT_REP"] = 1154;
        values[valuesById[1155] = "C2S_MSG_GET_ORDER_INFO_BYID"] = 1155;
        values[valuesById[1156] = "S2C_MSG_GET_ORDER_INFO_BYID_REP"] = 1156;
        values[valuesById[1157] = "C2S_MSG_GET_BLACK_LIST"] = 1157;
        values[valuesById[1158] = "SC2_MSG_GET_BLACK_LIST_REP"] = 1158;
        values[valuesById[1159] = "C2S_MSG_SET_BLACK_LIST"] = 1159;
        values[valuesById[1160] = "SC2_MSG_SET_BLACK_LIST_REP"] = 1160;
        values[valuesById[1161] = "C2S_MSG_THIRD_PAY"] = 1161;
        values[valuesById[1162] = "S2C_MSG_THIRD_PAY_REP"] = 1162;
        values[valuesById[1163] = "C2S_MSG_PCAUTH"] = 1163;
        values[valuesById[1164] = "S2C_MSG_PCAUTH_REP"] = 1164;
        values[valuesById[1165] = "C2S_MSG_PCLOGIN"] = 1165;
        values[valuesById[1166] = "S2C_MSG_PCLOGIN_REP"] = 1166;
        values[valuesById[1167] = "C2S_MSG_VOICE_CALL"] = 1167;
        values[valuesById[1168] = "S2C_MSG_VOICE_CALL_REP"] = 1168;
        values[valuesById[1169] = "C2S_MSG_OPER_VOICE_CALL"] = 1169;
        values[valuesById[1170] = "S2C_MSG_OPER_VOICE_CALL_REP"] = 1170;
        values[valuesById[1171] = "C2S_MSG_VOICE_DATA"] = 1171;
        values[valuesById[1172] = "S2C_MSG_VOICE_DATA_REP"] = 1172;
        values[valuesById[1173] = "C2S_MSG_NEED_READ_GROUP_NOTIFY"] = 1173;
        values[valuesById[1174] = "S2C_MSG_NEED_READ_GROUP_NOTIFY_REP"] = 1174;
        values[valuesById[1175] = "C2S_MSG_READ_GROUP_NOTIFY"] = 1175;
        values[valuesById[1176] = "S2C_MSG_READ_GROUP_NOTIFY_REP"] = 1176;
        values[valuesById[1177] = "C2S_MSG_SET_FORBID_TM"] = 1177;
        values[valuesById[1178] = "S2C_MSG_SET_FORBID_TM_REP"] = 1178;
        values[valuesById[1179] = "C2S_MSG_GET_GROUP_MEMBER_LIST"] = 1179;
        values[valuesById[1180] = "S2C_MSG_GET_GROUP_MEMBER_LIST_REP"] = 1180;
        values[valuesById[1181] = "C2S_MSG_GET_FRIEND_INCR_LIST"] = 1181;
        values[valuesById[1182] = "S2C_MSG_GET_FRIEND_INCR_LIST_REP"] = 1182;
        values[valuesById[1183] = "C2S_MSG_BIND_OPENID"] = 1183;
        values[valuesById[1184] = "S2C_MSG_BING_OPENID_REP"] = 1184;
        values[valuesById[1185] = "C2S_MSG_H5LOGIN"] = 1185;
        values[valuesById[1186] = "S2C_MSG_H5LOGIN_REP"] = 1186;
        values[valuesById[1187] = "C2S_MSG_ADD_FRIEND_BYFID"] = 1187;
        values[valuesById[1188] = "S2C_MSG_ADD_FRIEND_BYFID_REP"] = 1188;
        values[valuesById[1189] = "C2S_MSG_SET_GROUP_HEADURL"] = 1189;
        values[valuesById[1190] = "S2C_MSG_SET_GROUP_HEADURL_REP"] = 1190;
        values[valuesById[1191] = "C2S_MSG_SET_COMPLETE_NAME"] = 1191;
        values[valuesById[1192] = "S2C_MSG_SET_COMPLETE_NAME_REP"] = 1192;
        values[valuesById[1193] = "C2S_MSG_SET_PHONENUM"] = 1193;
        values[valuesById[1194] = "S2C_MSG_SET_PHONENUM_REP"] = 1194;
        values[valuesById[1195] = "C2S_MSG_SET_PRIVACY"] = 1195;
        values[valuesById[1196] = "S2C_MSG_SET_PRIVACY_REP"] = 1196;
        values[valuesById[1301] = "C2S_MSG_GET_CHATROOM_LIST"] = 1301;
        values[valuesById[1302] = "S2C_MSG_GET_CHATROOM_LIST_REP"] = 1302;
        values[valuesById[1303] = "C2S_MSG_GET_CHATROOM_MEMBERS"] = 1303;
        values[valuesById[1304] = "S2C_MSG_GET_CHATROOM_MEMBERS_REP"] = 1304;
        values[valuesById[1305] = "C2S_MSG_JOIN_CHATROOM"] = 1305;
        values[valuesById[1306] = "S2C_MSG_JOIN_CHATROOM_REP"] = 1306;
        values[valuesById[1307] = "C2S_MSG_QUIT_CHATROOM"] = 1307;
        values[valuesById[1308] = "S2C_MSG_QUIT_CHATROOM_REP"] = 1308;
        values[valuesById[1309] = "C2S_MSG_SEND_CHATROOM_MSG"] = 1309;
        values[valuesById[1310] = "S2C_MSG_SEND_CHATROOM_MSG_REP"] = 1310;
        values[valuesById[1311] = "C2S_MSG_CHATROOM_KICKOUT"] = 1311;
        values[valuesById[1312] = "S2C_MSG_CHATROOM_KICKOUT_REP"] = 1312;
        values[valuesById[1313] = "C2S_MSG_CHATROOM_FORBID"] = 1313;
        values[valuesById[1314] = "S2C_MSG_CHATROOM_FORBID_REP"] = 1314;
        values[valuesById[1315] = "C2S_MSG_DEL_CHATROOM_MSG"] = 1315;
        values[valuesById[1316] = "S2C_MSG_DEL_CHATROOM_MSG_REP"] = 1316;
        values[valuesById[1317] = "C2S_MSG_CHATROOM_SET_ADMIN"] = 1317;
        values[valuesById[1318] = "S2C_MSG_CHATROOM_SET_ADMIN_REP"] = 1318;
        values[valuesById[1319] = "C2S_MSG_GET_CHATROOM_HISTORY_MSG"] = 1319;
        values[valuesById[1320] = "S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP"] = 1320;
        values[valuesById[1321] = "S2C_MSG_JOIN_CHATROOM_NTY"] = 1321;
        values[valuesById[1323] = "C2S_MSG_CHATROOM_NTY_MSG_TOALL"] = 1323;
        values[valuesById[1324] = "S2C_MSG_CHATROOM_NTY_MSG_TOALL_REP"] = 1324;
        values[valuesById[1325] = "C2S_MSG_SEND_CHATROOM_AD"] = 1325;
        values[valuesById[1326] = "S2C_MSG_SEND_CHATROOM_AD_REP"] = 1326;
        values[valuesById[1200] = "S2C_MSG_RED_NTY"] = 1200;
        values[valuesById[1201] = "S2C_MSG_LOGIN_OTHER_NTY"] = 1201;
        values[valuesById[1202] = "S2C_MSG_GROUP_BASE_NTY"] = 1202;
        values[valuesById[1203] = "S2C_MSG_GROUP_OPER_NTY"] = 1203;
        values[valuesById[1204] = "S2C_MSG_HANDLE_FRIEND_NTY"] = 1204;
        values[valuesById[1205] = "S2C_MSG_NEW_ORDER_NTY"] = 1205;
        values[valuesById[1206] = "S2C_MSG_GROUP_MEMBER_LIST_NTY"] = 1206;
        values[valuesById[1207] = "S2C_MSG_RATE_NTY"] = 1207;
        values[valuesById[1208] = "S2C_MSG_PC_FLOW_NTY"] = 1208;
        values[valuesById[1209] = "S2C_MSG_PC_DATA_NTY"] = 1209;
        values[valuesById[1210] = "S2C_MSG_VOICE_CALL_NTY"] = 1210;
        values[valuesById[1211] = "S2C_MSG_VOICE_DATA_NTY"] = 1211;
        values[valuesById[1212] = "S2C_MSG_FRIEND_STATE_NTY"] = 1212;
        return values;
    })();

    /**
     * SERVER_MSG_ID enum.
     * @name net.SERVER_MSG_ID
     * @enum {number}
     * @property {number} S2S_MSG_REGISTER=501 S2S_MSG_REGISTER value
     * @property {number} S2S_MSG_REGISTER_REP=502 S2S_MSG_REGISTER_REP value
     * @property {number} S2S_MSG_SYNC_BLACK_OPER=503 S2S_MSG_SYNC_BLACK_OPER value
     * @property {number} S2S_MSG_INCR_CHAT_VERSION=504 S2S_MSG_INCR_CHAT_VERSION value
     * @property {number} S2S_MSG_CHATMSG_RED_NTY=505 S2S_MSG_CHATMSG_RED_NTY value
     * @property {number} S2S_MSG_SYNC_SCREEN_SHOT=506 S2S_MSG_SYNC_SCREEN_SHOT value
     * @property {number} S2S_MSG_SYNC_FRIEND_APPLY=507 S2S_MSG_SYNC_FRIEND_APPLY value
     * @property {number} S2S_MSG_SYNC_OPER_FRIEND_APPLY=508 S2S_MSG_SYNC_OPER_FRIEND_APPLY value
     * @property {number} S2S_MSG_SYNC_FRIEND_RELATION=509 S2S_MSG_SYNC_FRIEND_RELATION value
     * @property {number} S2S_MSG_SYNC_GROUP_BROADCAST=510 S2S_MSG_SYNC_GROUP_BROADCAST value
     * @property {number} S2S_MSG_SYNC_VOICECALL=511 S2S_MSG_SYNC_VOICECALL value
     * @property {number} S2S_MSG_SYNC_OPER_VOICECALL=512 S2S_MSG_SYNC_OPER_VOICECALL value
     * @property {number} S2S_MSG_SYNC_OFFLINE_QUIT_CHATROOM=513 S2S_MSG_SYNC_OFFLINE_QUIT_CHATROOM value
     * @property {number} S2S_MSG_SYNC_USER_INFO=514 S2S_MSG_SYNC_USER_INFO value
     * @property {number} S2S_MSG_SYNC_FOLLOW_HOST=515 S2S_MSG_SYNC_FOLLOW_HOST value
     * @property {number} S2S_MSG_SYNC_CHATROOM_NTY_MSG=516 S2S_MSG_SYNC_CHATROOM_NTY_MSG value
     * @property {number} S2S_MSG_TRANS_TO_IMSVR=601 S2S_MSG_TRANS_TO_IMSVR value
     * @property {number} S2S_MSG_BROADCAST_TO_CLIENT=602 S2S_MSG_BROADCAST_TO_CLIENT value
     * @property {number} S2S_MSG_REPORT_STATE=603 S2S_MSG_REPORT_STATE value
     */
    net.SERVER_MSG_ID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[501] = "S2S_MSG_REGISTER"] = 501;
        values[valuesById[502] = "S2S_MSG_REGISTER_REP"] = 502;
        values[valuesById[503] = "S2S_MSG_SYNC_BLACK_OPER"] = 503;
        values[valuesById[504] = "S2S_MSG_INCR_CHAT_VERSION"] = 504;
        values[valuesById[505] = "S2S_MSG_CHATMSG_RED_NTY"] = 505;
        values[valuesById[506] = "S2S_MSG_SYNC_SCREEN_SHOT"] = 506;
        values[valuesById[507] = "S2S_MSG_SYNC_FRIEND_APPLY"] = 507;
        values[valuesById[508] = "S2S_MSG_SYNC_OPER_FRIEND_APPLY"] = 508;
        values[valuesById[509] = "S2S_MSG_SYNC_FRIEND_RELATION"] = 509;
        values[valuesById[510] = "S2S_MSG_SYNC_GROUP_BROADCAST"] = 510;
        values[valuesById[511] = "S2S_MSG_SYNC_VOICECALL"] = 511;
        values[valuesById[512] = "S2S_MSG_SYNC_OPER_VOICECALL"] = 512;
        values[valuesById[513] = "S2S_MSG_SYNC_OFFLINE_QUIT_CHATROOM"] = 513;
        values[valuesById[514] = "S2S_MSG_SYNC_USER_INFO"] = 514;
        values[valuesById[515] = "S2S_MSG_SYNC_FOLLOW_HOST"] = 515;
        values[valuesById[516] = "S2S_MSG_SYNC_CHATROOM_NTY_MSG"] = 516;
        values[valuesById[601] = "S2S_MSG_TRANS_TO_IMSVR"] = 601;
        values[valuesById[602] = "S2S_MSG_BROADCAST_TO_CLIENT"] = 602;
        values[valuesById[603] = "S2S_MSG_REPORT_STATE"] = 603;
        return values;
    })();

    /**
     * PHP_MSG_ID enum.
     * @name net.PHP_MSG_ID
     * @enum {number}
     * @property {number} PHP_MSG_THIRD_LOGIN=11 PHP_MSG_THIRD_LOGIN value
     * @property {number} PHP_MSG_CREATE_CHATROOM=12 PHP_MSG_CREATE_CHATROOM value
     * @property {number} PHP_MSG_DISMISS_CHATROOM=13 PHP_MSG_DISMISS_CHATROOM value
     * @property {number} PHP_MSG_KICK_CHATROOM_MEMBER=14 PHP_MSG_KICK_CHATROOM_MEMBER value
     * @property {number} PHP_MSG_SET_CHATROOMADMIN=15 PHP_MSG_SET_CHATROOMADMIN value
     * @property {number} PHP_MSG_SET_CHATROOM_FORBID=16 PHP_MSG_SET_CHATROOM_FORBID value
     * @property {number} PHP_MSG_GET_CHATROOM_MEMBER=17 PHP_MSG_GET_CHATROOM_MEMBER value
     * @property {number} PHP_MSG_GET_CHATROOM_LIST=18 PHP_MSG_GET_CHATROOM_LIST value
     * @property {number} PHP_MSG_GET_ALLCHATROOM_FORBID=19 PHP_MSG_GET_ALLCHATROOM_FORBID value
     * @property {number} PHP_MSG_GET_CHATROOM_INFO=20 PHP_MSG_GET_CHATROOM_INFO value
     * @property {number} PHP_MSG_SET_USERTYPE=21 PHP_MSG_SET_USERTYPE value
     * @property {number} PHP_MSG_GET_USER_SCORE=22 PHP_MSG_GET_USER_SCORE value
     * @property {number} PHP_MSG_CHANGE_USER_SCORE=23 PHP_MSG_CHANGE_USER_SCORE value
     * @property {number} PHP_MSG_SCORE_RECORDS=24 PHP_MSG_SCORE_RECORDS value
     * @property {number} PHP_MSG_SET_ALLCHATROOM_FORBID=25 PHP_MSG_SET_ALLCHATROOM_FORBID value
     * @property {number} PHP_MSG_GET_VIP_DATA=26 PHP_MSG_GET_VIP_DATA value
     * @property {number} PHP_MSG_ADD_VIP_EXP=27 PHP_MSG_ADD_VIP_EXP value
     * @property {number} PHP_MSG_VIP_REWARD=28 PHP_MSG_VIP_REWARD value
     * @property {number} PHP_MSG_INVITE_REG=29 PHP_MSG_INVITE_REG value
     * @property {number} PHP_MSG_REG_USER=30 PHP_MSG_REG_USER value
     * @property {number} PHP_MSG_SET_NAME=31 PHP_MSG_SET_NAME value
     * @property {number} PHP_MSG_FOLLOW_HOST=32 PHP_MSG_FOLLOW_HOST value
     */
    net.PHP_MSG_ID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[11] = "PHP_MSG_THIRD_LOGIN"] = 11;
        values[valuesById[12] = "PHP_MSG_CREATE_CHATROOM"] = 12;
        values[valuesById[13] = "PHP_MSG_DISMISS_CHATROOM"] = 13;
        values[valuesById[14] = "PHP_MSG_KICK_CHATROOM_MEMBER"] = 14;
        values[valuesById[15] = "PHP_MSG_SET_CHATROOMADMIN"] = 15;
        values[valuesById[16] = "PHP_MSG_SET_CHATROOM_FORBID"] = 16;
        values[valuesById[17] = "PHP_MSG_GET_CHATROOM_MEMBER"] = 17;
        values[valuesById[18] = "PHP_MSG_GET_CHATROOM_LIST"] = 18;
        values[valuesById[19] = "PHP_MSG_GET_ALLCHATROOM_FORBID"] = 19;
        values[valuesById[20] = "PHP_MSG_GET_CHATROOM_INFO"] = 20;
        values[valuesById[21] = "PHP_MSG_SET_USERTYPE"] = 21;
        values[valuesById[22] = "PHP_MSG_GET_USER_SCORE"] = 22;
        values[valuesById[23] = "PHP_MSG_CHANGE_USER_SCORE"] = 23;
        values[valuesById[24] = "PHP_MSG_SCORE_RECORDS"] = 24;
        values[valuesById[25] = "PHP_MSG_SET_ALLCHATROOM_FORBID"] = 25;
        values[valuesById[26] = "PHP_MSG_GET_VIP_DATA"] = 26;
        values[valuesById[27] = "PHP_MSG_ADD_VIP_EXP"] = 27;
        values[valuesById[28] = "PHP_MSG_VIP_REWARD"] = 28;
        values[valuesById[29] = "PHP_MSG_INVITE_REG"] = 29;
        values[valuesById[30] = "PHP_MSG_REG_USER"] = 30;
        values[valuesById[31] = "PHP_MSG_SET_NAME"] = 31;
        values[valuesById[32] = "PHP_MSG_FOLLOW_HOST"] = 32;
        return values;
    })();

    net.msg_register_svr = (function() {

        /**
         * Properties of a msg_register_svr.
         * @memberof net
         * @interface Imsg_register_svr
         * @property {number|null} [svrid] msg_register_svr svrid
         * @property {number|null} [svrtype] msg_register_svr svrtype
         */

        /**
         * Constructs a new msg_register_svr.
         * @memberof net
         * @classdesc Represents a msg_register_svr.
         * @implements Imsg_register_svr
         * @constructor
         * @param {net.Imsg_register_svr=} [properties] Properties to set
         */
        function msg_register_svr(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_register_svr svrid.
         * @member {number} svrid
         * @memberof net.msg_register_svr
         * @instance
         */
        msg_register_svr.prototype.svrid = 0;

        /**
         * msg_register_svr svrtype.
         * @member {number} svrtype
         * @memberof net.msg_register_svr
         * @instance
         */
        msg_register_svr.prototype.svrtype = 0;

        /**
         * Encodes the specified msg_register_svr message. Does not implicitly {@link net.msg_register_svr.verify|verify} messages.
         * @function encode
         * @memberof net.msg_register_svr
         * @static
         * @param {net.Imsg_register_svr} message msg_register_svr message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_register_svr.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.svrid != null && Object.hasOwnProperty.call(message, "svrid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.svrid);
            if (message.svrtype != null && Object.hasOwnProperty.call(message, "svrtype"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.svrtype);
            return writer;
        };

        /**
         * Decodes a msg_register_svr message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_register_svr
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_register_svr} msg_register_svr
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_register_svr.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_register_svr();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.svrid = reader.uint32();
                    break;
                case 2:
                    message.svrtype = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_register_svr;
    })();

    net.msg_register_svr_rep = (function() {

        /**
         * Properties of a msg_register_svr_rep.
         * @memberof net
         * @interface Imsg_register_svr_rep
         * @property {number|null} [result] msg_register_svr_rep result
         */

        /**
         * Constructs a new msg_register_svr_rep.
         * @memberof net
         * @classdesc Represents a msg_register_svr_rep.
         * @implements Imsg_register_svr_rep
         * @constructor
         * @param {net.Imsg_register_svr_rep=} [properties] Properties to set
         */
        function msg_register_svr_rep(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_register_svr_rep result.
         * @member {number} result
         * @memberof net.msg_register_svr_rep
         * @instance
         */
        msg_register_svr_rep.prototype.result = 0;

        /**
         * Encodes the specified msg_register_svr_rep message. Does not implicitly {@link net.msg_register_svr_rep.verify|verify} messages.
         * @function encode
         * @memberof net.msg_register_svr_rep
         * @static
         * @param {net.Imsg_register_svr_rep} message msg_register_svr_rep message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_register_svr_rep.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.result);
            return writer;
        };

        /**
         * Decodes a msg_register_svr_rep message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_register_svr_rep
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_register_svr_rep} msg_register_svr_rep
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_register_svr_rep.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_register_svr_rep();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.result = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_register_svr_rep;
    })();

    net.msg_sync_black_oper = (function() {

        /**
         * Properties of a msg_sync_black_oper.
         * @memberof net
         * @interface Imsg_sync_black_oper
         * @property {number|null} [uid] msg_sync_black_oper uid
         * @property {number|null} [otheruid] msg_sync_black_oper otheruid
         * @property {number|null} [opertype] msg_sync_black_oper opertype
         */

        /**
         * Constructs a new msg_sync_black_oper.
         * @memberof net
         * @classdesc Represents a msg_sync_black_oper.
         * @implements Imsg_sync_black_oper
         * @constructor
         * @param {net.Imsg_sync_black_oper=} [properties] Properties to set
         */
        function msg_sync_black_oper(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_black_oper uid.
         * @member {number} uid
         * @memberof net.msg_sync_black_oper
         * @instance
         */
        msg_sync_black_oper.prototype.uid = 0;

        /**
         * msg_sync_black_oper otheruid.
         * @member {number} otheruid
         * @memberof net.msg_sync_black_oper
         * @instance
         */
        msg_sync_black_oper.prototype.otheruid = 0;

        /**
         * msg_sync_black_oper opertype.
         * @member {number} opertype
         * @memberof net.msg_sync_black_oper
         * @instance
         */
        msg_sync_black_oper.prototype.opertype = 0;

        /**
         * Encodes the specified msg_sync_black_oper message. Does not implicitly {@link net.msg_sync_black_oper.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_black_oper
         * @static
         * @param {net.Imsg_sync_black_oper} message msg_sync_black_oper message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_black_oper.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uid);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.otheruid);
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.opertype);
            return writer;
        };

        /**
         * Decodes a msg_sync_black_oper message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_black_oper
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_black_oper} msg_sync_black_oper
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_black_oper.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_black_oper();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.uint32();
                    break;
                case 3:
                    message.opertype = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_black_oper;
    })();

    net.msg_incr_chat_version = (function() {

        /**
         * Properties of a msg_incr_chat_version.
         * @memberof net
         * @interface Imsg_incr_chat_version
         * @property {number|null} [uid] msg_incr_chat_version uid
         * @property {number|Long|null} [chatkey] msg_incr_chat_version chatkey
         */

        /**
         * Constructs a new msg_incr_chat_version.
         * @memberof net
         * @classdesc Represents a msg_incr_chat_version.
         * @implements Imsg_incr_chat_version
         * @constructor
         * @param {net.Imsg_incr_chat_version=} [properties] Properties to set
         */
        function msg_incr_chat_version(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_incr_chat_version uid.
         * @member {number} uid
         * @memberof net.msg_incr_chat_version
         * @instance
         */
        msg_incr_chat_version.prototype.uid = 0;

        /**
         * msg_incr_chat_version chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_incr_chat_version
         * @instance
         */
        msg_incr_chat_version.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_incr_chat_version message. Does not implicitly {@link net.msg_incr_chat_version.verify|verify} messages.
         * @function encode
         * @memberof net.msg_incr_chat_version
         * @static
         * @param {net.Imsg_incr_chat_version} message msg_incr_chat_version message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_incr_chat_version.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uid);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            return writer;
        };

        /**
         * Decodes a msg_incr_chat_version message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_incr_chat_version
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_incr_chat_version} msg_incr_chat_version
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_incr_chat_version.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_incr_chat_version();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.uint32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_incr_chat_version;
    })();

    net.msg_chatmsg_red_nty = (function() {

        /**
         * Properties of a msg_chatmsg_red_nty.
         * @memberof net
         * @interface Imsg_chatmsg_red_nty
         * @property {number|null} [recvuid] msg_chatmsg_red_nty recvuid
         * @property {number|null} [redtype] msg_chatmsg_red_nty redtype
         * @property {number|null} [nopush] msg_chatmsg_red_nty nopush
         * @property {net.Ichat_msg|null} [msg_info] msg_chatmsg_red_nty msg_info
         */

        /**
         * Constructs a new msg_chatmsg_red_nty.
         * @memberof net
         * @classdesc Represents a msg_chatmsg_red_nty.
         * @implements Imsg_chatmsg_red_nty
         * @constructor
         * @param {net.Imsg_chatmsg_red_nty=} [properties] Properties to set
         */
        function msg_chatmsg_red_nty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_chatmsg_red_nty recvuid.
         * @member {number} recvuid
         * @memberof net.msg_chatmsg_red_nty
         * @instance
         */
        msg_chatmsg_red_nty.prototype.recvuid = 0;

        /**
         * msg_chatmsg_red_nty redtype.
         * @member {number} redtype
         * @memberof net.msg_chatmsg_red_nty
         * @instance
         */
        msg_chatmsg_red_nty.prototype.redtype = 0;

        /**
         * msg_chatmsg_red_nty nopush.
         * @member {number} nopush
         * @memberof net.msg_chatmsg_red_nty
         * @instance
         */
        msg_chatmsg_red_nty.prototype.nopush = 0;

        /**
         * msg_chatmsg_red_nty msg_info.
         * @member {net.Ichat_msg|null|undefined} msg_info
         * @memberof net.msg_chatmsg_red_nty
         * @instance
         */
        msg_chatmsg_red_nty.prototype.msg_info = null;

        /**
         * Encodes the specified msg_chatmsg_red_nty message. Does not implicitly {@link net.msg_chatmsg_red_nty.verify|verify} messages.
         * @function encode
         * @memberof net.msg_chatmsg_red_nty
         * @static
         * @param {net.Imsg_chatmsg_red_nty} message msg_chatmsg_red_nty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_chatmsg_red_nty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recvuid != null && Object.hasOwnProperty.call(message, "recvuid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.recvuid);
            if (message.redtype != null && Object.hasOwnProperty.call(message, "redtype"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.redtype);
            if (message.nopush != null && Object.hasOwnProperty.call(message, "nopush"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.nopush);
            if (message.msg_info != null && Object.hasOwnProperty.call(message, "msg_info"))
                $root.net.chat_msg.encode(message.msg_info, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_chatmsg_red_nty message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_chatmsg_red_nty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_chatmsg_red_nty} msg_chatmsg_red_nty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_chatmsg_red_nty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_chatmsg_red_nty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.recvuid = reader.uint32();
                    break;
                case 2:
                    message.redtype = reader.uint32();
                    break;
                case 3:
                    message.nopush = reader.uint32();
                    break;
                case 4:
                    message.msg_info = $root.net.chat_msg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_chatmsg_red_nty;
    })();

    net.msg_sync_screen_shot = (function() {

        /**
         * Properties of a msg_sync_screen_shot.
         * @memberof net
         * @interface Imsg_sync_screen_shot
         * @property {number|Long|null} [chatkey] msg_sync_screen_shot chatkey
         * @property {number|null} [ss] msg_sync_screen_shot ss
         */

        /**
         * Constructs a new msg_sync_screen_shot.
         * @memberof net
         * @classdesc Represents a msg_sync_screen_shot.
         * @implements Imsg_sync_screen_shot
         * @constructor
         * @param {net.Imsg_sync_screen_shot=} [properties] Properties to set
         */
        function msg_sync_screen_shot(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_screen_shot chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_sync_screen_shot
         * @instance
         */
        msg_sync_screen_shot.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * msg_sync_screen_shot ss.
         * @member {number} ss
         * @memberof net.msg_sync_screen_shot
         * @instance
         */
        msg_sync_screen_shot.prototype.ss = 0;

        /**
         * Encodes the specified msg_sync_screen_shot message. Does not implicitly {@link net.msg_sync_screen_shot.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_screen_shot
         * @static
         * @param {net.Imsg_sync_screen_shot} message msg_sync_screen_shot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_screen_shot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.chatkey);
            if (message.ss != null && Object.hasOwnProperty.call(message, "ss"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.ss);
            return writer;
        };

        /**
         * Decodes a msg_sync_screen_shot message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_screen_shot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_screen_shot} msg_sync_screen_shot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_screen_shot.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_screen_shot();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatkey = reader.int64();
                    break;
                case 2:
                    message.ss = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_screen_shot;
    })();

    net.msg_sync_friend_apply = (function() {

        /**
         * Properties of a msg_sync_friend_apply.
         * @memberof net
         * @interface Imsg_sync_friend_apply
         * @property {number|null} [uid] msg_sync_friend_apply uid
         * @property {number|null} [otheruid] msg_sync_friend_apply otheruid
         * @property {Uint8Array|null} [hellomsg] msg_sync_friend_apply hellomsg
         */

        /**
         * Constructs a new msg_sync_friend_apply.
         * @memberof net
         * @classdesc Represents a msg_sync_friend_apply.
         * @implements Imsg_sync_friend_apply
         * @constructor
         * @param {net.Imsg_sync_friend_apply=} [properties] Properties to set
         */
        function msg_sync_friend_apply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_friend_apply uid.
         * @member {number} uid
         * @memberof net.msg_sync_friend_apply
         * @instance
         */
        msg_sync_friend_apply.prototype.uid = 0;

        /**
         * msg_sync_friend_apply otheruid.
         * @member {number} otheruid
         * @memberof net.msg_sync_friend_apply
         * @instance
         */
        msg_sync_friend_apply.prototype.otheruid = 0;

        /**
         * msg_sync_friend_apply hellomsg.
         * @member {Uint8Array} hellomsg
         * @memberof net.msg_sync_friend_apply
         * @instance
         */
        msg_sync_friend_apply.prototype.hellomsg = $util.newBuffer([]);

        /**
         * Encodes the specified msg_sync_friend_apply message. Does not implicitly {@link net.msg_sync_friend_apply.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_friend_apply
         * @static
         * @param {net.Imsg_sync_friend_apply} message msg_sync_friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_friend_apply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uid);
            if (message.otheruid != null && Object.hasOwnProperty.call(message, "otheruid"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.otheruid);
            if (message.hellomsg != null && Object.hasOwnProperty.call(message, "hellomsg"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.hellomsg);
            return writer;
        };

        /**
         * Decodes a msg_sync_friend_apply message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_friend_apply} msg_sync_friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_friend_apply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_friend_apply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.uint32();
                    break;
                case 2:
                    message.otheruid = reader.uint32();
                    break;
                case 3:
                    message.hellomsg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_friend_apply;
    })();

    net.msg_sync_oper_friend_apply = (function() {

        /**
         * Properties of a msg_sync_oper_friend_apply.
         * @memberof net
         * @interface Imsg_sync_oper_friend_apply
         * @property {net.Ibase_info|null} [user_info] msg_sync_oper_friend_apply user_info
         * @property {number|null} [applyuid] msg_sync_oper_friend_apply applyuid
         * @property {number|null} [handletype] msg_sync_oper_friend_apply handletype
         */

        /**
         * Constructs a new msg_sync_oper_friend_apply.
         * @memberof net
         * @classdesc Represents a msg_sync_oper_friend_apply.
         * @implements Imsg_sync_oper_friend_apply
         * @constructor
         * @param {net.Imsg_sync_oper_friend_apply=} [properties] Properties to set
         */
        function msg_sync_oper_friend_apply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_oper_friend_apply user_info.
         * @member {net.Ibase_info|null|undefined} user_info
         * @memberof net.msg_sync_oper_friend_apply
         * @instance
         */
        msg_sync_oper_friend_apply.prototype.user_info = null;

        /**
         * msg_sync_oper_friend_apply applyuid.
         * @member {number} applyuid
         * @memberof net.msg_sync_oper_friend_apply
         * @instance
         */
        msg_sync_oper_friend_apply.prototype.applyuid = 0;

        /**
         * msg_sync_oper_friend_apply handletype.
         * @member {number} handletype
         * @memberof net.msg_sync_oper_friend_apply
         * @instance
         */
        msg_sync_oper_friend_apply.prototype.handletype = 0;

        /**
         * Encodes the specified msg_sync_oper_friend_apply message. Does not implicitly {@link net.msg_sync_oper_friend_apply.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_oper_friend_apply
         * @static
         * @param {net.Imsg_sync_oper_friend_apply} message msg_sync_oper_friend_apply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_oper_friend_apply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.user_info != null && Object.hasOwnProperty.call(message, "user_info"))
                $root.net.base_info.encode(message.user_info, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.applyuid != null && Object.hasOwnProperty.call(message, "applyuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.applyuid);
            if (message.handletype != null && Object.hasOwnProperty.call(message, "handletype"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.handletype);
            return writer;
        };

        /**
         * Decodes a msg_sync_oper_friend_apply message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_oper_friend_apply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_oper_friend_apply} msg_sync_oper_friend_apply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_oper_friend_apply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_oper_friend_apply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.user_info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.applyuid = reader.uint32();
                    break;
                case 3:
                    message.handletype = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_oper_friend_apply;
    })();

    net.msg_sync_friend_relation = (function() {

        /**
         * Properties of a msg_sync_friend_relation.
         * @memberof net
         * @interface Imsg_sync_friend_relation
         * @property {number|null} [uid] msg_sync_friend_relation uid
         * @property {number|null} [uid1] msg_sync_friend_relation uid1
         * @property {number|null} [uid2] msg_sync_friend_relation uid2
         * @property {number|null} [delstate1] msg_sync_friend_relation delstate1
         * @property {number|null} [delstate2] msg_sync_friend_relation delstate2
         * @property {number|null} [ptime] msg_sync_friend_relation ptime
         */

        /**
         * Constructs a new msg_sync_friend_relation.
         * @memberof net
         * @classdesc Represents a msg_sync_friend_relation.
         * @implements Imsg_sync_friend_relation
         * @constructor
         * @param {net.Imsg_sync_friend_relation=} [properties] Properties to set
         */
        function msg_sync_friend_relation(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_friend_relation uid.
         * @member {number} uid
         * @memberof net.msg_sync_friend_relation
         * @instance
         */
        msg_sync_friend_relation.prototype.uid = 0;

        /**
         * msg_sync_friend_relation uid1.
         * @member {number} uid1
         * @memberof net.msg_sync_friend_relation
         * @instance
         */
        msg_sync_friend_relation.prototype.uid1 = 0;

        /**
         * msg_sync_friend_relation uid2.
         * @member {number} uid2
         * @memberof net.msg_sync_friend_relation
         * @instance
         */
        msg_sync_friend_relation.prototype.uid2 = 0;

        /**
         * msg_sync_friend_relation delstate1.
         * @member {number} delstate1
         * @memberof net.msg_sync_friend_relation
         * @instance
         */
        msg_sync_friend_relation.prototype.delstate1 = 0;

        /**
         * msg_sync_friend_relation delstate2.
         * @member {number} delstate2
         * @memberof net.msg_sync_friend_relation
         * @instance
         */
        msg_sync_friend_relation.prototype.delstate2 = 0;

        /**
         * msg_sync_friend_relation ptime.
         * @member {number} ptime
         * @memberof net.msg_sync_friend_relation
         * @instance
         */
        msg_sync_friend_relation.prototype.ptime = 0;

        /**
         * Encodes the specified msg_sync_friend_relation message. Does not implicitly {@link net.msg_sync_friend_relation.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_friend_relation
         * @static
         * @param {net.Imsg_sync_friend_relation} message msg_sync_friend_relation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_friend_relation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uid);
            if (message.uid1 != null && Object.hasOwnProperty.call(message, "uid1"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.uid1);
            if (message.uid2 != null && Object.hasOwnProperty.call(message, "uid2"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.uid2);
            if (message.delstate1 != null && Object.hasOwnProperty.call(message, "delstate1"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.delstate1);
            if (message.delstate2 != null && Object.hasOwnProperty.call(message, "delstate2"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.delstate2);
            if (message.ptime != null && Object.hasOwnProperty.call(message, "ptime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ptime);
            return writer;
        };

        /**
         * Decodes a msg_sync_friend_relation message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_friend_relation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_friend_relation} msg_sync_friend_relation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_friend_relation.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_friend_relation();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.uint32();
                    break;
                case 2:
                    message.uid1 = reader.uint32();
                    break;
                case 3:
                    message.uid2 = reader.uint32();
                    break;
                case 4:
                    message.delstate1 = reader.uint32();
                    break;
                case 5:
                    message.delstate2 = reader.uint32();
                    break;
                case 6:
                    message.ptime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_friend_relation;
    })();

    net.msg_sync_group_broadcast = (function() {

        /**
         * Properties of a msg_sync_group_broadcast.
         * @memberof net
         * @interface Imsg_sync_group_broadcast
         * @property {Array.<number>|null} [uids] msg_sync_group_broadcast uids
         * @property {number|null} [groupkey] msg_sync_group_broadcast groupkey
         * @property {number|null} [redtype] msg_sync_group_broadcast redtype
         * @property {number|null} [uid] msg_sync_group_broadcast uid
         * @property {Uint8Array|null} [content] msg_sync_group_broadcast content
         * @property {number|null} [exceptuid] msg_sync_group_broadcast exceptuid
         * @property {number|null} [msgtype] msg_sync_group_broadcast msgtype
         */

        /**
         * Constructs a new msg_sync_group_broadcast.
         * @memberof net
         * @classdesc Represents a msg_sync_group_broadcast.
         * @implements Imsg_sync_group_broadcast
         * @constructor
         * @param {net.Imsg_sync_group_broadcast=} [properties] Properties to set
         */
        function msg_sync_group_broadcast(properties) {
            this.uids = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_group_broadcast uids.
         * @member {Array.<number>} uids
         * @memberof net.msg_sync_group_broadcast
         * @instance
         */
        msg_sync_group_broadcast.prototype.uids = $util.emptyArray;

        /**
         * msg_sync_group_broadcast groupkey.
         * @member {number} groupkey
         * @memberof net.msg_sync_group_broadcast
         * @instance
         */
        msg_sync_group_broadcast.prototype.groupkey = 0;

        /**
         * msg_sync_group_broadcast redtype.
         * @member {number} redtype
         * @memberof net.msg_sync_group_broadcast
         * @instance
         */
        msg_sync_group_broadcast.prototype.redtype = 0;

        /**
         * msg_sync_group_broadcast uid.
         * @member {number} uid
         * @memberof net.msg_sync_group_broadcast
         * @instance
         */
        msg_sync_group_broadcast.prototype.uid = 0;

        /**
         * msg_sync_group_broadcast content.
         * @member {Uint8Array} content
         * @memberof net.msg_sync_group_broadcast
         * @instance
         */
        msg_sync_group_broadcast.prototype.content = $util.newBuffer([]);

        /**
         * msg_sync_group_broadcast exceptuid.
         * @member {number} exceptuid
         * @memberof net.msg_sync_group_broadcast
         * @instance
         */
        msg_sync_group_broadcast.prototype.exceptuid = 0;

        /**
         * msg_sync_group_broadcast msgtype.
         * @member {number} msgtype
         * @memberof net.msg_sync_group_broadcast
         * @instance
         */
        msg_sync_group_broadcast.prototype.msgtype = 0;

        /**
         * Encodes the specified msg_sync_group_broadcast message. Does not implicitly {@link net.msg_sync_group_broadcast.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_group_broadcast
         * @static
         * @param {net.Imsg_sync_group_broadcast} message msg_sync_group_broadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_group_broadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uids != null && message.uids.length)
                for (var i = 0; i < message.uids.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uids[i]);
            if (message.groupkey != null && Object.hasOwnProperty.call(message, "groupkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupkey);
            if (message.redtype != null && Object.hasOwnProperty.call(message, "redtype"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.redtype);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.uid);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.content);
            if (message.exceptuid != null && Object.hasOwnProperty.call(message, "exceptuid"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.exceptuid);
            if (message.msgtype != null && Object.hasOwnProperty.call(message, "msgtype"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.msgtype);
            return writer;
        };

        /**
         * Decodes a msg_sync_group_broadcast message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_group_broadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_group_broadcast} msg_sync_group_broadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_group_broadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_group_broadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uids && message.uids.length))
                        message.uids = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uids.push(reader.uint32());
                    } else
                        message.uids.push(reader.uint32());
                    break;
                case 2:
                    message.groupkey = reader.int32();
                    break;
                case 3:
                    message.redtype = reader.int32();
                    break;
                case 4:
                    message.uid = reader.int32();
                    break;
                case 5:
                    message.content = reader.bytes();
                    break;
                case 6:
                    message.exceptuid = reader.int32();
                    break;
                case 7:
                    message.msgtype = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_group_broadcast;
    })();

    net.msg_sync_voicecall = (function() {

        /**
         * Properties of a msg_sync_voicecall.
         * @memberof net
         * @interface Imsg_sync_voicecall
         * @property {number|null} [uid] msg_sync_voicecall uid
         * @property {number|null} [destuid] msg_sync_voicecall destuid
         * @property {Uint8Array|null} [token] msg_sync_voicecall token
         */

        /**
         * Constructs a new msg_sync_voicecall.
         * @memberof net
         * @classdesc Represents a msg_sync_voicecall.
         * @implements Imsg_sync_voicecall
         * @constructor
         * @param {net.Imsg_sync_voicecall=} [properties] Properties to set
         */
        function msg_sync_voicecall(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_voicecall uid.
         * @member {number} uid
         * @memberof net.msg_sync_voicecall
         * @instance
         */
        msg_sync_voicecall.prototype.uid = 0;

        /**
         * msg_sync_voicecall destuid.
         * @member {number} destuid
         * @memberof net.msg_sync_voicecall
         * @instance
         */
        msg_sync_voicecall.prototype.destuid = 0;

        /**
         * msg_sync_voicecall token.
         * @member {Uint8Array} token
         * @memberof net.msg_sync_voicecall
         * @instance
         */
        msg_sync_voicecall.prototype.token = $util.newBuffer([]);

        /**
         * Encodes the specified msg_sync_voicecall message. Does not implicitly {@link net.msg_sync_voicecall.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_voicecall
         * @static
         * @param {net.Imsg_sync_voicecall} message msg_sync_voicecall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_voicecall.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.destuid != null && Object.hasOwnProperty.call(message, "destuid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.destuid);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.token);
            return writer;
        };

        /**
         * Decodes a msg_sync_voicecall message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_voicecall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_voicecall} msg_sync_voicecall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_voicecall.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_voicecall();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.destuid = reader.int32();
                    break;
                case 3:
                    message.token = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_voicecall;
    })();

    net.msg_sync_oper_voicecall = (function() {

        /**
         * Properties of a msg_sync_oper_voicecall.
         * @memberof net
         * @interface Imsg_sync_oper_voicecall
         * @property {number|null} [opertype] msg_sync_oper_voicecall opertype
         * @property {number|Long|null} [chatkey] msg_sync_oper_voicecall chatkey
         */

        /**
         * Constructs a new msg_sync_oper_voicecall.
         * @memberof net
         * @classdesc Represents a msg_sync_oper_voicecall.
         * @implements Imsg_sync_oper_voicecall
         * @constructor
         * @param {net.Imsg_sync_oper_voicecall=} [properties] Properties to set
         */
        function msg_sync_oper_voicecall(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_oper_voicecall opertype.
         * @member {number} opertype
         * @memberof net.msg_sync_oper_voicecall
         * @instance
         */
        msg_sync_oper_voicecall.prototype.opertype = 0;

        /**
         * msg_sync_oper_voicecall chatkey.
         * @member {number|Long} chatkey
         * @memberof net.msg_sync_oper_voicecall
         * @instance
         */
        msg_sync_oper_voicecall.prototype.chatkey = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Encodes the specified msg_sync_oper_voicecall message. Does not implicitly {@link net.msg_sync_oper_voicecall.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_oper_voicecall
         * @static
         * @param {net.Imsg_sync_oper_voicecall} message msg_sync_oper_voicecall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_oper_voicecall.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.opertype != null && Object.hasOwnProperty.call(message, "opertype"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.opertype);
            if (message.chatkey != null && Object.hasOwnProperty.call(message, "chatkey"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.chatkey);
            return writer;
        };

        /**
         * Decodes a msg_sync_oper_voicecall message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_oper_voicecall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_oper_voicecall} msg_sync_oper_voicecall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_oper_voicecall.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_oper_voicecall();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.opertype = reader.int32();
                    break;
                case 2:
                    message.chatkey = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_oper_voicecall;
    })();

    net.msg_sync_offline_quit_chatroom = (function() {

        /**
         * Properties of a msg_sync_offline_quit_chatroom.
         * @memberof net
         * @interface Imsg_sync_offline_quit_chatroom
         * @property {number|null} [uid] msg_sync_offline_quit_chatroom uid
         */

        /**
         * Constructs a new msg_sync_offline_quit_chatroom.
         * @memberof net
         * @classdesc Represents a msg_sync_offline_quit_chatroom.
         * @implements Imsg_sync_offline_quit_chatroom
         * @constructor
         * @param {net.Imsg_sync_offline_quit_chatroom=} [properties] Properties to set
         */
        function msg_sync_offline_quit_chatroom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_offline_quit_chatroom uid.
         * @member {number} uid
         * @memberof net.msg_sync_offline_quit_chatroom
         * @instance
         */
        msg_sync_offline_quit_chatroom.prototype.uid = 0;

        /**
         * Encodes the specified msg_sync_offline_quit_chatroom message. Does not implicitly {@link net.msg_sync_offline_quit_chatroom.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_offline_quit_chatroom
         * @static
         * @param {net.Imsg_sync_offline_quit_chatroom} message msg_sync_offline_quit_chatroom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_offline_quit_chatroom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_sync_offline_quit_chatroom message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_offline_quit_chatroom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_offline_quit_chatroom} msg_sync_offline_quit_chatroom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_offline_quit_chatroom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_offline_quit_chatroom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_offline_quit_chatroom;
    })();

    net.msg_sync_user_info = (function() {

        /**
         * Properties of a msg_sync_user_info.
         * @memberof net
         * @interface Imsg_sync_user_info
         * @property {net.Ibase_info|null} [uinfo] msg_sync_user_info uinfo
         */

        /**
         * Constructs a new msg_sync_user_info.
         * @memberof net
         * @classdesc Represents a msg_sync_user_info.
         * @implements Imsg_sync_user_info
         * @constructor
         * @param {net.Imsg_sync_user_info=} [properties] Properties to set
         */
        function msg_sync_user_info(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_user_info uinfo.
         * @member {net.Ibase_info|null|undefined} uinfo
         * @memberof net.msg_sync_user_info
         * @instance
         */
        msg_sync_user_info.prototype.uinfo = null;

        /**
         * Encodes the specified msg_sync_user_info message. Does not implicitly {@link net.msg_sync_user_info.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_user_info
         * @static
         * @param {net.Imsg_sync_user_info} message msg_sync_user_info message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_user_info.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uinfo != null && Object.hasOwnProperty.call(message, "uinfo"))
                $root.net.base_info.encode(message.uinfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_sync_user_info message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_user_info
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_user_info} msg_sync_user_info
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_user_info.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_user_info();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uinfo = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_user_info;
    })();

    net.msg_sync_follow_host = (function() {

        /**
         * Properties of a msg_sync_follow_host.
         * @memberof net
         * @interface Imsg_sync_follow_host
         * @property {number|null} [uid] msg_sync_follow_host uid
         * @property {number|null} [host] msg_sync_follow_host host
         * @property {net.Ibase_info|null} [user_info] msg_sync_follow_host user_info
         */

        /**
         * Constructs a new msg_sync_follow_host.
         * @memberof net
         * @classdesc Represents a msg_sync_follow_host.
         * @implements Imsg_sync_follow_host
         * @constructor
         * @param {net.Imsg_sync_follow_host=} [properties] Properties to set
         */
        function msg_sync_follow_host(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_follow_host uid.
         * @member {number} uid
         * @memberof net.msg_sync_follow_host
         * @instance
         */
        msg_sync_follow_host.prototype.uid = 0;

        /**
         * msg_sync_follow_host host.
         * @member {number} host
         * @memberof net.msg_sync_follow_host
         * @instance
         */
        msg_sync_follow_host.prototype.host = 0;

        /**
         * msg_sync_follow_host user_info.
         * @member {net.Ibase_info|null|undefined} user_info
         * @memberof net.msg_sync_follow_host
         * @instance
         */
        msg_sync_follow_host.prototype.user_info = null;

        /**
         * Encodes the specified msg_sync_follow_host message. Does not implicitly {@link net.msg_sync_follow_host.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_follow_host
         * @static
         * @param {net.Imsg_sync_follow_host} message msg_sync_follow_host message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_follow_host.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.host != null && Object.hasOwnProperty.call(message, "host"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.host);
            if (message.user_info != null && Object.hasOwnProperty.call(message, "user_info"))
                $root.net.base_info.encode(message.user_info, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a msg_sync_follow_host message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_follow_host
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_follow_host} msg_sync_follow_host
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_follow_host.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_follow_host();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    message.host = reader.int32();
                    break;
                case 3:
                    message.user_info = $root.net.base_info.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_follow_host;
    })();

    net.msg_sync_chatroom_nty_msg = (function() {

        /**
         * Properties of a msg_sync_chatroom_nty_msg.
         * @memberof net
         * @interface Imsg_sync_chatroom_nty_msg
         * @property {number|null} [uid] msg_sync_chatroom_nty_msg uid
         * @property {Array.<number>|null} [uid_vec] msg_sync_chatroom_nty_msg uid_vec
         * @property {Uint8Array|null} [content] msg_sync_chatroom_nty_msg content
         */

        /**
         * Constructs a new msg_sync_chatroom_nty_msg.
         * @memberof net
         * @classdesc Represents a msg_sync_chatroom_nty_msg.
         * @implements Imsg_sync_chatroom_nty_msg
         * @constructor
         * @param {net.Imsg_sync_chatroom_nty_msg=} [properties] Properties to set
         */
        function msg_sync_chatroom_nty_msg(properties) {
            this.uid_vec = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_sync_chatroom_nty_msg uid.
         * @member {number} uid
         * @memberof net.msg_sync_chatroom_nty_msg
         * @instance
         */
        msg_sync_chatroom_nty_msg.prototype.uid = 0;

        /**
         * msg_sync_chatroom_nty_msg uid_vec.
         * @member {Array.<number>} uid_vec
         * @memberof net.msg_sync_chatroom_nty_msg
         * @instance
         */
        msg_sync_chatroom_nty_msg.prototype.uid_vec = $util.emptyArray;

        /**
         * msg_sync_chatroom_nty_msg content.
         * @member {Uint8Array} content
         * @memberof net.msg_sync_chatroom_nty_msg
         * @instance
         */
        msg_sync_chatroom_nty_msg.prototype.content = $util.newBuffer([]);

        /**
         * Encodes the specified msg_sync_chatroom_nty_msg message. Does not implicitly {@link net.msg_sync_chatroom_nty_msg.verify|verify} messages.
         * @function encode
         * @memberof net.msg_sync_chatroom_nty_msg
         * @static
         * @param {net.Imsg_sync_chatroom_nty_msg} message msg_sync_chatroom_nty_msg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_sync_chatroom_nty_msg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.uid);
            if (message.uid_vec != null && message.uid_vec.length)
                for (var i = 0; i < message.uid_vec.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.uid_vec[i]);
            if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.content);
            return writer;
        };

        /**
         * Decodes a msg_sync_chatroom_nty_msg message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_sync_chatroom_nty_msg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_sync_chatroom_nty_msg} msg_sync_chatroom_nty_msg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_sync_chatroom_nty_msg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_sync_chatroom_nty_msg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int32();
                    break;
                case 2:
                    if (!(message.uid_vec && message.uid_vec.length))
                        message.uid_vec = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uid_vec.push(reader.int32());
                    } else
                        message.uid_vec.push(reader.int32());
                    break;
                case 3:
                    message.content = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_sync_chatroom_nty_msg;
    })();

    net.msg_trans_to_imsvr = (function() {

        /**
         * Properties of a msg_trans_to_imsvr.
         * @memberof net
         * @interface Imsg_trans_to_imsvr
         * @property {number|null} [cmd] msg_trans_to_imsvr cmd
         * @property {number|null} [svrid] msg_trans_to_imsvr svrid
         * @property {Uint8Array|null} [data] msg_trans_to_imsvr data
         * @property {number|null} [uid] msg_trans_to_imsvr uid
         */

        /**
         * Constructs a new msg_trans_to_imsvr.
         * @memberof net
         * @classdesc Represents a msg_trans_to_imsvr.
         * @implements Imsg_trans_to_imsvr
         * @constructor
         * @param {net.Imsg_trans_to_imsvr=} [properties] Properties to set
         */
        function msg_trans_to_imsvr(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_trans_to_imsvr cmd.
         * @member {number} cmd
         * @memberof net.msg_trans_to_imsvr
         * @instance
         */
        msg_trans_to_imsvr.prototype.cmd = 0;

        /**
         * msg_trans_to_imsvr svrid.
         * @member {number} svrid
         * @memberof net.msg_trans_to_imsvr
         * @instance
         */
        msg_trans_to_imsvr.prototype.svrid = 0;

        /**
         * msg_trans_to_imsvr data.
         * @member {Uint8Array} data
         * @memberof net.msg_trans_to_imsvr
         * @instance
         */
        msg_trans_to_imsvr.prototype.data = $util.newBuffer([]);

        /**
         * msg_trans_to_imsvr uid.
         * @member {number} uid
         * @memberof net.msg_trans_to_imsvr
         * @instance
         */
        msg_trans_to_imsvr.prototype.uid = 0;

        /**
         * Encodes the specified msg_trans_to_imsvr message. Does not implicitly {@link net.msg_trans_to_imsvr.verify|verify} messages.
         * @function encode
         * @memberof net.msg_trans_to_imsvr
         * @static
         * @param {net.Imsg_trans_to_imsvr} message msg_trans_to_imsvr message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_trans_to_imsvr.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.cmd != null && Object.hasOwnProperty.call(message, "cmd"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.cmd);
            if (message.svrid != null && Object.hasOwnProperty.call(message, "svrid"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.svrid);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.uid);
            return writer;
        };

        /**
         * Decodes a msg_trans_to_imsvr message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_trans_to_imsvr
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_trans_to_imsvr} msg_trans_to_imsvr
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_trans_to_imsvr.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_trans_to_imsvr();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.cmd = reader.uint32();
                    break;
                case 2:
                    message.svrid = reader.uint32();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                case 4:
                    message.uid = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_trans_to_imsvr;
    })();

    net.msg_broadcast_to_client = (function() {

        /**
         * Properties of a msg_broadcast_to_client.
         * @memberof net
         * @interface Imsg_broadcast_to_client
         * @property {Array.<number>|null} [uid_list] msg_broadcast_to_client uid_list
         * @property {number|null} [cmd] msg_broadcast_to_client cmd
         * @property {Uint8Array|null} [data] msg_broadcast_to_client data
         */

        /**
         * Constructs a new msg_broadcast_to_client.
         * @memberof net
         * @classdesc Represents a msg_broadcast_to_client.
         * @implements Imsg_broadcast_to_client
         * @constructor
         * @param {net.Imsg_broadcast_to_client=} [properties] Properties to set
         */
        function msg_broadcast_to_client(properties) {
            this.uid_list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_broadcast_to_client uid_list.
         * @member {Array.<number>} uid_list
         * @memberof net.msg_broadcast_to_client
         * @instance
         */
        msg_broadcast_to_client.prototype.uid_list = $util.emptyArray;

        /**
         * msg_broadcast_to_client cmd.
         * @member {number} cmd
         * @memberof net.msg_broadcast_to_client
         * @instance
         */
        msg_broadcast_to_client.prototype.cmd = 0;

        /**
         * msg_broadcast_to_client data.
         * @member {Uint8Array} data
         * @memberof net.msg_broadcast_to_client
         * @instance
         */
        msg_broadcast_to_client.prototype.data = $util.newBuffer([]);

        /**
         * Encodes the specified msg_broadcast_to_client message. Does not implicitly {@link net.msg_broadcast_to_client.verify|verify} messages.
         * @function encode
         * @memberof net.msg_broadcast_to_client
         * @static
         * @param {net.Imsg_broadcast_to_client} message msg_broadcast_to_client message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_broadcast_to_client.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid_list != null && message.uid_list.length)
                for (var i = 0; i < message.uid_list.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.uid_list[i]);
            if (message.cmd != null && Object.hasOwnProperty.call(message, "cmd"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.cmd);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.data);
            return writer;
        };

        /**
         * Decodes a msg_broadcast_to_client message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_broadcast_to_client
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_broadcast_to_client} msg_broadcast_to_client
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_broadcast_to_client.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_broadcast_to_client();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.uid_list && message.uid_list.length))
                        message.uid_list = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.uid_list.push(reader.uint32());
                    } else
                        message.uid_list.push(reader.uint32());
                    break;
                case 2:
                    message.cmd = reader.uint32();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_broadcast_to_client;
    })();

    net.msg_report_state = (function() {

        /**
         * Properties of a msg_report_state.
         * @memberof net
         * @interface Imsg_report_state
         * @property {number|null} [svrid] msg_report_state svrid
         * @property {number|null} [svrtype] msg_report_state svrtype
         */

        /**
         * Constructs a new msg_report_state.
         * @memberof net
         * @classdesc Represents a msg_report_state.
         * @implements Imsg_report_state
         * @constructor
         * @param {net.Imsg_report_state=} [properties] Properties to set
         */
        function msg_report_state(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * msg_report_state svrid.
         * @member {number} svrid
         * @memberof net.msg_report_state
         * @instance
         */
        msg_report_state.prototype.svrid = 0;

        /**
         * msg_report_state svrtype.
         * @member {number} svrtype
         * @memberof net.msg_report_state
         * @instance
         */
        msg_report_state.prototype.svrtype = 0;

        /**
         * Encodes the specified msg_report_state message. Does not implicitly {@link net.msg_report_state.verify|verify} messages.
         * @function encode
         * @memberof net.msg_report_state
         * @static
         * @param {net.Imsg_report_state} message msg_report_state message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        msg_report_state.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.svrid != null && Object.hasOwnProperty.call(message, "svrid"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.svrid);
            if (message.svrtype != null && Object.hasOwnProperty.call(message, "svrtype"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.svrtype);
            return writer;
        };

        /**
         * Decodes a msg_report_state message from the specified reader or buffer.
         * @function decode
         * @memberof net.msg_report_state
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {net.msg_report_state} msg_report_state
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        msg_report_state.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.net.msg_report_state();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.svrid = reader.uint32();
                    break;
                case 2:
                    message.svrtype = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        return msg_report_state;
    })();

    return net;
})();

module.exports = $root;
